
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $84d1df06ca739753$export$2e2bcd8739ae039);

var $ci9CE = parcelRequire("ci9CE");

var $c99Cv = parcelRequire("c99Cv");

var $ckRW7 = parcelRequire("ckRW7");

var $lYxW4 = parcelRequire("lYxW4");

var $3ELGV = parcelRequire("3ELGV");

var $aIOQY = parcelRequire("aIOQY");

var $iPUx5 = parcelRequire("iPUx5");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $fhnAG = parcelRequire("fhnAG");

var $dwPVL = parcelRequire("dwPVL");

var $7qROO = parcelRequire("7qROO");
const $84d1df06ca739753$var$DEV_MODE = location.host.split(':')[0] === 'localhost';
const $84d1df06ca739753$var$currentDate = new Date();
const $84d1df06ca739753$var$MONTH = $84d1df06ca739753$var$currentDate.getMonth();
const $84d1df06ca739753$var$CURRENT_YEAR = $84d1df06ca739753$var$currentDate.getFullYear();
const $84d1df06ca739753$var$isLocalhost = location.host.indexOf('localhost') > -1;
const $84d1df06ca739753$var$START_MONTH = $84d1df06ca739753$var$isLocalhost ? 10 : 11;
const $84d1df06ca739753$var$YEAR = $84d1df06ca739753$var$MONTH >= $84d1df06ca739753$var$START_MONTH ? $84d1df06ca739753$var$CURRENT_YEAR + 1 : $84d1df06ca739753$var$CURRENT_YEAR;
const $84d1df06ca739753$var$PREVIOUS_YEAR = $84d1df06ca739753$var$YEAR - 1;
const $84d1df06ca739753$var$LAST_FIVE = [
    $84d1df06ca739753$var$YEAR - 1,
    $84d1df06ca739753$var$YEAR - 2,
    $84d1df06ca739753$var$YEAR - 3,
    $84d1df06ca739753$var$YEAR - 4,
    $84d1df06ca739753$var$YEAR - 5
].map((year)=>({
        label: String(year),
        value: String(year)
    }));
const $84d1df06ca739753$var$SUPPORTED_PROJECTS = [
    'wikipedia',
    'commons',
    'wikisource',
    'wiktionary',
    'wikifunctions',
    'wikidata',
    'wikivoyage',
    'wikinews',
    'wikiversity',
    'wikibooks',
    'wikiquote',
    'mediawiki',
    'wikimedia'
];
var $84d1df06ca739753$export$2e2bcd8739ae039 = (0, $TusQn.defineComponent)({
    name: 'App',
    components: {
        ShareBox: $fhnAG.default,
        Page: $aIOQY.default,
        CdxButton: $iPUx5.CdxButton,
        CdxSelect: $iPUx5.CdxSelect,
        CdxIcon: $iPUx5.CdxIcon,
        CdxMessage: $iPUx5.CdxMessage,
        CdxTextInput: $iPUx5.CdxTextInput
    },
    computed: {
        supportedLanguages () {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7qROO))).map((code)=>({
                    code: code,
                    label: (0, $dwPVL.default).message(`language-${code}`, this.language)
                }));
        },
        appStyle () {
            const cp = this.currentPage;
            const p = this.pages.length;
            const colors = [
                'transparent',
                'rgb(247, 176, 206)',
                'rgb(125, 211, 164)',
                'rgb(248, 216, 102)',
                'rgb(134, 132, 127)',
                'rgb(173, 128, 86)',
                'rgb(134, 132, 127)',
                'rgb(0, 0, 0)'
            ];
            const index = Math.floor(cp / p * colors.length) - 1;
            let bgColor = colors[index];
            return `background: ${bgColor}`;
        },
        disableBtn () {
            if (!this.project.match(/[^\.]*\.(wikivoyage|wikinews|wikiversity|wikibooks|wikiquote|wiktionary|wikifunctions|wikisource|wikipedia|mediawiki|wikidata|wikimedia)\.org/) || !this.username.match(/^[^:]+$/)) return true;
            if (this.project.match(/(foundation|office)\.wikimedia\.org$/)) return true;
            return this.currentPage === 0;
        }
    },
    props: {
        lastFiveYears: {
            type: Array,
            default: $84d1df06ca739753$var$LAST_FIVE
        },
        navigatorShareable: {
            type: Boolean,
            default: navigator.share !== undefined
        },
        shareable: {
            type: Boolean,
            default: navigator.clipboard !== undefined || navigator.share !== undefined
        },
        host: {
            type: String,
            default: window.location.host
        },
        nextIcon: {
            type: Object,
            default: (0, $lYxW4.cdxIconArrowNext)
        },
        shareIcon: {
            type: String,
            default: (0, $lYxW4.cdxIconShare)
        }
    },
    methods: {
        setLanguage (ev) {
            const language = ev.target.value;
            window.location.search = `?uselang=${language}`;
            (0, $dwPVL.default).setLanguage(language).then(()=>{
                this.language = language;
                this.languageDirection = (0, $dwPVL.default).isRTL() ? 'rtl' : 'ltr';
            });
        },
        updateYear (y) {
            this.previousYear = y;
            this.nextYear = parseInt(y, 10) + 1;
        },
        shareIt () {
            const share = async (blob)=>{
                let msg = '';
                const clipboardShare = async (blob)=>{
                    try {
                        await navigator.clipboard.write([
                            new ClipboardItem({
                                'image/png': blob
                            })
                        ]);
                        msg = (0, $dwPVL.default).message('image-shared');
                    } catch (error) {
                        // pass.
                        try {
                            await navigator.clipboard.writeText((0, $c99Cv.default)(this.stats));
                            msg = (0, $dwPVL.default).message('text-shared');
                        } catch (error) {
                            this.errorMsg = 'clipboard-error';
                        }
                    }
                };
                if (navigator.share) {
                    const file = new File([
                        blob
                    ], 'share.png', blob);
                    if (navigator.canShare({
                        files: [
                            file
                        ]
                    })) {
                        const shareData = {
                            title: `Wikipedia Year In Review (${$84d1df06ca739753$var$PREVIOUS_YEAR})`,
                            text: (0, $c99Cv.default)(this.stats),
                            files: [
                                file
                            ],
                            url: `https://${location.host}`
                        };
                        return navigator.share(shareData).then(()=>msg, (err)=>{
                            this.errorMsg = 'share-error';
                            this.error = true;
                        });
                    }
                }
                await clipboardShare(msg);
                return msg ? Promise.resolve(msg) : Promise.reject();
            };
            this.error = false;
            this.feedback = '';
            const node = document.getElementById('statBox');
            $ckRW7.toBlob(node).then((blob)=>{
                share(blob).then(async (msg)=>{
                    this.feedback = msg;
                    this.error = false;
                }, (err)=>{
                    this.errorMsg = 'share-error';
                    this.error = true;
                });
            }).catch(function(error) {
                this.errorMsg = 'share-error';
                this.error = true;
            });
        },
        decrementPage () {
            this.currentPage--;
            this.activePage = this.pages[this.currentPage];
        },
        incrementPage () {
            this.currentPage++;
            this.activePage = this.pages[this.currentPage];
        },
        start () {
            this.currentPage = 0;
            const loader = setInterval(()=>{
                this.loading++;
            }, 1000);
            const err = (errObj)=>{
                const errString = errObj.toString();
                if (errString.indexOf('TOOMANYEDITS') > -1) this.errorMsg = 'username-disabled-error';
                else {
                    this.errorMsg = errString;
                    if ($84d1df06ca739753$var$DEV_MODE) console.error(errString);
                }
                this.error = true;
                this.currentPage = -1;
                clearInterval(loader);
                this.loading = 0;
            };
            const statuschecker = setInterval(()=>{
                const s = (0, $3ELGV.default).getStatus();
                const now = s.date;
                if (!now) return;
                const end = new Date(this.previousYear, 11, 31);
                const ONE_DAY = 86400000;
                const diff = (end - now) / ONE_DAY;
                this.status = (365 - diff) / 365;
            }, 300);
            (0, $3ELGV.default)(this.username, parseInt(this.previousYear, 10), this.project).then((stats)=>{
                clearInterval(loader);
                clearInterval(statuschecker);
                this.loading = 0;
                this.stats = stats;
                this.pages = (0, $ci9CE.default)(stats);
                this.activePage = this.pages[this.currentPage];
            }, err);
        }
    },
    updated () {
        if (this.pages.length && this.currentPage >= this.pages.length && !this.shareImg) {
            const node = document.getElementById('statBox');
            $ckRW7.toBlob(node).then((blob)=>{
                this.shareImg = URL.createObjectURL(blob);
            });
        }
    },
    mounted () {
        setInterval(()=>{
            const project = $84d1df06ca739753$var$SUPPORTED_PROJECTS[Math.floor(Math.random() * (0, (/*@__PURE__*/$parcel$interopDefault($7qROO))).length)];
            if (project) this.$nextTick(()=>{
                this.titleProjectMessage = `project-${project}`;
            });
        }, 700);
    },
    data () {
        return {
            shareImg: null,
            titleProjectMessage: 'project-wikipedia',
            language: (0, $dwPVL.default).getLanguage(),
            languageDirection: (0, $dwPVL.default).isRTL() ? 'rtl' : 'ltr',
            errorMsg: '',
            previousYear: $84d1df06ca739753$var$PREVIOUS_YEAR,
            nextYear: $84d1df06ca739753$var$YEAR,
            feedback: '',
            loading: 0,
            status: '',
            error: false,
            activePage: null,
            currentPage: -1,
            /* @type YIRFact[] */ pages: [],
            /* @type YIRStats */ stats: {
                year: $84d1df06ca739753$var$YEAR,
                thankedCount: 0,
                talkEdits: 0,
                thanksCount: 0,
                totalEdits: 0
            },
            project: 'en.wikipedia.org',
            username: ''
        };
    }
});

});
parcelRegister("ci9CE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f2ea14ae6efb45e$export$2e2bcd8739ae039);

var $3cyRD = parcelRequire("3cyRD");

var $aPr1G = parcelRequire("aPr1G");

var $kq3aq = parcelRequire("kq3aq");

var $in8H9 = parcelRequire("in8H9");

var $bTXrZ = parcelRequire("bTXrZ");

var $7G7bO = parcelRequire("7G7bO");

var $9O2ok = parcelRequire("9O2ok");

var $mRIGV = parcelRequire("mRIGV");

var $cvdAV = parcelRequire("cvdAV");
/**
 * @param {YIRStats} stats
 * @return {YIRFact[]}
 */ function $8f2ea14ae6efb45e$var$facts(stats) {
    const year = stats.year;
    const project = stats.project;
    let pages = [];
    pages.push((0, $3cyRD.default)(stats, year, project));
    pages = pages.concat((0, $cvdAV.default)(stats));
    pages = pages.concat((0, $kq3aq.default)(stats));
    pages = pages.concat((0, $aPr1G.default)(stats));
    pages = pages.concat((0, $in8H9.default)(stats, project));
    pages = pages.concat((0, $7G7bO.default)(stats));
    pages = pages.concat((0, $9O2ok.default)(stats));
    pages = pages.concat((0, $mRIGV.default)(stats));
    pages = pages.concat((0, $bTXrZ.default)(stats));
    return pages;
}
var $8f2ea14ae6efb45e$export$2e2bcd8739ae039 = $8f2ea14ae6efb45e$var$facts;

});
parcelRegister("3cyRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $254d895c26eb20bd$export$2e2bcd8739ae039);

var $4YTRO = parcelRequire("4YTRO");

var $4hP4t = parcelRequire("4hP4t");
const $254d895c26eb20bd$var$WIKIPEDIA = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/e/ed/WP20Symbols_MediaWiki.svg',
    width: 512,
    height: 401
};
var /**
 * @param {YIRStats} stats
 * @param {number} year
 * @param {string} project
 * @return {YIRFact}
 */ $254d895c26eb20bd$export$2e2bcd8739ae039 = (stats, year, project)=>{
    let contribs, messageText, value;
    switch(project){
        case 'commons.wikimedia.org':
            contribs = stats.fileUploads;
            value = (0, $4YTRO.default)(contribs);
            messageText = (0, $4hP4t.toFactMessage)('files-you-uploaded', value);
            break;
        default:
            contribs = stats.totalEdits;
            value = (0, $4YTRO.default)(contribs);
            messageText = (0, $4hP4t.toFactMessage)('edits-you-made', value);
            break;
    }
    if (contribs) {
        project;
        return {
            image: $254d895c26eb20bd$var$WIKIPEDIA,
            message: messageText
        };
    } else return {
        image: $254d895c26eb20bd$var$WIKIPEDIA,
        message: (0, $4hP4t.toFactMessage)('no-contributions-this-year', year)
    };
};

});
parcelRegister("4YTRO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a081a043ce94894$export$2e2bcd8739ae039);

var $dwPVL = parcelRequire("dwPVL");
var /**
 * @param {number} num
 * @return {string}
 */ $3a081a043ce94894$export$2e2bcd8739ae039 = (num)=>{
    return `${(0, $dwPVL.default).convertNumber(num)}`;
};

});
parcelRegister("dwPVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d968bda0fab4cf4$export$2e2bcd8739ae039);
// @ts-ignore

var $8ySYM = parcelRequire("8ySYM");
let $9d968bda0fab4cf4$var$langCode = 'en';
let $9d968bda0fab4cf4$var$messages = Object.assign({}, (0, (/*@__PURE__*/$parcel$interopDefault($8ySYM))));
/**
 * @param {string} key 
 * @param  {...any} args 
 * @returns 
 */ function $9d968bda0fab4cf4$var$message(key, ...args) {
    let val = $9d968bda0fab4cf4$var$messages[key];
    const qqx = `\xab${key}\xbb`;
    if ($9d968bda0fab4cf4$var$langCode === 'qqx') return qqx;
    if (val === undefined) val = (0, (/*@__PURE__*/$parcel$interopDefault($8ySYM)))[key] || qqx;
    if (val.indexOf('$') > -1 && $9d968bda0fab4cf4$var$langCode !== 'qqx') args.forEach((replacement, i)=>{
        val = val.replace(new RegExp('\\$' + (i + 1), 'g'), replacement);
    });
    return val;
}
function $9d968bda0fab4cf4$var$getLanguage() {
    return $9d968bda0fab4cf4$var$langCode;
}
/**
 * @param {number} num
 * @return {string}
 */ function $9d968bda0fab4cf4$var$convertNumber(num) {
    /** @type Intl.NumberFormatOptions */ const formatterOptions = {
        style: 'decimal',
        // @ts-ignore
        notation: num > 1000 ? 'compact' : 'standard',
        compactDisplay: 'short',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
    };
    let formatter;
    try {
        formatter = new Intl.NumberFormat($9d968bda0fab4cf4$var$getLanguage(), formatterOptions);
    } catch (e) {
        formatter = new Intl.NumberFormat('en', formatterOptions);
    }
    return formatter.format(num);
}
/**
 * @return {boolean}
 */ function $9d968bda0fab4cf4$var$isRTL() {
    return [
        'aeb_arab',
        'arc',
        'ar',
        'arz',
        'azb',
        'bcc',
        'bgn',
        'bqi',
        'ckb',
        'dv',
        'fa',
        'glk',
        'he',
        'khw',
        'kk_cn',
        'kk_arab',
        'ks_arab',
        'ku_arab',
        'lki',
        'lrc',
        'luz',
        'mzn',
        'pnb',
        'ps',
        'sd',
        'sdh',
        'skr_arab',
        'ug_arab',
        'ur',
        'yi'
    ].indexOf($9d968bda0fab4cf4$var$langCode) > -1;
}
/**
 * 
 * @param {string} languageCode
 * @return {Promise<boolean>}
 */ function $9d968bda0fab4cf4$var$setLanguage(languageCode) {
    $9d968bda0fab4cf4$var$langCode = languageCode;
    return new Promise((resolve)=>{
        fetch(`/i18n/${languageCode}.json`).then((r)=>r.json(), ()=>resolve(true)).then((json)=>{
            $9d968bda0fab4cf4$var$messages = Object.assign({}, json);
            resolve(true);
        }, ()=>{
            // if the language code has a dash try without.
            if (languageCode.indexOf('-') > -1) $9d968bda0fab4cf4$var$setLanguage(languageCode.split('-')[0]).then(()=>resolve(true));
            $9d968bda0fab4cf4$var$messages = {};
            resolve(true);
        });
    });
}
/**
 * @param {Document} doc
 */ const $9d968bda0fab4cf4$var$cleanHTML = (doc)=>{
    let scripts = doc.querySelectorAll('script');
    for (let script of scripts)script.remove();
    // remove all attributes except href.
    Array.from(doc.querySelectorAll('*')).filter((node)=>node.attributes.length).forEach((node)=>{
        Array.from(node.attributes).filter((attr)=>[
                'href'
            ].indexOf(attr.name) === -1).forEach((attr)=>node.removeAttribute(attr.name));
    });
};
/**
 * @param {string} html
 * @return {string}
 */ function $9d968bda0fab4cf4$var$sanitize(html) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(html, 'text/html');
    $9d968bda0fab4cf4$var$cleanHTML(doc);
    return doc.body.innerHTML;
}
/**
 * @param {string} key
 * @return {boolean}
 */ function $9d968bda0fab4cf4$var$exists(key) {
    return $9d968bda0fab4cf4$var$messages[key] !== undefined;
}
var $9d968bda0fab4cf4$export$2e2bcd8739ae039 = {
    isRTL: $9d968bda0fab4cf4$var$isRTL,
    exists: $9d968bda0fab4cf4$var$exists,
    sanitize: $9d968bda0fab4cf4$var$sanitize,
    convertNumber: $9d968bda0fab4cf4$var$convertNumber,
    getLanguage: $9d968bda0fab4cf4$var$getLanguage,
    setLanguage: $9d968bda0fab4cf4$var$setLanguage,
    message: $9d968bda0fab4cf4$var$message
};

});
parcelRegister("8ySYM", function(module, exports) {
module.exports = JSON.parse('{"@metadata":{"authors":["Jon Robson","Jon Harald S\xf8by","Amire80"]},"share-to-clipboard":"Share image to clipboard","project-wikipedia":"Wikipedia","project-commons":"Commons","project-wikisource":"Wikisource","project-wiktionary":"Wiktionary","project-wikifunctions":"Wikifunctions","project-wikidata":"Wikidata","project-wikivoyage":"Wikivoyage","project-wikinews":"Wikinews","project-wikiversity":"Wikiversity","project-wikibooks":"Wikibooks","project-wikiquote":"Wikiquote","project-mediawiki":"MediaWiki","project-wikimedia":"Wikimedia","intro":"Let\'s look back at all the good work you have been doing this year in helping build the best place on the Internet!","text-shared":"Text has been shared to your clipboard.","image-shared":"An image has been shared to your clipboard.","language-ar":"Arabic","language-nl":"Dutch","language-fr":"French","language-az":"Azerbaijani","language-pa":"Punjabi","language-fi":"Finnish","language-tr":"Turkish","language-bn":"Bangla","language-skr-arab":"Saraiki (Arabic script)","language-sr-ec":"Serbian (Cyrillic script)","language-it":"Italian","language-ru":"Russian","language-es":"Spanish","language-lb":"Luxembourgish","language-mk":"Macedonian","language-ur":"Urdu","year-in-review":"Year in Review","username-placeholder":"What\'s your username?","project-label":"Your Wikimedia project:","get-started":"Get started","error-share":"An unexpected error occurred during the share process.","error-clipboard":"An unexpected error occurred while attempting to copy to the clipboard.","error-toomanyedits":"This username has too many edits. Unfortunately it is not supported at the current time.","error-generic":"An error occurred while trying to check that: $1.","year-placeholder":"Select year","save-image":"Download as image","thanks-for-playing":"Thank you for viewing your year in review and for contributing to the sum of all human knowledge.","thanks":"thanks","hny":"Happy $1!","share":"Share stats","language-en":"English","language-yoda":"Yoda","language-label":"Change language","you-made-contributions-to":"You made contributions to","and":"and","edits-you-made":"You made <strong>$1</strong><span>edits</span> across the project.","files-you-uploaded":"You uploaded <strong>$1</strong><span>files</span> across the project.","files":"files","edits":"edits","no-contributions-this-year":"You didn\'t edit this project this year, but... <strong>$1</strong> is another year to contribute to the sum of all human knowledge!","no-contributions":"You didn\'t edit this project this year, but...","next-year":"is another year to contribute to the sum of all human knowledge!","day-0":"Sundays","day-1":"Mondays","day-2":"Tuesdays","day-3":"Wednesdays","day-4":"Thursdays","day-5":"Fridays","day-6":"Saturdays","time-afternoon":"afternoon editor","time-morning":"morning editor","time-lunch":"lunchtime editor","time-sleep":"before bedtime editor","time-night":"nocturnal editor","time-early":"early editor","time-evening":"evening editor","thanks-for-caring":"Thank you caring!","we-appreciate-you":"We appreciate you!","thank-fan":"was your biggest fan","thanked-most":"was the user you thanked the most","share-text":"Here is how I have been contributing to Wikipedia in $1! Edits: $2, Discussions: $3, Thanks: $4, Thanked: $5 #wikipediaYIR","generate-your-own":"Generate your own Year in Review at","interface-edits":"interface edits","template-edits":"template edits","talk-page-edits":"talk page edits","thanked":"thanked","file-uploads":"file uploads","claims":"claims","badge-chatterbox":"chatterbox","badge-chatterbox-desc":"You edited talk pages more than 1000 times.","badge-100":"100 club","badge-100-desc":"You edited more than 100 times","badge-1k":"1K Club","badge-1k-desc":"You edited more than 1000 times","badge-10k":"10K Club","badge-10k-desc":"You edited more than 10,000 times","badge-100k":"100K Club","badge-100k-desc":"You edited more than 100,000 times","badge-1m":"millionaires club","badge-1m-desc":"You edited more than a million times. Is that even possible!?","badge-appreciated":"appreciated","badge-appreciated-desc":"You were appreciated a significant amount of times. You are a pillar to your community!","badge-proofreader":"proofreader","badge-proofreader-desc":"You proofread over 50 pages! Impressive!","badge-template-wizard":"template wizard","badge-template-wizard-desc":"You edited more than 50 pages in the Module and Template namespace","badge-interface-hero":"interface hero","badge-interface-hero-desc":"You edited more than 20 pages in the MediaWiki namespace","badge-day-desc":"The day you were most likely to edit","badge-archivist":"archivist","badge-archivist-desc":"You uploaded more files than there were days in the year","badge-timeslot-desc":"The time you were most likely to edit was $1","longest-streak":"longest streak","badge-streak":"marathoner","badge-streak-desc":"A badge for editors who edited for more than 50 consecutive days.","language-he":"Hebrew","language-id":"Indonesian","language-pl":"Polish","language-sv":"Swedish","language-uk":"Ukrainian","language-zh-hant":"Chinese (Traditional)","language-ko":"Korean","language-nb":"Norwegian Bokm\xe5l","language-zh-hans":"Simplified Chinese","you-made-edits-across-project":"You made <strong>$1</strong> <span>edits</span> across the project","streak-message":"At one point this year you edited the project<strong>$1</strong>consecutive days!","paragraph-message":"Editing approximately <strong>$1</strong> <span>paragraphs</span>of text!","you-made-edits-num-articles":"You made <strong>$1</strong> edits in $2 different articles","edited-most-day-total":"You edited the most on <strong>$1</strong> ($2 edits)","most-edited-time-sleep":"Most editing occurs between <strong>$1</strong> $2","talk-message":"You contributed <strong>$1</strong> <span>times</span> to discussions.","template-message":"You edited templates <strong>$1</strong> <span>times</span>","gadget-message":"You edited gadgets and interface messages <strong>$1</strong> <span>times</span>","appreciated-message":"You were appreciated by <strong>$1</strong> <span>editors</span>","appreciated-message-1a":"And you showed appreciation to <strong>$1</strong> <span>other humans</span>","appreciated-message-1b":"You showed appreciation to <strong>$1</strong> <span>other humans</span>"}');

});



parcelRegister("4hP4t", function(module, exports) {

$parcel$export(module.exports, "toFactMessage", () => $31f05d9cfe573ccd$export$7a2c299ce54b020c);

var $dwPVL = parcelRequire("dwPVL");
function $31f05d9cfe573ccd$export$7a2c299ce54b020c(key, ...args) {
    return (0, $dwPVL.default).sanitize((0, $dwPVL.default).message(key, ...args));
}

});


parcelRegister("aPr1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e23a1a3ab027522$export$2e2bcd8739ae039);

var $4YTRO = parcelRequire("4YTRO");

var $9xb1l = parcelRequire("9xb1l");

var $liybR = parcelRequire("liybR");

var $4hP4t = parcelRequire("4hP4t");
const $7e23a1a3ab027522$var$PUZZLE_COLLAB = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/c/c2/Adapted_Wikipedia20symbol_collaboration.svg',
    width: 512,
    height: 401
};
const $7e23a1a3ab027522$var$PEN_PAPER = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/7/7c/WP20Symbols_PENANDPAPER.svg',
    width: 512,
    height: 401
};
var /**
 * @param {YIRStats} stats
 * @return {YIRFact[]}
 */ $7e23a1a3ab027522$export$2e2bcd8739ae039 = (stats)=>{
    const topDay = stats.dayofweek[0];
    if (stats.articleEdits === 0) return [];
    return [
        {
            message: (0, $4hP4t.toFactMessage)('you-made-edits-num-articles', (0, $4YTRO.default)(stats.articleEdits), (0, $4YTRO.default)(stats.articlesNumber)),
            image: $7e23a1a3ab027522$var$PEN_PAPER
        },
        {
            message: (0, $4hP4t.toFactMessage)('edited-most-day-total', (0, $liybR.humanDay)(topDay.day), topDay.count),
            class: 'smaller',
            image: $7e23a1a3ab027522$var$PUZZLE_COLLAB
        },
        (0, $9xb1l.default)(stats.hourofweek)
    ];
};

});
parcelRegister("9xb1l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f0fbe9641a405b4$export$2e2bcd8739ae039);

var $liybR = parcelRequire("liybR");

var $4hP4t = parcelRequire("4hP4t");
const $6f0fbe9641a405b4$var$PUZZLE_COLLAB = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/c/c2/Adapted_Wikipedia20symbol_collaboration.svg',
    width: 512,
    height: 401
};
var /**
 * @param {YIRTimeSlot[]} hours
 * @return {YIRFact}
 */ $6f0fbe9641a405b4$export$2e2bcd8739ae039 = (hours)=>{
    const value = hours[0].timespan;
    return {
        message: (0, $4hP4t.toFactMessage)('most-edited-time-sleep', value, (0, $liybR.getTimeslotNote)(value)),
        class: 'smaller',
        image: $6f0fbe9641a405b4$var$PUZZLE_COLLAB
    };
};

});
parcelRegister("liybR", function(module, exports) {

$parcel$export(module.exports, "humanDay", () => $f815cce656cd8ad0$export$ba6cd178d45d1408);
$parcel$export(module.exports, "getTimeslotNote", () => $f815cce656cd8ad0$export$5052b5089e5b8c99);

var $dwPVL = parcelRequire("dwPVL");
const $f815cce656cd8ad0$export$ba6cd178d45d1408 = (day)=>{
    return [
        (0, $dwPVL.default).message('day-0'),
        (0, $dwPVL.default).message('day-1'),
        (0, $dwPVL.default).message('day-2'),
        (0, $dwPVL.default).message('day-3'),
        (0, $dwPVL.default).message('day-4'),
        (0, $dwPVL.default).message('day-5'),
        (0, $dwPVL.default).message('day-6')
    ][day];
};
const $f815cce656cd8ad0$export$5052b5089e5b8c99 = (timespan)=>{
    switch(timespan){
        case '14:00 - 17:00':
            return (0, $dwPVL.default).message('time-afternoon');
        case '10:00 - 12:00':
            return (0, $dwPVL.default).message('time-morning');
        case '12:00 - 14:00':
            return (0, $dwPVL.default).message('time-lunch');
        case '22:00 - 0:00':
            return (0, $dwPVL.default).message('time-sleep');
        case '0:00 - 6:00':
            return (0, $dwPVL.default).message('time-night');
        case '6:00 - 10:00':
            return (0, $dwPVL.default).message('time-early');
        case '17:00 - 22:00':
            return (0, $dwPVL.default).message('time-evening');
        default:
            return '';
    }
};

});



parcelRegister("kq3aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $edd8b14b024ba7be$export$2e2bcd8739ae039);

var $4YTRO = parcelRequire("4YTRO");

var $4hP4t = parcelRequire("4hP4t");
const $edd8b14b024ba7be$var$PUZZLE = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/6/65/WP20Symbols_puzzleglobe1.svg',
    width: 512,
    height: 401
};
var /**
 * @param {YIRStats} stats
 * @return {YIRFact[]}
 */ $edd8b14b024ba7be$export$2e2bcd8739ae039 = (stats)=>{
    if (stats.paragraphs && stats.project !== 'commons.wikimedia.org') return [
        {
            image: $edd8b14b024ba7be$var$PUZZLE,
            message: (0, $4hP4t.toFactMessage)('paragraph-message', (0, $4YTRO.default)(Math.floor(stats.paragraphs)))
        }
    ];
    else return [];
};

});

parcelRegister("in8H9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6011e9d29889a1f$export$2e2bcd8739ae039);

var $dwPVL = parcelRequire("dwPVL");
/**
 * @param {string} project
 * @param {string} title
 * @return {string}
 */ const $d6011e9d29889a1f$var$wikiUrl = (project, title)=>{
    return `https://${project}/wiki/${encodeURIComponent(title)}`;
};
var /**
 * @param {YIRStats} stats
 * @param {string} project
 * @return {YIRFact[]}
 */ $d6011e9d29889a1f$export$2e2bcd8739ae039 = (stats, project)=>{
    if (stats.top5[0]) {
        let topTitle = stats.top5[0].title;
        const topLink = `<span>[[<a class="wikiLink" href="${$d6011e9d29889a1f$var$wikiUrl(project, topTitle)}">${topTitle}</a>]]</span>`;
        return [
            {
                message: `${(0, $dwPVL.default).message('you-made-contributions-to')} ${topLink}`,
                image: stats.thumbs[0]
            },
            ...stats.top5.slice(1).map((t, i)=>{
                const link = `<span>[[<a class="wikiLink" href="${$d6011e9d29889a1f$var$wikiUrl(project, t.title)}">${t.title}</a>]]</span>`;
                return {
                    image: stats.thumbs[i + 1],
                    message: `${(0, $dwPVL.default).message('and')} ${link}`
                };
            })
        ];
    } else return [];
};

});

parcelRegister("bTXrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aa2f25ec103aa9d$export$2e2bcd8739ae039);

var $4YTRO = parcelRequire("4YTRO");

var $dwPVL = parcelRequire("dwPVL");

var $4hP4t = parcelRequire("4hP4t");
const $8aa2f25ec103aa9d$var$FRIENDSHIP = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/7/72/Adapted_Wikipedia20symbol_friendship.svg',
    width: 512,
    height: 401
};
const $8aa2f25ec103aa9d$var$COMMUNITY = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/a/a3/Adapted_Wikipedia20symbol_community.svg',
    width: 512,
    height: 401
};
var /**
 * @param {YIRStats} stats
 * @return {YIRFact[]}
 */ $8aa2f25ec103aa9d$export$2e2bcd8739ae039 = (stats)=>{
    let wasThanked = false;
    let /** @type YIRFact[] */ pages = [];
    if (stats.thanksCount > 0) {
        wasThanked = true;
        pages = pages.concat([
            {
                message: (0, $4hP4t.toFactMessage)('appreciated-message', (0, $4YTRO.default)(stats.thankedCount)),
                image: $8aa2f25ec103aa9d$var$FRIENDSHIP
            }
        ]);
    }
    if (stats.thanksCount > 0) {
        const messageKey = wasThanked ? 'appreciated-message-1a' : 'appreciated-message-1b';
        pages = pages.concat([
            {
                image: $8aa2f25ec103aa9d$var$COMMUNITY,
                message: (0, $4hP4t.toFactMessage)(messageKey, (0, $4YTRO.default)(stats.thanksCount))
            },
            {
                message: `<span>${(0, $dwPVL.default).message('thanks-for-caring')}</span> ${(0, $dwPVL.default).message('we-appreciate-you')}`
            }
        ]);
    }
    if (stats.topThanksTo.length) pages = pages.concat([
        {
            message: `<span>@${stats.topThanksTo[0].title}</span> ${(0, $dwPVL.default).message('thanked-most')}`
        }
    ]);
    if (stats.topThanksFrom.length) pages = pages.concat([
        {
            message: `<span>@${stats.topThanksFrom[0].user}</span> ${(0, $dwPVL.default).message('thank-fan')}`
        }
    ]);
    return pages;
};

});

parcelRegister("7G7bO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5972085bf13280b1$export$2e2bcd8739ae039);

var $4YTRO = parcelRequire("4YTRO");

var $4hP4t = parcelRequire("4hP4t");
const $5972085bf13280b1$var$MEETING = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/f/f9/Adapted_Wikipedia20symbol_meeting.svg',
    width: 512,
    height: 401
};
var /**
 * @param {YIRStats} stats
 * @return {YIRFact[]}
 */ $5972085bf13280b1$export$2e2bcd8739ae039 = (stats)=>{
    if (stats.talkEdits > 0) return [
        {
            message: (0, $4hP4t.toFactMessage)('talk-message', (0, $4YTRO.default)(stats.talkEdits)),
            image: $5972085bf13280b1$var$MEETING
        }
    ];
    else return [];
};

});

parcelRegister("9O2ok", function(module, exports) {

$parcel$export(module.exports, "default", () => $723aa36e7c7d792f$export$2e2bcd8739ae039);

var $4YTRO = parcelRequire("4YTRO");

var $4hP4t = parcelRequire("4hP4t");
const $723aa36e7c7d792f$var$DATA = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/1/12/Adapted_Wikipedia20symbols_data_w.svg',
    width: 512,
    height: 401
};
var /**
 * @param {YIRStats} stats
 * @return {YIRFact[]}
 */ $723aa36e7c7d792f$export$2e2bcd8739ae039 = (stats)=>{
    if (stats.templateEdits > 0) return [
        {
            message: (0, $4hP4t.toFactMessage)('template-message', (0, $4YTRO.default)(stats.templateEdits)),
            image: $723aa36e7c7d792f$var$DATA
        }
    ];
    else return [];
};

});

parcelRegister("mRIGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $044bb9d3ceef9b00$export$2e2bcd8739ae039);

var $4YTRO = parcelRequire("4YTRO");

var $4hP4t = parcelRequire("4hP4t");
const $044bb9d3ceef9b00$var$CHEMISTRY = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Adapted_Wikipedia20symbols_chemistry_w.svg',
    width: 512,
    height: 401
};
var /**
 * @param {YIRStats} stats
 * @return {YIRFact[]}
 */ $044bb9d3ceef9b00$export$2e2bcd8739ae039 = (stats)=>{
    if (stats.interfaceEdits > 0) return [
        {
            message: (0, $4hP4t.toFactMessage)('gadget-message', (0, $4YTRO.default)(stats.interfaceEdits)),
            image: $044bb9d3ceef9b00$var$CHEMISTRY
        }
    ];
    else return [];
};

});

parcelRegister("cvdAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $91a2ece52dfefd84$export$2e2bcd8739ae039);

var $4YTRO = parcelRequire("4YTRO");

var $4hP4t = parcelRequire("4hP4t");
const $91a2ece52dfefd84$var$LIGHTNING = {
    source: 'https://upload.wikimedia.org/wikipedia/commons/5/56/WP20Symbols_2019_dosangriff.png',
    width: 512,
    height: 401
};
var /**
 * @param {YIRStats} stats
 * @return {YIRFact[]}
 */ $91a2ece52dfefd84$export$2e2bcd8739ae039 = (stats)=>{
    const streak = stats.streak.longestStreak;
    if (streak <= 1) return [];
    return [
        {
            message: (0, $4hP4t.toFactMessage)('streak-message', (0, $4YTRO.default)(streak)),
            image: $91a2ece52dfefd84$var$LIGHTNING
        }
    ];
};

});


parcelRegister("c99Cv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d7dc9a2edec3aab$export$2e2bcd8739ae039);

var $dwPVL = parcelRequire("dwPVL");
var /**
 * @param {YIRStats} stats
 * @return {string}
 */ $8d7dc9a2edec3aab$export$2e2bcd8739ae039 = (stats)=>{
    return (0, $dwPVL.default).message('share-text', stats.year - 1, stats.totalEdits, stats.talkEdits, stats.thanksCount, stats.thankedCount);
};

});

parcelRegister("ckRW7", function(module, exports) {

$parcel$export(module.exports, "toBlob", () => $8fb130f5e2a07b68$export$b20f4ee19ffa0668);

var $iVtuB = parcelRequire("iVtuB");

var $7EVqD = parcelRequire("7EVqD");

var $FrxEM = parcelRequire("FrxEM");

var $8RwLg = parcelRequire("8RwLg");

var $dCPPv = parcelRequire("dCPPv");
async function $8fb130f5e2a07b68$export$20d300cb2d558b7(node, options = {}) {
    const { width: width, height: height } = (0, $dCPPv.getImageSize)(node, options);
    const clonedNode = await (0, $iVtuB.cloneNode)(node, options, true);
    await (0, $8RwLg.embedWebFonts)(clonedNode, options);
    await (0, $7EVqD.embedImages)(clonedNode, options);
    (0, $FrxEM.applyStyle)(clonedNode, options);
    const datauri = await (0, $dCPPv.nodeToDataURL)(clonedNode, width, height);
    return datauri;
}
async function $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options = {}) {
    const { width: width, height: height } = (0, $dCPPv.getImageSize)(node, options);
    const svg = await $8fb130f5e2a07b68$export$20d300cb2d558b7(node, options);
    const img = await (0, $dCPPv.createImage)(svg);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const ratio = options.pixelRatio || (0, $dCPPv.getPixelRatio)();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) (0, $dCPPv.checkCanvasDimensions)(canvas);
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function $8fb130f5e2a07b68$export$6f9e32581c0cde11(node, options = {}) {
    const { width: width, height: height } = (0, $dCPPv.getImageSize)(node, options);
    const canvas = await $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options);
    const ctx = canvas.getContext('2d');
    return ctx.getImageData(0, 0, width, height).data;
}
async function $8fb130f5e2a07b68$export$aba256f33615c92e(node, options = {}) {
    const canvas = await $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL();
}
async function $8fb130f5e2a07b68$export$ed218bd2440d33a5(node, options = {}) {
    const canvas = await $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL('image/jpeg', options.quality || 1);
}
async function $8fb130f5e2a07b68$export$b20f4ee19ffa0668(node, options = {}) {
    const canvas = await $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options);
    const blob = await (0, $dCPPv.canvasToBlob)(canvas);
    return blob;
}
async function $8fb130f5e2a07b68$export$92678bad7eef403b(node, options = {}) {
    return (0, $8RwLg.getWebFontCSS)(node, options);
}

});
parcelRegister("iVtuB", function(module, exports) {

$parcel$export(module.exports, "cloneNode", () => $dc746d806551912c$export$ae8e35ea29ddac22);

var $kLeZY = parcelRequire("kLeZY");

var $dCPPv = parcelRequire("dCPPv");

var $8V5Rc = parcelRequire("8V5Rc");

var $lLVB3 = parcelRequire("lLVB3");
async function $dc746d806551912c$var$cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === 'data:,') return canvas.cloneNode(false);
    return (0, $dCPPv.createImage)(dataURL);
}
async function $dc746d806551912c$var$cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 || ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return (0, $dCPPv.createImage)(dataURL);
    }
    const poster = video.poster;
    const contentType = (0, $8V5Rc.getMimeType)(poster);
    const dataURL = await (0, $lLVB3.resourceToDataURL)(poster, contentType, options);
    return (0, $dCPPv.createImage)(dataURL);
}
async function $dc746d806551912c$var$cloneIFrameElement(iframe) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) return await $dc746d806551912c$export$ae8e35ea29ddac22(iframe.contentDocument.body, {}, true);
    } catch (_b) {
    // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function $dc746d806551912c$var$cloneSingleNode(node, options) {
    if ((0, $dCPPv.isInstanceOfElement)(node, HTMLCanvasElement)) return $dc746d806551912c$var$cloneCanvasElement(node);
    if ((0, $dCPPv.isInstanceOfElement)(node, HTMLVideoElement)) return $dc746d806551912c$var$cloneVideoElement(node, options);
    if ((0, $dCPPv.isInstanceOfElement)(node, HTMLIFrameElement)) return $dc746d806551912c$var$cloneIFrameElement(node);
    return node.cloneNode(false);
}
const $dc746d806551912c$var$isSlotElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
async function $dc746d806551912c$var$cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    let children = [];
    if ($dc746d806551912c$var$isSlotElement(nativeNode) && nativeNode.assignedNodes) children = (0, $dCPPv.toArray)(nativeNode.assignedNodes());
    else if ((0, $dCPPv.isInstanceOfElement)(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) children = (0, $dCPPv.toArray)(nativeNode.contentDocument.body.childNodes);
    else children = (0, $dCPPv.toArray)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    if (children.length === 0 || (0, $dCPPv.isInstanceOfElement)(nativeNode, HTMLVideoElement)) return clonedNode;
    await children.reduce((deferred, child)=>deferred.then(()=>$dc746d806551912c$export$ae8e35ea29ddac22(child, options)).then((clonedChild)=>{
            if (clonedChild) clonedNode.appendChild(clonedChild);
        }), Promise.resolve());
    return clonedNode;
}
function $dc746d806551912c$var$cloneCSSStyle(nativeNode, clonedNode) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) return;
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    } else (0, $dCPPv.toArray)(sourceStyle).forEach((name)=>{
        let value = sourceStyle.getPropertyValue(name);
        if (name === 'font-size' && value.endsWith('px')) {
            const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
            value = `${reducedFont}px`;
        }
        if ((0, $dCPPv.isInstanceOfElement)(nativeNode, HTMLIFrameElement) && name === 'display' && value === 'inline') value = 'block';
        if (name === 'd' && clonedNode.getAttribute('d')) value = `path(${clonedNode.getAttribute('d')})`;
        targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
}
function $dc746d806551912c$var$cloneInputValue(nativeNode, clonedNode) {
    if ((0, $dCPPv.isInstanceOfElement)(nativeNode, HTMLTextAreaElement)) clonedNode.innerHTML = nativeNode.value;
    if ((0, $dCPPv.isInstanceOfElement)(nativeNode, HTMLInputElement)) clonedNode.setAttribute('value', nativeNode.value);
}
function $dc746d806551912c$var$cloneSelectValue(nativeNode, clonedNode) {
    if ((0, $dCPPv.isInstanceOfElement)(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child)=>nativeNode.value === child.getAttribute('value'));
        if (selectedOption) selectedOption.setAttribute('selected', '');
    }
}
function $dc746d806551912c$var$decorate(nativeNode, clonedNode) {
    if ((0, $dCPPv.isInstanceOfElement)(clonedNode, Element)) {
        $dc746d806551912c$var$cloneCSSStyle(nativeNode, clonedNode);
        (0, $kLeZY.clonePseudoElements)(nativeNode, clonedNode);
        $dc746d806551912c$var$cloneInputValue(nativeNode, clonedNode);
        $dc746d806551912c$var$cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function $dc746d806551912c$var$ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
    if (uses.length === 0) return clone;
    const processedDefs = {};
    for(let i = 0; i < uses.length; i++){
        const use = uses[i];
        const id = use.getAttribute('xlink:href');
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) // eslint-disable-next-line no-await-in-loop
            processedDefs[id] = await $dc746d806551912c$export$ae8e35ea29ddac22(definition, options, true);
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = 'http://www.w3.org/1999/xhtml';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('xmlns', ns);
        svg.style.position = 'absolute';
        svg.style.width = '0';
        svg.style.height = '0';
        svg.style.overflow = 'hidden';
        svg.style.display = 'none';
        const defs = document.createElementNS(ns, 'defs');
        svg.appendChild(defs);
        for(let i = 0; i < nodes.length; i++)defs.appendChild(nodes[i]);
        clone.appendChild(svg);
    }
    return clone;
}
async function $dc746d806551912c$export$ae8e35ea29ddac22(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) return null;
    return Promise.resolve(node).then((clonedNode)=>$dc746d806551912c$var$cloneSingleNode(clonedNode, options)).then((clonedNode)=>$dc746d806551912c$var$cloneChildren(node, clonedNode, options)).then((clonedNode)=>$dc746d806551912c$var$decorate(node, clonedNode)).then((clonedNode)=>$dc746d806551912c$var$ensureSVGSymbols(clonedNode, options));
}

});
parcelRegister("kLeZY", function(module, exports) {

$parcel$export(module.exports, "clonePseudoElements", () => $f1d3d4da19ace37e$export$8df63687a708ed2e);

var $dCPPv = parcelRequire("dCPPv");
function $f1d3d4da19ace37e$var$formatCSSText(style) {
    const content = style.getPropertyValue('content');
    return `${style.cssText} content: '${content.replace(/'|"/g, '')}';`;
}
function $f1d3d4da19ace37e$var$formatCSSProperties(style) {
    return (0, $dCPPv.toArray)(style).map((name)=>{
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? ' !important' : ''};`;
    }).join(' ');
}
function $f1d3d4da19ace37e$var$getPseudoElementStyle(className, pseudo, style) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText ? $f1d3d4da19ace37e$var$formatCSSText(style) : $f1d3d4da19ace37e$var$formatCSSProperties(style);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function $f1d3d4da19ace37e$var$clonePseudoElement(nativeNode, clonedNode, pseudo) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue('content');
    if (content === '' || content === 'none') return;
    const className = (0, $dCPPv.uuid)();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    } catch (err) {
        return;
    }
    const styleElement = document.createElement('style');
    styleElement.appendChild($f1d3d4da19ace37e$var$getPseudoElementStyle(className, pseudo, style));
    clonedNode.appendChild(styleElement);
}
function $f1d3d4da19ace37e$export$8df63687a708ed2e(nativeNode, clonedNode) {
    $f1d3d4da19ace37e$var$clonePseudoElement(nativeNode, clonedNode, ':before');
    $f1d3d4da19ace37e$var$clonePseudoElement(nativeNode, clonedNode, ':after');
}

});
parcelRegister("dCPPv", function(module, exports) {

$parcel$export(module.exports, "resolveUrl", () => $9eb70742a7095e98$export$f85c16a6d62f7d63);
$parcel$export(module.exports, "uuid", () => $9eb70742a7095e98$export$31b40729666a4ae0);
$parcel$export(module.exports, "toArray", () => $9eb70742a7095e98$export$45b10814cc054894);
$parcel$export(module.exports, "getImageSize", () => $9eb70742a7095e98$export$ada5537b2c061996);
$parcel$export(module.exports, "getPixelRatio", () => $9eb70742a7095e98$export$d39ce20a37bba061);
$parcel$export(module.exports, "checkCanvasDimensions", () => $9eb70742a7095e98$export$c2c809a2fe6b0f1a);
$parcel$export(module.exports, "canvasToBlob", () => $9eb70742a7095e98$export$403d539f215df596);
$parcel$export(module.exports, "createImage", () => $9eb70742a7095e98$export$ec664d7487540b);
$parcel$export(module.exports, "nodeToDataURL", () => $9eb70742a7095e98$export$b62810fb8ca515fa);
$parcel$export(module.exports, "isInstanceOfElement", () => $9eb70742a7095e98$export$3a92fc9ec83ef360);

var $hPtJY = parcelRequire("hPtJY");
function $9eb70742a7095e98$export$f85c16a6d62f7d63(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) return url;
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) return window.location.protocol + url;
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) return url;
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement('base');
    const a = doc.createElement('a');
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
const $9eb70742a7095e98$export$31b40729666a4ae0 = (()=>{
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = ()=>// eslint-disable-next-line no-bitwise
        `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function $9eb70742a7095e98$export$1391212d75b2ee65(ms) {
    return (args)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(args), ms);
        });
}
function $9eb70742a7095e98$export$45b10814cc054894(arrayLike) {
    const arr = [];
    for(let i = 0, l = arrayLike.length; i < l; i++)arr.push(arrayLike[i]);
    return arr;
}
function $9eb70742a7095e98$var$px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace('px', '')) : 0;
}
function $9eb70742a7095e98$var$getNodeWidth(node) {
    const leftBorder = $9eb70742a7095e98$var$px(node, 'border-left-width');
    const rightBorder = $9eb70742a7095e98$var$px(node, 'border-right-width');
    return node.clientWidth + leftBorder + rightBorder;
}
function $9eb70742a7095e98$var$getNodeHeight(node) {
    const topBorder = $9eb70742a7095e98$var$px(node, 'border-top-width');
    const bottomBorder = $9eb70742a7095e98$var$px(node, 'border-bottom-width');
    return node.clientHeight + topBorder + bottomBorder;
}
function $9eb70742a7095e98$export$ada5537b2c061996(targetNode, options = {}) {
    const width = options.width || $9eb70742a7095e98$var$getNodeWidth(targetNode);
    const height = options.height || $9eb70742a7095e98$var$getNodeHeight(targetNode);
    return {
        width: width,
        height: height
    };
}
function $9eb70742a7095e98$export$d39ce20a37bba061() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = $hPtJY;
    } catch (e) {
    // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) ratio = 1;
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const $9eb70742a7095e98$var$canvasDimensionLimit = 16384;
function $9eb70742a7095e98$export$c2c809a2fe6b0f1a(canvas) {
    if (canvas.width > $9eb70742a7095e98$var$canvasDimensionLimit || canvas.height > $9eb70742a7095e98$var$canvasDimensionLimit) {
        if (canvas.width > $9eb70742a7095e98$var$canvasDimensionLimit && canvas.height > $9eb70742a7095e98$var$canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= $9eb70742a7095e98$var$canvasDimensionLimit / canvas.width;
                canvas.width = $9eb70742a7095e98$var$canvasDimensionLimit;
            } else {
                canvas.width *= $9eb70742a7095e98$var$canvasDimensionLimit / canvas.height;
                canvas.height = $9eb70742a7095e98$var$canvasDimensionLimit;
            }
        } else if (canvas.width > $9eb70742a7095e98$var$canvasDimensionLimit) {
            canvas.height *= $9eb70742a7095e98$var$canvasDimensionLimit / canvas.width;
            canvas.width = $9eb70742a7095e98$var$canvasDimensionLimit;
        } else {
            canvas.width *= $9eb70742a7095e98$var$canvasDimensionLimit / canvas.height;
            canvas.height = $9eb70742a7095e98$var$canvasDimensionLimit;
        }
    }
}
function $9eb70742a7095e98$export$403d539f215df596(canvas, options = {}) {
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, options.type ? options.type : 'image/png', options.quality ? options.quality : 1);
    });
    return new Promise((resolve)=>{
        const binaryString = window.atob(canvas.toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined).split(',')[1]);
        const len = binaryString.length;
        const binaryArray = new Uint8Array(len);
        for(let i = 0; i < len; i += 1)binaryArray[i] = binaryString.charCodeAt(i);
        resolve(new Blob([
            binaryArray
        ], {
            type: options.type ? options.type : 'image/png'
        }));
    });
}
function $9eb70742a7095e98$export$ec664d7487540b(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.decode = ()=>resolve(img);
        img.onload = ()=>resolve(img);
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.src = url;
    });
}
async function $9eb70742a7095e98$export$fe77aa9c02de4599(svg) {
    return Promise.resolve().then(()=>new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html)=>`data:image/svg+xml;charset=utf-8,${html}`);
}
async function $9eb70742a7095e98$export$b62810fb8ca515fa(node, width, height) {
    const xmlns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(xmlns, 'svg');
    const foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttribute('width', `${width}`);
    svg.setAttribute('height', `${height}`);
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    foreignObject.setAttribute('width', '100%');
    foreignObject.setAttribute('height', '100%');
    foreignObject.setAttribute('x', '0');
    foreignObject.setAttribute('y', '0');
    foreignObject.setAttribute('externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return $9eb70742a7095e98$export$fe77aa9c02de4599(svg);
}
const $9eb70742a7095e98$export$3a92fc9ec83ef360 = (node, instance)=>{
    if (node instanceof instance) return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null) return false;
    return nodePrototype.constructor.name === instance.name || $9eb70742a7095e98$export$3a92fc9ec83ef360(nodePrototype, instance);
};

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("8V5Rc", function(module, exports) {

$parcel$export(module.exports, "getMimeType", () => $67e830aaea99e7b5$export$200548c990602f61);
const $67e830aaea99e7b5$var$WOFF = 'application/font-woff';
const $67e830aaea99e7b5$var$JPEG = 'image/jpeg';
const $67e830aaea99e7b5$var$mimes = {
    woff: $67e830aaea99e7b5$var$WOFF,
    woff2: $67e830aaea99e7b5$var$WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: $67e830aaea99e7b5$var$JPEG,
    jpeg: $67e830aaea99e7b5$var$JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml',
    webp: 'image/webp'
};
function $67e830aaea99e7b5$var$getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : '';
}
function $67e830aaea99e7b5$export$200548c990602f61(url) {
    const extension = $67e830aaea99e7b5$var$getExtension(url).toLowerCase();
    return $67e830aaea99e7b5$var$mimes[extension] || '';
}

});

parcelRegister("lLVB3", function(module, exports) {

$parcel$export(module.exports, "isDataUrl", () => $fd9aaa441bfc2baf$export$f8a05efa20ffd5a);
$parcel$export(module.exports, "makeDataUrl", () => $fd9aaa441bfc2baf$export$68336ea1617fa80a);
$parcel$export(module.exports, "fetchAsDataURL", () => $fd9aaa441bfc2baf$export$c20a8b76c95b0d41);
$parcel$export(module.exports, "resourceToDataURL", () => $fd9aaa441bfc2baf$export$bdf0422c029b202a);
function $fd9aaa441bfc2baf$var$getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function $fd9aaa441bfc2baf$export$f8a05efa20ffd5a(url) {
    return url.search(/^(data:)/) !== -1;
}
function $fd9aaa441bfc2baf$export$68336ea1617fa80a(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function $fd9aaa441bfc2baf$export$c20a8b76c95b0d41(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) throw new Error(`Resource "${res.url}" not found`);
    const blob = await res.blob();
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = ()=>{
            try {
                resolve(process({
                    res: res,
                    result: reader.result
                }));
            } catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const $fd9aaa441bfc2baf$var$cache = {};
function $fd9aaa441bfc2baf$var$getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, '');
    if (includeQueryParams) key = url;
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) key = key.replace(/.*\//, '');
    return contentType ? `[${contentType}]${key}` : key;
}
async function $fd9aaa441bfc2baf$export$bdf0422c029b202a(resourceUrl, contentType, options) {
    const cacheKey = $fd9aaa441bfc2baf$var$getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if ($fd9aaa441bfc2baf$var$cache[cacheKey] != null) return $fd9aaa441bfc2baf$var$cache[cacheKey];
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) // eslint-disable-next-line no-param-reassign
    resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
    let dataURL;
    try {
        const content = await $fd9aaa441bfc2baf$export$c20a8b76c95b0d41(resourceUrl, options.fetchRequestInit, ({ res: res, result: result })=>{
            if (!contentType) // eslint-disable-next-line no-param-reassign
            contentType = res.headers.get('Content-Type') || '';
            return $fd9aaa441bfc2baf$var$getContentFromDataUrl(result);
        });
        dataURL = $fd9aaa441bfc2baf$export$68336ea1617fa80a(content, contentType);
    } catch (error) {
        dataURL = options.imagePlaceholder || '';
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) msg = typeof error === 'string' ? error : error.message;
        if (msg) console.warn(msg);
    }
    $fd9aaa441bfc2baf$var$cache[cacheKey] = dataURL;
    return dataURL;
}

});


parcelRegister("7EVqD", function(module, exports) {

$parcel$export(module.exports, "embedImages", () => $5938d0f1526f12ac$export$6660fa8dd20e53aa);

var $c5frv = parcelRequire("c5frv");

var $dCPPv = parcelRequire("dCPPv");

var $lLVB3 = parcelRequire("lLVB3");

var $8V5Rc = parcelRequire("8V5Rc");
async function $5938d0f1526f12ac$var$embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await (0, $c5frv.embedResources)(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function $5938d0f1526f12ac$var$embedBackground(clonedNode, options) {
    if (!await $5938d0f1526f12ac$var$embedProp('background', clonedNode, options)) await $5938d0f1526f12ac$var$embedProp('background-image', clonedNode, options);
    if (!await $5938d0f1526f12ac$var$embedProp('mask', clonedNode, options)) await $5938d0f1526f12ac$var$embedProp('mask-image', clonedNode, options);
}
async function $5938d0f1526f12ac$var$embedImageNode(clonedNode, options) {
    const isImageElement = (0, $dCPPv.isInstanceOfElement)(clonedNode, HTMLImageElement);
    if (!(isImageElement && !(0, $lLVB3.isDataUrl)(clonedNode.src)) && !((0, $dCPPv.isInstanceOfElement)(clonedNode, SVGImageElement) && !(0, $lLVB3.isDataUrl)(clonedNode.href.baseVal))) return;
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await (0, $lLVB3.resourceToDataURL)(url, (0, $8V5Rc.getMimeType)(url), options);
    await new Promise((resolve, reject)=>{
        clonedNode.onload = resolve;
        clonedNode.onerror = reject;
        const image = clonedNode;
        if (image.decode) image.decode = resolve;
        if (image.loading === 'lazy') image.loading = 'eager';
        if (isImageElement) {
            clonedNode.srcset = '';
            clonedNode.src = dataURL;
        } else clonedNode.href.baseVal = dataURL;
    });
}
async function $5938d0f1526f12ac$var$embedChildren(clonedNode, options) {
    const children = (0, $dCPPv.toArray)(clonedNode.childNodes);
    const deferreds = children.map((child)=>$5938d0f1526f12ac$export$6660fa8dd20e53aa(child, options));
    await Promise.all(deferreds).then(()=>clonedNode);
}
async function $5938d0f1526f12ac$export$6660fa8dd20e53aa(clonedNode, options) {
    if ((0, $dCPPv.isInstanceOfElement)(clonedNode, Element)) {
        await $5938d0f1526f12ac$var$embedBackground(clonedNode, options);
        await $5938d0f1526f12ac$var$embedImageNode(clonedNode, options);
        await $5938d0f1526f12ac$var$embedChildren(clonedNode, options);
    }
}

});
parcelRegister("c5frv", function(module, exports) {

$parcel$export(module.exports, "shouldEmbed", () => $8cc1ee3e9af11276$export$7b668369e5eab853);
$parcel$export(module.exports, "embedResources", () => $8cc1ee3e9af11276$export$3d88803585cbbc21);

var $dCPPv = parcelRequire("dCPPv");

var $8V5Rc = parcelRequire("8V5Rc");

var $lLVB3 = parcelRequire("lLVB3");
const $8cc1ee3e9af11276$var$URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const $8cc1ee3e9af11276$var$URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const $8cc1ee3e9af11276$var$FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function $8cc1ee3e9af11276$var$toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, 'g');
}
function $8cc1ee3e9af11276$export$d04549d631b8762d(cssText) {
    const urls = [];
    cssText.replace($8cc1ee3e9af11276$var$URL_REGEX, (raw, quotation, url)=>{
        urls.push(url);
        return raw;
    });
    return urls.filter((url)=>!(0, $lLVB3.isDataUrl)(url));
}
async function $8cc1ee3e9af11276$export$2be46bb7e96db87f(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? (0, $dCPPv.resolveUrl)(resourceURL, baseURL) : resourceURL;
        const contentType = (0, $8V5Rc.getMimeType)(resourceURL);
        let dataURL;
        if (getContentFromUrl) {
            const content = await getContentFromUrl(resolvedURL);
            dataURL = (0, $lLVB3.makeDataUrl)(content, contentType);
        } else dataURL = await (0, $lLVB3.resourceToDataURL)(resolvedURL, contentType, options);
        return cssText.replace($8cc1ee3e9af11276$var$toRegex(resourceURL), `$1${dataURL}$3`);
    } catch (error) {
    // pass
    }
    return cssText;
}
function $8cc1ee3e9af11276$var$filterPreferredFontFormat(str, { preferredFontFormat: preferredFontFormat }) {
    return !preferredFontFormat ? str : str.replace($8cc1ee3e9af11276$var$FONT_SRC_REGEX, (match)=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            const [src, , format] = $8cc1ee3e9af11276$var$URL_WITH_FORMAT_REGEX.exec(match) || [];
            if (!format) return '';
            if (format === preferredFontFormat) return `src: ${src};`;
        }
    });
}
function $8cc1ee3e9af11276$export$7b668369e5eab853(url) {
    return url.search($8cc1ee3e9af11276$var$URL_REGEX) !== -1;
}
async function $8cc1ee3e9af11276$export$3d88803585cbbc21(cssText, baseUrl, options) {
    if (!$8cc1ee3e9af11276$export$7b668369e5eab853(cssText)) return cssText;
    const filteredCSSText = $8cc1ee3e9af11276$var$filterPreferredFontFormat(cssText, options);
    const urls = $8cc1ee3e9af11276$export$d04549d631b8762d(filteredCSSText);
    return urls.reduce((deferred, url)=>deferred.then((css)=>$8cc1ee3e9af11276$export$2be46bb7e96db87f(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}

});


parcelRegister("FrxEM", function(module, exports) {

$parcel$export(module.exports, "applyStyle", () => $07c931b022560f33$export$d63a6b7859608045);
function $07c931b022560f33$export$d63a6b7859608045(node, options) {
    const { style: style } = node;
    if (options.backgroundColor) style.backgroundColor = options.backgroundColor;
    if (options.width) style.width = `${options.width}px`;
    if (options.height) style.height = `${options.height}px`;
    const manual = options.style;
    if (manual != null) Object.keys(manual).forEach((key)=>{
        style[key] = manual[key];
    });
    return node;
}

});

parcelRegister("8RwLg", function(module, exports) {

$parcel$export(module.exports, "getWebFontCSS", () => $673cafb05cbd0034$export$253c9aa3d83a57b6);
$parcel$export(module.exports, "embedWebFonts", () => $673cafb05cbd0034$export$2c2c83b77c8cb421);

var $dCPPv = parcelRequire("dCPPv");

var $lLVB3 = parcelRequire("lLVB3");

var $c5frv = parcelRequire("c5frv");
const $673cafb05cbd0034$var$cssFetchCache = {};
async function $673cafb05cbd0034$var$fetchCSS(url) {
    let cache = $673cafb05cbd0034$var$cssFetchCache[url];
    if (cache != null) return cache;
    const res = await fetch(url);
    const cssText = await res.text();
    cache = {
        url: url,
        cssText: cssText
    };
    $673cafb05cbd0034$var$cssFetchCache[url] = cache;
    return cache;
}
async function $673cafb05cbd0034$var$embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc)=>{
        let url = loc.replace(regexUrl, '$1');
        if (!url.startsWith('https://')) url = new URL(url, data.url).href;
        return (0, $lLVB3.fetchAsDataURL)(url, options.fetchRequestInit, ({ result: result })=>{
            cssText = cssText.replace(loc, `url(${result})`);
            return [
                loc,
                result
            ];
        });
    });
    return Promise.all(loadFonts).then(()=>cssText);
}
function $673cafb05cbd0034$var$parseCSS(source) {
    if (source == null) return [];
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, '');
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, '');
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) break;
            else importRegex.lastIndex = unifiedRegex.lastIndex;
        } else unifiedRegex.lastIndex = importRegex.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
async function $673cafb05cbd0034$var$getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet)=>{
        if ('cssRules' in sheet) try {
            (0, $dCPPv.toArray)(sheet.cssRules || []).forEach((item, index)=>{
                if (item.type === CSSRule.IMPORT_RULE) {
                    let importIndex = index + 1;
                    const url = item.href;
                    const deferred = $673cafb05cbd0034$var$fetchCSS(url).then((metadata)=>$673cafb05cbd0034$var$embedFonts(metadata, options)).then((cssText)=>$673cafb05cbd0034$var$parseCSS(cssText).forEach((rule)=>{
                            try {
                                sheet.insertRule(rule, rule.startsWith('@import') ? importIndex += 1 : sheet.cssRules.length);
                            } catch (error) {
                                console.error('Error inserting rule from remote css', {
                                    rule: rule,
                                    error: error
                                });
                            }
                        })).catch((e)=>{
                        console.error('Error loading remote css', e.toString());
                    });
                    deferreds.push(deferred);
                }
            });
        } catch (e) {
            const inline = styleSheets.find((a)=>a.href == null) || document.styleSheets[0];
            if (sheet.href != null) deferreds.push($673cafb05cbd0034$var$fetchCSS(sheet.href).then((metadata)=>$673cafb05cbd0034$var$embedFonts(metadata, options)).then((cssText)=>$673cafb05cbd0034$var$parseCSS(cssText).forEach((rule)=>{
                    inline.insertRule(rule, sheet.cssRules.length);
                })).catch((err)=>{
                console.error('Error loading remote stylesheet', err);
            }));
            console.error('Error inlining remote css file', e);
        }
    });
    return Promise.all(deferreds).then(()=>{
        // Second loop parses rules
        styleSheets.forEach((sheet)=>{
            if ('cssRules' in sheet) try {
                (0, $dCPPv.toArray)(sheet.cssRules || []).forEach((item)=>{
                    ret.push(item);
                });
            } catch (e) {
                console.error(`Error while reading CSS rules from ${sheet.href}`, e);
            }
        });
        return ret;
    });
}
function $673cafb05cbd0034$var$getWebFontRules(cssRules) {
    return cssRules.filter((rule)=>rule.type === CSSRule.FONT_FACE_RULE).filter((rule)=>(0, $c5frv.shouldEmbed)(rule.style.getPropertyValue('src')));
}
async function $673cafb05cbd0034$var$parseWebFontRules(node, options) {
    if (node.ownerDocument == null) throw new Error('Provided element is not within a Document');
    const styleSheets = (0, $dCPPv.toArray)(node.ownerDocument.styleSheets);
    const cssRules = await $673cafb05cbd0034$var$getCSSRules(styleSheets, options);
    return $673cafb05cbd0034$var$getWebFontRules(cssRules);
}
async function $673cafb05cbd0034$export$253c9aa3d83a57b6(node, options) {
    const rules = await $673cafb05cbd0034$var$parseWebFontRules(node, options);
    const cssTexts = await Promise.all(rules.map((rule)=>{
        const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
        return (0, $c5frv.embedResources)(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join('\n');
}
async function $673cafb05cbd0034$export$2c2c83b77c8cb421(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await $673cafb05cbd0034$export$253c9aa3d83a57b6(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement('style');
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        else clonedNode.appendChild(styleNode);
    }
}

});


parcelRegister("lYxW4", function(module, exports) {

$parcel$export(module.exports, "cdxIconArrowNext", () => $fff98676c7577ddf$export$762a0d3de84f4d81);
$parcel$export(module.exports, "cdxIconEdit", () => $fff98676c7577ddf$export$d6fb4db85f196eee);
$parcel$export(module.exports, "cdxIconLabFlask", () => $fff98676c7577ddf$export$19f4c64dfdaeee91);
$parcel$export(module.exports, "cdxIconLogoWikidata", () => $fff98676c7577ddf$export$5c12ea71f69a73a2);
$parcel$export(module.exports, "cdxIconOngoingConversation", () => $fff98676c7577ddf$export$6e7000a955d4e27c);
$parcel$export(module.exports, "cdxIconPlay", () => $fff98676c7577ddf$export$508f0988d770d488);
$parcel$export(module.exports, "cdxIconShare", () => $fff98676c7577ddf$export$c5152ec34a67c148);
$parcel$export(module.exports, "cdxIconTemplateAdd", () => $fff98676c7577ddf$export$158770cea961694b);
$parcel$export(module.exports, "cdxIconUpload", () => $fff98676c7577ddf$export$6a95885911251ca6);
$parcel$export(module.exports, "cdxIconUserTalk", () => $fff98676c7577ddf$export$188dca7f870a8168);
const $fff98676c7577ddf$var$H = '<path d="M11 9V4H9v5H4v2h5v5h2v-5h5V9z"/>', $fff98676c7577ddf$var$g = '<path d="M11.53 2.3A1.85 1.85 0 0010 1.21 1.85 1.85 0 008.48 2.3L.36 16.36C-.48 17.81.21 19 1.88 19h16.24c1.67 0 2.36-1.19 1.52-2.64zM11 16H9v-2h2zm0-4H9V6h2z"/>', $fff98676c7577ddf$var$x = '<path d="M1 15h18v2H1zM1 3h18v2H1z"/><rect width="8" height="6" x="6" y="7" rx="1"/>', $fff98676c7577ddf$var$V = '<path d="M12 7h7v2h-7zm0 4h7v2h-7zM1 15h18v2H1zM1 3h18v2H1z"/><rect width="8" height="6" x="1" y="7" rx="1"/>', $fff98676c7577ddf$var$u = '<path d="M1 7h7v2H1zm0 4h7v2H1zm0 4h18v2H1zM1 3h18v2H1z"/><rect width="8" height="6" x="11" y="7" rx="1"/>', $fff98676c7577ddf$var$L = '<path d="M1.2 9a4.25 4.25 0 017.9-.6 2.8 2.8 0 011.8 0 4.25 4.25 0 017.9.6 1.01 1.01 0 11.1 2 4.23 4.23 0 01-8.4-.6 1 1 0 00-1 0 4.23 4.23 0 01-8.4.6 1.01 1.01 0 11.1-2m4.05-1a2.25 2.25 0 000 4.5 2.25 2.25 0 000-4.5m9.5 0a2.25 2.25 0 000 4.5 2.25 2.25 0 000-4.5"/>', $fff98676c7577ddf$var$I = '<path d="M8.59 3.42 14.17 9H2v2h12.17l-5.58 5.59L10 18l8-8-8-8z"/>', $fff98676c7577ddf$var$A = '<path d="m5.83 9 5.58-5.58L10 2l-8 8 8 8 1.41-1.41L5.83 11H18V9z"/>', $fff98676c7577ddf$var$C = '<path d="M5 1a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V3a2 2 0 00-2-2zm0 3h5v1H5zm0 2h5v1H5zm0 2h5v1H5zm10 7H5v-1h10zm0-2H5v-1h10zm0-2H5v-1h10zm0-2h-4V4h4z"/>', $fff98676c7577ddf$var$k = '<path d="M5 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm10 10h-4v4H9v-4H5V9h4V5h2v4h4z"/>', $fff98676c7577ddf$var$y = '<path d="m9 17-4.59-4.59L5.83 11 9 14.17l8-8V3a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V9z"/>', $fff98676c7577ddf$var$F = '<path d="M15 1H5c-1.1 0-2 .9-2 2v6h4.6l3.7-3.7L10 4h4v4l-1.3-1.3L9.4 10l3.3 3.3L14 12v4h-4l1.3-1.3L7.6 11H3v6c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2"/>', $fff98676c7577ddf$var$f = '<path d="M15 1H5a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V3a2 2 0 00-2-2m-4 15H9v-2h2zm2.7-7.6a5 5 0 01-.3.7 2.7 2.7 0 01-.5.6l-.5.5a2.7 2.7 0 01-.6.5c-.2.2-.3.4-.5.6a1.9 1.9 0 00-.3.8 3.4 3.4 0 00-.1 1H9.1a5 5 0 01.1-1.2 3 3 0 01.2-.9 2.5 2.5 0 01.4-.7l.6-.6a1.8 1.8 0 01.5-.4c.2-.1.3-.3.4-.4l.3-.6a1.7 1.7 0 00.1-.7 3 3 0 00-.2-.9 2.2 2.2 0 00-1-.9.9.9 0 00-.5-.1 1.68 1.68 0 00-1.5.7A2.86 2.86 0 008 8.1H6.2a5.1 5.1 0 01.3-1.7 3.5 3.5 0 01.8-1.3 3.6 3.6 0 011.2-.8 5.1 5.1 0 011.7-.3 6 6 0 011.4.2 2.6 2.6 0 011.1.7 4.4 4.4 0 01.8 1.1 4 4 0 01.3 1.5 3 3 0 01-.1.9"/>', $fff98676c7577ddf$var$S = '<path d="M5 1a2 2 0 00-2 2v1c0 5 2 8 7 8V9l5 4-5 4v-3c-3.18 0-5.51-.85-7-2.68V17a2 2 0 002 2h10a2 2 0 002-2V3a2 2 0 00-2-2z"/>', $fff98676c7577ddf$var$b = '<path d="M7 0a2 2 0 00-2 2h9a2 2 0 012 2v12a2 2 0 002-2V2a2 2 0 00-2-2z"/><path d="M13 20a2 2 0 002-2V5a2 2 0 00-2-2H4a2 2 0 00-2 2v13a2 2 0 002 2zM9 5h4v5H9zM4 5h4v1H4zm0 2h4v1H4zm0 2h4v1H4zm0 2h9v1H4zm0 2h9v1H4zm0 2h9v1H4z"/>', $fff98676c7577ddf$var$q = '<path d="M12.43 14.34A5 5 0 0110 15a5 5 0 113.95-2L17 16.09V3a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 001.45-.63z"/><circle cx="10" cy="10" r="3"/>', $fff98676c7577ddf$var$T = '<path d="M7 0a2 2 0 00-2 2h9a2 2 0 012 2v12a2 2 0 002-2V2a2 2 0 00-2-2z"/><path d="M10.8 15.6a4.6 4.7 0 01-2.3.6 4.6 4.7 0 113.7-1.9l2.8 3V4.9A1.9 1.9 0 0013.1 3H4a1.9 1.9 0 00-2 1.9V18a1.9 1.9 0 001.9 2H13a1.9 1.9 0 001.4-.6z"/><circle cx="8.5" cy="11.5" r="3"/>', $fff98676c7577ddf$var$B = '<path d="M13 0a2 2 0 012 2H6a2 2 0 00-2 2v12a2 2 0 01-2-2V2a2 2 0 012-2z"/><path d="M13.8 15.5a4.6 4.7 0 01-2.3.6 4.6 4.7 0 113.7-1.9l2.8 3V5a1.9 1.9 0 00-1.9-2H7a1.9 1.9 0 00-2 1.9V18a1.9 1.9 0 001.9 2H16a1.9 1.9 0 001.4-.6z"/><circle cx="11.5" cy="11.5" r="3"/>', $fff98676c7577ddf$var$Z = '<path d="M9.5 19.75a4.25 4.25 0 01-4.25-4.25V9a2.75 2.75 0 015.5 0v6h-1.5V9a1.25 1.25 0 00-2.5 0v6.5a2.75 2.75 0 005.5 0V4a2.25 2.25 0 00-4.5 0v1h-1.5V4a3.75 3.75 0 017.5 0v11.5a4.25 4.25 0 01-4.25 4.25"/>', $fff98676c7577ddf$var$W = '<path d="M16 7a5.38 5.38 0 00-4.46-4.85C11.6 1.46 11.53 0 10 0S8.4 1.46 8.46 2.15A5.38 5.38 0 004 7v6l-2 2v1h16v-1l-2-2zm-6 13a3 3 0 003-3H7a3 3 0 003 3"/>', $fff98676c7577ddf$var$w = '<path d="M11.5 2.19C14.09 2.86 16 5.2 16 8v6l2 2v1H2v-1l2-2V8c0-2.8 1.91-5.14 4.5-5.81V1.5C8.5.67 9.17 0 10 0s1.5.67 1.5 1.5zM10 4C7.79 4 6 5.79 6 8v7h8V8c0-2.21-1.79-4-4-4M8 18h4c0 1.1-.9 2-2 2s-2-.9-2-2"/>', $fff98676c7577ddf$var$R = '<path d="M14 18h-1.57a.66.66 0 01-.44-.13.9.9 0 01-.25-.34l-1-2.77H5.3l-1 2.77a.8.8 0 01-.24.32.65.65 0 01-.44.15H2L7 5.47h2zm-3.85-4.7L8.42 8.72A13 13 0 018 7.37q-.1.41-.21.75t-.21.6L5.85 13.3zM15 2l3 4h-6z"/>', $fff98676c7577ddf$var$U = '<path d="M10 1a9 9 0 109 9 9 9 0 00-9-9m5 10H5V9h10z"/>', $fff98676c7577ddf$var$D = '<path d="M13.5 15h-7L5 19H1L8 1h4l7 18h-4Zm-6-3h5L10 4Z"/>', $fff98676c7577ddf$var$E = '<path d="M6.89 11.9c0 1.57 1.61 2.44 4.85 2.63l2.55-.04.37.05c-.03.14-.29.4-.77.76l-.1.07A6.97 6.97 0 019.63 17a4.3 4.3 0 01-3.16-1.16 4.3 4.3 0 01-1.13-3.15c0-1.58.66-3 1.96-4.27v-.05l-.7-.64A1.1 1.1 0 016.33 7c0-.58.28-1.3.84-2.18C7.93 3.6 8.7 3 9.46 3c1.03 0 1.89.49 2.56 1.45.38.56-.03.65-1.24.26q-1.47-.57-2.4.96l.02.1 1.31 1h.06c1.64-.57 2.82-.86 3.55-.84a5.5 5.5 0 00-.28.86 32 32 0 01-.36 1.14l-.14.44-.45.05c-2.04.28-3.5.84-4.37 1.67a2.5 2.5 0 00-.83 1.78"/>', $fff98676c7577ddf$var$P = '<path d="M15.5 6.6c.4 0 .7-.2.9-.4a1.3 1.3 0 000-1.8c-.2-.3-.5-.4-.9-.4s-.7.1-1 .4a1.3 1.3 0 000 1.8c.3.2.6.4 1 .4M9.8 14l.4-1 .6.2a10 10 0 002.6.2c1 0 1.8 0 2.5-.2s1.3-.4 1.7-.7A3 3 0 0019 10c0-.6-.1-1-.4-1.5a2 2 0 00-1-1c-.5-.3-1-.5-1.7-.5l-1.3.3c-.4 0-.8.3-1.2.5a8.7 8.7 0 00-2.3 2l-.7.8a.7.7 0 01-.2-.2l-.2-.3a28 28 0 00-.4-1.7l-.1-.3-2.8.7.1.3.5 1.6.2 1.3-.1.6-.4.5-.6.2a4 4 0 01-1 .1l-1-.1-.5-.5a1 1 0 01-.2-.6v-.4l.2-.4.2-.8.1-.3-2.4-.8-.1.3-.5 1.2a6.7 6.7 0 00-.2 1.6c0 .6.1 1 .4 1.5.2.5.5.8 1 1.1.4.3.9.5 1.4.6a7.2 7.2 0 003.4 0 5 5 0 001.5-.7l1.1-1Zm3.4-3c.3-.5 1.1-1.4 2.3-1.5 1 0 1 .8.5 1-.3.2-1.2.5-2.8.5"/>', $fff98676c7577ddf$var$N = '<path d="M11.61 13.756q-.655 0-1.12-.457a1.5 1.5 0 01-.463-1.106q0-.667.463-1.125.465-.477 1.12-.477.658 0 1.102.477.463.458.463 1.125 0 .648-.463 1.106a1.47 1.47 0 01-1.101.457ZM11.109 19a9.8 9.8 0 01-2.858-.4 6.7 6.7 0 01-2.26-1.183 5.2 5.2 0 01-1.468-1.887Q4 14.405 4 12.956q0-1.43.464-2.594a6.8 6.8 0 011.294-2.078A8.8 8.8 0 017.67 6.7q1.101-.686 2.357-1.125c.85-.292.914-.394 1.816-.534q-.6-.152-1.314-.286a24 24 0 00-1.487-.228 13 13 0 00-1.584-.096q-.773 0-1.507.076a9 9 0 00-1.236.21L4.232 1.38q.58-.151 1.255-.267A8.5 8.5 0 016.878 1q1.198 0 2.183.19 1.005.192 1.835.477.85.268 1.565.553.734.287 1.371.477.656.19 1.256.19h1.004l.387 3.662q-.6 0-1.507.171a15 15 0 00-1.913.515q-1.023.343-2.028.858a9.6 9.6 0 00-1.796 1.163 5.8 5.8 0 00-1.314 1.45 3.33 3.33 0 00-.483 1.754q0 .877.29 1.468.31.61.83.972.542.382 1.256.553.735.172 1.584.172 1.14 0 2.299-.229a13 13 0 002.337-.705L17 17.684q-1.584.705-3.11 1.01T11.108 19Z"/>', $fff98676c7577ddf$var$O = '<path d="M1 18V9c0-1.34.29-2.61.86-3.64a6.13 6.13 0 012.55-2.45C5.54 2.3 7.38 2 9 2c2.19 0 3.47.43 4.73 1.28A5.3 5.3 0 0116 7h3v3h-3c0 1.78-.27 2.73-1.16 3.69a4.55 4.55 0 01-3.48 1.44 5.5 5.5 0 01-2.5-.53 3.94 3.94 0 01-1.62-1.46 4.1 4.1 0 01-.58-2.17 3.6 3.6 0 011.26-2.94c.85-.7 2.1-1.06 3.74-1.06L13 7c0-.5-.76-1.03-1.47-1.4A5.2 5.2 0 009 5c-1.44 0-3 .04-4 1-.76.74-1 1.61-1 3v9zm12-8.42h-1.31c-.53 0-.97.12-1.3.35q-.51.33-.51 1.02c0 .44.1.82.3 1.13.23.3.62.44 1.2.44.51 0 .92-.2 1.23-.62.32-.41.39-1.19.39-2.32"/>', $fff98676c7577ddf$var$l = '<path d="M8.46 1q2.325 0 3.9.45c1.07.29 1.86.77 2.39 1.44.54.66.8 1.55.8 2.67 0 .68-.1 1.29-.31 1.84a3.34 3.34 0 01-.94 1.37c-.39.35-.98.63-1.55.73.59.12 1.23.4 1.7.7.48.3.85.74 1.13 1.31s.42 1.33.42 2.27c0 1.1-.26 2.04-.79 2.83a4.9 4.9 0 01-2.2 1.79q-1.455.6-3.45.6H3V1zm.41 7c1.09 0 1.83-.04 2.24-.4.43-.35.64-.86.64-1.53 0-.7-.25-1.38-.74-1.68s-1.27-.4-2.33-.4H7v4h1.87ZM7 11v5h2.14a3.3 3.3 0 002.34-.8 2.5 2.5 0 00.66-1.8c0-.45-.1-.85-.3-1.18a2 2 0 00-.95-.93 5.1 5.1 0 00-1.87-.3H7Z"/>', $fff98676c7577ddf$var$Q = '<path d="M4 19V1h12v3H8v4h1c2 0 3.62.14 4.72.61a5.27 5.27 0 012.48 1.95c.53.82.8 1.88.8 2.94 0 1.78-.78 3-2 4-1.2.97-3.35 1.5-6 1.5zm5-3a6.7 6.7 0 003.01-.68c.7-.37.99-.9.99-1.82 0-.96-.33-1.71-1.07-2.01A7.6 7.6 0 009 11H8v5z"/>', $fff98676c7577ddf$var$G = '<path d="M14 19H6v-2l2-1V4L6 3V1h8v2l-2 1v12l2 1z"/>', $fff98676c7577ddf$var$K = '<path d="M12 19H8V4H3V1h14v3h-5z"/>', $fff98676c7577ddf$var$d = '<path d="M4.5 10 1 3h4l3 7V3h4v7l3-7h4l-3.5 7 3.5 7h-4l-3-7v7H8v-7l-3 7H1z"/>', $fff98676c7577ddf$var$o = '<path d="M9 19H5V1h10v3H9v5h5v3H9z"/>', $fff98676c7577ddf$var$r = '<path d="M10 9h7v9a20.4 20.4 0 01-6.5 1 9.7 9.7 0 01-4.64-1.03 6.8 6.8 0 01-2.89-3.04A11.2 11.2 0 012 10a9.9 9.9 0 011.1-4.78A7.7 7.7 0 016.35 2.1C7.77 1.37 9.95 1 12 1c.97 0 1.48.1 2.42.3.93.19 1.81.37 2.58.7l-1 3c-.56-.28-1.5-.46-2.23-.64A9.2 9.2 0 0011.53 4c-1.12 0-2.1.34-2.94.83A5.05 5.05 0 006.66 6.9 6.7 6.7 0 006 10a9 9 0 00.48 3.09c.32.88.84 1.58 1.53 2.08.7.5 1.62.83 2.75.83.37 0 .8.02 1.08 0 .3-.03.66 0 1.16-.34V12h-3z"/>', $fff98676c7577ddf$var$J = '<path d="M10 19a6.4 6.4 0 01-3.15-.74 5.13 5.13 0 01-2.12-2.15A6.2 6.2 0 014 13c0-2.02.46-3.84 1.36-4.87a4.54 4.54 0 013.58-1.55c.61 0 1.15.07 1.6.21a22 22 0 011.15.41C12.5 7.5 13 8 13 8V6c0-1-.5-1.5-.5-1.5s-.5-.5-.97-.73c0 0-.53-.27-1.53-.3 0 0-.33-.02-.78.13-.42.14-.8.3-1.02.65-.16.25-.2.44-.2.75H5c-.02-.15 0-.4 0-.53 0-.77.02-1.2.5-1.76.5-.56 1.18-.98 2-1.27C8.35 1.14 8.97 1 10 1c1.18 0 2.5.21 3.34.65A4.54 4.54 0 0116 6v7c0 2-.51 3.25-1.53 4.36-1 1.1-2.57 1.64-4.47 1.64m0-3c.88 0 1.65-.06 2.07-.65.42-.6.64-1.37.64-2.3v-.47c0-1-.2-1.8-.57-2.42-.38-.61-1.07-.92-2.1-.92a2.1 2.1 0 00-1.83.94A5.44 5.44 0 007.58 13c0 1 .18 1.6.56 2.26.4.65.93.74 1.86.74"/>', $fff98676c7577ddf$var$z = '<path d="M5 19V1h4v15h7v3z"/>', $fff98676c7577ddf$var$e = '<path d="M18 19h-4L5 5v14H2V1h5l8 13c-.02-.84 0-1 0-2V1h3z"/>', $fff98676c7577ddf$var$Y = '<path d="m12 19 6-18h-4l-4 14L6 1H2l6 18z"/>', $fff98676c7577ddf$var$j = '<path d="M15 2a7.65 7.65 0 00-5 2 7.65 7.65 0 00-5-2H1v15h4a7.65 7.65 0 015 2 7.65 7.65 0 015-2h4V2zm2.5 13.5H14a4.38 4.38 0 00-3 1V5s1-1.5 4-1.5h2.5z"/><path d="M9 3.5h2v1H9z"/>', $fff98676c7577ddf$var$X = '<path d="M5 1a2 2 0 00-2 2v16l7-5 7 5V3a2 2 0 00-2-2z"/>', $fff98676c7577ddf$var$_ = '<path d="M5 1a2 2 0 00-2 2v16l7-5 7 5V3a2 2 0 00-2-2zm10 14.25-5-3.5-5 3.5V3h10z"/>', $fff98676c7577ddf$var$$ = '<path d="M17.07 7.07V2.93h-4.14L10 0 7.07 2.93H2.93v4.14L0 10l2.93 2.93v4.14h4.14L10 20l2.93-2.93h4.14v-4.14L20 10zM10 16a6 6 0 116-6 6 6 0 01-6 6"/><circle cx="10" cy="10" r="4.5"/>', $fff98676c7577ddf$var$c1 = '<path d="M2 2a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2zm2 1.5A1.5 1.5 0 112.5 5 1.5 1.5 0 014 3.5M18 16H2V8h16z"/>', $fff98676c7577ddf$var$a1 = '<path d="M15 3V1h-2v2H7V1H5v2H2a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V5a2 2 0 00-2-2zm3 14H2V8h16zm-2-6h-4v4h4z"/>', $fff98676c7577ddf$var$t1 = '<path d="M10 16c-4.455 0-6.685-5.386-3.535-8.535S15 6.545 15 11a5 5 0 01-5 5M6.42 2.56l-.67.64c-.37.357-.865.808-1.38.81H2C.914 4 0 4.712 0 5.76v10.48C0 17.27 1 18 2 18h16c1 0 2-.716 2-1.76V5.76C20 4.723 19 4 18 4h-2.37c-.515-.002-1.01-.453-1.38-.81l-.67-.64A2 2 0 0012.2 2H7.8a2 2 0 00-1.38.56"/><circle cx="10" cy="11" r="3"/>', $fff98676c7577ddf$var$h1 = '<path d="M10 0a10 10 0 1010 10A10 10 0 0010 0M2 10a8 8 0 011.69-4.9L14.9 16.31A8 8 0 012 10m14.31 4.9L5.1 3.69A8 8 0 0116.31 14.9"/>', $fff98676c7577ddf$var$o1 = '<path d="M3 3H1v16h18v-2H3z"/><path d="M11 11 8 9l-4 4v3h14V5z"/>', $fff98676c7577ddf$var$s1 = '<path d="M7 14.17 2.83 10l-1.41 1.41L7 17 19 5l-1.41-1.42z"/>', $fff98676c7577ddf$var$l1 = '<path d="m.29 12.71 1.42-1.42 2.22 2.22 8.3-10.14 1.54 1.26-9.7 11.86zM12 10h5v2h-5zm-3 4h5v2H9zm6-8h5v2h-5z"/>', $fff98676c7577ddf$var$n1 = '<path d="M10 0a10 10 0 1010 10A10 10 0 0010 0m5.66 14.24-1.41 1.41L10 11.41l-4.24 4.25-1.42-1.42L8.59 10 4.34 5.76l1.42-1.42L10 8.59l4.24-4.24 1.41 1.41L11.41 10z"/>', $fff98676c7577ddf$var$v1 = '<path d="M10 0a10 10 0 1010 10A10 10 0 0010 0m2.5 14.5L9 11V4h2v6l3 3z"/>', $fff98676c7577ddf$var$d1 = '<path d="m4.34 2.93 12.73 12.73-1.41 1.41L2.93 4.35z"/><path d="M17.07 4.34 4.34 17.07l-1.41-1.41L15.66 2.93z"/>', $fff98676c7577ddf$var$e1 = '<path id="cdx-icon-code-a" d="M1 10.08V8.92h1.15c1.15 0 1.15 0 1.15-1.15V5a7.4 7.4 0 01.09-1.3 2 2 0 01.3-.7 1.84 1.84 0 01.93-.68A6.4 6.4 0 016.74 2h1.18v1.15h-.86A1.32 1.32 0 006 3.62a1.7 1.7 0 00-.36 1.23V7a3.2 3.2 0 01-.28 1.72 2 2 0 01-1.26.77 2.15 2.15 0 011.26.79A3.26 3.26 0 015.62 12v3.15A1.67 1.67 0 006 16.37a1.31 1.31 0 001.08.47h.87V18H6.74a6.3 6.3 0 01-2.12-.29 1.82 1.82 0 01-.93-.71 1.9 1.9 0 01-.3-.72A7.5 7.5 0 013.31 15v-3.77c0-1.15 0-1.15-1.15-1.15zm18 0V8.92h-1.15c-1.15 0-1.15 0-1.15-1.15V5a7.4 7.4 0 00-.08-1.32 2 2 0 00-.3-.73 1.84 1.84 0 00-.93-.68A6.4 6.4 0 0013.26 2h-1.18v1.15h.87a1.32 1.32 0 011.05.47 1.7 1.7 0 01.36 1.23V7a3.2 3.2 0 00.28 1.72 2 2 0 001.26.77 2.15 2.15 0 00-1.26.79 3.26 3.26 0 00-.26 1.72v3.15a1.67 1.67 0 01-.38 1.22 1.31 1.31 0 01-1.08.47h-.87V18h1.19a6.3 6.3 0 002.12-.29 1.82 1.82 0 00.93-.68 1.9 1.9 0 00.3-.72 7.5 7.5 0 00.1-1.31v-3.77c0-1.15 0-1.15 1.15-1.15z"/><use xlink:href="#cdx-icon-code-a" transform="matrix(-1 0 0 1 20 0)"/>', $fff98676c7577ddf$var$r1 = '<path d="m2.5 15.25 7.5-7.5 7.5 7.5 1.5-1.5-9-9-9 9z"/>', $fff98676c7577ddf$var$z1 = '<path d="M3 3h8v2h2V3c0-1.1-.895-2-2-2H3c-1.1 0-2 .895-2 2v8c0 1.1.895 2 2 2h2v-2H3z"/><path d="M9 9h8v8H9zm0-2c-1.1 0-2 .895-2 2v8c0 1.1.895 2 2 2h8c1.1 0 2-.895 2-2V9c0-1.1-.895-2-2-2z"/>', $fff98676c7577ddf$var$i1 = '<path d="M9.97 0c-1.66 0-3 1.34-3 3v3l-2.4-1.5a3.003 3.003 0 00-3 5.2 3.003 3.003 0 004.452-2.051l.952.55v6.8h2v-5.65l4.01 2.32.988-1.73-5-2.94v-1.17a2.996 2.996 0 004-2.829c0-1.66-1.34-3-3-3zM9 3a1 1 0 012 0 1 1 0 01-2 0M2 7a1 1 0 012 0 1 1 0 01-2 0m15 12h-2v-2h2V9h-3V7h3c1.1 0 2 .895 2 2v8c0 1.1-.895 2-2 2m-6 0h2v-2h-2zm-4-2c0 1.1.895 2 2 2v-2z"/>', $fff98676c7577ddf$var$p1 = '<path d="M4 1h12l2 2v2H2V3zM2 8h16v4H2zm16 9v-2H2v2l2 2h12z"/>', $fff98676c7577ddf$var$m1 = '<path d="M3 1a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V3a2 2 0 00-2-2zm2 16a2 2 0 112-2 2 2 0 01-2 2M5 7a2 2 0 112-2 2 2 0 01-2 2m5 5a2 2 0 112-2 2 2 0 01-2 2m5 5a2 2 0 112-2 2 2 0 01-2 2m0-10a2 2 0 112-2 2 2 0 01-2 2"/>', $fff98676c7577ddf$var$M1 = '<path d="M11 2 9.7 3.3l6.6 6.7-6.6 6.7L11 18l8-8zM2.5 2 1 3.3 7.8 10l-6.7 6.7L2.5 18l8-8z"/>', $fff98676c7577ddf$var$H1 = '<path d="m9 2 1.3 1.3L3.7 10l6.6 6.7L9 18l-8-8zm8.5 0L19 3.3 12.2 10l6.7 6.7-1.4 1.3-8-8z"/>', $fff98676c7577ddf$var$g1 = '<path d="M10 15 2 5h16z"/>', $fff98676c7577ddf$var$x1 = '<path d="M17 12v5H3v-5H1v5a2 2 0 002 2h14a2 2 0 002-2v-5z"/><path d="M15 9h-4V1H9v8H5l5 6z"/>', $fff98676c7577ddf$var$V1 = '<path d="M2 11h16v2H2zm0-4h16v2H2zm11 8H7l3 3zM7 5h6l-3-3z"/>', $fff98676c7577ddf$var$u1 = '<path d="m16.77 8 1.94-2a1 1 0 000-1.41l-3.34-3.3a1 1 0 00-1.41 0L12 3.23zM1 14.25V19h4.75l9.96-9.96-4.75-4.75z"/>', $fff98676c7577ddf$var$L1 = '<path d="M12 12a2 2 0 01-2-2V5.25l-9 9V19h4.75l7-7zm7-8h-.5V2.5a2.5 2.5 0 00-5 0V4H13a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1V5a1 1 0 00-1-1m-3 4a1 1 0 111-1 1 1 0 01-1 1m1.5-4h-3V2.75C14.5 2 14.5 1 16 1s1.5 1 1.5 1.75z"/>', $fff98676c7577ddf$var$I1 = '<path d="M1 14.25V19h4.75l8.33-8.33-5.27-4.23zM13 2.86V0L8 4l5 4V5h.86c2.29 0 4 1.43 4 4.29H20a6.51 6.51 0 00-6.14-6.43z"/>', $fff98676c7577ddf$var$A1 = '<path d="M3 15.25V20h4.75l8.33-8.33-5.27-4.23z"/><path d="M13 2.86V0l5 4-5 4V5h-.86c-2.28 0-4 1.43-4 4.29H6a6.51 6.51 0 016.14-6.43z"/>', $fff98676c7577ddf$var$C1 = '<circle cx="10" cy="10" r="2"/><circle cx="3" cy="10" r="2"/><circle cx="17" cy="10" r="2"/>', $fff98676c7577ddf$var$k1 = '<path d="M13.728 1H6.272L1 6.272v7.456L6.272 19h7.456L19 13.728V6.272zM11 15H9v-2h2zm0-4H9V5h2z"/>', $fff98676c7577ddf$var$y1 = '<path d="M7 7V1H5v4H1v2zM5 19h2v-6H1v2h4zm10-4h4v-2h-6v6h2zm0-8h4V5h-4V1h-2v6z"/>', $fff98676c7577ddf$var$F1 = '<path d="m17.5 4.75-7.5 7.5-7.5-7.5L1 6.25l9 9 9-9z"/>', $fff98676c7577ddf$var$f1 = '<path d="M10 14.5a4.5 4.5 0 114.5-4.5 4.5 4.5 0 01-4.5 4.5M10 3C3 3 0 10 0 10s3 7 10 7 10-7 10-7-3-7-10-7"/><circle cx="10" cy="10" r="2.5"/>', $fff98676c7577ddf$var$S1 = '<path d="M12.49 9.94A2.5 2.5 0 0010 7.5z"/><path d="M8.2 5.9a4.4 4.4 0 011.8-.4 4.5 4.5 0 014.5 4.5 4.3 4.3 0 01-.29 1.55L17 14.14A14 14 0 0020 10s-3-7-10-7a9.6 9.6 0 00-4 .85zM2 2 1 3l2.55 2.4A13.9 13.9 0 000 10s3 7 10 7a9.7 9.7 0 004.64-1.16L18 19l1-1zm8 12.5A4.5 4.5 0 015.5 10a4.45 4.45 0 01.6-2.2l1.53 1.44a2.5 2.5 0 00-.13.76 2.49 2.49 0 003.41 2.32l1.54 1.45a4.47 4.47 0 01-2.45.73"/>', $fff98676c7577ddf$var$b1 = '<path d="M19 16 2 12a3.83 3.83 0 01-1-2.5A3.83 3.83 0 012 7l17-4z"/><rect width="4" height="8" x="4" y="9" rx="2"/>', $fff98676c7577ddf$var$q1 = '<path d="M17 6 3 1v18h2v-6.87z"/>', $fff98676c7577ddf$var$T1 = '<path d="M8 2H2a2 2 0 00-2 2v2h12z"/><rect width="20" height="14" y="4" rx="2"/>', $fff98676c7577ddf$var$B1 = '<path d="M13.263 0a4 4 0 00-3.846 2.901L8.246 7H5v2h2.674L6.66 12.55A2 2 0 014.737 14h-.131a2 2 0 01-1.665-.89l-.664-.997-1.664 1.11.664.996A4 4 0 004.606 16h.131a4 4 0 003.846-2.901L9.754 9H13V7h-2.674l1.014-3.55A2 2 0 0113.263 2h.132a2 2 0 011.664.89l.664.997 1.664-1.11-.664-.996A4 4 0 0013.395 0zm6.151 18-2.5-2.5 2.5-2.5L18 11.586l-2.5 2.5-2.5-2.5L11.586 13l2.5 2.5-2.5 2.5L13 19.414l2.5-2.5 2.5 2.5z"/>', $fff98676c7577ddf$var$Z1 = '<path d="M18 10a8 8 0 01-14.93 4H.832C2.375 17.532 5.9 20 10 20c5.523 0 10-4.477 10-10S15.523 0 10 0C5.9 0 2.375 2.468.832 6H3.07A8 8 0 0118 10M2.062 11H8v4l6-5-6-5v4H0v2z"/>', $fff98676c7577ddf$var$W1 = '<path d="M1 1v6h2V3h4V1zm2 12H1v6h6v-2H3zm14 4h-4v2h6v-6h-2zm0-16h-4v2h4v4h2V1z"/>', $fff98676c7577ddf$var$w1 = '<path d="M10 13 1 1h18z"/><path d="M8 9v8l4 2V9z"/>', $fff98676c7577ddf$var$R1 = '<path d="M12.2 17.94c1.26-2 2-4.45 2.14-7.06h3.86a8.26 8.26 0 01-6 7.06M1.8 10.88h3.86c.14 2.6.88 5.06 2.14 7.06a8.26 8.26 0 01-6-7.06m6-8.82c-1.26 2-2 4.45-2.14 7.07H1.8a8.26 8.26 0 016-7.07m4.79 8.82A12.5 12.5 0 0110 18a12.5 12.5 0 01-2.59-7.13zM7.4 9.13A12.5 12.5 0 0110 1.99a12.5 12.5 0 012.59 7.14zm10.8 0h-3.87a14.8 14.8 0 00-2.14-7.07 8.26 8.26 0 016 7.07M10 0a10 10 0 100 20 10 10 0 000-20"/>', $fff98676c7577ddf$var$U1 = '<path d="M17 6.67V3h-4.2L9.87.07 6.94 3H3v3.67L.07 9.6 3 12.53V17h3.94l2.93 2.93L12.8 17H17v-4.47l2.93-2.93zm-7 8.93v-12a6.21 6.21 0 016 6 6.21 6.21 0 01-6 6"/>', $fff98676c7577ddf$var$D1 = '<path d="M20 7h-7L10 .5 7 7H0l5.46 5.47-1.64 7 6.18-3.7 6.18 3.73-1.63-7zm-10 6.9V4.6l1.9 3.9h4.6l-3.73 3.4 1 4.28z"/>', $fff98676c7577ddf$var$E1 = '<path d="M18 4.6V17c0 1.9-.5 3-2.4 3H9.5c-.9 0-1.8-.4-2.4-1l-4.6-5-.5-1c0-1 .5-1 .5-1 .3 0 .6 0 1 .2L7 14V3.3C7 2.6 7.3 2 8 2c.6 0 1 .7 1 1.4V9h1V1.2c0-.6.3-1.2 1-1.2s1 .6 1 1.3V9h1V2c0-.7.3-1.3 1-1.3s1 .6 1 1.3v7h1V4.6c0-.7.3-1.3 1-1.3s1 .6 1 1.3"/>', $fff98676c7577ddf$var$P1 = '<path d="M14.75 1A5.24 5.24 0 0010 4 5.24 5.24 0 000 6.25C0 11.75 10 19 10 19s10-7.25 10-12.75A5.25 5.25 0 0014.75 1"/>', $fff98676c7577ddf$var$N1 = '<path d="M10.06 1C13 1 15 2.89 15 5.53a4.59 4.59 0 01-2.29 4.08c-1.42.92-1.82 1.53-1.82 2.71V13H8.38v-.81a3.84 3.84 0 012-3.84c1.34-.9 1.79-1.53 1.79-2.71a2.1 2.1 0 00-2.08-2.14h-.17a2.3 2.3 0 00-2.38 2.22v.17H5A4.71 4.71 0 019.51 1a5 5 0 01.55 0"/><circle cx="10" cy="17" r="2"/>', $fff98676c7577ddf$var$O1 = '<path d="M10 0a10 10 0 1010 10A10 10 0 0010 0m1 16H9v-2h2zm2.71-7.6a2.6 2.6 0 01-.33.74 3.2 3.2 0 01-.48.55l-.54.48c-.21.18-.41.35-.58.52a2.5 2.5 0 00-.47.56A2.3 2.3 0 0011 12a3.8 3.8 0 00-.11 1H9.08a9 9 0 01.07-1.25 3.3 3.3 0 01.25-.9 2.8 2.8 0 01.41-.67 4 4 0 01.58-.58c.17-.16.34-.3.51-.44a3 3 0 00.43-.44 1.8 1.8 0 00.3-.55 2 2 0 00.11-.72 2.1 2.1 0 00-.17-.86 1.7 1.7 0 00-1-.9 1.7 1.7 0 00-.5-.1 1.77 1.77 0 00-1.53.68 3 3 0 00-.5 1.82H6.16a4.7 4.7 0 01.28-1.68 3.6 3.6 0 01.8-1.29 3.9 3.9 0 011.28-.83A4.6 4.6 0 0110.18 4a4.4 4.4 0 011.44.23 3.5 3.5 0 011.15.65 3.1 3.1 0 01.78 1.06 3.5 3.5 0 01.29 1.45 3.4 3.4 0 01-.13 1.01"/>', $fff98676c7577ddf$var$Q1 = '<path d="M15 11h-3.75l2.55-3.4a4.75 4.75 0 10-7.6 0L8.75 11H5v2h4v7h2v-7h4zM7.54 3.52A2.75 2.75 0 1112.2 6.4L10 9.33 7.8 6.4a2.69 2.69 0 01-.26-2.88"/>', $fff98676c7577ddf$var$G1 = '<path d="M15.14 2.27a1 1 0 00-1.41 0l-10 10a1 1 0 000 1.41L4 14l-3 4h5l1-1 .29.29a1 1 0 001.41 0l10-10a1 1 0 00.03-1.43zM7 15l-2-2 9-9 2 2z"/>', $fff98676c7577ddf$var$K1 = '<path d="M9 6v5h.06l2.48 2.47 1.41-1.41L11 10.11V6z"/><path d="M10 1a9 9 0 00-7.85 13.35L.5 16H6v-5.5l-2.38 2.38A7 7 0 1110 17v2a9 9 0 000-18"/>', $fff98676c7577ddf$var$J1 = '<path d="M10 1 0 10h3v9h4v-4.6c0-1.47 1.31-2.66 3-2.66s3 1.19 3 2.66V19h4v-9h3z"/>', $fff98676c7577ddf$var$Y1 = '<path d="M2 2a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2zm-.17 13 4.09-5.25 2.92 3.51L12.92 8l5.25 7z"/>', $fff98676c7577ddf$var$j1 = '<path d="M16 17H2l3.5-4.5 2.5 3 3.5-4.5.5.67V8H8V6H2a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2v-6h-5.75z"/><path d="M16 4V0h-2v4h-4v2h4v4h2V6h4V4z"/>', $fff98676c7577ddf$var$X1 = '<path d="M12 6v2H8v4H2v6a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2zM3.83 17l3.55-4.5 2.52 3 3.55-4.5L18 17zM4 10h2V6h4V4H6V0H4v4H0v2h4z"/>', $fff98676c7577ddf$var$_1 = '<path d="M16.67 9.47 20 12.13v4.09A2 2 0 0117.78 18H2.22A2 2 0 010 16.22v-5.86L3.33 13l4.45-3.53L12.22 13z"/><path d="M20 9.64 16.67 7l-4.44 3.56L7.78 7l-4.45 3.53L0 7.87V3.78A2 2 0 012.22 2h15.56A2 2 0 0120 3.78z"/>', $fff98676c7577ddf$var$$1 = '<path d="M3 5a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2zm0 11 3.5-4.5 2.5 3 3.5-4.5 4.5 6zM16 2a2 2 0 012 2H2a2 2 0 012-2z"/>', $fff98676c7577ddf$var$c0 = '<path d="M1 3v14h18V3zm17 13H2V4h16z"/><path d="M8.58 14h.81l3.11-4 3 4H17l-4.5-6L9 12.51 6.5 9.5 3 14h1.56l1.94-2.5z"/>', $fff98676c7577ddf$var$a0 = '<path d="M3 2a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2zm0 15a1 1 0 01-1-1V4a1 1 0 011-1h14a1 1 0 011 1v12a1 1 0 01-1 1z"/><path d="M17 4H3v12h14zM5 13l2.5-3 2 2L12 9l3 4z"/>', $fff98676c7577ddf$var$t0 = '<path d="M19 3H1v14h18zM3 14l3.5-4.5 2.5 3L12.5 8l4.5 6z"/><path d="M19 5H1V3h18zm0 12H1v-2h18z"/>', $fff98676c7577ddf$var$h0 = '<path d="M3 2a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2zm0 15a1 1 0 01-1-1V4a1 1 0 011-1h14a1 1 0 011 1v12a1 1 0 01-1 1z"/><path d="M17 4H3v10h14zM5 12l2.5-3 2 2L12 8l3 4zm-1 3h12v1H4z"/>', $fff98676c7577ddf$var$o0 = '<path d="M16 17H2l3.5-4.5 2.5 3 3-3.81A2 2 0 0110 10V6H2a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2v-6h-5.75z"/><path d="M19 4h-.5V2.5a2.5 2.5 0 00-5 0V4H13a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1V5a1 1 0 00-1-1m-3 4a1 1 0 111-1 1 1 0 01-1 1m1.5-4h-3V2.75C14.5 2 14.5 1 16 1s1.5 1 1.5 1.75z"/>', $fff98676c7577ddf$var$s0 = '<path d="M8 5a1 1 0 00-1-1h-.5V2.5A2.45 2.45 0 004 0a2.45 2.45 0 00-2.5 2.5V4H1a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1zM4 8a1 1 0 111-1 1 1 0 01-1 1m1.5-4h-3V2.75C2.5 2 2.5 1 4 1s1.5 1 1.5 1.75zM10 6v4a2 2 0 01-2 2H2v6a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2zM4 17l3.54-4.5 2.53 3 3.54-4.5 4.56 6z"/>', $fff98676c7577ddf$var$l0 = '<path d="M1 16h18v2H1zm8-9h10v2H9zm0 4h10v2H9zM1 2h18v2H1zm5 8-5 4V6z"/>', $fff98676c7577ddf$var$n0 = '<path d="M8.703 1.845 4.641 7.65l-.099.148L3 10l1.542 2.203q.048.076.1.148l2.914 4.164 1.147 1.64a2 2 0 01-2.783-.496l-4.558-6.512a2 2 0 010-2.294L5.92 2.341a2 2 0 012.783-.496m-2.341 9.302 4.558 6.512a2 2 0 003.277 0l4.559-6.512a2 2 0 000-2.294l-4.559-6.512a2 2 0 00-3.277 0L6.362 8.853a2 2 0 000 2.294m7.835-8.806L12.56 3.488 17.117 10l-4.558 6.512-1.639 1.147 1.639-1.147L8 10l4.559-6.512z"/>', $fff98676c7577ddf$var$p = '<path d="M8 19a1 1 0 001 1h2a1 1 0 001-1v-1H8zm9-12a7 7 0 10-12 4.9S7 14 7 15v1a1 1 0 001 1h4a1 1 0 001-1v-1c0-1 2-3.1 2-3.1A7 7 0 0017 7"/>', $fff98676c7577ddf$var$v0 = '<path d="M6 3H5V1h1c.768 0 1.47.289 2 .764A3 3 0 0110 1h1v2h-1a1 1 0 00-1 1v12a1 1 0 001 1h1v2h-1c-.768 0-1.47-.289-2-.764A3 3 0 016 19H5v-2h1a1 1 0 001-1V4a1 1 0 00-1-1m6 12h6a2 2 0 002-2V7a2 2 0 00-2-2h-6v2h6v6h-6zm-8-2v2H2a2 2 0 01-2-2V7a2 2 0 012-2h2v2H2v6z"/>', $fff98676c7577ddf$var$d0 = '<path d="M4 10a6 6 0 1012 0 6 6 0 00-12 0m6-8a8 8 0 110 16 8 8 0 010-16m1 7v5H9V9zm0-1V6H9v2z"/>', $fff98676c7577ddf$var$e0 = '<path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0M9 5h2v2H9zm0 4h2v6H9z"/>', $fff98676c7577ddf$var$r0 = '<path d="m3 19 9.992-18H16l2 18h-3l-.4-5H8.5L6 19zm7-8h4.5c-.051-.69-.483-6.429-.5-7-.255.588-3.693 6.361-4 7"/>', $fff98676c7577ddf$var$z0 = '<path d="M10.7 11.8h-1l-1.1-.5a2 2 0 01-.7-1V8.8a10.7 10.7 0 00-3 1.5l-1 1a3 3 0 00-.6 1.3v1c.1.4.3.6.5.8l.9.4 1.1.1c.6 0 1 0 1.6-.2.6 0 1.1-.2 1.7-.4l.3 1.8a11 11 0 01-4.1.9c-.7 0-1.4 0-2-.3-.5-.1-1-.4-1.3-.8a2 2 0 01-.8-1.2C1 14 1 13.6 1 12.9a5 5 0 01.6-1.7c.3-.6.7-1 1.1-1.5a9.6 9.6 0 014.7-2.3 25 25 0 00-2-.4 6.7 6.7 0 00-2 0h-.8V5a10.4 10.4 0 011.9-.2 6.7 6.7 0 012.5.4l1 .4 1 .3.9.2h.6l-.2 2.2-1 .1V9h.1c0 .3.2.5.4.6l.7.2H14a.8.8 0 00.5-.2l.1-.3-.1-.6-.6-.9a31 31 0 00-1.4-1.4V6a4.7 4.7 0 01.2-1l.2-.3.9-.6a23 23 0 012.9-1.4l1.7-.7.5 1.8a188 188 0 00-4 1.8 8.8 8.8 0 001.5 2c.2.4.4.7.4 1v1l-.3.7-.7.8-1.3.5-1.8.2h-2.1Zm-5.4 1.6c.1.2.4.3.7.3s.5-.1.8-.3l.4-.7c0-.3 0-.6-.2-.8a.8.8 0 00-.6-.3l-.9.3-.4.8c0 .2 0 .5.2.7"/>', $fff98676c7577ddf$var$i0 = '<path d="M6.29 19a54 54 0 01-.73-2.88 31 31 0 01-.42-2.47A15 15 0 015 11.79q0-1.455.54-2.43a4.2 4.2 0 011.43-1.57 6 6 0 011.99-.84 9.3 9.3 0 012.2-.22c.74.01 1.45.08 2.1.22a4 4 0 00-.12-1.3 2.8 2.8 0 00-.46-1.07 2.1 2.1 0 00-.75-.7 1.9 1.9 0 00-.99-.27 2.2 2.2 0 00-.96.22 3 3 0 00-.89.66c-.28.3-.54.67-.79 1.1L6.17 4.48c.42-.85.9-1.53 1.43-2.03.54-.5 1.11-.86 1.7-1.09A4.9 4.9 0 0111.1 1c.89 0 1.64.18 2.27.53a4.2 4.2 0 011.52 1.4c.39.55.67 1.16.84 1.8A6.5 6.5 0 0116 6.58a6.8 6.8 0 01-.89 3.23 20 20 0 00-2.41-.48 9.8 9.8 0 00-2.04-.1 4.2 4.2 0 00-1.54.36 2.16 2.16 0 00-1 .86c-.24.39-.36.87-.36 1.46 0 .55.05 1.18.14 1.9.1.73.23 1.48.4 2.26s.37 1.55.58 2.32l-2.6.62Z"/>', $fff98676c7577ddf$var$p0 = '<path d="m8.5 16 .37-2.28c1.34 0 2.5-.04 3.5-.12.99-.07 1.8-.2 2.45-.34a3.54 3.54 0 001.43-.62c.33-.27.49-.6.49-.99 0-.48-.09-1.04-.25-1.68a18 18 0 00-.62-2.01l2.12-.66a19 19 0 01.85 2.9c.1.49.16.95.16 1.37a3.8 3.8 0 01-.52 2.03 3.8 3.8 0 01-1.74 1.37c-.8.35-1.88.61-3.25.78S10.55 16 8.5 16m0 0c-1.3 0-2.57-.1-3.5-.29a6.9 6.9 0 01-2.26-.81c-.6-.36-1.03-.8-1.32-1.32A3.64 3.64 0 011 11.8a10.8 10.8 0 01.35-2.3l.29-1.06 2.05.5-.18.74a18 18 0 00-.17.77 5 5 0 00-.06.72c0 .54.17 1 .5 1.39q.525.585 1.74.87c.82.2 1.92.29 3.33.29l.39 1.66zm3.06-8.58a1.2 1.2 0 01-.86-.35 1.2 1.2 0 01-.34-.85 1.2 1.2 0 01.34-.85c.24-.25.52-.37.86-.37.32 0 .6.12.83.37a1.2 1.2 0 01.34.85 1.2 1.2 0 01-.34.85 1.13 1.13 0 01-.84.35ZM8.47 7.4a1.22 1.22 0 01-.87-.35 1.14 1.14 0 01-.35-.83 1.2 1.2 0 01.35-.85c.23-.25.52-.37.87-.37.32 0 .6.12.83.37a1.2 1.2 0 01.35.85c0 .32-.12.6-.35.83s-.5.35-.83.35"/>', $fff98676c7577ddf$var$m0 = '<path d="M4.37 1 17 3.183l-.297 2.158-4.918-.859a14.2 14.2 0 00-2.718 2.305 10.7 10.7 0 00-1.83 2.723q-.642 1.447-.642 2.893 0 2.035 1.038 3.237 1.063 1.202 2.892 1.202 2.076 0 2.966-1.128t.89-3.041v-1.079H17v1.226q0 2.845-1.68 4.512Q13.637 19 10.524 19q-2.002 0-3.485-.81a5.73 5.73 0 01-2.25-2.304q-.79-1.497-.79-3.483 0-1.52.643-3.09a11.6 11.6 0 011.754-2.967 12 12 0 012.521-2.379l-4.844-.833L4.371 1Z"/>', $fff98676c7577ddf$var$v = '<path d="M9 19c-2.01 0-3.26-.6-4.35-1.81S3 14.32 3 12.25a14.05 14.05 0 011.47-6.23 11 11 0 011.87-2.58 8 8 0 012.65-1.79 10.16 10.16 0 015.92-.4 7.8 7.8 0 012.09.8L15.94 4.2a9 9 0 00-1.54-.66 6.3 6.3 0 00-1.94-.27 5.6 5.6 0 00-3 .78 6.6 6.6 0 00-2.09 2.11c-.54.87-.95 1.83-1.23 2.87a12.8 12.8 0 00-.39 3.12 5 5 0 001.03 3.36c.7.8 1.71 1.2 3.02 1.2.67 0 1.34-.07 2-.22a16 16 0 001.93-.57v2.28a13.6 13.6 0 01-4.73.79Z"/>', $fff98676c7577ddf$var$M0 = '<path d="M2 19 6 1h4.6c2.29 0 4.17.59 5.46 1.76C17.36 3.94 18 5.72 18 8.09c0 2.14-.42 4.03-1.28 5.68a9.36 9.36 0 01-3.74 3.85A12 12 0 017 19zm5.16-2.3c1.71 0 3.16-.38 4.33-1.15a7.37 7.37 0 002.66-3.1c.6-1.3.9-2.74.9-4.34 0-1.68-.43-2.9-1.28-3.66a4.86 4.86 0 00-3.4-1.16H8.33l-3 13.42h1.83Z"/>', $fff98676c7577ddf$var$H0 = '<path d="M4 19 8 1h9l-.6 2H10L8.6 9H15l-.6 2H8.2L7 17h6.5l-.5 2z"/>', $fff98676c7577ddf$var$g0 = '<path d="M10.5 19c-1.08 0-2.1-.22-2.93-.65a4.9 4.9 0 01-1.91-1.76 4.77 4.77 0 01-.66-2.5c0-.42.04-.82.11-1.2A4.5 4.5 0 015.4 12h2.3a6 6 0 00-.3 1.84 3.8 3.8 0 00.32 1.56c.21.48.54.87.98 1.17.46.31 1.1.43 1.79.43.71 0 1.22-.12 1.67-.43a2.74 2.74 0 001-1.29c.23-.52.35-1.12.35-1.78q0-1.05-.39-1.89A2.7 2.7 0 0012 10.4a3.05 3.05 0 00-1.77-.4H9V8h1.33a3.2 3.2 0 001.64-.47c.4-.25.7-.57.89-.94a2.8 2.8 0 00-.03-2.44 2.3 2.3 0 00-.84-.9S11.52 3 11 3V1c.96 0 1.47.19 2.2.56.73.36 1.3.85 1.7 1.47a3.5 3.5 0 01.64 2.03c0 .96-.3 1.77-.88 2.43-.58.64-1.2 1.3-2.16 1.51.64.09 1.09.2 1.63.58.56.38 1.01.9 1.35 1.58.35.66.52 1.49.52 2.48a5.4 5.4 0 01-.7 2.81 4.63 4.63 0 01-1.94 1.87 5.7 5.7 0 01-2.86.68"/>', $fff98676c7577ddf$var$t = '<path d="m5 19 .33-1.51 2.17-.66 2.9-13.66-1.9-.63L9 1h7l-.71 1.6-2.29.57-2.83 13.66 2.14.66L12 19z"/>', $fff98676c7577ddf$var$a = '<path d="M2 19 6 1h3L7 9.5 15 1h3l-8.5 9 5.5 9h-3l-5-9-2 9z"/>', $fff98676c7577ddf$var$x0 = '<path d="M8 19q-1.254 0-2.225-.22C5.128 18.632 4.536 18.294 4 18v-2.36q.828.442 1.799.785.994.32 2.225.319a5.1 5.1 0 001.775-.294 2.84 2.84 0 001.325-.932q.498-.638.497-1.619c-.001-.981-.205-1.201-.615-1.643q-.615-.687-1.965-1.52-.851-.54-1.538-1.153a5.1 5.1 0 01-1.089-1.447q-.402-.834-.402-1.986 0-1.594.734-2.747A4.94 4.94 0 018.78 1.638Q10.06 1 11.645 1q1.326 0 2.367.294 1.041.27 1.988.785l-.947 2.134a9.3 9.3 0 00-1.61-.638 5.6 5.6 0 00-1.798-.294q-1.302 0-2.13.71-.828.712-.829 1.963 0 1.079.568 1.667.592.565 1.728 1.3.995.637 1.728 1.3.734.637 1.112 1.471.403.81.403 1.962 0 1.765-.805 2.967-.78 1.178-2.201 1.79Q9.823 19.001 8 19"/>', $fff98676c7577ddf$var$V0 = '<path d="M2 18.5A1.5 1.5 0 003.5 20H5V0H3.5A1.5 1.5 0 002 1.5zM6 0v20h10a2 2 0 002-2V2a2 2 0 00-2-2zm7 8H8V7h5zm3-2H8V5h8z"/>', $fff98676c7577ddf$var$u0 = '<path d="M15 6a1.54 1.54 0 01-1.5-1.5 1.5 1.5 0 013 0A1.54 1.54 0 0115 6m-1.5-5A5.55 5.55 0 008 6.5a6.8 6.8 0 00.7 2.8L1 17v2h4v-2h2v-2h2l3.2-3.2a6 6 0 001.3.2A5.55 5.55 0 0019 6.5 5.55 5.55 0 0013.5 1"/>', $fff98676c7577ddf$var$L0 = '<path d="M0 15a2 2 0 002 2h16a2 2 0 002-2V5a2 2 0 00-2-2H2a2 2 0 00-2 2zm9-9h2v2H9zm0 3h2v2H9zM6 6h2v2H6zm0 3h2v2H6zm-1 5H3v-2h2zm0-3H3V9h2zm0-3H3V6h2zm9 6H6v-2h8zm0-3h-2V9h2zm0-3h-2V6h2zm3 6h-2v-2h2zm0-3h-2V9h2zm0-3h-2V6h2z"/>', $fff98676c7577ddf$var$I0 = '<path d="M13 7.61V3h1V1H6v2h1v4.61l-5.86 9.88A1 1 0 002 19h16a1 1 0 00.86-1.51zm-4.2.88a1 1 0 00.2-.6V3h2v4.89a1 1 0 00.14.51l2.14 3.6H6.72z"/>', $fff98676c7577ddf$var$A0 = '<path d="M20 18h-1.44a.6.6 0 01-.4-.12.8.8 0 01-.23-.31L17 15h-5l-1 2.54a.8.8 0 01-.22.3.6.6 0 01-.4.14H9l4.55-11.47h1.89zm-3.53-4.31L14.89 9.5a12 12 0 01-.39-1.24q-.09.37-.19.69l-.19.56-1.58 4.19zm-6.3-1.58a13.4 13.4 0 01-2.91-1.41 11.46 11.46 0 002.81-5.37H12V4H7.31a4 4 0 00-.2-.56C6.87 2.79 6.6 2 6.6 2l-1.47.5s.4.89.6 1.5H0v1.33h2.15A11.23 11.23 0 005 10.7a17.2 17.2 0 01-5 2.1q.56.82.87 1.38a23.3 23.3 0 005.22-2.51 15.6 15.6 0 003.56 1.77zM3.63 5.33h4.91a8.1 8.1 0 01-2.45 4.45 9.1 9.1 0 01-2.46-4.45"/>', $fff98676c7577ddf$var$C0 = '<path d="M17.66 18h-2a.85.85 0 01-.56-.17 1.1 1.1 0 01-.32-.43l-1.33-3.53h-6.9L5.22 17.4a1.06 1.06 0 01-.31.41.83.83 0 01-.56.19h-2L8.68 2h2.63zm-4.92-6-2.2-5.84A16 16 0 0110 4.43q-.12.52-.27 1t-.27.77L7.26 12z"/>', $fff98676c7577ddf$var$k0 = '<path d="M8 12V1H1v18h18v-7z"/><path d="M11 1v8h8V1zm6 6h-4V3h4z"/>', $fff98676c7577ddf$var$y0 = '<path d="M4.83 15h2.91a4.9 4.9 0 01-1.55-2H5a3 3 0 110-6h3a3 3 0 012.82 4h2.1a5 5 0 00.08-.83v-.34A4.83 4.83 0 008.17 5H4.83A4.83 4.83 0 000 9.83v.34A4.83 4.83 0 004.83 15"/><path d="M15.17 5h-2.91a4.9 4.9 0 011.55 2H15a3 3 0 110 6h-3a3 3 0 01-2.82-4h-2.1a5 5 0 00-.08.83v.34A4.83 4.83 0 0011.83 15h3.34A4.83 4.83 0 0020 10.17v-.34A4.83 4.83 0 0015.17 5"/>', $fff98676c7577ddf$var$F0 = '<path d="M19 1h-8l3.286 3.286L6 12l1.371 1.472 8.332-7.77.007.008L19 9zM2 5h4v2H3v10h10v-4.004h2V18a1 1 0 01-1 1H2a1 1 0 01-1-1V6a1 1 0 011-1"/>', $fff98676c7577ddf$var$f0 = '<path d="M16.07 8H15V5s0-5-5-5-5 5-5 5v3H3.93A1.93 1.93 0 002 9.93v8.15A1.93 1.93 0 003.93 20h12.14A1.93 1.93 0 0018 18.07V9.93A1.93 1.93 0 0016.07 8M7 5.5C7 4 7 2 10 2s3 2 3 3.5V8H7zM10 16a2 2 0 112-2 2 2 0 01-2 2"/>', $fff98676c7577ddf$var$S0 = '<path d="M7 15h12v2H7zm0-6h12v2H7zm0-6h12v2H7z"/><circle cx="3" cy="4" r="2"/><circle cx="3" cy="10" r="2"/><circle cx="3" cy="16" r="2"/>', $fff98676c7577ddf$var$b0 = '<path d="M7 15h12v2H7zm0-6h12v2H7zm0-6h12v2H7zM2 6h1V1H1v1h1zm1 9v1H2v1h1v1H1v1h3v-5H1v1zM1 8v1h2v1H1.5a.5.5 0 00-.5.5V13h3v-1H2v-1h1.5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5z"/>', $fff98676c7577ddf$var$q0 = '<path d="M2 15h11v2H2zm0-6h11v2H2zm0-6h11v2H2zm15-2h-1v1h1v4h1V1zm-2 12v1h2v1h-1v1h1v1h-2v1h3v-5zm0-6v1h2v1h-1.5c-.3 0-.5.2-.5.5V12h3v-1h-2v-1h1.5c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5z"/>', $fff98676c7577ddf$var$T0 = '<path d="M16.07 8H15V5s0-5-5-5-5 5-5 5v3H3.93A1.93 1.93 0 002 9.93v8.15A1.93 1.93 0 003.93 20h12.14A1.93 1.93 0 0018 18.07V9.93A1.93 1.93 0 0016.07 8M10 16a2 2 0 112-2 2 2 0 01-2 2m3-8H7V5.5C7 4 7 2 10 2s3 2 3 3.5z"/>', $fff98676c7577ddf$var$B0 = '<path d="M1 11v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v6h8V5l4.75 5L9 15v-4z"/>', $fff98676c7577ddf$var$Z0 = '<path d="M3 3h8V1H3a2 2 0 00-2 2v14a2 2 0 002 2h8v-2H3z"/><path d="M13 5v4H5v2h8v4l6-5z"/>', $fff98676c7577ddf$var$W0 = '<path d="M10 18a8 8 0 118-8 8 8 0 01-8 8m0-18A9.94 9.94 0 000 10a9.94 9.94 0 0010 10 9.94 9.94 0 0010-10A9.94 9.94 0 0010 0"/><path d="M13.49 11.67c-1 0-1.43-.57-1.43-1.71s.43-1.71 1.43-1.71c.57 0 .86.29 1.14.86l1.29-.71A2.8 2.8 0 0013.2 7a2.9 2.9 0 00-2.14.86A2.7 2.7 0 0010.2 10a3 3 0 00.86 2.29 2.9 2.9 0 002.14.86 3.24 3.24 0 002.71-1.57L14.63 11a1.46 1.46 0 01-1.14.71zm-6 0c-1 0-1.43-.57-1.43-1.71s.43-1.71 1.43-1.71c.57 0 .86.29 1.14.86l1.29-.71A2.8 2.8 0 007.2 7a2.9 2.9 0 00-2.14.86A2.7 2.7 0 004.2 10a3 3 0 00.86 2.29 2.9 2.9 0 002.14.86 3.24 3.24 0 002.71-1.57L8.63 11a1.46 1.46 0 01-1.14.71z"/>', $fff98676c7577ddf$var$w0 = '<g transform="translate(10 10)"><g id="cdx-icon-logo-MediaWiki-b"><path id="cdx-icon-logo-MediaWiki-a" d="M0 10c-2.9-3.3-.8-5.9 0-5.9S2.9 6.7 0 10"/><use xlink:href="#cdx-icon-logo-MediaWiki-a" transform="rotate(15)"/><use xlink:href="#cdx-icon-logo-MediaWiki-a" transform="rotate(30)"/><use xlink:href="#cdx-icon-logo-MediaWiki-a" transform="rotate(45)"/><use xlink:href="#cdx-icon-logo-MediaWiki-a" transform="rotate(60)"/><use xlink:href="#cdx-icon-logo-MediaWiki-a" transform="rotate(75)"/></g><use xlink:href="#cdx-icon-logo-MediaWiki-b" transform="rotate(90)"/><use xlink:href="#cdx-icon-logo-MediaWiki-b" transform="rotate(180)"/><use xlink:href="#cdx-icon-logo-MediaWiki-b" transform="rotate(270)"/></g>', $fff98676c7577ddf$var$R0 = '<path d="M5.346 1.15A10 10 0 019.991 0a9.96 9.96 0 014.652 1.146 10 10 0 013.585 3.187l-1.932 1.108a7.8 7.8 0 00-2.762-2.375 7.75 7.75 0 00-9.835 2.375L1.767 4.333A10 10 0 015.346 1.15m-.197 4.294A6.7 6.7 0 017.034 4.04c-.419.41-.786.869-1.093 1.368q-.395.045-.792.036m2.56-1.683-.048.002v.017l.048-.02Zm0 0a7.2 7.2 0 011.622.118 7 7 0 00.527-.554 6.6 6.6 0 00-2.15.436Zm-1.18 1.544q.352-.5.787-.927l.26.603q-.51.21-1.047.324m1.197-1.1L7.724 4.2v.006h.002Zm0 0 .255.594q.468-.24.892-.554a6.6 6.6 0 00-1.147-.04m2.127-.207a7 7 0 00.57-.648v.006a6.7 6.7 0 012.999.922 9.5 9.5 0 01-.809 1.144 7.2 7.2 0 00-2.76-1.424M3.462 8.711a6.75 6.75 0 011.317-2.844v.006q.446.03.894 0a7.2 7.2 0 00-.809 3.004 10 10 0 01-1.402-.166m6.002-4.35.008-.006-.011.006zm0 0a6.5 6.5 0 01-1.295.845l1.19 2.768a9.5 9.5 0 002.964-2.215 6.74 6.74 0 00-2.859-1.397Zm-3.252 1.46.002-.004-.01.006.008-.001Zm0 0a6.8 6.8 0 00-.914 3.07 9.5 9.5 0 003.635-.745l-1.19-2.752a6.6 6.6 0 01-1.531.428Zm7.577-1.29.005-.01-.01.006zm0 0a10 10 0 01-.845 1.187 7.1 7.1 0 011.839 2.877q.673-.691 1.237-1.476a6.6 6.6 0 00-2.231-2.588M3.4 9.156l.001-.007-.01.005.01.002Zm0 0a6.66 6.66 0 00.44 3.398q.956.105 1.919.072a7 7 0 01-.304-.62 7 7 0 01-.585-2.683 10 10 0 01-1.47-.167m9.247-3.095.007-.008-.01.005zm0 0a9.9 9.9 0 01-3.11 2.307l1.31 3.032a13.3 13.3 0 003.588-2.44 7 7 0 00-.276-.742 6.6 6.6 0 00-1.512-2.157M5.85 11.826a6.7 6.7 0 01-.552-2.492 9.9 9.9 0 003.82-.8l1.312 3.046c-1.331.567-2.746.91-4.188 1.016a6.5 6.5 0 01-.392-.77M14.913 9.1q.7-.7 1.294-1.493h.003a6.6 6.6 0 01.337 3.691q-.773.732-1.635 1.354a7.1 7.1 0 000-3.552Zm-8.365 6.65a6.64 6.64 0 01-2.51-2.721q.984.09 1.97.038a7.1 7.1 0 002.602 2.385q-1.021.216-2.062.299Zm4.467-3.94a13.6 13.6 0 003.53-2.353 6.7 6.7 0 01-.215 3.602q-1.072.71-2.242 1.244zm-1.737 3.484a6.65 6.65 0 01-2.76-2.265 13.5 13.5 0 004.077-1.041l1.074 2.492q-1.164.498-2.39.814Zm5.405-1.938a16 16 0 001.657-1.269 6.66 6.66 0 01-3.393 3.943 7.2 7.2 0 001.736-2.675Zm-4.906 3.368a6.6 6.6 0 01-2.528-.591l.006-.009a17 17 0 002.001-.357 7.2 7.2 0 003.081.532 6.6 6.6 0 01-2.56.425m2.483-2.006q.916-.416 1.775-.942l.005-.008a6.8 6.8 0 01-1.363 1.916zm.005 1.138a6.7 6.7 0 01-2.274-.296q.946-.283 1.855-.67zM.715 6.302a10.06 10.06 0 00.704 8.879 10 10 0 003.172 3.286A10 10 0 008.886 20v-2.248a7.77 7.77 0 01-5.542-3.686 7.83 7.83 0 01-.683-6.634zm16.619 1.13 1.951-1.13a10.06 10.06 0 01-.704 8.88 10 10 0 01-3.173 3.286A10 10 0 0111.112 20v-2.248a7.76 7.76 0 005.544-3.684 7.82 7.82 0 00.678-6.636"/>', $fff98676c7577ddf$var$U0 = '<path d="M14.222.03c-1.812 1.753-3.604 3.49-3.604 3.49l.644 1.31c.873-.864 1.75-1.625 2.587-2.472 1.762 3.869 2.963 6.987 4.44 11.109.483 1.339.384 1.399-.771 2.122-1.857.923-2.445 1.53-4.658 3.884h1.515c1.85-1.673 2.536-2.263 4.853-3.484.82-.473.932-1.07.596-2C18.74 10.977 16.39 4.484 14.222.03"/><path d="M9.498.071C8.172.966 7.149 2.254 5.996 3.358l.473 1.508c.903-.71 1.688-1.569 2.5-2.38l4.376 10.977c.252.743-.145 1.405-.944 2.125-.956.769-2.925 2.56-3.818 3.926h1.358c1.426-1.464 1.683-1.663 3.306-3.068 1.09-1.112 2.074-1.681 1.56-3.106z"/><path d="M5.023 0C4.67.12 4.376.347 4.1.588a880 880 0 00-3.889 3.75c-.196.182-.213.45-.21.718L.017 6.57S1.743 4.892 4.32 2.41c1.39 3.615 2.837 7.21 4.263 10.813.195.544-.272.99-.864 1.585-.818.798-2.53 2.44-4.281 4.635h1.756l4.22-4.629c.402-.552.9-1.091.69-1.591L5.024 0Z"/>', $fff98676c7577ddf$var$D0 = '<path d="M0 4v12.258h.742V4zm1.482 0v12.258h2.223V4zm2.96 0v12.258H6.67V4zm2.964 0v12.258h.744V4zm1.48 0v12.258h.745V4zm1.483 0v12.258h2.224V4zm2.962 0v12.258h.742V4zm1.482 0v12.258h2.223V4zm2.96 0v12.258h.744V4zm1.484 0v12.258H20V4z"/>', $fff98676c7577ddf$var$E0 = '<path d="M15.752 7.06q-.248 0-.56.03-.263.03-.528.032-.217 0-.54-.032a8 8 0 00-.6-.03q-.094 0-.094.144 0 .146.062.145.696.031.697.538c-.004.16-.04.318-.104.465l-1.415 3.284.23.515 1.672-3.758c.175-.393.34-.66.503-.798.178-.146.397-.233.627-.246a.11.11 0 00.087-.052.2.2 0 00.04-.114q-.004-.124-.077-.124Zm-5.038.289q.697.032.697.506a1.1 1.1 0 01-.156.497l-.028.053.23.516.286-.528q.367-.64.61-.822c.193-.13.418-.207.65-.222q.115 0 .115-.166c0-.087-.021-.124-.062-.124q-.263 0-.659.036a6 6 0 01-.47.027q-.225 0-.571-.032a8 8 0 00-.61-.03q-.03 0-.062.046a.17.17 0 00-.031.098q-.002.144.061.145M8.07 11.625 6.56 8.228a.8.8 0 01-.087-.31.47.47 0 01.2-.394c.163-.108.353-.169.548-.174q.051 0 .051-.144t-.087-.145q-.346 0-.798.03a7.7 7.7 0 01-1.41 0 10 10 0 00-.727-.03c-.054 0-.087.048-.087.145q0 .057.037.1a.1.1 0 00.078.044c.272.017.532.111.751.272q.27.22.513.773l1.91 4.368.616-1.138Z"/><path d="M11.979 14.312a.14.14 0 00.125.087h1.137a.134.134 0 00.122-.19l-2.777-6.215a1.7 1.7 0 00-.358-.506 1.4 1.4 0 00-.552-.314 3 3 0 00-.878-.11c-.347 0-.692.05-1.025.148a.135.135 0 00-.092.15l.16.963a.13.13 0 00.13.112.2.2 0 00.043-.008c.18-.06.37-.089.56-.087q.211-.006.414.055a.7.7 0 01.269.162.9.9 0 01.174.26q.072.155.151.348l.113.284-2.536 4.765a.135.135 0 00.126.182H8.63a.13.13 0 00.122-.08l.008-.015 1.707-3.148 1.513 3.157ZM3.752 5.208a7.86 7.86 0 016.225-3.085A7.88 7.88 0 0116.22 5.17l1.77-1.186a10.01 10.01 0 00-16.027.064z"/><path d="M17.288 7.01a7.8 7.8 0 01.585 2.965c0 4.331-3.531 7.903-7.873 7.903-4.341 0-7.871-3.572-7.871-7.903-.001-1 .191-1.993.567-2.92L.883 5.88a9.9 9.9 0 00-.882 4.095C0 15.477 4.487 20 10 20s10-4.523 10-10.025a9.9 9.9 0 00-.917-4.17z"/>', $fff98676c7577ddf$var$P0 = '<path d="M6.08 5.555a6.048 6.048 0 003.055 10.593v-7.54L6.08 5.556zm7.828.004-3.05 3.05v7.536a6.048 6.048 0 003.05-10.587z"/><path d="M3.414 2.89C1.424 4.69.164 7.287.168 10.173c.007 5.406 4.42 9.806 9.828 9.806s9.82-4.4 9.828-9.806c.004-2.886-1.255-5.482-3.246-7.285L14.865 4.6a7.36 7.36 0 012.524 5.568c-.007 4.09-3.3 7.375-7.394 7.375S2.61 14.26 2.604 10.17a7.36 7.36 0 012.523-5.568z"/><circle cx="10" cy="3.32" r="3.32"/>', $fff98676c7577ddf$var$N0 = '<path d="M13.09 6.18a3.68 3.68 0 01-2.18-2.55c.09.09 1.82.91 1.82.91L10 0 7.27 4.55l1.82-.91a5.1 5.1 0 00.55 1.91 5.13 5.13 0 002 2 9 9 0 012 1.18l-.64.63-.45-.45-.26 1.54 1.54-.26-.45-.45.62-.65a5.7 5.7 0 011.45 3.45h-.91v-.73l-1.26.91 1.26.91v-.73h.91A5.2 5.2 0 0114 16.36l-.64-.64.45-.45-1.53-.27.26 1.54.45-.45.64.64a5.7 5.7 0 01-3.45 1.45v-.91h.73L10 16l-.91 1.27h.73v.91a5.2 5.2 0 01-3.45-1.45l.63-.64.45.45.27-1.54-1.54.26.45.45-.63.65a5.7 5.7 0 01-1.45-3.45h.91v.73l1.26-.91-1.26-.91v.73h-.91A5.2 5.2 0 016 9.09l.64.64-.45.45 1.54.26-.28-1.53-.45.45-.64-.64L5 7.45a7.29 7.29 0 108.09-1.27"/><circle cx="10" cy="12.7" r="2.5"/>', $fff98676c7577ddf$var$O0 = '<path d="M12 17c0 1.1-2 2-2 2s-2-.9-2-2m2-10a1.54 1.54 0 01-1.5-1.5 1.5 1.5 0 013 0A1.54 1.54 0 0110 7m3.3 4.7C14.1 7.9 12.7 1 10 1S5.8 7.7 6.6 11.5L5 15h2.7l.3 1h4c.2-.3.1-.5.3-1H15z"/>', $fff98676c7577ddf$var$Q0 = '<path d="M16 10a6 6 0 01-6 6 6 6 0 01-6-6 6 6 0 016-6 6 6 0 016 6M7.55 8.94a10 10 0 011.33-3.81 5 5 0 00-3.86 4.45H7.5c0-.22.03-.43.05-.64m1 .12a8 8 0 00-.05.52h3.06a8 8 0 00-.05-.52 9.1 9.1 0 00-1.48-3.89 9.1 9.1 0 00-1.48 3.9Zm4.01.52h2.42a5 5 0 00-3.79-4.44 10 10 0 011.37 4.44m-7.53 1a5 5 0 003.87 4.3 9.4 9.4 0 01-1.4-4.3zm5 4.21c1-1.47 1.43-2.9 1.52-4.21H8.52a8.53 8.53 0 001.52 4.21zm1.14.07a5 5 0 003.8-4.28h-2.41a9.35 9.35 0 01-1.39 4.28M3.07 6a7.97 7.97 0 000 8h1.18A6.96 6.96 0 013 10c0-1.49.46-2.87 1.25-4Zm12.68 0h1.18a7.97 7.97 0 010 8h-1.18A6.96 6.96 0 0017 10c0-1.49-.46-2.87-1.25-4m2.74 7h1.05a9.9 9.9 0 000-6h-1.05a9.04 9.04 0 010 6M.46 13h1.05a9.04 9.04 0 010-6H.46a9.9 9.9 0 000 6"/>', $fff98676c7577ddf$var$G0 = '<path d="M11.14 4H14a.69.69 0 010 .65c-1 .16-1.36.91-1.81 1.83l-1.4 2.75 2.35 5.21h.07l3.52-8.1c.44-1.07.4-1.59-.79-1.7a.68.68 0 010-.65h3.45a.68.68 0 010 .65c-1.21.16-1.42.91-1.81 1.83l-4.37 10.08c-.13.3-.24.45-.44.45s-.33-.16-.42-.45l-2.48-5.73-2.72 5.73c-.11.3-.24.45-.44.45s-.31-.16-.42-.45l-4-10.09c-.57-1.4-.6-1.7-1.65-1.8A.68.68 0 01.62 4h3.91a.68.68 0 010 .65c-1.16.13-1.21.45-.74 1.58l3.41 8.19h.05L9.3 10 7.78 6.45C7.17 5.05 7 4.77 6.24 4.66a.69.69 0 010-.65h3.32a.68.68 0 010 .65c-.74.12-.7.45-.19 1.58l.87 2 .08.09 1-2c.57-1.14.64-1.58-.15-1.7a.69.69 0 01-.03-.63"/>', $fff98676c7577ddf$var$K0 = '<path d="M9.133 4.643a6.52 6.52 0 012.79 5.354 6.52 6.52 0 01-2.672 5.269l-.12.086-.923-1.322a4.91 4.91 0 002.103-4.033c0-1.578-.748-3.03-1.988-3.95l-.114-.082z"/><path d="M5.347 13.275a3.347 3.347 0 10-.001-6.695 3.347 3.347 0 00.001 6.695M13.874 0a13.08 13.08 0 014.627 9.997c0 3.86-1.678 7.448-4.538 9.92l-.096.083-1.15-1.357a11.3 11.3 0 004.006-8.646c0-3.33-1.444-6.424-3.908-8.562l-.091-.079L13.873 0Z"/><path d="M11.453 2.386a9.71 9.71 0 013.668 7.611 9.71 9.71 0 01-3.576 7.537l-.09.073-1.074-1.347A7.99 7.99 0 0013.4 9.997a7.99 7.99 0 00-2.932-6.194l-.087-.07 1.073-1.347Z"/>', $fff98676c7577ddf$var$J0 = '<path d="M9.94 0a10 10 0 00-8.08 4.2h4.21c.06-.35.16-.72.49-1.04.2-.23.67-.2 1-.26.33-.07.87-.92 1.4-1.17.64.33 1.34.83 1.7 1.08.62-.49 1.16-1.33 1.4-.65.2-.33.53-.54.9-.63.17-.04.4-.03.52-.05.14-.06.42-.27.66-.34-.38.58-.43 2.25-.44 3.06v.35c.55.12 1.25.03 1.49-.35h2.95A9.99 9.99 0 0010 0zm-.36 2.5c.17.47.31.94.26 1.4-.06.3.07.28.31.16s.36-.26.72-.37c.27-.07.08-.26-.05-.4-.4-.34-.82-.56-1.24-.8zm-8.3 2.6A9.95 9.95 0 000 10a10 10 0 0020 0 9.94 9.94 0 00-1.28-4.9H2.8c.52 1.1.81 1.7 2.6 1.46.62-.1 1-.16 1 .48.08.39.38.52 1.15.38.3-.11.57-.28.79-.14h.02v.01a.04.04 0 01.01.02c0 .1-.19.31.04.57.57.55 1.12 1.04 1.7 1.6.13.64.7.55 1.15.42.68-.2.38.1.63.41.14.22.46.81.84.6.01 1.08.28 1.85.84 2.27-.17.63-.33 1.5-.03 2.02-.5-.16-.3.81-.45 1.22-.26.68-.48.65-.72.71.22.24.5.49.92.64v.01l.02.01c0 .23.04.43.18.57-.26-.06-.57-.42-1.08-.19-.56.25-.68.08-.48-.29.26-.57-.3-.78-.88-.92v-.23c.12-.04.26-.08.42-.1.25-.05.42-.14.4-.5-.01-.5-.03-1 0-1.48a6 6 0 01.18-1.21c.07-.2.44-.38.13-.64A42 42 0 008.3 9.3l-.06-.02 1.65 2.93c.2.49.58 1-.1 1.13v.01c-.03.47.06 1.28-.26 1.44-.36.25-.39.48-.42.86-.06.4-.06.86.06 1.18.12.05.24.08.37.1l.32.04c-.43.56-.96.39-1.27-.13l-1.67-2.58c.08-2.51.13-4.2-.05-6.3-.92.08-1.85.01-2.83-.56-.22-.4-.47-.36-.89-.26.05-.37-.1-.73-.32-1.1l-.1-.93H1.29zm14.51 1.03c1.6-.04 1.14 2.78 1.14 4.15h.01l-.13.7-.2 1.21c.07.6-.09.68-.2 1.02 0 1.32-.18 1.7-1.29 2.7a2.16 2.16 0 01-1.17-2.25c.04-.24.2-.51-.01-.9a7.4 7.4 0 01.14-3.35.6.6 0 01.2-.02.63.63 0 00.57-.74 3.3 3.3 0 00.6-.2c-.81-.76-.52-2.3.34-2.32"/>', $fff98676c7577ddf$var$Y0 = '<circle cx="9.5" cy="2.5" r="2.5"/><path d="M14.434 7.33a6.4 6.4 0 011.677 4.322c0 3.582-2.951 6.488-6.59 6.488-3.64 0-6.595-2.906-6.595-6.488 0-1.643.624-3.141 1.648-4.284L3.138 5.967a8.37 8.37 0 00-2.137 5.592C1 16.219 4.81 20 9.503 20s8.498-3.78 8.498-8.441a8.38 8.38 0 00-2.152-5.615Z"/><path d="M4.368 3.754 4.34 5.525s.22.93 1.75 1.411c1.487.468 3.581.3 5.048.964 1.273.575 1.71 1.53 1.71 1.53l.03-1.66s-.11-.876-1.285-1.239c-1.176-.362-3.141-.48-5.428-1.265-1.025-.352-1.812-1.485-1.798-1.512Zm1.665 3.798L5.97 9.5s.16.415 1.578.826c.848.246 3.364.467 4.666.998 1.139.464 1.665 1.554 1.665 1.554l.12-1.623c-.376-.92-.81-1.148-2.342-1.544-1.044-.27-2.24-.318-3.163-.625-1.811-.603-2.46-1.533-2.46-1.533Z"/><path d="M14.492 3.74v1.738s-.244.807-1.556 1.295c-1.69.628-4.273.583-6.004 1.556a2.03 2.03 0 00-.962 1.167l.027-1.999s.3-.743 1.83-1.22c1.964-.614 3.21-.38 4.962-1.128 1.14-.487 1.716-1.395 1.703-1.409m-9.6 7.474-.069 1.918s.301.61 1.192.99c1.703.728 2.904.193 5.405 1.332 1.129.513 1.395 1.362 1.395 1.362l-.006-1.926s-.147-.59-1.242-.953c-1.095-.362-3.488-.609-5.113-1.22-1.117-.42-1.576-1.517-1.562-1.503"/><path d="m5.984 16.62.027-1.837s.126-.53 1.83-1.074c1.606-.512 3.602-.502 4.537-.89.935-.39 1.62-1.566 1.62-1.566l-.007 1.95s.049.696-1.378 1.15c-1.856.59-3.03.38-4.859 1.065-1.036.389-1.743 1.243-1.77 1.203Zm6.896-8.851.022 1.674s-.262.492-1.417.96c-1.573.64-3.003.278-5.007 1.133-.748.318-1.656 1.596-1.656 1.596l.053-2.026s.539-.87 1.51-1.22c2.083-.752 2.858-.202 5.035-1.1.736-.305 1.438-.934 1.46-1.017"/>', $fff98676c7577ddf$var$j0 = '<path d="M9.982 3c-.2.04-.44.196-.641.47-.2.234-.361.585-.521.976h2.284c-.16-.43-.32-.742-.52-.977-.161-.273-.402-.43-.602-.469m.722.079c.08.078.12.117.16.195q.36.468.601 1.172h1.604c-.642-.703-1.443-1.211-2.365-1.367m-1.444 0a4.37 4.37 0 00-2.365 1.406H8.5c.16-.469.36-.899.601-1.172a.6.6 0 01.16-.234Zm-1.162.039a6.35 6.35 0 00-2.285 1.328h.682a5.2 5.2 0 011.603-1.328m3.848.039c.601.312 1.123.742 1.604 1.328h.681a6.1 6.1 0 00-2.285-1.328m-6.494 1.64A6.1 6.1 0 004.29 6.596h1.042a7.5 7.5 0 01.882-1.797h-.762Zm1.163 0a7 7 0 00-.962 1.798h2.365c.08-.586.2-1.211.4-1.797zm2.124 0c-.2.587-.32 1.173-.4 1.798h3.327a9.7 9.7 0 00-.401-1.797zm2.887 0c.16.587.32 1.173.4 1.798h2.325a5.6 5.6 0 00-.962-1.797zm2.164 0c.401.548.682 1.134.882 1.798h1.042c-.28-.664-.681-1.25-1.162-1.797zm-9.62 2.11a6.1 6.1 0 00-.361 2.072H4.97c0-.704.08-1.407.28-2.071zm1.403 0a7.2 7.2 0 00-.281 2.072h2.566c0-.704.04-1.368.12-2.071zm2.725 0c-.08.704-.12 1.368-.12 2.072h3.648c0-.704-.04-1.368-.12-2.071zm3.728 0c.08.704.12 1.368.12 2.072h2.566a7.2 7.2 0 00-.28-2.071zm2.726 0c.2.665.28 1.368.28 2.072h1.163a6.1 6.1 0 00-.36-2.071zM20 9.332H0v.646h20zm-16.645 1H.685v6.707h2.67zm5.321 0H6.005v6.707h2.67zm5.32 0h-2.67v6.707h2.67zm5.321 0h-2.671v6.707h2.67zM20 17.355H0V18h20z"/>', $fff98676c7577ddf$var$X0 = '<path d="M15.874 8.19 20 0l-8.254 4.095c.99.263 1.892.78 2.617 1.498a5.8 5.8 0 011.51 2.596Zm-6.349 4.043L14.678 20l.56-9.291a5.9 5.9 0 01-2.65 1.523 5.95 5.95 0 01-3.063 0Zm-.159-7.508L.001 5.28l7.829 5.113a5.8 5.8 0 010-3.038c.27-.995.8-1.902 1.536-2.63"/>', $fff98676c7577ddf$var$_0 = '<path d="M2.22 18.6v.01c-.35-.21-.61-.5-.71-.84l-.07-.37L.21 3.36c-.03-.45.17-.9.57-1.25.39-.36.97-.6 1.62-.66L15.35.22a2.8 2.8 0 011.7.35 1.5 1.5 0 01.77 1.13l1.23 14.12c.03.45-.17.9-.57 1.25a2.85 2.85 0 01-1.62.67L3.92 18.95a2.75 2.75 0 01-1.7-.35m-1-1.1c.02.18.07.35.15.5l.02.25c.05.56.4 1.03.9 1.34.51.3 1.19.46 1.9.4l13.34-1.27a3.15 3.15 0 001.8-.74c.45-.4.71-.93.66-1.49L18.73 1.87a1.77 1.77 0 00-.9-1.33 2.9 2.9 0 00-1.24-.4 3.2 3.2 0 00-1.27-.12L2.4 1.23a3.1 3.1 0 00-1.74.72c-.44.39-.7.9-.64 1.44l1.22 14.1zm1.2 1.9a1.6 1.6 0 01-.78-1 2 2 0 00.47.39c.49.3 1.14.44 1.84.38l12.93-1.22c.7-.06 1.31-.33 1.74-.72.44-.38.7-.9.64-1.43L18.04 1.69a1.62 1.62 0 00-.62-1.11c.1.04.2.09.29.15.46.28.76.7.8 1.16l1.26 14.62c.04.48-.18.94-.59 1.3-.4.37-1 .63-1.67.7L4.17 19.75a2.9 2.9 0 01-1.76-.36ZM1.21 5.3l4.34-.5.06.47-.28.04c-.28.03-.48.12-.6.26a.57.57 0 00-.15.46 12 12 0 00.53 1.33l2.91 6.12 1.15-5.56-.8-1.68c-.16-.27-.31-.5-.48-.7a1 1 0 00-.28-.23 1.4 1.4 0 00-.42-.17c-.1-.02-.25-.02-.48 0l-.08.02-.06-.48 4.56-.53.06.48-.38.04c-.3.04-.5.13-.6.26a.67.67 0 00-.13.53c0 .02 0 .06.03.15l.15.4 3.2 6.84 1.32-6.48c.16-.75.22-1.25.18-1.51a.57.57 0 00-.14-.32.57.57 0 00-.3-.18c-.2-.05-.47-.06-.8-.02h-.08l-.06-.48 3.53-.4.06.48h-.08c-.29.04-.5.12-.66.24-.15.12-.3.33-.42.64-.08.2-.2.7-.35 1.5l-2.01 9.9-.45.05-3.4-7.06-1.61 7.64-.42.04-4.56-9.42q-.51-1.05-.63-1.23a1 1 0 00-.47-.4 1.6 1.6 0 00-.76-.07h-.08Z"/>', $fff98676c7577ddf$var$$0 = '<path d="M13 3 7 1 1 3v16l6-2 6 2 6-2V1zM7 14.89l-4 1.36V4.35L7 3zm10 .75L13 17V5.1l4-1.36z"/>', $fff98676c7577ddf$var$c2 = '<path d="M10 0a7.65 7.65 0 00-8 8c0 2.52 2 5 3 6s5 6 5 6 4-5 5-6 3-3.48 3-6a7.65 7.65 0 00-8-8m0 11.25A3.25 3.25 0 1113.25 8 3.25 3.25 0 0110 11.25"/>', $fff98676c7577ddf$var$a2 = '<path d="M10 0a7.65 7.65 0 00-8 8c0 2.52 2 5 3 6s5 6 5 6 4-5 5-6 3-3.48 3-6a7.65 7.65 0 00-8-8m5 9h-4v4H9V9H5V7h4V3h2v4h4z"/>', $fff98676c7577ddf$var$t2 = '<path d="m20 6-1-1-1.5 1.5L16 5l-1 1 1.5 1.5L15 9l1 1 1.5-1.5L19 10l1-1-1.5-1.5z"/><circle cx="7.5" cy="14.5" r="3.5"/><circle cx="7" cy="3" r="2"/><circle cx="13" cy="7" r="1"/><circle cx="10" cy="6" r="1"/><circle cx="3" cy="3" r="1"/><circle cx="1" cy="6" r="1"/><circle cx="1" cy="9" r="1"/><circle cx="3" cy="12" r="1"/>', $fff98676c7577ddf$var$h2 = '<path d="M6.5 3.5 0 10l1.5 1.5 5 5L8 15l-5-5 5-5zm7 0L12 5l5 5-5 5 1.5 1.5L20 10z"/>', $fff98676c7577ddf$var$o2 = '<path d="M14 2H4l5 8-5 8h12v-4h-2v2H8.25L12 10 8.25 4H14v2h2V2z"/>', $fff98676c7577ddf$var$s2 = '<path d="M13 5H5l3 5-3 5h10v-3h-2v1H9.2l1.8-3-1.8-3H13v1h2V5zM2 1h16v2H2zm0 16h16v2H2z"/>', $fff98676c7577ddf$var$l2 = '<path d="M12 5H4l3 5-3 5h10v-3h-2v1H8.2l1.8-3-1.8-3H12v1h2V5zM1 9h3v2H1zm15 0h3v2h-3z"/>', $fff98676c7577ddf$var$n2 = '<path d="M4 13H0V7h4zm12-6h4v6h-4zM6 6l3 4-3 4h8v-3h-2v1H9.5l1.5-2-1.5-2H12v1h2V6z"/>', $fff98676c7577ddf$var$v2 = '<path d="M1 3v2h18V3zm0 8h18V9H1zm0 6h18v-2H1z"/>', $fff98676c7577ddf$var$d2 = '<path d="M0 8v8a2 2 0 002 2h16a2 2 0 002-2V8l-10 4z"/><path d="M2 2a2 2 0 00-2 2v2l10 4 10-4V4a2 2 0 00-2-2z"/>', $fff98676c7577ddf$var$e2 = '<path d="M17.39 15.14A7.33 7.33 0 0111.75 1.6c.23-.11.56-.23.79-.34a8.2 8.2 0 00-5.41.45 9 9 0 107 16.58 8.42 8.42 0 004.29-3.84 5.3 5.3 0 01-1.03.69"/>', $fff98676c7577ddf$var$r2 = '<path d="m19 10-4-3v2h-4V5h2l-3-4-3 4h2v4H5V7l-4 3 4 3v-2h4v4H7l3 4 3-4h-2v-4h4v2z"/>', $fff98676c7577ddf$var$z2 = '<path d="M3 1h2v18H3zm13.5 1.5L15 1l-9 9 9 9 1.5-1.5L9 10z"/>', $fff98676c7577ddf$var$i2 = '<path d="M15 1h2v18h-2zM3.5 2.5 11 10l-7.5 7.5L5 19l9-9-9-9z"/>', $fff98676c7577ddf$var$p2 = '<path d="M8 15V5h8v10h2V2H6v13"/><circle cx="15" cy="15" r="3"/><circle cx="5" cy="15" r="3"/>', $fff98676c7577ddf$var$m2 = '<circle cx="10" cy="15" r="2"/><path d="M1 7.4a12 13 0 0118 0l-1.5 1.4a10 11.1 0 00-15 0zm3.7 3.2a7 7.3 0 0110.7 0L14 12a5 5.3 0 00-7.8 0z"/>', $fff98676c7577ddf$var$M2 = '<circle cx="10" cy="16" r="2"/><path d="M16.4 11.6A7.1 7.1 0 0012 9.1l3.4 3.4zM19 8.4A12.2 14 0 008.2 4.2L10 6a9.9 9.9 0 017.4 3.7zM3.5 2 2 3.4l2.2 2.2A13.1 13.1 0 001 8.4l1.5 1.3a10.7 10.7 0 013.2-2.6L8 9.3a7.3 7.3 0 00-3.3 2.3L6.1 13a5.2 5.2 0 013.6-2l6.8 7 1.5-1.5z"/>', $fff98676c7577ddf$var$H2 = '<path d="M17 17H3V3h5V1H3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-5h-2z"/><path d="m11 1 3.29 3.29-5.73 5.73 1.42 1.42 5.73-5.73L19 9V1z"/>', $fff98676c7577ddf$var$g2 = '<path d="M17 4v6H7V6l-6 5 6 5v-4h12V4z"/>', $fff98676c7577ddf$var$x2 = '<path d="M5 2a2 2 0 00-2 2v12a1 1 0 01-1-1V5h-.5A1.5 1.5 0 000 6.5v10A1.5 1.5 0 001.5 18H18a2 2 0 002-2V4a2 2 0 00-2-2zm1 2h11v4H6zm0 6h6v1H6zm0 2h6v1H6zm0 2h6v1H6zm7-4h4v5h-4z"/>', $fff98676c7577ddf$var$V2 = '<path d="M7 1 5.6 2.5 13 10l-7.4 7.5L7 19l9-9z"/>', $fff98676c7577ddf$var$m = '<path d="M16 3v2h1v10l2 2V3zM9 5V3H5l2 2zM1 1 0 2l1 1v14h3v-2H3V5l2 2v10h4v-2H7V9l6 6h-2v2h4l3 3 1-1zm12 10 2 2V3h-4v2h2z"/>', $fff98676c7577ddf$var$u2 = '<circle cx="9.85" cy="10" r="9"/>', $fff98676c7577ddf$var$L2 = '<path d="M10 0a10 10 0 1010 10A10 10 0 0010 0m1 16H9v-2h2zm0-4H9V4h2z"/>', $fff98676c7577ddf$var$I2 = '<path d="M2 0a2 2 0 00-2 2v18l4-4h14a2 2 0 002-2V2a2 2 0 00-2-2zm3 9.06a1.39 1.39 0 111.37-1.39A1.39 1.39 0 015 9.06m5.16 0a1.39 1.39 0 111.39-1.39 1.39 1.39 0 01-1.42 1.39zm5.16 0a1.39 1.39 0 111.39-1.39 1.39 1.39 0 01-1.42 1.39z"/>', $fff98676c7577ddf$var$A2 = '<path d="M1 16h18v2H1zm8-9h10v2H9zm0 4h10v2H9zM1 2h18v2H1zm0 8 5 4V6z"/>', $fff98676c7577ddf$var$C2 = '<path d="M1 12h18v7H1zM1 1v8h8V1zm6 6H3V3h4z"/>', $fff98676c7577ddf$var$k2 = '<circle cx="10" cy="10" r="1.75"/><path d="M15 1H5a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V3a2 2 0 00-2-2m0 9.75-1.37.25a3.7 3.7 0 01-.38.93l.82 1.07L13 14.07l-1.12-.82a3.7 3.7 0 01-.93.38l-.2 1.37h-1.5L9 13.63a3.7 3.7 0 01-.93-.38L7 14.07 5.93 13l.82-1.12a3.7 3.7 0 01-.38-.88L5 10.75v-1.5L6.37 9a3.7 3.7 0 01.38-.93L5.93 7 7 5.93l1.12.82A3.7 3.7 0 019 6.37L9.25 5h1.5L11 6.37a3.7 3.7 0 01.93.38L13 5.93 14.07 7l-.82 1.12a3.7 3.7 0 01.38.93l1.37.2z"/>', $fff98676c7577ddf$var$y2 = '<path d="M13 15v2a3 3 0 01-3 3 10 10 0 1110-10 5 5 0 01-5 5ZM3 8.5a1.5 1.5 0 103 0 1.5 1.5 0 10-3 0m3-4a1.5 1.5 0 103 0 1.5 1.5 0 10-3 0m5 0a1.5 1.5 0 103 0 1.5 1.5 0 10-3 0m3 4a1.5 1.5 0 103 0 1.5 1.5 0 10-3 0"/>', $fff98676c7577ddf$var$F2 = '<path d="M3 3h8v2h2V3c0-1.1-.895-2-2-2H3c-1.1 0-2 .895-2 2v8c0 1.1.895 2 2 2h2v-2H3zm4 12v2c0 1.1.895 2 2 2h8c1.1 0 2-.895 2-2V9c0-1.1-.895-2-2-2h-2v2h2v8H9v-2z"/><path d="M10 5H8v3H5v2h3v3h2v-3h3V8h-3z"/>', $fff98676c7577ddf$var$f2 = '<rect width="6" height="16" x="3" y="2" rx="1"/><rect width="6" height="16" x="11" y="2" rx="1"/>', $fff98676c7577ddf$var$S2 = '<path d="M4.55 19A1 1 0 013 18.13V1.87A1 1 0 014.55 1l12.2 8.13a1 1 0 010 1.7z"/>', $fff98676c7577ddf$var$b2 = '<path d="m4 10 9 9 1.4-1.5L7 10l7.4-7.5L13 1z"/>', $fff98676c7577ddf$var$q2 = '<path d="M5 1h10v4H5zM3 6a2 2 0 00-2 2v7h4v4h10v-4h4V8a2 2 0 00-2-2zm11 12H6v-6h8zm2-8a1 1 0 111-1 1 1 0 01-1 1"/>', $fff98676c7577ddf$var$T2 = '<path d="M13 8V2a2 2 0 002-2H5a2 2 0 002 2v6H6a2 2 0 00-2 2v1h5v5l1 4 1-4v-5h5v-1a2 2 0 00-2-2z"/>', $fff98676c7577ddf$var$B2 = '<circle cx="17" cy="10" r="3"/><path d="M10.58 3A3 3 0 0111 4.5a3 3 0 01-6 0A3 3 0 015.42 3H1v12a2 2 0 002 2h12V3z"/>', $fff98676c7577ddf$var$Z2 = '<path d="m7 6 1-2H6C3.79 4 2 6.79 2 9v7h7V9H5c0-3 2-3 2-3m7 3c0-3 2-3 2-3l1-2h-2c-2.21 0-4 2.79-4 5v7h7V9z"/>', $fff98676c7577ddf$var$W2 = '<path d="M7 3H3v4h4zm6 0v4h4V3zM7 13H3v4h4zm8 0v-2h4v2h-2v4h-2v2h4v-4h-4v2h-4v2h2v-4h-2v-4h2v2zm-4-4V1h8v8zM1 9V1h8v8zm0 2h8v8H1z"/>', $fff98676c7577ddf$var$w2 = '<path d="M1 3h16v2H1zm0 6h11v2H1zm0 6h7v2H1zm17.8-3.1 1-1.1a.6.6 0 000-.8L18 8.2a.6.6 0 00-.8 0l-1 1zm-3.3-2L10 15.3V18h2.6l5.6-5.5-2.7-2.7Z"/>', $fff98676c7577ddf$var$R2 = '<path d="M19 3H3v2h16zm0 6h-7v2h7zm0 6H8v2h11zM8.8 11.9l1-1.1a.6.6 0 000-.8L8 8.2a.6.6 0 00-.8 0l-1 1L8.7 12zm-3.3-2L0 15.3V18h2.6l5.6-5.5-2.7-2.7Z"/>', $fff98676c7577ddf$var$U2 = '<path d="M19 8.5 12 3v11zM12 7v3h-1c-4 0-7 2-7 6v1H1v-1c0-6 5-9 10-9z"/>', $fff98676c7577ddf$var$D2 = '<path d="m15 10-2.78-2.78L9.44 10V1H5a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V3a2 2 0 00-2-2z"/>', $fff98676c7577ddf$var$E2 = '<path d="M7 0a2 2 0 00-2 2h9a2 2 0 012 2v12a2 2 0 002-2V2a2 2 0 00-2-2z"/><path d="m13 12-2.8-2.8L7.4 12V3H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>', $fff98676c7577ddf$var$P2 = '<path d="M13 0a2 2 0 012 2H6a2 2 0 00-2 2v12a2 2 0 01-2-2V2a2 2 0 012-2z"/><path d="M5 18c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2v9l-2.8-2.8-2.8 2.8V3H7C5.4 3 5 4.6 5 5z"/>', $fff98676c7577ddf$var$N2 = '<path d="M0 3v16h5V3zm4 12H1v-1h3zm0-3H1v-1h3zm2-9v16h5V3zm4 12H7v-1h3zm0-3H7v-1h3zm1-8.5 4.1 15.4 4.8-1.3-4-15.3zm7 10.6-2.9.8-.3-1 2.9-.8zm-.8-2.9-2.9.8-.2-1 2.9-.8z"/>', $fff98676c7577ddf$var$O2 = '<path d="M15.65 4.35A8 8 0 1017.4 13h-2.22a6 6 0 11-1-7.22L11 9h7V2z"/>', $fff98676c7577ddf$var$Q2 = '<path d="M1.22 0 0 1.22l4 4V17a2 2 0 002 2h8a2 2 0 002-1.8l2.8 2.8 1.2-1.22zM17 4V2h-3.5l-1-1h-5l-1 1h-.84l2 2zM8.66 5H16v7.34z"/>', $fff98676c7577ddf$var$G2 = '<path d="M10.5 5h6.505C18.107 5 19 5.896 19 6.997V14h-7v2h5.005c1.102 0 1.995.888 1.995 2v2H1v-2c0-1.105.893-2 1.995-2H8v-2H1V6.997C1 5.894 1.893 5 2.995 5H9.5V2.915a1.5 1.5 0 111 0zm-4 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3m7 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3"/>', $fff98676c7577ddf$var$K2 = '<path d="M8 12V9l6-6 3 3-6 6zm10-7-3-3 2-2 3 3zM8 2h2v2H8zM4 2h2v2H4zM0 3a1 1 0 011-1h1v2H0zm0 3h2v2H0zm0 4h2v2H0zm0 4h2v2H0zm0 4h2v2H1a1 1 0 01-1-1zm4 0h2v2H4zm4 0h2v2H8zm4 0h2v1a1 1 0 01-1 1h-1zm0-4h2v2h-2z"/>', $fff98676c7577ddf$var$J2 = '<path d="M12.2 13.6a7 7 0 111.4-1.4l5.4 5.4-1.4 1.4zM3 8a5 5 0 1010 0A5 5 0 003 8"/>', $fff98676c7577ddf$var$Y2 = '<path d="M11.59 15.87h-1.52a.64.64 0 01-.42-.13.84.84 0 01-.24-.32l-1-2.67H3.18l-1 2.67a.8.8 0 01-.23.31.63.63 0 01-.42.14H0L4.8 3.76h2zm-3.72-4.54L6.2 6.91a12 12 0 01-.41-1.3q-.09.4-.2.73c-.07.22-.14.42-.2.58l-1.67 4.41zm5.58-2.84a4.9 4.9 0 013.46-1.35 3.4 3.4 0 011.32.24 2.6 2.6 0 011 .68 3 3 0 01.6 1 4.1 4.1 0 01.17 1.36v5.45h-.81a.8.8 0 01-.39-.08.6.6 0 01-.23-.32l-.18-.7a8 8 0 01-.65.53 4 4 0 01-.66.39 3.3 3.3 0 01-.73.24 4.3 4.3 0 01-.86.08 3.2 3.2 0 01-1-.14 2.1 2.1 0 01-.78-.43 2 2 0 01-.52-.72 2.5 2.5 0 01-.19-1 2 2 0 01.26-1 2.4 2.4 0 01.87-.85 5.7 5.7 0 011.6-.62 11.7 11.7 0 012.51-.25v-.57A2.06 2.06 0 0017.85 9a1.46 1.46 0 00-1.16-.45 2.5 2.5 0 00-.87.13 4 4 0 00-.62.32l-.46.28a.77.77 0 01-.43.13.52.52 0 01-.32-.1.8.8 0 01-.21-.24zm4.79 3.63a11.5 11.5 0 00-1.63.15 4.6 4.6 0 00-1.08.31 1.4 1.4 0 00-.59.45 1 1 0 00-.18.57 1.25 1.25 0 00.1.52.94.94 0 00.27.35 1.1 1.1 0 00.4.2 2 2 0 00.51.06 2.6 2.6 0 001.21-.27 3.8 3.8 0 001-.77z"/>', $fff98676c7577ddf$var$j2 = '<path d="M5.3 7.9a7.3 7.3 0 015.1-2 5 5 0 012 .3 4 4 0 011.4 1 4.4 4.4 0 01.9 1.6 6 6 0 01.3 2v8h-1.2a1.2 1.2 0 01-.6-.1 1 1 0 01-.3-.5l-.3-1a12 12 0 01-1 .8 6 6 0 01-1 .6 4.8 4.8 0 01-1 .3 6.4 6.4 0 01-1.3.1 4.7 4.7 0 01-1.4-.2 3.1 3.1 0 01-1.2-.7 3 3 0 01-.7-1 3.7 3.7 0 01-.3-1.5 2.9 2.9 0 01.4-1.4 3.6 3.6 0 011.3-1.3 8.4 8.4 0 012.4-.9 17.2 17.2 0 013.6-.4v-.9a3 3 0 00-.6-2 2.1 2.1 0 00-1.7-.7 3.8 3.8 0 00-1.3.2 6 6 0 00-.9.4l-.7.4a1.1 1.1 0 01-.6.2A.8.8 0 016 9a1.2 1.2 0 01-.3-.4zm6.2-5.8a.9.9 0 00.9-1.1H14a3.8 3.8 0 01-.2 1.2 2.7 2.7 0 01-.5.9 2.2 2.2 0 01-.7.5 2.3 2.3 0 01-1 .2 2 2 0 01-.8-.1 6.5 6.5 0 01-.8-.4L9.4 3a1.2 1.2 0 00-.5-.2.8.8 0 00-.7.3 1.1 1.1 0 00-.2.8H6.4a3.7 3.7 0 01.1-1.2 2.8 2.8 0 01.5-.9 2.3 2.3 0 01.8-.6 2.2 2.2 0 011-.2 2 2 0 01.8.2 6 6 0 01.7.3zm1 11.2a17 17 0 00-2.5.2 7 7 0 00-1.6.4 2.1 2.1 0 00-.9.7 1.4 1.4 0 00-.2.9 1.9 1.9 0 000 .7 1.4 1.4 0 00.5.6 1.6 1.6 0 00.6.2 3 3 0 00.7.1 3.8 3.8 0 001.8-.4 5.6 5.6 0 001.5-1z"/>', $fff98676c7577ddf$var$X2 = '<path d="M17.6 2a14.5 14.5 0 010 16l-.9-.56c-.28-.18-.17-.49-.05-.7a13.97 13.97 0 00-.09-13.6c-.08-.18-.16-.44.17-.65zM2.4 2c-2.9 3.87-3.38 10.9.03 15.94l.91-.56c.28-.17.16-.5.04-.7C.57 11.65 1.49 6.55 3.43 3.1c.08-.18.12-.38-.2-.59zM12 4h1v2.41l-.1.35.35-.34 1.98-1.15.54.94-2.02 1.15-.43.13.43.12L15.8 8.8l-.54.94-1.98-1.14-.38-.35.1.43V11h-1V8.76l.12-.52-.34.34L9.8 9.72l-.54-.94 2-1.15.48-.14-.47-.13L9.2 6.2l.54-.94 1.97 1.14.38.37-.09-.41z"/><circle cx="6.5" cy="13.5" r="1.5"/>', $fff98676c7577ddf$var$_2 = '<g transform="translate(10 10)"><path id="cdx-icon-settings-a" d="M1.5-10h-3l-1 6.5h5m0 7h-5l1 6.5h3"/><use xlink:href="#cdx-icon-settings-a" transform="rotate(45)"/><use xlink:href="#cdx-icon-settings-a" transform="rotate(90)"/><use xlink:href="#cdx-icon-settings-a" transform="rotate(135)"/></g><path d="M10 2.5a7.5 7.5 0 000 15 7.5 7.5 0 000-15v4a3.5 3.5 0 010 7 3.5 3.5 0 010-7"/>', $fff98676c7577ddf$var$$2 = '<path d="M12 6V2l7 7-7 7v-4c-5 0-8.5 1.5-11 5l.8-3 .2-.4A12 12 0 0112 6"/>', $fff98676c7577ddf$var$c5 = '<path d="M0 18h20v1H0zm-.003-6.155 1.06-1.06 4.363 4.362-1.06 1.06z"/><path d="m.004 15.147 4.363-4.363 1.06 1.061-4.362 4.363zM17 5c0 9-11 9-11 9v-1.5s8 .5 9.5-6.5C16 4 15 2.5 14 2.5S11 4 10.75 10c-.08 2 .75 4.5 3.25 4.5 1.5 0 2-1 3.5-1a2.07 2.07 0 012.25 2.5h-1.5s.13-1-.5-1C16 15 16 16 14 16c0 0-4.75 0-4.75-6S12 1 14 1c.5 0 3 0 3 4"/>', $fff98676c7577ddf$var$a5 = '<path d="M12 16h-1.05a.44.44 0 01-.29-.09.6.6 0 01-.17-.22l-.7-1.84H6.2l-.7 1.84a.56.56 0 01-.16.21.43.43 0 01-.29.1H4l3.31-8.35h1.38zm-2.57-3.13L8.28 9.82a9 9 0 01-.28-.9q-.06.27-.14.5l-.14.4-1.15 3zM15 6l3-4h-6z"/>', $fff98676c7577ddf$var$t5 = '<path d="M15.75 18h-1.51a.64.64 0 01-.42-.13.8.8 0 01-.24-.32l-1-2.65H7.41l-1 2.65a.8.8 0 01-.23.31.62.62 0 01-.42.14H4.25L9 6h2zm-3.69-4.5L10.4 9.12a12 12 0 01-.4-1.3q-.09.39-.2.72t-.2.58L7.95 13.5z"/>', $fff98676c7577ddf$var$h5 = '<path d="M10 0 3 8h14zm0 18-7-8h14z"/>', $fff98676c7577ddf$var$o5 = '<path d="M19 15.9v1.29a.77.77 0 01-.23.58.86.86 0 01-.63.23h-6.76v-2.87a4.4 4.4 0 001.74-.71 5.5 5.5 0 001.4-1.42 7 7 0 00.93-1.91 7.5 7.5 0 00.34-2.28 6.15 6.15 0 00-.47-2.48 5.1 5.1 0 00-1.26-1.78 5.2 5.2 0 00-1.85-1.07 7.15 7.15 0 00-4.43 0 5.08 5.08 0 00-3.11 2.87 6.1 6.1 0 00-.47 2.48 7.5 7.5 0 00.34 2.28A6.8 6.8 0 005.47 13a5.6 5.6 0 001.41 1.39 4.4 4.4 0 001.74.71V18H1.86a.86.86 0 01-.63-.23.77.77 0 01-.23-.58V15.9h4.76l1 .12a7 7 0 01-2-1.05 7.4 7.4 0 01-1.58-1.63 7.8 7.8 0 01-1-2.1 8 8 0 01-.38-2.47 7.6 7.6 0 01.65-3.17A7.5 7.5 0 014.1 3.17a8.1 8.1 0 012.65-1.6A9.2 9.2 0 0110 1a9.2 9.2 0 013.25.57 8.1 8.1 0 012.65 1.6 7.5 7.5 0 011.78 2.47 7.6 7.6 0 01.65 3.17 8 8 0 01-.33 2.48 7.7 7.7 0 01-1 2.1A7.4 7.4 0 0115.33 15a7 7 0 01-2 1.05l1-.12h1z"/>', $fff98676c7577ddf$var$s5 = '<path d="M7 0a2 2 0 00-2 2h9a2 2 0 012 2v12a2 2 0 002-2V2a2 2 0 00-2-2z"/><path d="M13 20H4a2 2 0 01-2-2V5a2 2 0 012-2h9a2 2 0 012 2v13a2 2 0 01-2 2m-6.5-3.5.41-1.09L8 15l-1.09-.41-.41-1.09-.41 1.09L5 15l1.09.41zm2.982-.949.952-2.561 2.53-.964-2.53-.964L9.482 8.5l-.952 2.562-2.53.964 2.53.964zM6 10.5l.547-1.453L8 8.5l-1.453-.547L6 6.5l-.547 1.453L4 8.5l1.453.547z"/>', $fff98676c7577ddf$var$l5 = '<path d="M6 14H0v6z"/><rect width="20" height="16" rx="2"/>', $fff98676c7577ddf$var$n5 = '<path d="M3 1a2 2 0 00-2 2v16l4-4h12a2 2 0 002-2V3a2 2 0 00-2-2zm12 8h-4v4H9V9H5V7h4V3h2v4h4z"/>', $fff98676c7577ddf$var$v5 = '<path d="M17 4v7a2 2 0 01-2 2H4v1a2 2 0 002 2h10l4 4V6a2 2 0 00-2-2zM6 10H0v6z"/><rect width="16" height="12" rx="2"/>', $fff98676c7577ddf$var$d5 = '<path d="M20 7h-7L10 .5 7 7H0l5.46 5.47-1.64 7 6.18-3.7 6.18 3.73-1.63-7zm-10 6.9-3.76 2.27 1-4.28L3.5 8.5h4.61L10 4.6l1.9 3.9h4.6l-3.73 3.4 1 4.28z"/>', $fff98676c7577ddf$var$e5 = '<rect width="16" height="16" x="2" y="2" rx="1"/>', $fff98676c7577ddf$var$r5 = '<path d="M6 8h2.6L10 4l1.4 4h2.7l-2.4-6H8.3zm-5 2v2h3.4L2 18h3l1.7-4.6h6.6L15 18h3l-2.4-6H19v-2z"/>', $fff98676c7577ddf$var$z5 = '<path d="M5.6 9h5.9l-.4-.2-1.4-.4a7 7 0 01-1.3-.6 2.9 2.9 0 01-.9-.7 1.6 1.6 0 01-.3-1 2.3 2.3 0 01.2-1 2 2 0 01.5-.7 2.5 2.5 0 01.9-.5 3.9 3.9 0 011.2-.1 3.9 3.9 0 011.3.2 6 6 0 011 .4l.6.4a.9.9 0 00.5.2.6.6 0 00.3-.1 1 1 0 00.3-.3l.7-1.3a6 6 0 00-2-1.3 7.4 7.4 0 00-2.7-.5 6.1 6.1 0 00-2.3.4A5 5 0 006.1 3a4.5 4.5 0 00-1.4 3.2A4.7 4.7 0 005 8.1a4 4 0 00.6.9M19 11H1v2h11.4a2.3 2.3 0 010 .6 2.5 2.5 0 01-.7 2 3.3 3.3 0 01-2.3.7A4.3 4.3 0 018 16a6 6 0 01-1.1-.5l-.8-.6a1 1 0 00-.6-.2.7.7 0 00-.4 0 .8.8 0 00-.2.3L4 16.3a6.4 6.4 0 001 1 7.2 7.2 0 001.4.6 8 8 0 001.4.5 7.7 7.7 0 001.5.1 6.5 6.5 0 002.4-.4 5.1 5.1 0 001.8-1.1 4.9 4.9 0 001.1-1.7 5.6 5.6 0 00.4-2.1V13h4z"/>', $fff98676c7577ddf$var$i5 = '<path d="M7.3 8h2.3l-4-6H3.3zm3.1 0h2.3l4-6h-2.3zM1 10v2h8v6h2v-6h8v-2z"/>', $fff98676c7577ddf$var$p5 = '<path d="M13.68 16h-2.42a.67.67 0 01-.46-.15 1.3 1.3 0 01-.28-.34l-2.77-4.44a2.7 2.7 0 01-.28.69L5 15.51a2.2 2.2 0 01-.29.34.58.58 0 01-.42.15H2l4.15-6.19L2.17 4h2.42a.8.8 0 01.41.09.8.8 0 01.24.26L8 8.59a2.7 2.7 0 01.33-.74L10.6 4.4a.69.69 0 01.6-.4h2.32l-4 5.71zm3.82-4h.5v-1h-.5a1.5 1.5 0 00-1 .39 1.5 1.5 0 00-1-.39H15v1h.5a.5.5 0 01.5.5v6a.5.5 0 01-.5.5H15v1h.5a1.5 1.5 0 001-.39 1.5 1.5 0 001 .39h.5v-1h-.5a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5"/>', $fff98676c7577ddf$var$m5 = '<path d="M4 9h12v2H4z"/>', $fff98676c7577ddf$var$M5 = '<path d="M10 20a10 10 0 010-20 10 10 0 110 20m-2-5 9-8.5L15.5 5 8 12 4.5 8.5 3 10z"/>', $fff98676c7577ddf$var$H5 = '<path d="M18 1V0h-.5a1.5 1.5 0 00-1 .39 1.5 1.5 0 00-1-.39H15v1h.5a.5.5 0 01.5.5v6a.5.5 0 01-.5.5H15v1h.5a1.5 1.5 0 001-.39 1.5 1.5 0 001 .39h.5V8h-.5a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm-4.32 15h-2.42a.67.67 0 01-.46-.15 1.3 1.3 0 01-.28-.34l-2.77-4.44a2.7 2.7 0 01-.28.69L5 15.51a2.2 2.2 0 01-.29.34.58.58 0 01-.42.15H2l4.15-6.19L2.17 4h2.42a.8.8 0 01.41.09.8.8 0 01.24.26L8 8.59a2.7 2.7 0 01.33-.74L10.6 4.4a.69.69 0 01.6-.4h2.32l-4 5.71z"/>', $fff98676c7577ddf$var$g5 = '<path d="M2 2a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2zm0 4h7v4H2zm0 10v-4h7v4zm16 0h-7v-4h7zm0-6h-7V6h7z"/>', $fff98676c7577ddf$var$x5 = '<path d="M0 3v14h8v1h12V2H8v1zm10 6h3V6h2v3h3v2h-3v3h-2v-3h-3zM6 5h2v10H6zM2 5h2v10H2z"/>', $fff98676c7577ddf$var$V5 = '<path d="M18 3h-6V2H0v16h12v-1h8V3zm-8 8H7v3H5v-3H2V9h3V6h2v3h3zm4 4h-2V5h2zm4 0h-2V5h2z"/>', $fff98676c7577ddf$var$u5 = '<path d="M3 0v8H2v12h16V8h-1V0zm8 10v3h3v2h-3v3H9v-3H6v-2h3v-3zm4-4v2H5V6zm0-4v2H5V2z"/>', $fff98676c7577ddf$var$L5 = '<path d="M17 20v-8h1V0H2v12h1v8zM9 10V7H6V5h3V2h2v3h3v2h-3v3zm-4 4v-2h10v2zm0 4v-2h10v2z"/>', $fff98676c7577ddf$var$I5 = '<path d="M2 8a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2v-6a2 2 0 00-2-2zm0 2h7v2H2zm0 6v-2h7v2zm16 0h-7v-2h7zm0-4h-7v-2h7zM2 2h16v4H2z"/>', $fff98676c7577ddf$var$A5 = '<path id="cdx-icon-tableMergeCells-a" d="M9 10 4 6v3H0v2h4v3zm-7 3H0v5h8v-2H2zM0 2v5h2V4h6V2z"/><use xlink:href="#cdx-icon-tableMergeCells-a" transform="matrix(-1 0 0 1 20 0)"/>', $fff98676c7577ddf$var$C5 = '<path d="m16 10-5-4v3H6v2h5v3z"/><path d="M0 2h20v16H0zm5 6v4h5v4h8V4h-8v4z"/>', $fff98676c7577ddf$var$k5 = '<path d="m4 10 5-4v3h5v2H9v3z"/><path d="M0 2v16h20V2zm2 2h8v4h5v4h-5v4H2z"/>', $fff98676c7577ddf$var$y5 = '<path d="m10 16-4-5h3V6h2v5h3z"/><path d="M2 0v20h16V0zm2 10h4V5h4v5h4v8H4z"/>', $fff98676c7577ddf$var$F5 = '<path d="M9 9H6l4-5 4 5h-3v5H9z"/><path d="M2 0h16v20H2zm2 2v8h4v5h4v-5h4V2z"/>', $fff98676c7577ddf$var$f5 = '<path d="M9 1.28A1 1 0 008.35 1H2a1 1 0 00-1 1v6.35a1 1 0 00.28.65L11 18.72a1 1 0 001.37 0l6.38-6.38a1 1 0 00-.03-1.34zM5 7a2 2 0 112-2 2 2 0 01-2 2"/>', $fff98676c7577ddf$var$S5 = '<path d="M16 5V1h-2v4h-4v2h4v4h2V7h4V5z"/><path d="M0 17V5h8v2H2v8h12v-2h2v4z"/>', $fff98676c7577ddf$var$b5 = '<path d="m19 10-6-5v4H6v2h7v4zM6 2V1H4.5a1.5 1.5 0 00-1 .39 1.5 1.5 0 00-1-.39H1v1h1.5a.5.5 0 01.5.5v15a.5.5 0 01-.5.5H1v1h1.5a1.5 1.5 0 001-.39 1.5 1.5 0 001 .39H6v-1H4.5a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5z"/>', $fff98676c7577ddf$var$q5 = '<path d="m1 10 6-5v4h7v2H7v4zm13-8V1h1.5a1.5 1.5 0 011 .39 1.5 1.5 0 011-.39H19v1h-1.5a.5.5 0 00-.5.5v15a.5.5 0 00.5.5H19v1h-1.5a1.5 1.5 0 01-1-.39 1.5 1.5 0 01-1 .39H14v-1h1.5a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5z"/>', $fff98676c7577ddf$var$T5 = '<path d="M1 3h18v2H1zm0 4h14v2H1zm0 4h10v2H1zm0 4h18v2H1z"/>', $fff98676c7577ddf$var$B5 = '<path d="M2 17h16v2H2zm9.34-15h3.31l2 14h-3.19l-.29-2.88H8L6.43 16H3.37zm-2 8.71h3.55l-.61-5.51z"/>', $fff98676c7577ddf$var$Z5 = '<path d="M1 7h18v2H1zm0 4h14v2H1z"/>', $fff98676c7577ddf$var$W5 = '<path d="M17 2h-3.5l-1-1h-5l-1 1H3v2h14zM4 17a2 2 0 002 2h8a2 2 0 002-2V5H4z"/>', $fff98676c7577ddf$var$w5 = '<path d="M3 1a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V3a2 2 0 00-2-2zm14 12h-4l-1 2H8l-1-2H3V3h14z"/>', $fff98676c7577ddf$var$R5 = '<path d="M1.22 0 0 1.22l3.06 3.06a9 9 0 0012.66 12.66L18.78 20 20 18.78zM5 11V9h2.78l2 2zm5-10a9 9 0 00-4.26 1.08L12.66 9H15v2h-.34l3.26 3.26A9 9 0 0010 1"/>', $fff98676c7577ddf$var$U5 = '<path d="M12.14 8.48 17 6 5.58 1.92zM1.22 0 0 1.22l3 3V19h2v-6.87l3.91-2L18.78 20 20 18.78z"/>', $fff98676c7577ddf$var$D5 = '<path d="m0 1.2 4.27 4.27L0 7l11.84 6.04.16.16V20h2v-4.8l4.74 4.74 1.198-1.198L1.198.002zM14 2 7.809 4.209 14 10.399z"/>', $fff98676c7577ddf$var$E5 = '<path d="M4.83 5A4.83 4.83 0 000 9.83v.34A4.83 4.83 0 004.83 15h2.91a4.9 4.9 0 01-1.55-2H5c-4 0-4-6 0-6h3q.113.002.225.012L6.215 5zm7.43 0a4.9 4.9 0 011.55 2H15c3.179.003 4.17 4.3 1.314 5.695l1.508 1.508A4.83 4.83 0 0020 10.17v-.34A4.83 4.83 0 0015.17 5zm-3.612.03 4.329 4.327A4.83 4.83 0 008.648 5.03M7.227 8.411C7.17 8.595 7.08 9 7.08 9c-.045.273-.08.584-.08.83v.34A4.83 4.83 0 0011.83 15h3.34q.475 0 .941-.094L14.205 13H12c-2.067-.006-3.51-2.051-2.82-4zm3.755 1.36A3 3 0 0110.82 11h1.389z"/><path d="M1.22 0 0 1.22 18.8 20l1.2-1.22z"/>', $fff98676c7577ddf$var$P5 = '<path d="M15 8V5s0-5-5-5a4.63 4.63 0 00-4.88 4h2C7.31 2.93 8 2 10 2c3 0 3 2 3 3.5V8H3.93A1.93 1.93 0 002 9.93v8.15A1.93 1.93 0 003.93 20h12.14A1.93 1.93 0 0018 18.07V9.93A1.93 1.93 0 0016.07 8zm-5 8a2 2 0 112-2 2 2 0 01-2 2"/>', $fff98676c7577ddf$var$N5 = '<path d="M20 7h-7L10 .5 7 7H0l5.46 5.47-1.64 7 6.18-3.7 6.18 3.73-1.63-7z"/>', $fff98676c7577ddf$var$O5 = '<path d="M3 17h14v2H3zm4.7-6.7L10 3.7l2.3 6.6zm6.6 5.7H17L11.5 2h-3L3 16h2.7L7 12h5.8z"/>', $fff98676c7577ddf$var$i = '<path d="M3 17h14v2H3zm2.6-2.7a5.5 5.5 0 001.9 1.2 6.6 6.6 0 002.5.5 6.6 6.6 0 002.5-.5 5.4 5.4 0 003-3.1A6.8 6.8 0 0016 10V2h-2.2v8a5 5 0 01-.3 1.7 3.7 3.7 0 01-.7 1.3 3.3 3.3 0 01-1.2.8 4 4 0 01-1.6.3 4 4 0 01-1.6-.3 3.3 3.3 0 01-1.2-.9 3.6 3.6 0 01-.7-1.3 5.2 5.2 0 01-.3-1.6V2H4v8a6.8 6.8 0 00.4 2.4 5.5 5.5 0 001.2 1.9"/>', $fff98676c7577ddf$var$Q5 = '<path d="M1 8.5 8 14v-4h1c4 0 7 2 7 6v1h3v-1c0-6-5-9-10-9H8V3z"/>', $fff98676c7577ddf$var$G5 = '<path d="m10 5 8 10H2z"/>', $fff98676c7577ddf$var$K5 = '<path d="M17 12v5H3v-5H1v5a2 2 0 002 2h14a2 2 0 002-2v-5z"/><path d="M10 1 5 7h4v8h2V7h4z"/>', $fff98676c7577ddf$var$J5 = '<path d="M10 12.5c-5.92 0-9 3.5-9 5.5v1h18v-1c0-2-3.08-5.5-9-5.5"/><circle cx="10" cy="6" r="5"/>', $fff98676c7577ddf$var$Y5 = '<circle cx="8.5" cy="10.5" r="3.5"/><path d="M14 0v4h-4v2h4v4h2V6h4V4h-4V0zM8 15c-4.6 0-7 2.69-7 4.23V20h14v-.77C15 17.69 12.6 15 8 15"/>', $fff98676c7577ddf$var$j5 = '<path d="M15 2H5L4 8h12zM0 10s2 1 10 1 10-1 10-1l-4-2H4zm8 4h4v1H8z"/><circle cx="6" cy="15" r="3"/><circle cx="14" cy="15" r="3"/>', $fff98676c7577ddf$var$X5 = '<path d="M10 11c-5.92 0-8 3-8 5v3h16v-3c0-2-2.08-5-8-5"/><circle cx="10" cy="5.5" r="4.5"/>', $fff98676c7577ddf$var$_5 = '<path d="M10 8c1.7 0 3.06-1.35 3.06-3S11.7 2 10 2 6.94 3.35 6.94 5 8.3 8 10 8m0 2c-2.8 0-5.06-2.24-5.06-5S7.2 0 10 0s5.06 2.24 5.06 5-2.26 5-5.06 5m-7 8h14v-1.33c0-1.75-2.31-3.56-7-3.56s-7 1.81-7 3.56zm7-6.89c6.66 0 9 3.33 9 5.56V20H1v-3.33c0-2.23 2.34-5.56 9-5.56"/>', $fff98676c7577ddf$var$$5 = '<circle cx="15.5" cy="10.5" r="2.5"/><path d="M1 15h8v2H1Zm0-6h10v2H1Zm0-6h16v2H1Zm14.5 10.6c-3.3 0-4.5 1.6-4.5 2.7V18h9v-1.7c0-1-1.2-2.7-4.5-2.7"/>', $fff98676c7577ddf$var$c3 = '<circle cx="6" cy="6" r="3"/><circle cx="14" cy="6" r="3"/><path d="M14 10c3.31 0 6 1.79 6 4v2h-6v-2c0-1.48-1.21-2.77-3-3.46.88-.35 1.91-.54 3-.54m-8 0c3.31 0 6 1.79 6 4v2H0v-2c0-2.21 2.69-4 6-4"/>', $fff98676c7577ddf$var$a3 = '<circle cx="10" cy="5.5" r="4.5"/><path d="M20 16.288v-1.632l-1.012-.168c-.055-.22-.164-.437-.324-.76l-.014-.028.619-.844-1.181-1.18-.844.618a3 3 0 00-.788-.338l-.112-1.012h-1.632l-.141.851-.027.161c-.282.056-.507.17-.788.338l-.844-.619-1.18 1.181.562.844c-.106.176-.168.33-.227.49l-.025.07-.01.027q-.035.096-.076.2L11 14.6v1.631l1.012.17c.057.28.17.505.338.786l-.563.844.969.969.213.213.32-.213.524-.35c.199.1.443.2.691.3l.05.02.046.018.002.012.167 1h1.687l.167-1 .002-.012c.281-.057.506-.17.787-.338l.477.35.367.27 1.182-1.182-.62-.844c.17-.28.282-.563.338-.788Zm-4.5.843a1.66 1.66 0 01-1.688-1.687c0-.956.732-1.688 1.688-1.688s1.688.732 1.688 1.688-.732 1.687-1.688 1.687M10 11c.739 0 1.418.047 2.04.133l-1.594 1.596.574.862-1.02.12v3.367l1.098.183-.598.897.842.842H2v-3c0-2 2.083-5 8-5"/>', $fff98676c7577ddf$var$t3 = '<path d="M18 0H2a2 2 0 00-2 2v18l4-4h14a2 2 0 002-2V2a2 2 0 00-2-2m-4 4a1.5 1.5 0 11-1.5 1.5A1.5 1.5 0 0114 4M6 4a1.5 1.5 0 11-1.5 1.5A1.5 1.5 0 016 4m4 8c-2.61 0-4.83-.67-5.65-3h11.3c-.82 2.33-3.04 3-5.65 3"/>', $fff98676c7577ddf$var$h3 = '<path d="M18 16c0-2-2.083-5-8-5q-.534 0-1.026.032l.276 1.986Q9.609 13 10 13v4H6v2h2v-2h2v2h8zm-8-6a4.5 4.5 0 10-.878-8.914l.388 1.962Q9.745 3.001 10 3v5q-.255 0-.49-.048l-.388 1.962Q9.548 10 10 10m-2.933 1.29c-.69.149-1.3.35-1.834.59l1.051 1.713c.351-.14.755-.263 1.218-.36zM4 19v-2H2v2zm-1.84-4h2.228c.124-.18.284-.37.49-.557L3.64 12.866c-.78.66-1.254 1.416-1.48 2.134M7.5 1.758 8.613 3.42c-.274.183-.51.419-.693.693L6.258 3c.329-.49.751-.913 1.242-1.242M5.586 4.622l1.962.388a2.5 2.5 0 000 .98l-1.962.388a4.5 4.5 0 010-1.756M6.258 8 7.92 6.887c.183.274.419.51.693.693L7.5 9.242A4.5 4.5 0 016.258 8"/>', $fff98676c7577ddf$var$o3 = '<path d="m4 14 5.2 3.9c.3.3.8 0 .8-.5V2.6c0-.5-.5-.8-.8-.5L4 6m0 8H1c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h3m9.5 8.5c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4 1.6-1.6 1.6-4.1 0-5.7-.4-.4-.3-1.1.1-1.4s.9-.3 1.3 0c2.3 2.3 2.3 6.1 0 8.5-.1.2-.4.3-.7.3"/>', $fff98676c7577ddf$var$s3 = '<path d="m20 18.6-2.3-2.3-1.4-1.4-1.4-1.4-1.5-1.5L10 8.6l-4-4L1.4 0 0 1.4l4.3 4.3L4 6H1c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h3l5.2 3.9c.3.3.8 0 .8-.5v-6l5.6 5.6 2.9 2.9zm-10-16c0-.5-.5-.8-.8-.5L7.6 3.3 10 5.8zm5.7 1.7c2.4 2.4 2.9 5.9 1.7 8.8l1.5 1.5c2-3.8 1.4-8.5-1.8-11.7-.4-.3-.9-.3-1.3 0-.4.4-.5 1-.1 1.4m-2.9 2.9c.7.7 1.1 1.6 1.1 2.6l1.8 1.8c.5-2 0-4.2-1.5-5.8-.4-.3-.9-.3-1.3 0s-.4 1-.1 1.4"/>', $fff98676c7577ddf$var$l3 = '<path d="M20 18.6 18.6 20l-4.5-4.5-3.3 2.4c-.3.3-.8 0-.8-.5v-6L6.6 8c-.9 1.5-.7 3.3.5 4.7l.2.2c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3s-.6-.1-.7-.3c-2-2.1-2.3-5.4-.7-7.7L3.7 5.1c-2.5 3.1-2.2 7.7.6 10.6.2.2.3.4.3.7 0 .5-.4 1-1 1-.2 0-.5-.1-.7-.3C-.7 13.4-1 7.6 2.3 3.7L0 1.4 1.4 0m9.4 2.1L16 6h3c.6 0 .9.3 1 .9V13c0 .6-.3.9-.9 1h-.8L10 5.8V2.7c0-.6.5-.9.8-.6"/>', $fff98676c7577ddf$var$n3 = '<path d="M4 6v8l5.2 3.9c.3.3.8 0 .8-.5V2.6c0-.5-.5-.8-.8-.5zm0 8H1a1 1 0 01-1-1V7a1 1 0 011-1h3m12.4 11.4a1 1 0 01-.7-1.7 8 8 0 000-11.4A1 1 0 0117 3a10 10 0 010 14.2 1 1 0 01-.7.3z"/><path d="M13.5 14.5a1 1 0 01-.7-.3 1 1 0 010-1.4 4 4 0 000-5.6 1 1 0 011.4-1.4 6 6 0 010 8.4 1 1 0 01-.7.3"/>', $fff98676c7577ddf$var$v3 = '<path d="M2 2h4v4H2zm12 0h4v4h-4zM8 2h4v4H8zM2 14h4v4H2zm12 0h4v4h-4zm-6 0h4v4H8zM2 8h4v4H2zm12 0h4v4h-4zM8 8h4v4H8z"/>', $fff98676c7577ddf$var$d3 = '<path d="M8 6h9v2H8zm0-3h11v2H8zM1 3h6v6H1zm7 11h9v2H8zm0-3h11v2H8zm-7 0h6v6H1z"/>', $fff98676c7577ddf$var$e3 = '<path d="M17.5 11.83a.79.79 0 01-.83.83h-3.34A1.49 1.49 0 0111.67 11V9.33a.79.79 0 01.83-.83h4.17a.79.79 0 01.83.83zM8.33 11a1.49 1.49 0 01-1.67 1.67H3.33a.79.79 0 01-.83-.83V9.33a.79.79 0 01.83-.83H7.5a.79.79 0 01.83.83zM0 6.2v6.28a.2.2 0 00.2.2h1.72a1.61 1.61 0 001.42.83h3.33A2.46 2.46 0 009.13 12a.19.19 0 01.18-.13h1.39a.19.19 0 01.18.13 2.46 2.46 0 002.46 1.53h3.33c.55 0 1.1 0 1.37-.7a.2.2 0 01.18-.13h1.58a.2.2 0 00.2-.2V6.2a.2.2 0 00-.2-.2H.2a.2.2 0 00-.2.2"/>', $fff98676c7577ddf$var$r3 = '<path d="M1 3h16v2H1Zm0 6h6v2H1Zm0 6h8v2H1Zm8-4.24h3.85L14.5 7l1.65 3.76H20l-3 3.17.9 4.05-3.4-2.14L11.1 18l.9-4.05Z"/>', $fff98676c7577ddf$var$M = '<path d="M1 3v14h3v-2H3V5h1V3zm4 0v14h4v-2H7V5h2V3zm11 0v2h1v10h-1v2h3V3zm-5 0v2h2v10h-2v2h4V3z"/>', $fff98676c7577ddf$var$z3 = '<path d="M2 2a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2zm0 2h16v12H2z"/><path d="M4 6h12v2H4z"/>', $fff98676c7577ddf$var$i3 = '<path d="M8 15a7 7 0 004.2-1.4l5.4 5.4 1.4-1.4-5.4-5.4A7 7 0 108 15m0-2A5 5 0 118 3a5 5 0 010 10m1-6h2v2H9v2H7V9H5V7h2V5h2Z"/>', $fff98676c7577ddf$var$p3 = '<path d="M8 15a7 7 0 004.2-1.4l5.4 5.4 1.4-1.4-5.4-5.4A7 7 0 108 15m0-2A5 5 0 118 3a5 5 0 010 10M5 7h6v2H5Z"/>', $fff98676c7577ddf$export$8b4a3712db5e5259 = $fff98676c7577ddf$var$H, $fff98676c7577ddf$export$3789de9f39aa8866 = $fff98676c7577ddf$var$g, $fff98676c7577ddf$export$8e8820e7fe2c2c56 = $fff98676c7577ddf$var$x, $fff98676c7577ddf$export$a427c5cc51aaa0a9 = $fff98676c7577ddf$var$V, $fff98676c7577ddf$export$c85c683dec941b20 = $fff98676c7577ddf$var$u, $fff98676c7577ddf$export$3d566aa70c22a212 = $fff98676c7577ddf$var$L, $fff98676c7577ddf$export$762a0d3de84f4d81 = {
    ltr: $fff98676c7577ddf$var$I,
    shouldFlip: !0
}, $fff98676c7577ddf$export$585a3d1ebe665a8f = {
    ltr: $fff98676c7577ddf$var$A,
    shouldFlip: !0
}, $fff98676c7577ddf$export$927c1e66a14ace5f = {
    ltr: $fff98676c7577ddf$var$C,
    shouldFlip: !0
}, $fff98676c7577ddf$export$67910a76cfdc32cc = $fff98676c7577ddf$var$k, $fff98676c7577ddf$export$ad46b9c10c06c614 = $fff98676c7577ddf$var$y, $fff98676c7577ddf$export$cf29cc808e0db959 = {
    ltr: $fff98676c7577ddf$var$F,
    shouldFlip: !0
}, $fff98676c7577ddf$export$73cc19c2693ac6b = {
    ltr: $fff98676c7577ddf$var$f,
    shouldFlip: !0,
    shouldFlipExceptions: [
        "he",
        "yi"
    ]
}, $fff98676c7577ddf$export$17651ceaf7f1d64e = {
    ltr: $fff98676c7577ddf$var$S,
    shouldFlip: !0
}, $fff98676c7577ddf$export$75db531473ab62ca = {
    ltr: $fff98676c7577ddf$var$b,
    shouldFlip: !0
}, $fff98676c7577ddf$export$d89678e0b33cc210 = $fff98676c7577ddf$var$q, $fff98676c7577ddf$export$cf08a14a4b50d3be = {
    ltr: $fff98676c7577ddf$var$T,
    rtl: $fff98676c7577ddf$var$B
}, $fff98676c7577ddf$export$afaf3cb822b119f7 = $fff98676c7577ddf$var$Z, $fff98676c7577ddf$export$433d76dbc0e37afe = $fff98676c7577ddf$var$W, $fff98676c7577ddf$export$b0732dbf372dc6f0 = $fff98676c7577ddf$var$w, $fff98676c7577ddf$export$34a9d635a4d1e044 = $fff98676c7577ddf$var$R, $fff98676c7577ddf$export$2867b74ff2626e39 = $fff98676c7577ddf$var$U, $fff98676c7577ddf$export$664e2ae730597dd2 = {
    langCodeMap: {
        ar: $fff98676c7577ddf$var$E,
        be: $fff98676c7577ddf$var$K,
        ce: $fff98676c7577ddf$var$G,
        cs: $fff98676c7577ddf$var$l,
        en: $fff98676c7577ddf$var$l,
        he: $fff98676c7577ddf$var$l,
        ml: $fff98676c7577ddf$var$l,
        pl: $fff98676c7577ddf$var$l,
        sco: $fff98676c7577ddf$var$l,
        da: $fff98676c7577ddf$var$o,
        de: $fff98676c7577ddf$var$o,
        hu: $fff98676c7577ddf$var$o,
        ksh: $fff98676c7577ddf$var$o,
        nn: $fff98676c7577ddf$var$o,
        no: $fff98676c7577ddf$var$o,
        sv: $fff98676c7577ddf$var$o,
        es: $fff98676c7577ddf$var$e,
        gl: $fff98676c7577ddf$var$e,
        pt: $fff98676c7577ddf$var$e,
        eu: $fff98676c7577ddf$var$z,
        fi: $fff98676c7577ddf$var$z,
        fa: $fff98676c7577ddf$var$P,
        fr: $fff98676c7577ddf$var$r,
        it: $fff98676c7577ddf$var$r,
        hy: $fff98676c7577ddf$var$O,
        ka: $fff98676c7577ddf$var$J,
        ky: $fff98676c7577ddf$var$d,
        ru: $fff98676c7577ddf$var$d,
        uk: $fff98676c7577ddf$var$d,
        nl: $fff98676c7577ddf$var$Y,
        os: $fff98676c7577ddf$var$Q,
        ur: $fff98676c7577ddf$var$N
    },
    default: $fff98676c7577ddf$var$D
}, $fff98676c7577ddf$export$f2629dd30fd3d8a9 = {
    ltr: $fff98676c7577ddf$var$j,
    shouldFlip: !0
}, $fff98676c7577ddf$export$6635bf398cb1da26 = $fff98676c7577ddf$var$X, $fff98676c7577ddf$export$16598f35e1bc8b09 = $fff98676c7577ddf$var$_, $fff98676c7577ddf$export$4f1cdff7f8a5d67d = $fff98676c7577ddf$var$$, $fff98676c7577ddf$export$f2bdd35609785e6f = {
    ltr: $fff98676c7577ddf$var$c1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$581fd6fda0d7cf4a = $fff98676c7577ddf$var$a1, $fff98676c7577ddf$export$5674178d4a7f2fde = $fff98676c7577ddf$var$t1, $fff98676c7577ddf$export$aa27fbee1c07e267 = $fff98676c7577ddf$var$h1, $fff98676c7577ddf$export$32b3bfc0a8b18852 = $fff98676c7577ddf$var$o1, $fff98676c7577ddf$export$10adfc8e4f813da7 = $fff98676c7577ddf$var$s1, $fff98676c7577ddf$export$7fb292913a773bb3 = $fff98676c7577ddf$var$l1, $fff98676c7577ddf$export$6a8358a2246fc25d = $fff98676c7577ddf$var$n1, $fff98676c7577ddf$export$b496308a45c5d4c2 = $fff98676c7577ddf$var$v1, $fff98676c7577ddf$export$c282c82fdb688938 = $fff98676c7577ddf$var$d1, $fff98676c7577ddf$export$d65195d6064d44ca = $fff98676c7577ddf$var$e1, $fff98676c7577ddf$export$a529c9a41741f7a = $fff98676c7577ddf$var$r1, $fff98676c7577ddf$export$94f59b3089d1f340 = {
    ltr: $fff98676c7577ddf$var$z1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$a1d126cec859a3f = {
    ltr: $fff98676c7577ddf$var$i1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$17edf8b2ca44cb85 = $fff98676c7577ddf$var$p1, $fff98676c7577ddf$export$b281050478452039 = $fff98676c7577ddf$var$m1, $fff98676c7577ddf$export$3d8545ab5d61f904 = {
    ltr: $fff98676c7577ddf$var$M1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$2309a4a56867caf2 = {
    ltr: $fff98676c7577ddf$var$H1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$f4fb2d66276e0a97 = $fff98676c7577ddf$var$g1, $fff98676c7577ddf$export$1a020e39ef829a40 = $fff98676c7577ddf$var$x1, $fff98676c7577ddf$export$42dadaa17b0191de = $fff98676c7577ddf$var$V1, $fff98676c7577ddf$export$d6fb4db85f196eee = $fff98676c7577ddf$var$u1, $fff98676c7577ddf$export$1f3952f9e69fc6e1 = $fff98676c7577ddf$var$L1, $fff98676c7577ddf$export$add101d844bfa0ea = {
    ltr: $fff98676c7577ddf$var$I1,
    rtl: $fff98676c7577ddf$var$A1
}, $fff98676c7577ddf$export$b966adf6b0f4e3c7 = $fff98676c7577ddf$var$C1, $fff98676c7577ddf$export$b380a05c42c1d99f = $fff98676c7577ddf$var$k1, $fff98676c7577ddf$export$e93d1ce227cdf266 = $fff98676c7577ddf$var$y1, $fff98676c7577ddf$export$c64b033c23def486 = $fff98676c7577ddf$var$F1, $fff98676c7577ddf$export$8aa254c78917e37c = $fff98676c7577ddf$var$f1, $fff98676c7577ddf$export$7d244834340bd750 = $fff98676c7577ddf$var$S1, $fff98676c7577ddf$export$d5da2c2883d4b9c0 = {
    ltr: $fff98676c7577ddf$var$b1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$cc42306153f329c9 = {
    ltr: $fff98676c7577ddf$var$q1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$4e0cfbc6821c3dba = {
    ltr: $fff98676c7577ddf$var$T1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$67224572ded694a6 = $fff98676c7577ddf$var$B1, $fff98676c7577ddf$export$a69968890d4904d6 = {
    ltr: $fff98676c7577ddf$var$Z1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$d2a6dca2f051dd48 = $fff98676c7577ddf$var$W1, $fff98676c7577ddf$export$fecd6d03bb2c004b = {
    ltr: $fff98676c7577ddf$var$w1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$7bad7ccb8c59799 = $fff98676c7577ddf$var$R1, $fff98676c7577ddf$export$d8f4eed4227bf763 = {
    ltr: $fff98676c7577ddf$var$U1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$cdfff317efeb9bc1 = {
    ltr: $fff98676c7577ddf$var$D1,
    shouldFlip: !0
}, $fff98676c7577ddf$export$c3c8d179e7e09ba5 = $fff98676c7577ddf$var$E1, $fff98676c7577ddf$export$70be1191c07403d9 = $fff98676c7577ddf$var$P1, $fff98676c7577ddf$export$a5116550fef0ea42 = {
    ltr: $fff98676c7577ddf$var$N1,
    shouldFlip: !0,
    shouldFlipExceptions: [
        "he",
        "yi"
    ]
}, $fff98676c7577ddf$export$9b05a54388b23ab0 = {
    ltr: $fff98676c7577ddf$var$O1,
    shouldFlip: !0,
    shouldFlipExceptions: [
        "he",
        "yi"
    ]
}, $fff98676c7577ddf$export$da39b0629c65339 = $fff98676c7577ddf$var$Q1, $fff98676c7577ddf$export$fed6ee554d56d00c = $fff98676c7577ddf$var$G1, $fff98676c7577ddf$export$8a2a230105fbb969 = $fff98676c7577ddf$var$K1, $fff98676c7577ddf$export$dc60b9ffd67932c0 = $fff98676c7577ddf$var$J1, $fff98676c7577ddf$export$32cf3ab91eef61b3 = $fff98676c7577ddf$var$Y1, $fff98676c7577ddf$export$15f90b0d2422861d = {
    ltr: $fff98676c7577ddf$var$j1,
    rtl: $fff98676c7577ddf$var$X1
}, $fff98676c7577ddf$export$aa223152c841f955 = $fff98676c7577ddf$var$_1, $fff98676c7577ddf$export$56129141f0198139 = $fff98676c7577ddf$var$$1, $fff98676c7577ddf$export$bf894e95763fb983 = $fff98676c7577ddf$var$c0, $fff98676c7577ddf$export$8f01252389625fd2 = $fff98676c7577ddf$var$a0, $fff98676c7577ddf$export$9311ec9ed5fd5350 = $fff98676c7577ddf$var$t0, $fff98676c7577ddf$export$3bdae1a17ea3aef1 = $fff98676c7577ddf$var$h0, $fff98676c7577ddf$export$5f3bbd1f1158ae9a = {
    ltr: $fff98676c7577ddf$var$o0,
    rtl: $fff98676c7577ddf$var$s0
}, $fff98676c7577ddf$export$eb45c88764d4d907 = {
    ltr: $fff98676c7577ddf$var$l0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$1d5515e32ce93924 = {
    ltr: $fff98676c7577ddf$var$n0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$3c2dd3b5624acde1 = {
    ltr: $fff98676c7577ddf$var$v0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$b545b338dd7f23c8 = {
    langCodeMap: {
        ar: $fff98676c7577ddf$var$p
    },
    default: $fff98676c7577ddf$var$d0
}, $fff98676c7577ddf$export$752ab2a393f368b4 = {
    langCodeMap: {
        ar: $fff98676c7577ddf$var$p
    },
    default: $fff98676c7577ddf$var$e0
}, $fff98676c7577ddf$export$396735e621866f77 = {
    langCodeMap: {
        ar: $fff98676c7577ddf$var$i0,
        cs: $fff98676c7577ddf$var$t,
        en: $fff98676c7577ddf$var$t,
        fr: $fff98676c7577ddf$var$t,
        he: $fff98676c7577ddf$var$t,
        ml: $fff98676c7577ddf$var$t,
        pl: $fff98676c7577ddf$var$t,
        pt: $fff98676c7577ddf$var$t,
        sco: $fff98676c7577ddf$var$t,
        be: $fff98676c7577ddf$var$a,
        ce: $fff98676c7577ddf$var$a,
        da: $fff98676c7577ddf$var$a,
        de: $fff98676c7577ddf$var$a,
        fi: $fff98676c7577ddf$var$a,
        ky: $fff98676c7577ddf$var$a,
        nn: $fff98676c7577ddf$var$a,
        no: $fff98676c7577ddf$var$a,
        os: $fff98676c7577ddf$var$a,
        sv: $fff98676c7577ddf$var$a,
        ru: $fff98676c7577ddf$var$a,
        uk: $fff98676c7577ddf$var$a,
        es: $fff98676c7577ddf$var$v,
        gl: $fff98676c7577ddf$var$v,
        it: $fff98676c7577ddf$var$v,
        nl: $fff98676c7577ddf$var$v,
        eu: $fff98676c7577ddf$var$H0,
        fa: $fff98676c7577ddf$var$z0,
        hu: $fff98676c7577ddf$var$M0,
        hy: $fff98676c7577ddf$var$m0,
        ksh: $fff98676c7577ddf$var$x0,
        ka: $fff98676c7577ddf$var$g0,
        ur: $fff98676c7577ddf$var$p0
    },
    default: $fff98676c7577ddf$var$r0
}, $fff98676c7577ddf$export$d62865d2547237a9 = {
    ltr: $fff98676c7577ddf$var$V0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$4ae876e052ca6a6b = $fff98676c7577ddf$var$u0, $fff98676c7577ddf$export$701af9929b1b413a = $fff98676c7577ddf$var$L0, $fff98676c7577ddf$export$19f4c64dfdaeee91 = $fff98676c7577ddf$var$I0, $fff98676c7577ddf$export$d4564faaec7e0008 = $fff98676c7577ddf$var$A0, $fff98676c7577ddf$export$3483665629bda76e = $fff98676c7577ddf$var$C0, $fff98676c7577ddf$export$c51bd4e0fcd485df = {
    ltr: $fff98676c7577ddf$var$k0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$da5406547c430f7a = $fff98676c7577ddf$var$y0, $fff98676c7577ddf$export$f915d4742cb5dd68 = {
    ltr: $fff98676c7577ddf$var$F0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$75d0e85af0a8fc1f = $fff98676c7577ddf$var$f0, $fff98676c7577ddf$export$a1a7f54778c492c7 = {
    ltr: $fff98676c7577ddf$var$S0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$2738c2187d6bbe66 = {
    ltr: $fff98676c7577ddf$var$b0,
    rtl: $fff98676c7577ddf$var$q0
}, $fff98676c7577ddf$export$b247567fb6517202 = $fff98676c7577ddf$var$T0, $fff98676c7577ddf$export$3d7e593c95bb2027 = {
    ltr: $fff98676c7577ddf$var$B0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$a99781bbb9a626bc = {
    ltr: $fff98676c7577ddf$var$Z0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$bce1c99d88f0f5b4 = $fff98676c7577ddf$var$W0, $fff98676c7577ddf$export$5b8bb24937e7229c = $fff98676c7577ddf$var$w0, $fff98676c7577ddf$export$9c8853a01f349f59 = $fff98676c7577ddf$var$R0, $fff98676c7577ddf$export$db220b1723a28ec5 = $fff98676c7577ddf$var$U0, $fff98676c7577ddf$export$5c12ea71f69a73a2 = $fff98676c7577ddf$var$D0, $fff98676c7577ddf$export$5a06bea7c9c51c75 = $fff98676c7577ddf$var$E0, $fff98676c7577ddf$export$63be0c6a52d8c838 = $fff98676c7577ddf$var$P0, $fff98676c7577ddf$export$2ab45fb3ee4c00e4 = $fff98676c7577ddf$var$N0, $fff98676c7577ddf$export$2c34038a82212169 = $fff98676c7577ddf$var$O0, $fff98676c7577ddf$export$4188f82aba4e0549 = $fff98676c7577ddf$var$Q0, $fff98676c7577ddf$export$9c655571e65a2c0a = $fff98676c7577ddf$var$G0, $fff98676c7577ddf$export$fa35bb55cc4364ac = $fff98676c7577ddf$var$K0, $fff98676c7577ddf$export$58830203ef0d3447 = $fff98676c7577ddf$var$J0, $fff98676c7577ddf$export$41b8de465ae2678e = $fff98676c7577ddf$var$Y0, $fff98676c7577ddf$export$9ea7f81b1346c60e = $fff98676c7577ddf$var$j0, $fff98676c7577ddf$export$6c593fb4dd9cab81 = $fff98676c7577ddf$var$X0, $fff98676c7577ddf$export$ec2e93668b77dc5d = $fff98676c7577ddf$var$_0, $fff98676c7577ddf$export$de198b1e482507f0 = {
    ltr: $fff98676c7577ddf$var$$0,
    shouldFlip: !0
}, $fff98676c7577ddf$export$dabed8ab15d0dc48 = $fff98676c7577ddf$var$c2, $fff98676c7577ddf$export$34c99570b87cdb1c = $fff98676c7577ddf$var$a2, $fff98676c7577ddf$export$3842164d6e44d686 = $fff98676c7577ddf$var$t2, $fff98676c7577ddf$export$aeaf94cd042f99a8 = $fff98676c7577ddf$var$h2, $fff98676c7577ddf$export$530cacc27985154f = $fff98676c7577ddf$var$o2, $fff98676c7577ddf$export$147c2d164feec218 = $fff98676c7577ddf$var$s2, $fff98676c7577ddf$export$2b202ff7e81f8184 = $fff98676c7577ddf$var$l2, $fff98676c7577ddf$export$a10c0e1799cf326f = $fff98676c7577ddf$var$n2, $fff98676c7577ddf$export$3da0cd3b23305c90 = $fff98676c7577ddf$var$v2, $fff98676c7577ddf$export$bfd1db7a5e279299 = $fff98676c7577ddf$var$d2, $fff98676c7577ddf$export$7547f3b8f653c59c = $fff98676c7577ddf$var$e2, $fff98676c7577ddf$export$bc89f624bcf8084e = $fff98676c7577ddf$var$r2, $fff98676c7577ddf$export$37902123073b9824 = {
    ltr: $fff98676c7577ddf$var$z2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$363bb4a8314b1119 = {
    ltr: $fff98676c7577ddf$var$i2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$7580be3e079c0a98 = $fff98676c7577ddf$var$p2, $fff98676c7577ddf$export$fec89bca40b94f77 = $fff98676c7577ddf$var$m2, $fff98676c7577ddf$export$df87f1531e90bdb3 = $fff98676c7577ddf$var$M2, $fff98676c7577ddf$export$3022b44fa429d434 = {
    ltr: $fff98676c7577ddf$var$H2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$3f0599c8d2f866e6 = {
    ltr: $fff98676c7577ddf$var$g2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$e23fe245a6a341c0 = {
    ltr: $fff98676c7577ddf$var$x2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$e873de9c265ef045 = {
    ltr: $fff98676c7577ddf$var$V2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$3bad1eaeabbf7917 = $fff98676c7577ddf$var$m, $fff98676c7577ddf$export$6d9b2a238dd559bd = $fff98676c7577ddf$var$m, $fff98676c7577ddf$export$184ff4f215bf91c0 = $fff98676c7577ddf$var$u2, $fff98676c7577ddf$export$d1c93e6af2cdda4c = $fff98676c7577ddf$var$L2, $fff98676c7577ddf$export$6e7000a955d4e27c = {
    ltr: $fff98676c7577ddf$var$I2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$cf48a0b26d274b8e = {
    ltr: $fff98676c7577ddf$var$A2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$551ddbef2ee68dff = {
    ltr: $fff98676c7577ddf$var$C2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$dc75a5fed2b1acdd = $fff98676c7577ddf$var$k2, $fff98676c7577ddf$export$d20c33ef4014ca5f = {
    ltr: $fff98676c7577ddf$var$y2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$bfa3d9dbd7e0ba0b = {
    ltr: $fff98676c7577ddf$var$F2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$7f0a3eee396550d2 = $fff98676c7577ddf$var$f2, $fff98676c7577ddf$export$508f0988d770d488 = $fff98676c7577ddf$var$S2, $fff98676c7577ddf$export$7666d52f0c4f00f2 = {
    ltr: $fff98676c7577ddf$var$b2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$f5d653dc487f0be1 = $fff98676c7577ddf$var$q2, $fff98676c7577ddf$export$24339a27796a821a = $fff98676c7577ddf$var$T2, $fff98676c7577ddf$export$acd50f7540e581ac = {
    ltr: $fff98676c7577ddf$var$B2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$f459e0cc8b2d26ca = {
    ltr: $fff98676c7577ddf$var$Z2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$5a4cc7357d436fa3 = $fff98676c7577ddf$var$W2, $fff98676c7577ddf$export$87b130a89e2602e6 = {
    ltr: $fff98676c7577ddf$var$w2,
    rtl: $fff98676c7577ddf$var$R2
}, $fff98676c7577ddf$export$f98adb87d7f7beb3 = {
    ltr: $fff98676c7577ddf$var$U2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$f47908f5baeb18b4 = $fff98676c7577ddf$var$D2, $fff98676c7577ddf$export$a59f5b063a401c96 = {
    ltr: $fff98676c7577ddf$var$E2,
    rtl: $fff98676c7577ddf$var$P2
}, $fff98676c7577ddf$export$5ccc1ba7bd09ec5d = {
    ltr: $fff98676c7577ddf$var$N2,
    shouldFlip: !0
}, $fff98676c7577ddf$export$b07055c704bf52f0 = $fff98676c7577ddf$var$O2, $fff98676c7577ddf$export$4dd38b076ae79942 = $fff98676c7577ddf$var$Q2, $fff98676c7577ddf$export$a57991056ea735fa = $fff98676c7577ddf$var$G2, $fff98676c7577ddf$export$f476fc8d975588be = $fff98676c7577ddf$var$K2, $fff98676c7577ddf$export$998df425b9e11098 = $fff98676c7577ddf$var$J2, $fff98676c7577ddf$export$7c8f8d030c3fcabc = $fff98676c7577ddf$var$Y2, $fff98676c7577ddf$export$432ab00ecbea594a = $fff98676c7577ddf$var$j2, $fff98676c7577ddf$export$b925259b6ad84e03 = $fff98676c7577ddf$var$X2, $fff98676c7577ddf$export$bc5517534214c2a1 = $fff98676c7577ddf$var$_2, $fff98676c7577ddf$export$c5152ec34a67c148 = $fff98676c7577ddf$var$$2, $fff98676c7577ddf$export$5f80c60a9151e750 = {
    ltr: $fff98676c7577ddf$var$c5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$2d504fa3474468ea = $fff98676c7577ddf$var$a5, $fff98676c7577ddf$export$e34ff6746cd6729e = $fff98676c7577ddf$var$t5, $fff98676c7577ddf$export$2c9ea826c06333ec = $fff98676c7577ddf$var$h5, $fff98676c7577ddf$export$f9e9ee9fa2854ddb = $fff98676c7577ddf$var$o5, $fff98676c7577ddf$export$16b01586527c6074 = {
    ltr: $fff98676c7577ddf$var$s5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$f3d4ec95f3f45bac = {
    ltr: $fff98676c7577ddf$var$l5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$abb82b97bb6e7446 = {
    ltr: $fff98676c7577ddf$var$n5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$510606979d4afa72 = {
    ltr: $fff98676c7577ddf$var$v5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$c7b11920c23c35e9 = $fff98676c7577ddf$var$d5, $fff98676c7577ddf$export$b9644e743f2fb2d1 = $fff98676c7577ddf$var$e5, $fff98676c7577ddf$export$d9ed90526c24a019 = {
    langCodeMap: {
        en: $fff98676c7577ddf$var$z5,
        fi: $fff98676c7577ddf$var$i5
    },
    default: $fff98676c7577ddf$var$r5
}, $fff98676c7577ddf$export$5acd2c715641ede2 = {
    ltr: $fff98676c7577ddf$var$p5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$fa1c9acf4753fedc = $fff98676c7577ddf$var$m5, $fff98676c7577ddf$export$75bcedee58330432 = $fff98676c7577ddf$var$M5, $fff98676c7577ddf$export$48ea8db7a9600d07 = {
    ltr: $fff98676c7577ddf$var$H5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$d79ddb79680548bc = $fff98676c7577ddf$var$g5, $fff98676c7577ddf$export$cbe01a15dbae5272 = {
    ltr: $fff98676c7577ddf$var$x5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$ac806f1feb220e2c = {
    ltr: $fff98676c7577ddf$var$V5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$add464e2744be304 = $fff98676c7577ddf$var$u5, $fff98676c7577ddf$export$bae91ec7c03ea55f = $fff98676c7577ddf$var$L5, $fff98676c7577ddf$export$84b68a96a6c19c70 = $fff98676c7577ddf$var$I5, $fff98676c7577ddf$export$e16d35143a20446e = $fff98676c7577ddf$var$A5, $fff98676c7577ddf$export$f3c9d1f87ad31985 = {
    ltr: $fff98676c7577ddf$var$C5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$cfcd597c8ccf9637 = {
    ltr: $fff98676c7577ddf$var$k5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$9bdf25b5d004c3d4 = $fff98676c7577ddf$var$y5, $fff98676c7577ddf$export$3a745f11789a70e8 = $fff98676c7577ddf$var$F5, $fff98676c7577ddf$export$25d8651b915b6e6d = {
    ltr: $fff98676c7577ddf$var$f5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$158770cea961694b = {
    ltr: $fff98676c7577ddf$var$S5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$35e0bb2077a01c99 = $fff98676c7577ddf$var$b5, $fff98676c7577ddf$export$448a1e2de1dad3b6 = $fff98676c7577ddf$var$q5, $fff98676c7577ddf$export$6f1ec1af94ac7659 = {
    ltr: $fff98676c7577ddf$var$T5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$b7b20e8c8258b9f = $fff98676c7577ddf$var$B5, $fff98676c7577ddf$export$78984bd154591501 = {
    ltr: $fff98676c7577ddf$var$Z5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$61b5976a4610f93a = $fff98676c7577ddf$var$W5, $fff98676c7577ddf$export$c263af073f38039c = $fff98676c7577ddf$var$w5, $fff98676c7577ddf$export$3056a772aa627459 = $fff98676c7577ddf$var$R5, $fff98676c7577ddf$export$b9af7593619e6051 = {
    ltr: $fff98676c7577ddf$var$U5,
    rtl: $fff98676c7577ddf$var$D5
}, $fff98676c7577ddf$export$662a758ca404122 = $fff98676c7577ddf$var$E5, $fff98676c7577ddf$export$a6093498942b8dc0 = $fff98676c7577ddf$var$P5, $fff98676c7577ddf$export$57782d807f8cb642 = $fff98676c7577ddf$var$N5, $fff98676c7577ddf$export$de6d47c364a16177 = {
    langCodeMap: {
        en: $fff98676c7577ddf$var$i,
        de: $fff98676c7577ddf$var$i
    },
    default: $fff98676c7577ddf$var$O5
}, $fff98676c7577ddf$export$f5175e34a136cc = {
    ltr: $fff98676c7577ddf$var$Q5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$e88018287af4ea5d = $fff98676c7577ddf$var$G5, $fff98676c7577ddf$export$6a95885911251ca6 = $fff98676c7577ddf$var$K5, $fff98676c7577ddf$export$42b487c89650cf22 = $fff98676c7577ddf$var$J5, $fff98676c7577ddf$export$95fa4ee5d4786902 = {
    ltr: $fff98676c7577ddf$var$Y5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$7746e9e31f1ee9e0 = $fff98676c7577ddf$var$j5, $fff98676c7577ddf$export$1b4905b4581396ab = $fff98676c7577ddf$var$X5, $fff98676c7577ddf$export$e4e71e7cc74fb941 = $fff98676c7577ddf$var$_5, $fff98676c7577ddf$export$4b87dd2bc34908d0 = {
    ltr: $fff98676c7577ddf$var$$5,
    shouldFlip: !0
}, $fff98676c7577ddf$export$308e4685896a9f5 = {
    ltr: $fff98676c7577ddf$var$c3,
    shouldFlip: !0
}, $fff98676c7577ddf$export$9f5bb9880fa997c1 = {
    ltr: $fff98676c7577ddf$var$a3,
    shouldFlip: !0
}, $fff98676c7577ddf$export$188dca7f870a8168 = {
    ltr: $fff98676c7577ddf$var$t3,
    shouldFlip: !0
}, $fff98676c7577ddf$export$321003bd939db5df = {
    ltr: $fff98676c7577ddf$var$h3,
    shouldFlip: !0
}, $fff98676c7577ddf$export$67381a658bed7e29 = {
    ltr: $fff98676c7577ddf$var$o3,
    shouldFlip: !0
}, $fff98676c7577ddf$export$54b72003632bd0d6 = {
    ltr: $fff98676c7577ddf$var$s3,
    rtl: $fff98676c7577ddf$var$l3
}, $fff98676c7577ddf$export$3d464b44edbf9f6 = {
    ltr: $fff98676c7577ddf$var$n3,
    shouldFlip: !0
}, $fff98676c7577ddf$export$2d953f71d491fb0a = $fff98676c7577ddf$var$v3, $fff98676c7577ddf$export$94691ec4157dca80 = {
    ltr: $fff98676c7577ddf$var$d3,
    shouldFlip: !0
}, $fff98676c7577ddf$export$4093206e9e699f4 = $fff98676c7577ddf$var$e3, $fff98676c7577ddf$export$a712d7ce4ff2052e = {
    ltr: $fff98676c7577ddf$var$r3,
    shouldFlip: !0
}, $fff98676c7577ddf$export$ccd3ee6c5d3f5e46 = $fff98676c7577ddf$var$M, $fff98676c7577ddf$export$3db9e835a9d8772d = $fff98676c7577ddf$var$M, $fff98676c7577ddf$export$33fcee0928a34ac = $fff98676c7577ddf$var$z3, $fff98676c7577ddf$export$176dc0ee24a3e634 = $fff98676c7577ddf$var$i3, $fff98676c7577ddf$export$76358a630cdb2e6 = $fff98676c7577ddf$var$p3;
function $fff98676c7577ddf$export$ee5841356bc98ba3(c, s, h) {
    if (typeof c == "string" || "path" in c) return c;
    if ("shouldFlip" in c) return c.ltr;
    if ("rtl" in c) return h === "rtl" ? c.rtl : c.ltr;
    const n = s in c.langCodeMap ? c.langCodeMap[s] : c.default;
    return typeof n == "string" || "path" in n ? n : n.ltr;
}
function $fff98676c7577ddf$export$f62db0ca6e2edfee(c, s) {
    if (typeof c == "string") return !1;
    if ("langCodeMap" in c) {
        const h = s in c.langCodeMap ? c.langCodeMap[s] : c.default;
        if (typeof h == "string") return !1;
        c = h;
    }
    if ("shouldFlipExceptions" in c && Array.isArray(c.shouldFlipExceptions)) {
        const h = c.shouldFlipExceptions.indexOf(s);
        return h === void 0 || h === -1;
    }
    return "shouldFlip" in c ? c.shouldFlip : !1;
}

});

parcelRegister("3ELGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9a1a0b8b80662f$export$2e2bcd8739ae039);
// https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
const $2a9a1a0b8b80662f$var$DELAY = 300;
const $2a9a1a0b8b80662f$var$CACHE_VERSION = 3;
const $2a9a1a0b8b80662f$var$CACHE_KEY = `cache-summaries-${$2a9a1a0b8b80662f$var$CACHE_VERSION}`;
let $2a9a1a0b8b80662f$var$shortTermCache, $2a9a1a0b8b80662f$var$summaryCache;
// localStorage may not be available if running in Node.js
try {
    let i = $2a9a1a0b8b80662f$var$CACHE_VERSION - 1;
    while(i > 0){
        localStorage.removeItem(`cache-summaries-${i}`);
        i--;
    }
    $2a9a1a0b8b80662f$var$shortTermCache = JSON.parse(localStorage.getItem('cache-short') || '{}');
    $2a9a1a0b8b80662f$var$summaryCache = JSON.parse(localStorage.getItem($2a9a1a0b8b80662f$var$CACHE_KEY) || '{}');
} catch (e) {
    $2a9a1a0b8b80662f$var$shortTermCache = {};
    $2a9a1a0b8b80662f$var$summaryCache = {};
}
// A week cache is fine.
const $2a9a1a0b8b80662f$var$CACHE_TIME = 604800;
const $2a9a1a0b8b80662f$var$pruneCache = ()=>{
    const keys = Object.keys($2a9a1a0b8b80662f$var$shortTermCache);
    if (keys.length > 50) keys.slice(0, 50).forEach((key)=>{
        delete $2a9a1a0b8b80662f$var$shortTermCache[key];
    });
};
/**
 * @type YIRStatus
 */ let $2a9a1a0b8b80662f$var$status = {
    date: null,
    text: '31st December'
};
/**
 * @param {string} url
 * @return {Promise<ApiRawResponse>}
 */ const $2a9a1a0b8b80662f$var$cacheFetch = (url)=>{
    return new Promise((resolve, reject)=>{
        const cached = $2a9a1a0b8b80662f$var$shortTermCache[url];
        if (cached) {
            setTimeout(()=>{
                resolve(typeof cached === 'string' ? JSON.parse(cached) : cached);
            }, $2a9a1a0b8b80662f$var$DELAY);
            return;
        }
        fetch(url).then((r)=>r.json()).then((json)=>{
            if (!json.error) {
                $2a9a1a0b8b80662f$var$shortTermCache[url] = json;
                try {
                    localStorage.setItem('cache-short', JSON.stringify($2a9a1a0b8b80662f$var$shortTermCache));
                } catch (e) {
                    $2a9a1a0b8b80662f$var$pruneCache();
                    try {
                        localStorage.setItem('cache-short', JSON.stringify($2a9a1a0b8b80662f$var$shortTermCache));
                    } catch (e) {}
                }
            } else reject();
            resolve(json);
        });
    });
};
/**
 * @param {number} day
 * @return {string}
 */ const $2a9a1a0b8b80662f$var$getDateSuffix = (day)=>{
    if (day === 1) return 'st';
    else if (day === 2) return 'nd';
    else if (day === 3) return 'rd';
    else return 'th';
};
/**
 * @param {string} timestamp
 * @return {Date}
 */ const $2a9a1a0b8b80662f$var$toDate = (timestamp)=>{
    return new Date(timestamp);
};
/**
 * @param {string} timestamp
 * @return {string}
 */ const $2a9a1a0b8b80662f$var$toReadableMonth = (timestamp)=>{
    const date = $2a9a1a0b8b80662f$var$toDate(timestamp);
    const m = date.getMonth();
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    return `${months[m]}`;
};
/**
 * @param {string} url
 * @param {Record<string, string>} params
 * @param {'logevents'|'usercontribs'} list
 * @param {ApiListObj[]} [result] defaults to empty array
 * @param {number|null} [maxQueries] limit the continue to a certain number of queries
 * @param {number} [numQueries] tracks the number of queries so far
 * @return {Promise<ApiListObj[]>}
 */ const $2a9a1a0b8b80662f$var$continueFetch = (url, params, list, result = [], maxQueries = null, numQueries = 0)=>{
    const q = new URLSearchParams(params).toString();
    return $2a9a1a0b8b80662f$var$cacheFetch(`${url}?${q}`).then((r)=>{
        result = result.concat((r.query[list] || [])// @ts-ignore
        .filter((/** @type ApiListObj[] */ r)=>r));
        const c = result[result.length - 1];
        if (c) {
            const d = $2a9a1a0b8b80662f$var$toDate(c.timestamp);
            const day = d.getDate();
            const suffix = $2a9a1a0b8b80662f$var$getDateSuffix(day);
            $2a9a1a0b8b80662f$var$status.text = `${day}${suffix} ${$2a9a1a0b8b80662f$var$toReadableMonth(c.timestamp)}`;
            $2a9a1a0b8b80662f$var$status.date = d;
        }
        if (r.continue) {
            Object.keys(r.continue).forEach((key)=>{
                params[key] = r.continue[key];
            });
            if (maxQueries && numQueries > maxQueries) return result;
            // Check after 10 queries whether we have progressed beyond a day.
            // If we haven't its an indication we probably shouldn't continue.
            if (numQueries > 10 && result.length) {
                const lastResultDate = new Date(result[result.length - 1].timestamp);
                const lastMonth = lastResultDate.getMonth();
                const lastDate = lastResultDate.getDate();
                if (lastDate === 31 && lastMonth === 11) return Promise.reject(new Error('TOOMANYEDITS'));
                else if (lastDate === 1 && lastMonth === 0) return Promise.reject(new Error('TOOMANYEDITS'));
            }
            return $2a9a1a0b8b80662f$var$continueFetch(url, params, list, result, maxQueries, numQueries + 1).then((/** @type ApiListObj[] */ result2)=>{
                return result2;
            });
        } else return Promise.resolve(result);
    });
};
/**
 * @param {*} articles
 * @param {'title'|'user'|'day'} field
 * @return {YIRPage[]}
 */ const $2a9a1a0b8b80662f$var$topArticles = (articles, field = 'title')=>{
    const /** @type Record<string,number> */ titles = {};
    // @ts-ignore
    articles.forEach((t)=>{
        if (titles[t[field]] === undefined) titles[t[field]] = 0;
        titles[t[field]]++;
    });
    // @ts-ignore
    return Object.keys(titles).map((title)=>({
            [field]: title,
            count: titles[title]
        })).sort((a, b)=>a.count > b.count ? -1 : 1);
};
/**
 * @param {YIRDay[]} days
 * @return {YIRDay[]}
 */ const $2a9a1a0b8b80662f$var$topDays = (days)=>{
    // @ts-ignore
    /** @type YIRDay[] */ const top = $2a9a1a0b8b80662f$var$topArticles(days, 'day');
    return top;
};
/**
 * @param {YIRDay[]} days
 * @return {YIRTimeSlot[]}
 */ const $2a9a1a0b8b80662f$var$topHours = (days)=>{
    const /** @type Record<string,number> */ timeslot = {};
    const slots = [
        0,
        6,
        10,
        12,
        14,
        17,
        22
    ];
    slots.forEach((hour)=>timeslot[`${hour}`] = 0);
    days.forEach((t)=>{
        const hour = t.hour;
        let i = 0;
        while(slots[i] < hour)i++;
        if (i >= slots.length) i = slots.length - 1;
        timeslot[`${slots[i]}`]++;
    });
    return Object.keys(timeslot).map((hour)=>{
        let nextHourIndex = slots.indexOf(parseInt(hour, 10)) + 1;
        if (nextHourIndex >= slots.length) nextHourIndex = 0;
        return {
            timespan: `${hour}:00 - ${slots[nextHourIndex]}:00`,
            count: timeslot[hour]
        };
    }).sort((a, b)=>a.count > b.count ? -1 : 1);
};
/**
 * @param {string} username
 * @param {number} year
 * @param {string} project
 * @return {Promise<YIRStatsThanks>}
 */ const $2a9a1a0b8b80662f$var$thanksSummary = (username, year, project)=>{
    return $2a9a1a0b8b80662f$var$continueFetch(`https://${project}/w/api.php`, {
        leend: `${year - 1}-12-31T23:59:59.000Z`,
        maxage: `${$2a9a1a0b8b80662f$var$CACHE_TIME}`,
        smaxage: `${$2a9a1a0b8b80662f$var$CACHE_TIME}`,
        lestart: `${year + 1}-01-01T00:00:00.000Z`,
        lelimit: '500',
        origin: '*',
        action: 'query',
        format: 'json',
        formatversion: '2',
        list: 'logevents',
        letype: 'thanks',
        leuser: username
    }, 'logevents').then((thanks)=>{
        return {
            topThanksTo: $2a9a1a0b8b80662f$var$topArticles(thanks).map((u)=>Object.assign(u, {
                    title: u.title.indexOf(':') > -1 ? u.title.split(':')[1] : u.title
                })),
            thanksCount: thanks.length
        };
    });
};
/**
 * @param {string} username
 * @param {number} year
 * @param {string} project
 * @return {Promise<YIRStatsThanked>}
 */ const $2a9a1a0b8b80662f$var$thankedSummary = (username, year, project)=>{
    return $2a9a1a0b8b80662f$var$continueFetch(`https://${project}/w/api.php`, {
        leend: `${year - 1}-12-31T23:59:59.000Z`,
        lestart: `${year + 1}-01-01T00:00:00.000Z`,
        maxage: `${$2a9a1a0b8b80662f$var$CACHE_TIME}`,
        smaxage: `${$2a9a1a0b8b80662f$var$CACHE_TIME}`,
        lelimit: '500',
        origin: '*',
        action: 'query',
        format: 'json',
        formatversion: '2',
        list: 'logevents',
        letype: 'thanks',
        letitle: `User:${username}`
    }, 'logevents').then((/** @type {ApiListObj[]} */ thanks)=>{
        return {
            topThanksFrom: $2a9a1a0b8b80662f$var$topArticles(thanks, 'user'),
            thankedCount: thanks.length
        };
    });
};
/**
 * Check if a project supports the REST API for page summaries.
 * Only Wikipedia and Wikivoyage projects support this API.
 * @param {string} project
 * @return {boolean}
 */ const $2a9a1a0b8b80662f$var$supportsRestApi = (project)=>{
    return project.includes('wikipedia.org') || project.includes('wikivoyage.org');
};
/**
 * @param {string[]} titles
 * @param {string} project
 * @return {Promise<YIRImage[]>}
 */ const $2a9a1a0b8b80662f$var$addThumbs = (titles, project)=>{
    // Skip thumbnail fetching for projects that don't support the REST API
    if (!$2a9a1a0b8b80662f$var$supportsRestApi(project)) return Promise.resolve(titles.map(()=>undefined));
    return Promise.all(titles.map((t)=>fetch(`https://${project}/api/rest_v1/page/summary/${encodeURIComponent(t)}`).then((r)=>r.json(), ()=>{
            return Promise.resolve();
        }).then((p)=>p && p.thumbnail)));
};
/**
 * @param {ApiListObj[]} contribs
 * @return {YIRStreak}
 */ const $2a9a1a0b8b80662f$var$calculateStreak = (contribs)=>{
    // Extract unique contribution days
    const uniqueDays = Array.from(new Set(contribs.map((c)=>new Date(c.timestamp).toISOString().split("T")[0]) // Extract date only
    )).map((dateString)=>new Date(dateString)) // Convert back to Date objects
    .sort((a, b)=>a.getTime() - b.getTime()); // Sort dates by time
    if (!uniqueDays.length) return {
        currentStreak: 0,
        longestStreak: 0
    };
    let currentStreak = 1;
    let longestStreak = 1;
    let longestStreakStartDate = uniqueDays[0];
    let streakStartDate = uniqueDays[0];
    for(let i = 1; i < uniqueDays.length; i++){
        const daysDiff = (uniqueDays[i].getTime() - uniqueDays[i - 1].getTime()) / 86400000; // Difference in days
        if (daysDiff === 1) {
            currentStreak++;
            if (currentStreak > longestStreak) longestStreakStartDate = streakStartDate;
            longestStreak = Math.max(longestStreak, currentStreak);
        } else if (daysDiff > 1) {
            currentStreak = 1; // Reset streak
            streakStartDate = uniqueDays[i - 1];
        }
    }
    console.log('streak debug', longestStreakStartDate);
    return {
        currentStreak: currentStreak,
        longestStreak: longestStreak,
        longestStreakStartDate: longestStreakStartDate
    };
};
/**
 * @param {ApiListObj[]} contribs
 * @param {string} project
 * @return {Promise<YIRStatsContribs>}
 */ const $2a9a1a0b8b80662f$var$summarize = (contribs, project)=>{
    const articles = contribs.filter((c)=>c && c.ns === 0);
    const fileUploads = contribs.filter((c)=>c && c.ns === 6).length;
    const streak = $2a9a1a0b8b80662f$var$calculateStreak(contribs);
    const top = $2a9a1a0b8b80662f$var$topArticles(articles);
    const contribDayofweek = contribs.filter((c)=>c).map((c)=>{
        const t = new Date(c.timestamp);
        return {
            count: 0,
            hour: t.getHours(),
            day: t.getDay()
        };
    });
    const totalBytes = contribs.reduce((a, c)=>{
        let s = c.sizediff || 0;
        if (s < 0) s = -s;
        return a + s;
    }, 0);
    const top5 = top.slice(0, 5);
    return $2a9a1a0b8b80662f$var$addThumbs(top5.map((t)=>t.title), project).then((thumbs)=>{
        const dayofweek = $2a9a1a0b8b80662f$var$topDays(contribDayofweek);
        const hourofweek = $2a9a1a0b8b80662f$var$topHours(contribDayofweek);
        return {
            thumbs: thumbs,
            totalBytes: totalBytes,
            paragraphs: totalBytes / 1000,
            dayofweek: dayofweek,
            hourofweek: hourofweek,
            top5: top5,
            articlesNumber: top.length,
            totalEdits: contribs.length,
            fileUploads: fileUploads,
            articleEdits: articles.length,
            pageEdits: contribs.filter((/** @type {ApiListObj} */ c)=>c && c.ns === 104).length,
            interfaceEdits: contribs.filter((/** @type {ApiListObj} */ c)=>c && c.ns === 8).length,
            templateEdits: contribs.filter((/** @type {ApiListObj} */ c)=>c && (c.ns === 828 || c.ns === 10)).length,
            talkEdits: contribs.filter((/** @type {ApiListObj} */ c)=>c && c.ns % 2 !== 0).length,
            streak: streak
        };
    });
};
/**
 * @param {string} username
 * @param {string|number} year
 * @param {string} project
 * @return {Promise<ApiListObj[]>}
 */ const $2a9a1a0b8b80662f$var$loadUserCache = (username, year, project)=>{
    return new Promise((resolve)=>{
        const userCacheUrl = `data/shortcut/${year}/${project}/${encodeURIComponent(username.replace(/ /g, '_'))}.json`;
        fetch(userCacheUrl).then((r)=>r.json()).then((result)=>{
            resolve(result);
        }, ()=>{
            resolve([]);
        });
    });
};
/**
 * @param {string} username
 * @param {number} year
 * @param {string} project
 * @param {ApiListObj[]} result
 * @param {number|null} [maxQueries]
 * @return {Promise<ApiListObj[]>}
 */ const $2a9a1a0b8b80662f$var$resumeContributionsFetch = (username, year, project, result, maxQueries = null)=>{
    let ucstart = null;
    if (result.length) {
        const date = new Date(result[result.length - 1].timestamp);
        date.setTime(date.getTime() + 1000);
        ucstart = date.toISOString();
    }
    return $2a9a1a0b8b80662f$var$continueFetch(`https://${project}/w/api.php`, {
        ucstart: ucstart || `${year - 1}-12-31T23:59:59.000Z`,
        ucend: `${year + 1}-01-01T00:00:00.000Z`,
        uclimit: '500',
        origin: '*',
        action: 'query',
        format: 'json',
        ucdir: 'newer',
        formatversion: '2',
        list: 'usercontribs',
        ucuser: username,
        ucprop: 'title|timestamp|sizediff'
    }, 'usercontribs', result, maxQueries);
};
/**
 * @param {string} username
 * @param {number} year
 * @param {string} project
 * @return {Promise<YIRStatsContribs>}
 */ const $2a9a1a0b8b80662f$var$contributionsFetch = (username, year, project)=>{
    // first check the local cache
    return $2a9a1a0b8b80662f$var$loadUserCache(username, year, project).then((result)=>{
        return $2a9a1a0b8b80662f$var$resumeContributionsFetch(username, year, project, result);
    }).then((/** @type {ApiListObj[]} */ r)=>{
        return $2a9a1a0b8b80662f$var$summarize(r, project);
    });
};
/**
 * @param {string} username
 * @param {number} year
 * @param {string} project
 * @return {Promise<YIRStats>}
 */ const $2a9a1a0b8b80662f$var$yirRemoteFetch = (username, year, project)=>{
    if (!project.match(/[^\.]*\.(wikivoyage|wikinews|wikiversity|wikibooks|wikiquote|wiktionary|wikifunctions|wikisource|wikipedia|mediawiki|wikidata|wikimedia)\.org/) || !username.match(/^[^:]*$/)) return Promise.reject();
    const cacheKey = `${username}:${year}:${project}`;
    if ($2a9a1a0b8b80662f$var$summaryCache[cacheKey]) return Promise.resolve($2a9a1a0b8b80662f$var$summaryCache[cacheKey]);
    return Promise.all([
        $2a9a1a0b8b80662f$var$thanksSummary(username, year, project),
        $2a9a1a0b8b80662f$var$thankedSummary(username, year, project),
        $2a9a1a0b8b80662f$var$contributionsFetch(username, year, project)
    ]).then((results)=>{
        const summary = Object.assign.apply({}, results);
        summary.streak = results[2].streak; // Include streak data from contributions
        summary.year = year + 1;
        summary.project = project;
        $2a9a1a0b8b80662f$var$summaryCache[cacheKey] = summary;
        localStorage.setItem($2a9a1a0b8b80662f$var$CACHE_KEY, JSON.stringify($2a9a1a0b8b80662f$var$summaryCache));
        return summary;
    }, (e)=>{
        return Promise.reject(e);
    });
};
/**
 * @param {string} username
 * @param {number} year
 * @param {string} project
 * @return {Promise<YIRStats>}
 */ const $2a9a1a0b8b80662f$var$yir = (username, year, project)=>{
    return new Promise((resolve, reject)=>{
        fetch(`data/shortcut/${year}/${project}/${encodeURIComponent(username.replace(/ /g, '_'))}.summary.json`).then((r)=>r.json()).then((summary)=>resolve(summary), ()=>{
            $2a9a1a0b8b80662f$var$yirRemoteFetch(username, year, project).then((summary)=>resolve(summary), (e)=>{
                reject(e);
            });
        });
    });
};
$2a9a1a0b8b80662f$var$yir.getStatus = ()=>{
    return $2a9a1a0b8b80662f$var$status;
};
$2a9a1a0b8b80662f$var$yir.resumeContributionsFetch = $2a9a1a0b8b80662f$var$resumeContributionsFetch;
var $2a9a1a0b8b80662f$export$2e2bcd8739ae039 = $2a9a1a0b8b80662f$var$yir;

});

parcelRegister("aIOQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce575dfe7cd1dea$export$2e2bcd8739ae039);
let $7ce575dfe7cd1dea$var$script;




let $7ce575dfe7cd1dea$var$initialize = ()=>{
    $7ce575dfe7cd1dea$var$script = (parcelRequire("4CAsk"));
    if ($7ce575dfe7cd1dea$var$script.__esModule) $7ce575dfe7cd1dea$var$script = $7ce575dfe7cd1dea$var$script.default;
    $7ce575dfe7cd1dea$var$script.render = (parcelRequire("knzKa")).render;
    $7ce575dfe7cd1dea$var$script.__cssModules = {};
    (parcelRequire("j7uiT")).default($7ce575dfe7cd1dea$var$script);
    $7ce575dfe7cd1dea$var$script.__scopeId = 'data-v-c97b6d';
    $7ce575dfe7cd1dea$var$script.__file = "Page.vue";
};
$7ce575dfe7cd1dea$var$initialize();
var $7ce575dfe7cd1dea$export$2e2bcd8739ae039 = $7ce575dfe7cd1dea$var$script;

});
parcelRegister("4CAsk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $35d6fd69dd1f5d94$export$2e2bcd8739ae039);
var $35d6fd69dd1f5d94$export$2e2bcd8739ae039 = {
    name: 'Page',
    props: {
        image: Object,
        class: String,
        message: String
    },
    data () {
        return {
            pages: [],
            username: ''
        };
    }
};

});

parcelRegister("knzKa", function(module, exports) {

$parcel$export(module.exports, "render", () => $ed61ae91b6e8d096$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $ed61ae91b6e8d096$var$_hoisted_1 = {
    class: "page"
};
const $ed61ae91b6e8d096$var$_hoisted_2 = {
    class: "main"
};
const $ed61ae91b6e8d096$var$_hoisted_3 = [
    "src",
    "width",
    "height"
];
const $ed61ae91b6e8d096$var$_hoisted_4 = [
    "innerHTML"
];
const $ed61ae91b6e8d096$var$_hoisted_5 = {
    class: "text"
};
function $ed61ae91b6e8d096$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $ed61ae91b6e8d096$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $ed61ae91b6e8d096$var$_hoisted_2, [
            $props.image ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                key: 0,
                src: $props.image.source,
                width: $props.image.width,
                height: $props.image.height
            }, null, 8, $ed61ae91b6e8d096$var$_hoisted_3)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("p", {
                innerHTML: $props.message,
                class: (0, $8XWQX.normalizeClass)([
                    "message-text",
                    $props.class
                ])
            }, null, 10, $ed61ae91b6e8d096$var$_hoisted_4)
        ]),
        (0, $TusQn.createElementVNode)("div", $ed61ae91b6e8d096$var$_hoisted_5, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ])
    ]);
}

});
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "Comment", () => (parcelRequire("TusQn")).Comment);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createSlots", () => (parcelRequire("TusQn")).createSlots);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8XWQX")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8XWQX")).normalizeStyle);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("eeJ70")).Transition);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("eeJ70")).vModelCheckbox);
$parcel$export(module.exports, "vModelDynamic", () => (parcelRequire("eeJ70")).vModelDynamic);
$parcel$export(module.exports, "vModelRadio", () => (parcelRequire("eeJ70")).vModelRadio);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "vShow", () => (parcelRequire("eeJ70")).vShow);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("eeJ70")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8XWQX")).toDisplayString);
/**
* vue v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8XWQX");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Comment", () => $0a6cc4ba868319ae$export$4d299b491347818a);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "watchPostEffect", () => $0a6cc4ba868319ae$export$b7f27ea67102d543);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createSlots", () => $0a6cc4ba868319ae$export$85738f8fcd0a5430);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8XWQX")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8XWQX")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8XWQX")).normalizeStyle);
/**
* @vue/runtime-core v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8XWQX = parcelRequire("8XWQX");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8XWQX.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8XWQX.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8XWQX.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8XWQX.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8XWQX.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $0a6cc4ba868319ae$var$isFlushing = false;
let $0a6cc4ba868319ae$var$isFlushPending = false;
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = 0;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!$0a6cc4ba868319ae$var$queue.length || !$0a6cc4ba868319ae$var$queue.includes(job, $0a6cc4ba868319ae$var$isFlushing && job.allowRecurse ? $0a6cc4ba868319ae$var$flushIndex + 1 : $0a6cc4ba868319ae$var$flushIndex)) {
        if (job.id == null) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(job.id), 0, job);
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$isFlushing && !$0a6cc4ba868319ae$var$isFlushPending) {
        $0a6cc4ba868319ae$var$isFlushPending = true;
        $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
    }
}
function $0a6cc4ba868319ae$var$invalidateJob(job) {
    const i = $0a6cc4ba868319ae$var$queue.indexOf(job);
    if (i > $0a6cc4ba868319ae$var$flushIndex) $0a6cc4ba868319ae$var$queue.splice(i, 1);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8XWQX.isArray)(cb)) {
        if (!$0a6cc4ba868319ae$var$activePostFlushCbs || !$0a6cc4ba868319ae$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $0a6cc4ba868319ae$var$postFlushIndex + 1 : $0a6cc4ba868319ae$var$postFlushIndex)) $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$isFlushing ? $0a6cc4ba868319ae$var$flushIndex + 1 : 0) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++)$0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex]();
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $0a6cc4ba868319ae$var$comparator = (a, b)=>{
    const diff = $0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    $0a6cc4ba868319ae$var$isFlushPending = false;
    $0a6cc4ba868319ae$var$isFlushing = true;
    $0a6cc4ba868319ae$var$queue.sort($0a6cc4ba868319ae$var$comparator);
    const check = (0, $8XWQX.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && job.active !== false) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $0a6cc4ba868319ae$var$flushIndex = 0;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$isFlushing = false;
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        if (!$0a6cc4ba868319ae$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        for (const instance of instances)$0a6cc4ba868319ae$var$hmrDirtyComponents.delete($0a6cc4ba868319ae$var$normalizeClassComponent(instance.type));
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8XWQX.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8XWQX.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $8XWQX.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $8XWQX.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $8XWQX.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8XWQX.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8XWQX.toHandlerKey)((0, $8XWQX.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8XWQX.toHandlerKey)((0, $8XWQX.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8XWQX.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8XWQX.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8XWQX.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8XWQX.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8XWQX.extend)(normalized, raw);
    if ((0, $8XWQX.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8XWQX.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8XWQX.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8XWQX.hasOwn)(options, (0, $8XWQX.hyphenate)(key)) || (0, $8XWQX.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8XWQX.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8XWQX.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8XWQX.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8XWQX.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8XWQX.camelize)(name) || selfName === (0, $8XWQX.capitalize)((0, $8XWQX.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8XWQX.camelize)(name)] || registry[(0, $8XWQX.capitalize)((0, $8XWQX.camelize)(name))]);
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    create: $0a6cc4ba868319ae$var$createSuspenseBoundary,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8XWQX.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8XWQX.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8XWQX.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8XWQX.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8XWQX.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE = {};
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, once: once, onTrack: onTrack, onTrigger: onTrigger } = (0, $8XWQX.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    const warnInvalidSource = (s)=>{
        $0a6cc4ba868319ae$var$warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        $0a6cc4ba868319ae$var$traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $01W3b.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $01W3b.isShallow)(source);
    } else if ((0, $01W3b.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8XWQX.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $01W3b.isReactive)(s) || (0, $01W3b.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $01W3b.isRef)(s)) return s.value;
                else if ((0, $01W3b.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $8XWQX.isFunction)(s)) return $0a6cc4ba868319ae$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $8XWQX.isFunction)(source)) {
        if (cb) getter = ()=>$0a6cc4ba868319ae$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return $0a6cc4ba868319ae$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $8XWQX.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$0a6cc4ba868319ae$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        onCleanup = (0, $8XWQX.NOOP);
        if (!cb) getter();
        else if (immediate) $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $8XWQX.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE) : $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $8XWQX.hasChanged)(v1, oldValue[i])) : (0, $8XWQX.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
    }
    const effect = new (0, $01W3b.ReactiveEffect)(getter, (0, $8XWQX.NOOP), scheduler);
    const scope = (0, $01W3b.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, $8XWQX.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $0a6cc4ba868319ae$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8XWQX.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8XWQX.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$var$traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8XWQX.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ((0, $01W3b.isRef)(value)) $0a6cc4ba868319ae$var$traverse(value.value, depth, seen);
    else if ((0, $8XWQX.isArray)(value)) for(let i = 0; i < value.length; i++)$0a6cc4ba868319ae$var$traverse(value[i], depth, seen);
    else if ((0, $8XWQX.isSet)(value) || (0, $8XWQX.isMap)(value)) value.forEach((v1)=>{
        $0a6cc4ba868319ae$var$traverse(v1, depth, seen);
    });
    else if ((0, $8XWQX.isPlainObject)(value)) for(const key in value)$0a6cc4ba868319ae$var$traverse(value[key], depth, seen);
    return value;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8XWQX.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getExposeProxy($0a6cc4ba868319ae$var$currentRenderingInstance) || $0a6cc4ba868319ae$var$currentRenderingInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8XWQX.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8XWQX.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $0a6cc4ba868319ae$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getKeepAliveChild(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $0a6cc4ba868319ae$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild)) {
                const leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8XWQX.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getKeepAliveChild(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) return vnode;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8XWQX.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8XWQX.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8XWQX.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8XWQX.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8XWQX.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8XWQX.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8XWQX.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8XWQX.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8XWQX.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8XWQX.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") && $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $8XWQX.isArray)(source) || (0, $8XWQX.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8XWQX.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8XWQX.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.isCE || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8XWQX.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getExposeProxy(i) || i.proxy;
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8XWQX.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8XWQX.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8XWQX.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8XWQX.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8XWQX.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8XWQX.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8XWQX.hasOwn)(normalizedProps, key) || (0, $8XWQX.hasOwn)(ctx, key) || (0, $8XWQX.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8XWQX.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8XWQX.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8XWQX.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8XWQX.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8XWQX.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8XWQX.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8XWQX.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8XWQX.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8XWQX.isArray)(opt) || (0, $8XWQX.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8XWQX.isArray)(a) && (0, $8XWQX.isArray)(b)) return a.concat(b);
    return (0, $8XWQX.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8XWQX.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8XWQX.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8XWQX.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8XWQX.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8XWQX.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8XWQX.NOOP);
        const set = !(0, $8XWQX.isFunction)(opt) && (0, $8XWQX.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8XWQX.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8XWQX.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8XWQX.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8XWQX.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8XWQX.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8XWQX.NOOP)) {
    if ((0, $8XWQX.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8XWQX.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8XWQX.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8XWQX.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8XWQX.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8XWQX.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8XWQX.isObject)(raw)) {
        if ((0, $8XWQX.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8XWQX.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8XWQX.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8XWQX.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8XWQX.extend)((0, $8XWQX.isFunction)(to) ? to.call(this, this) : to, (0, $8XWQX.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8XWQX.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8XWQX.isArray)(to) && (0, $8XWQX.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8XWQX.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8XWQX.isFunction)(rootComponent)) rootComponent = (0, $8XWQX.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8XWQX.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8XWQX.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8XWQX.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $0a6cc4ba868319ae$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8XWQX.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8XWQX.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8XWQX.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8XWQX.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8XWQX.hyphenate)(key)) === key || !(0, $8XWQX.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8XWQX.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8XWQX.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8XWQX.hasOwn)(options, camelKey = (0, $8XWQX.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8XWQX.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8XWQX.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8XWQX.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8XWQX.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8XWQX.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8XWQX.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8XWQX.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8XWQX.isObject)(comp)) cache.set(comp, (0, $8XWQX.EMPTY_ARR));
        return 0, $8XWQX.EMPTY_ARR;
    }
    if ((0, $8XWQX.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8XWQX.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8XWQX.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8XWQX.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8XWQX.isArray)(opt) || (0, $8XWQX.isFunction)(opt) ? {
                type: opt
            } : (0, $8XWQX.extend)({}, opt);
            if (prop) {
                const booleanIndex = $0a6cc4ba868319ae$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $0a6cc4ba868319ae$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $8XWQX.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8XWQX.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8XWQX.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$isSameType(a, b) {
    return $0a6cc4ba868319ae$var$getType(a) === $0a6cc4ba868319ae$var$getType(b);
}
function $0a6cc4ba868319ae$var$getTypeIndex(type, expectedTypes) {
    if ((0, $8XWQX.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$0a6cc4ba868319ae$var$isSameType(t, type));
    else if ((0, $8XWQX.isFunction)(expectedTypes)) return $0a6cc4ba868319ae$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, $8XWQX.hasOwn)(rawProps, key) && !(0, $8XWQX.hasOwn)(rawProps, (0, $8XWQX.hyphenate)(key)));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8XWQX.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8XWQX.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8XWQX.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8XWQX.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8XWQX.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8XWQX.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8XWQX.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8XWQX.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            (0, $8XWQX.extend)(slots, children);
            (0, $8XWQX.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8XWQX.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $8XWQX.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8XWQX.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8XWQX.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8XWQX.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8XWQX.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $8XWQX.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8XWQX.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8XWQX.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $8XWQX.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8XWQX.isArray)(existing) && (0, $8XWQX.remove)(existing, refValue);
                    else {
                        if (!(0, $8XWQX.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $8XWQX.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $8XWQX.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasMismatch = false;
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $0a6cc4ba868319ae$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($0a6cc4ba868319ae$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            if (!("__vnode" in node)) Object.defineProperty(node, "__vnode", {
                value: vnode,
                enumerable: false
            });
            if (!("__vueParentComponent" in node)) Object.defineProperty(node, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $0a6cc4ba868319ae$var$hasMismatch = true;
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) for(const key in props){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$hasMismatch = true;
                    if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8XWQX.isOn)(key) && !(0, $8XWQX.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                }
                else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $0a6cc4ba868319ae$var$hasMismatch = true;
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $0a6cc4ba868319ae$var$hasMismatch = true;
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var _a;
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $8XWQX.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8XWQX.isString)(clientValue) ? clientValue : (0, $8XWQX.stringifyStyle)((0, $8XWQX.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        const root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode)) {
            const cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for(const key2 in cssVars)expectedMap.set(`--${key2}`, String(cssVars[key2]));
        }
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $8XWQX.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8XWQX.isBooleanAttr)(key) || (0, $8XWQX.isKnownHtmlAttr)(key))) {
        if ((0, $8XWQX.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8XWQX.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8XWQX.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key == null ? void 0 : key.trim();
        value = value == null ? void 0 : value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8XWQX.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8XWQX.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8XWQX.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8XWQX.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8XWQX.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8XWQX.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8XWQX.EMPTY_OBJ);
        const newProps = n2.props || (0, $8XWQX.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8XWQX.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8XWQX.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $8XWQX.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $0a6cc4ba868319ae$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8XWQX.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8XWQX.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn, (0, $8XWQX.NOOP), ()=>$0a6cc4ba868319ae$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8XWQX.EMPTY_ARR);
        c2 = c2 || (0, $8XWQX.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8XWQX.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $8XWQX.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs();
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8XWQX.isArray)(ch1) && (0, $8XWQX.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8XWQX.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8XWQX.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8XWQX.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8XWQX.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8XWQX.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8XWQX.isString)(klass)) props.class = (0, $8XWQX.normalizeClass)(klass);
        if ((0, $8XWQX.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8XWQX.isArray)(style)) style = (0, $8XWQX.extend)({}, style);
            props.style = (0, $8XWQX.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8XWQX.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8XWQX.isObject)(type) ? 4 : (0, $8XWQX.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8XWQX.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8XWQX.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) cloned.transition = transition.clone(cloned);
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8XWQX.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8XWQX.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8XWQX.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8XWQX.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8XWQX.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8XWQX.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8XWQX.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8XWQX.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8XWQX.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8XWQX.EMPTY_OBJ),
        data: (0, $8XWQX.EMPTY_OBJ),
        props: (0, $8XWQX.EMPTY_OBJ),
        attrs: (0, $8XWQX.EMPTY_OBJ),
        slots: (0, $8XWQX.EMPTY_OBJ),
        refs: (0, $8XWQX.EMPTY_OBJ),
        setupState: (0, $8XWQX.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8XWQX.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8XWQX.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $01W3b.resetTracking)();
        reset();
        if ((0, $8XWQX.isPromise)(setupResult)) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8XWQX.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8XWQX.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8XWQX.extend)((0, $8XWQX.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8XWQX.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8XWQX.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8XWQX.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8XWQX.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8XWQX.camelize)(name);
    const hyphenatedName = (0, $8XWQX.hyphenate)(name);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[name];
            if ((0, $8XWQX.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps)) && (0, $8XWQX.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, options.set ? options.set(value) : value);
            }
        };
    });
    const modifierKey = name === "modelValue" ? "modelModifiers" : `${name}Modifiers`;
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8XWQX.isObject)(propsOrChildren) && !(0, $8XWQX.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8XWQX.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8XWQX.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8XWQX.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8XWQX.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8XWQX.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8XWQX.isArray)(opts) && opts.includes(key) || (0, $8XWQX.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8XWQX.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.4.27";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8XWQX.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "shallowReadonly", () => $005d1fb7704e278c$export$7c4b5f2b50f09f6b);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
/**
* @vue/reactivity v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $lL4wb = parcelRequire("lL4wb");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$var$recordEffectScope(effect, scope = $005d1fb7704e278c$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeEffect;
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        $005d1fb7704e278c$var$recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
            this._dirtyLevel = 1;
            $005d1fb7704e278c$export$938a971395fef855();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    $005d1fb7704e278c$var$triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 4) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            $005d1fb7704e278c$export$c39176b1babaa8b8();
        }
        return this._dirtyLevel >= 4;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 4 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        let lastEffect = $005d1fb7704e278c$var$activeEffect;
        try {
            $005d1fb7704e278c$var$shouldTrack = true;
            $005d1fb7704e278c$var$activeEffect = this;
            this._runnings++;
            $005d1fb7704e278c$var$preCleanupEffect(this);
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this._runnings--;
            $005d1fb7704e278c$var$activeEffect = lastEffect;
            $005d1fb7704e278c$var$shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        if (this.active) {
            $005d1fb7704e278c$var$preCleanupEffect(this);
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this.onStop && this.onStop();
            this.active = false;
        }
    }
}
function $005d1fb7704e278c$var$triggerComputed(computed) {
    return computed.value;
}
function $005d1fb7704e278c$var$preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function $005d1fb7704e278c$var$postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)$005d1fb7704e278c$var$cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function $005d1fb7704e278c$var$cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $005d1fb7704e278c$export$28352bb4dd362521(fn, (0, $lL4wb.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $lL4wb.extend)(_effect, options);
        if (options.scope) $005d1fb7704e278c$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
let $005d1fb7704e278c$var$pauseScheduleStack = 0;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$262a949f95482a17() {
    $005d1fb7704e278c$var$pauseScheduleStack++;
}
function $005d1fb7704e278c$export$3539fa10306ef581() {
    $005d1fb7704e278c$var$pauseScheduleStack--;
    while(!$005d1fb7704e278c$var$pauseScheduleStack && $005d1fb7704e278c$var$queueEffectSchedulers.length)$005d1fb7704e278c$var$queueEffectSchedulers.shift()();
}
function $005d1fb7704e278c$var$trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) $005d1fb7704e278c$var$cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
const $005d1fb7704e278c$var$queueEffectSchedulers = [];
function $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const effect2 of dep.keys()){
        let tracking;
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) $005d1fb7704e278c$var$queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    $005d1fb7704e278c$export$3539fa10306ef581();
}
const $005d1fb7704e278c$var$createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("");
const $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY = Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $005d1fb7704e278c$var$createDep(()=>depsMap.delete(key)));
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, dep, void 0);
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $lL4wb.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $lL4wb.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $lL4wb.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $lL4wb.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $lL4wb.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $lL4wb.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $lL4wb.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $lL4wb.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                break;
        }
    }
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const dep of deps)if (dep) $005d1fb7704e278c$var$triggerEffects(dep, 4, void 0);
    $005d1fb7704e278c$export$3539fa10306ef581();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depsMap && depsMap.get(key);
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $lL4wb.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $lL4wb.isSymbol)));
const $005d1fb7704e278c$var$arrayInstrumentations = /* @__PURE__ */ $005d1fb7704e278c$var$createArrayInstrumentations();
function $005d1fb7704e278c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$005d1fb7704e278c$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($005d1fb7704e278c$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $005d1fb7704e278c$export$938a971395fef855();
            $005d1fb7704e278c$export$262a949f95482a17();
            const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $005d1fb7704e278c$export$3539fa10306ef581();
            $005d1fb7704e278c$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $lL4wb.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the reciever is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $lL4wb.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $lL4wb.hasOwn)($005d1fb7704e278c$var$arrayInstrumentations, key)) return Reflect.get($005d1fb7704e278c$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $lL4wb.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $lL4wb.isIntegerKey)(key) ? res : res.value;
        if ((0, $lL4wb.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $lL4wb.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $lL4wb.isArray)(target) && (0, $lL4wb.isIntegerKey)(key) ? Number(key) < target.length : (0, $lL4wb.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $lL4wb.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $lL4wb.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $lL4wb.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $lL4wb.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $lL4wb.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $005d1fb7704e278c$var$getProto(rawTarget);
    const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $005d1fb7704e278c$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $lL4wb.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $005d1fb7704e278c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $005d1fb7704e278c$var$add(value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const proto = $005d1fb7704e278c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $005d1fb7704e278c$var$set(key, value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $lL4wb.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $005d1fb7704e278c$var$deleteEntry(key) {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $005d1fb7704e278c$var$clear() {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $005d1fb7704e278c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $lL4wb.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, false, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$005d1fb7704e278c$var$mutableInstrumentations, $005d1fb7704e278c$var$readonlyInstrumentations, $005d1fb7704e278c$var$shallowInstrumentations, $005d1fb7704e278c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentations();
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $005d1fb7704e278c$var$shallowReadonlyInstrumentations : $005d1fb7704e278c$var$shallowInstrumentations : isReadonly ? $005d1fb7704e278c$var$readonlyInstrumentations : $005d1fb7704e278c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $lL4wb.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $lL4wb.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $lL4wb.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $lL4wb.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (Object.isExtensible(value)) (0, $lL4wb.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$var$toReactive = (value)=>(0, $lL4wb.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$var$toReadonly = (value)=>(0, $lL4wb.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
const $005d1fb7704e278c$var$COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(()=>getter(this._value), ()=>$005d1fb7704e278c$var$triggerRefValue(this, this.effect._dirtyLevel === 2 ? 2 : 3));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
        if ((!self._cacheable || self.effect.dirty) && (0, $lL4wb.hasChanged)(self._value, self._value = self.effect.run())) $005d1fb7704e278c$var$triggerRefValue(self, 4);
        $005d1fb7704e278c$var$trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) $005d1fb7704e278c$var$triggerRefValue(self, 2);
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $lL4wb.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $lL4wb.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function $005d1fb7704e278c$var$trackRefValue(ref2) {
    var _a;
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = $005d1fb7704e278c$var$createDep(()=>ref2.dep = void 0, ref2 instanceof $005d1fb7704e278c$var$ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function $005d1fb7704e278c$var$triggerRefValue(ref2, dirtyLevel = 4, newVal) {
    ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, void 0);
}
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $005d1fb7704e278c$var$toReactive(value);
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $005d1fb7704e278c$export$7f3fe6025abfa26e(newVal) || $005d1fb7704e278c$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $005d1fb7704e278c$export$ab18938b9fc5f28e(newVal);
        if ((0, $lL4wb.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $005d1fb7704e278c$var$toReactive(newVal);
            $005d1fb7704e278c$var$triggerRefValue(this, 4, newVal);
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    $005d1fb7704e278c$var$triggerRefValue(ref2, 4, void 0);
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $lL4wb.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$005d1fb7704e278c$var$trackRefValue(this), ()=>$005d1fb7704e278c$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $lL4wb.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $lL4wb.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $lL4wb.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
const $005d1fb7704e278c$export$483264c4ec4c46ce = $005d1fb7704e278c$export$2983e091f1a1e8e2;
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("lL4wb", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $fd717df9cc568609$export$b41394a5437791c8);
$parcel$export(module.exports, "NOOP", () => $fd717df9cc568609$export$5702a91a6f42969f);
$parcel$export(module.exports, "extend", () => $fd717df9cc568609$export$8b58be045bf06082);
$parcel$export(module.exports, "hasOwn", () => $fd717df9cc568609$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $fd717df9cc568609$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $fd717df9cc568609$export$5c90113a285f2241);
$parcel$export(module.exports, "isFunction", () => $fd717df9cc568609$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isSymbol", () => $fd717df9cc568609$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $fd717df9cc568609$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "toRawType", () => $fd717df9cc568609$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isIntegerKey", () => $fd717df9cc568609$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "hasChanged", () => $fd717df9cc568609$export$f619eb8b89076d23);
$parcel$export(module.exports, "def", () => $fd717df9cc568609$export$8afb76124cf08683);
/**
* @vue/shared v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $fd717df9cc568609$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $fd717df9cc568609$export$cf583d23ab39677c = {};
const $fd717df9cc568609$export$6bd8558f433f1cc1 = [];
const $fd717df9cc568609$export$5702a91a6f42969f = ()=>{};
const $fd717df9cc568609$export$c01351c0af048e39 = ()=>false;
const $fd717df9cc568609$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $fd717df9cc568609$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $fd717df9cc568609$export$8b58be045bf06082 = Object.assign;
const $fd717df9cc568609$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $fd717df9cc568609$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $fd717df9cc568609$export$b5a638e9b3fff9f3 = (val, key)=>$fd717df9cc568609$var$hasOwnProperty.call(val, key);
const $fd717df9cc568609$export$43bee75e5e14138e = Array.isArray;
const $fd717df9cc568609$export$5c90113a285f2241 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Map]";
const $fd717df9cc568609$export$6750766a7c7ec627 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Set]";
const $fd717df9cc568609$export$871608497c498473 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Date]";
const $fd717df9cc568609$export$49841c62b9eff15 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object RegExp]";
const $fd717df9cc568609$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $fd717df9cc568609$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $fd717df9cc568609$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $fd717df9cc568609$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $fd717df9cc568609$export$4369c812aac99591 = (val)=>{
    return ($fd717df9cc568609$export$a6cdc56e425d0d0a(val) || $fd717df9cc568609$export$f6e2535fb5126e54(val)) && $fd717df9cc568609$export$f6e2535fb5126e54(val.then) && $fd717df9cc568609$export$f6e2535fb5126e54(val.catch);
};
const $fd717df9cc568609$export$830c053460e5ddf6 = Object.prototype.toString;
const $fd717df9cc568609$export$1dccc787cc36538b = (value)=>$fd717df9cc568609$export$830c053460e5ddf6.call(value);
const $fd717df9cc568609$export$5ad0a3c360b8fbb5 = (value)=>{
    return $fd717df9cc568609$export$1dccc787cc36538b(value).slice(8, -1);
};
const $fd717df9cc568609$export$53b83ca8eaab0383 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Object]";
const $fd717df9cc568609$export$e2a2b93446ec9fe = (key)=>$fd717df9cc568609$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $fd717df9cc568609$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $fd717df9cc568609$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $fd717df9cc568609$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $fd717df9cc568609$var$camelizeRE = /-(\w)/g;
const $fd717df9cc568609$export$161d051f5dd25de7 = $fd717df9cc568609$var$cacheStringFunction((str)=>{
    return str.replace($fd717df9cc568609$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $fd717df9cc568609$var$hyphenateRE = /\B([A-Z])/g;
const $fd717df9cc568609$export$6e6a0a3676c4b8bb = $fd717df9cc568609$var$cacheStringFunction((str)=>str.replace($fd717df9cc568609$var$hyphenateRE, "-$1").toLowerCase());
const $fd717df9cc568609$export$9a00dee1beb8f576 = $fd717df9cc568609$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $fd717df9cc568609$export$8c022799eeaaefcd = $fd717df9cc568609$var$cacheStringFunction((str)=>{
    const s = str ? `on${$fd717df9cc568609$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $fd717df9cc568609$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $fd717df9cc568609$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $fd717df9cc568609$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $fd717df9cc568609$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $fd717df9cc568609$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $fd717df9cc568609$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $fd717df9cc568609$var$_globalThis;
const $fd717df9cc568609$export$ff5f2eeb11fc7e14 = ()=>{
    return $fd717df9cc568609$var$_globalThis || ($fd717df9cc568609$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $fd717df9cc568609$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $fd717df9cc568609$export$53d5e12f9a1d3cde(name) {
    return $fd717df9cc568609$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $fd717df9cc568609$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $fd717df9cc568609$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $fd717df9cc568609$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $fd717df9cc568609$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $fd717df9cc568609$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $fd717df9cc568609$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $fd717df9cc568609$export$f73b8c13b7f97ebf = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$GLOBALS_ALLOWED);
const $fd717df9cc568609$export$d6571a1911e4f27e = $fd717df9cc568609$export$f73b8c13b7f97ebf;
const $fd717df9cc568609$var$range = 2;
function $fd717df9cc568609$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $fd717df9cc568609$var$range; j <= i + $fd717df9cc568609$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $fd717df9cc568609$export$8756898546458274(value) {
    if ($fd717df9cc568609$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $fd717df9cc568609$export$844ec244b1367d54(item) ? $fd717df9cc568609$export$76a205ce979d066a(item) : $fd717df9cc568609$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($fd717df9cc568609$export$844ec244b1367d54(value) || $fd717df9cc568609$export$a6cdc56e425d0d0a(value)) return value;
}
const $fd717df9cc568609$var$listDelimiterRE = /;(?![^(]*\))/g;
const $fd717df9cc568609$var$propertyDelimiterRE = /:([^]+)/;
const $fd717df9cc568609$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $fd717df9cc568609$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($fd717df9cc568609$var$styleCommentRE, "").split($fd717df9cc568609$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($fd717df9cc568609$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $fd717df9cc568609$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $fd717df9cc568609$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if ($fd717df9cc568609$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $fd717df9cc568609$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $fd717df9cc568609$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($fd717df9cc568609$export$844ec244b1367d54(value)) res = value;
    else if ($fd717df9cc568609$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $fd717df9cc568609$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($fd717df9cc568609$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $fd717df9cc568609$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$fd717df9cc568609$export$844ec244b1367d54(klass)) props.class = $fd717df9cc568609$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $fd717df9cc568609$export$8756898546458274(style);
    return props;
}
const $fd717df9cc568609$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $fd717df9cc568609$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $fd717df9cc568609$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $fd717df9cc568609$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $fd717df9cc568609$export$1ccf854a0984f890 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$HTML_TAGS);
const $fd717df9cc568609$export$6328ce7565ea1049 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$SVG_TAGS);
const $fd717df9cc568609$export$4a46ca4c5be17b20 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$MATH_TAGS);
const $fd717df9cc568609$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$VOID_TAGS);
const $fd717df9cc568609$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $fd717df9cc568609$export$d186f5eb2e810715 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$specialBooleanAttrs);
const $fd717df9cc568609$export$f763ba3b84e9cd8c = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $fd717df9cc568609$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $fd717df9cc568609$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $fd717df9cc568609$var$attrValidationCache = {};
function $fd717df9cc568609$export$d55ef77660f30d12(name) {
    if ($fd717df9cc568609$var$attrValidationCache.hasOwnProperty(name)) return $fd717df9cc568609$var$attrValidationCache[name];
    const isUnsafe = $fd717df9cc568609$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $fd717df9cc568609$var$attrValidationCache[name] = !isUnsafe;
}
const $fd717df9cc568609$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $fd717df9cc568609$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $fd717df9cc568609$export$80da416f43933831 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $fd717df9cc568609$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $fd717df9cc568609$var$escapeRE = /["'&<>]/;
function $fd717df9cc568609$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $fd717df9cc568609$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $fd717df9cc568609$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $fd717df9cc568609$export$7b105034a53bde5f(src) {
    return src.replace($fd717df9cc568609$var$commentStripRE, "");
}
function $fd717df9cc568609$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $fd717df9cc568609$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $fd717df9cc568609$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $fd717df9cc568609$export$871608497c498473(a);
    let bValidType = $fd717df9cc568609$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $fd717df9cc568609$export$a244864fd9645c7f(a);
    bValidType = $fd717df9cc568609$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $fd717df9cc568609$export$43bee75e5e14138e(a);
    bValidType = $fd717df9cc568609$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $fd717df9cc568609$var$looseCompareArrays(a, b) : false;
    aValidType = $fd717df9cc568609$export$a6cdc56e425d0d0a(a);
    bValidType = $fd717df9cc568609$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$fd717df9cc568609$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $fd717df9cc568609$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$fd717df9cc568609$export$ae8015769846262c(item, val));
}
const $fd717df9cc568609$export$b5b1545233b45293 = (val)=>{
    return $fd717df9cc568609$export$844ec244b1367d54(val) ? val : val == null ? "" : $fd717df9cc568609$export$43bee75e5e14138e(val) || $fd717df9cc568609$export$a6cdc56e425d0d0a(val) && (val.toString === $fd717df9cc568609$export$830c053460e5ddf6 || !$fd717df9cc568609$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $fd717df9cc568609$var$replacer, 2) : String(val);
};
const $fd717df9cc568609$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $fd717df9cc568609$var$replacer(_key, val.value);
    else if ($fd717df9cc568609$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$fd717df9cc568609$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($fd717df9cc568609$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$fd717df9cc568609$var$stringifySymbol(v))
    };
    else if ($fd717df9cc568609$export$a244864fd9645c7f(val)) return $fd717df9cc568609$var$stringifySymbol(val);
    else if ($fd717df9cc568609$export$a6cdc56e425d0d0a(val) && !$fd717df9cc568609$export$43bee75e5e14138e(val) && !$fd717df9cc568609$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $fd717df9cc568609$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $fd717df9cc568609$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});


parcelRegister("8XWQX", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $68717c6dc3e7acb0$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $68717c6dc3e7acb0$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $68717c6dc3e7acb0$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $68717c6dc3e7acb0$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $68717c6dc3e7acb0$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $68717c6dc3e7acb0$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $68717c6dc3e7acb0$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $68717c6dc3e7acb0$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $68717c6dc3e7acb0$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $68717c6dc3e7acb0$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $68717c6dc3e7acb0$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $68717c6dc3e7acb0$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $68717c6dc3e7acb0$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $68717c6dc3e7acb0$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $68717c6dc3e7acb0$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $68717c6dc3e7acb0$export$844ec244b1367d54);
$parcel$export(module.exports, "isObject", () => $68717c6dc3e7acb0$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $68717c6dc3e7acb0$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $68717c6dc3e7acb0$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $68717c6dc3e7acb0$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isReservedProp", () => $68717c6dc3e7acb0$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $68717c6dc3e7acb0$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $68717c6dc3e7acb0$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $68717c6dc3e7acb0$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $68717c6dc3e7acb0$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $68717c6dc3e7acb0$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $68717c6dc3e7acb0$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $68717c6dc3e7acb0$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $68717c6dc3e7acb0$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $68717c6dc3e7acb0$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $68717c6dc3e7acb0$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $68717c6dc3e7acb0$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $68717c6dc3e7acb0$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $68717c6dc3e7acb0$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $68717c6dc3e7acb0$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $68717c6dc3e7acb0$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isBooleanAttr", () => $68717c6dc3e7acb0$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $68717c6dc3e7acb0$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $68717c6dc3e7acb0$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $68717c6dc3e7acb0$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $68717c6dc3e7acb0$export$921dd2acf0d386a3);
$parcel$export(module.exports, "toDisplayString", () => $68717c6dc3e7acb0$export$b5b1545233b45293);
/**
* @vue/shared v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $68717c6dc3e7acb0$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $68717c6dc3e7acb0$export$cf583d23ab39677c = {};
const $68717c6dc3e7acb0$export$6bd8558f433f1cc1 = [];
const $68717c6dc3e7acb0$export$5702a91a6f42969f = ()=>{};
const $68717c6dc3e7acb0$export$c01351c0af048e39 = ()=>false;
const $68717c6dc3e7acb0$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $68717c6dc3e7acb0$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $68717c6dc3e7acb0$export$8b58be045bf06082 = Object.assign;
const $68717c6dc3e7acb0$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $68717c6dc3e7acb0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $68717c6dc3e7acb0$export$b5a638e9b3fff9f3 = (val, key)=>$68717c6dc3e7acb0$var$hasOwnProperty.call(val, key);
const $68717c6dc3e7acb0$export$43bee75e5e14138e = Array.isArray;
const $68717c6dc3e7acb0$export$5c90113a285f2241 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Map]";
const $68717c6dc3e7acb0$export$6750766a7c7ec627 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Set]";
const $68717c6dc3e7acb0$export$871608497c498473 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Date]";
const $68717c6dc3e7acb0$export$49841c62b9eff15 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object RegExp]";
const $68717c6dc3e7acb0$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $68717c6dc3e7acb0$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $68717c6dc3e7acb0$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $68717c6dc3e7acb0$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $68717c6dc3e7acb0$export$4369c812aac99591 = (val)=>{
    return ($68717c6dc3e7acb0$export$a6cdc56e425d0d0a(val) || $68717c6dc3e7acb0$export$f6e2535fb5126e54(val)) && $68717c6dc3e7acb0$export$f6e2535fb5126e54(val.then) && $68717c6dc3e7acb0$export$f6e2535fb5126e54(val.catch);
};
const $68717c6dc3e7acb0$export$830c053460e5ddf6 = Object.prototype.toString;
const $68717c6dc3e7acb0$export$1dccc787cc36538b = (value)=>$68717c6dc3e7acb0$export$830c053460e5ddf6.call(value);
const $68717c6dc3e7acb0$export$5ad0a3c360b8fbb5 = (value)=>{
    return $68717c6dc3e7acb0$export$1dccc787cc36538b(value).slice(8, -1);
};
const $68717c6dc3e7acb0$export$53b83ca8eaab0383 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Object]";
const $68717c6dc3e7acb0$export$e2a2b93446ec9fe = (key)=>$68717c6dc3e7acb0$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $68717c6dc3e7acb0$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $68717c6dc3e7acb0$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $68717c6dc3e7acb0$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $68717c6dc3e7acb0$var$camelizeRE = /-(\w)/g;
const $68717c6dc3e7acb0$export$161d051f5dd25de7 = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>{
    return str.replace($68717c6dc3e7acb0$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $68717c6dc3e7acb0$var$hyphenateRE = /\B([A-Z])/g;
const $68717c6dc3e7acb0$export$6e6a0a3676c4b8bb = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>str.replace($68717c6dc3e7acb0$var$hyphenateRE, "-$1").toLowerCase());
const $68717c6dc3e7acb0$export$9a00dee1beb8f576 = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $68717c6dc3e7acb0$export$8c022799eeaaefcd = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>{
    const s = str ? `on${$68717c6dc3e7acb0$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $68717c6dc3e7acb0$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $68717c6dc3e7acb0$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $68717c6dc3e7acb0$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $68717c6dc3e7acb0$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $68717c6dc3e7acb0$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $68717c6dc3e7acb0$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $68717c6dc3e7acb0$var$_globalThis;
const $68717c6dc3e7acb0$export$ff5f2eeb11fc7e14 = ()=>{
    return $68717c6dc3e7acb0$var$_globalThis || ($68717c6dc3e7acb0$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $68717c6dc3e7acb0$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $68717c6dc3e7acb0$export$53d5e12f9a1d3cde(name) {
    return $68717c6dc3e7acb0$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $68717c6dc3e7acb0$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $68717c6dc3e7acb0$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $68717c6dc3e7acb0$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $68717c6dc3e7acb0$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $68717c6dc3e7acb0$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $68717c6dc3e7acb0$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $68717c6dc3e7acb0$export$f73b8c13b7f97ebf = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$GLOBALS_ALLOWED);
const $68717c6dc3e7acb0$export$d6571a1911e4f27e = $68717c6dc3e7acb0$export$f73b8c13b7f97ebf;
const $68717c6dc3e7acb0$var$range = 2;
function $68717c6dc3e7acb0$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $68717c6dc3e7acb0$var$range; j <= i + $68717c6dc3e7acb0$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $68717c6dc3e7acb0$export$8756898546458274(value) {
    if ($68717c6dc3e7acb0$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $68717c6dc3e7acb0$export$844ec244b1367d54(item) ? $68717c6dc3e7acb0$export$76a205ce979d066a(item) : $68717c6dc3e7acb0$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($68717c6dc3e7acb0$export$844ec244b1367d54(value) || $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(value)) return value;
}
const $68717c6dc3e7acb0$var$listDelimiterRE = /;(?![^(]*\))/g;
const $68717c6dc3e7acb0$var$propertyDelimiterRE = /:([^]+)/;
const $68717c6dc3e7acb0$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $68717c6dc3e7acb0$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($68717c6dc3e7acb0$var$styleCommentRE, "").split($68717c6dc3e7acb0$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($68717c6dc3e7acb0$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $68717c6dc3e7acb0$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $68717c6dc3e7acb0$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if ($68717c6dc3e7acb0$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $68717c6dc3e7acb0$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $68717c6dc3e7acb0$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($68717c6dc3e7acb0$export$844ec244b1367d54(value)) res = value;
    else if ($68717c6dc3e7acb0$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $68717c6dc3e7acb0$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($68717c6dc3e7acb0$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $68717c6dc3e7acb0$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$68717c6dc3e7acb0$export$844ec244b1367d54(klass)) props.class = $68717c6dc3e7acb0$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $68717c6dc3e7acb0$export$8756898546458274(style);
    return props;
}
const $68717c6dc3e7acb0$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $68717c6dc3e7acb0$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $68717c6dc3e7acb0$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $68717c6dc3e7acb0$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $68717c6dc3e7acb0$export$1ccf854a0984f890 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$HTML_TAGS);
const $68717c6dc3e7acb0$export$6328ce7565ea1049 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$SVG_TAGS);
const $68717c6dc3e7acb0$export$4a46ca4c5be17b20 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$MATH_TAGS);
const $68717c6dc3e7acb0$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$VOID_TAGS);
const $68717c6dc3e7acb0$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $68717c6dc3e7acb0$export$d186f5eb2e810715 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$specialBooleanAttrs);
const $68717c6dc3e7acb0$export$f763ba3b84e9cd8c = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $68717c6dc3e7acb0$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $68717c6dc3e7acb0$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $68717c6dc3e7acb0$var$attrValidationCache = {};
function $68717c6dc3e7acb0$export$d55ef77660f30d12(name) {
    if ($68717c6dc3e7acb0$var$attrValidationCache.hasOwnProperty(name)) return $68717c6dc3e7acb0$var$attrValidationCache[name];
    const isUnsafe = $68717c6dc3e7acb0$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $68717c6dc3e7acb0$var$attrValidationCache[name] = !isUnsafe;
}
const $68717c6dc3e7acb0$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $68717c6dc3e7acb0$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $68717c6dc3e7acb0$export$80da416f43933831 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $68717c6dc3e7acb0$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $68717c6dc3e7acb0$var$escapeRE = /["'&<>]/;
function $68717c6dc3e7acb0$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $68717c6dc3e7acb0$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $68717c6dc3e7acb0$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $68717c6dc3e7acb0$export$7b105034a53bde5f(src) {
    return src.replace($68717c6dc3e7acb0$var$commentStripRE, "");
}
function $68717c6dc3e7acb0$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $68717c6dc3e7acb0$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $68717c6dc3e7acb0$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $68717c6dc3e7acb0$export$871608497c498473(a);
    let bValidType = $68717c6dc3e7acb0$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $68717c6dc3e7acb0$export$a244864fd9645c7f(a);
    bValidType = $68717c6dc3e7acb0$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $68717c6dc3e7acb0$export$43bee75e5e14138e(a);
    bValidType = $68717c6dc3e7acb0$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $68717c6dc3e7acb0$var$looseCompareArrays(a, b) : false;
    aValidType = $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(a);
    bValidType = $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$68717c6dc3e7acb0$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $68717c6dc3e7acb0$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$68717c6dc3e7acb0$export$ae8015769846262c(item, val));
}
const $68717c6dc3e7acb0$export$b5b1545233b45293 = (val)=>{
    return $68717c6dc3e7acb0$export$844ec244b1367d54(val) ? val : val == null ? "" : $68717c6dc3e7acb0$export$43bee75e5e14138e(val) || $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(val) && (val.toString === $68717c6dc3e7acb0$export$830c053460e5ddf6 || !$68717c6dc3e7acb0$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $68717c6dc3e7acb0$var$replacer, 2) : String(val);
};
const $68717c6dc3e7acb0$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $68717c6dc3e7acb0$var$replacer(_key, val.value);
    else if ($68717c6dc3e7acb0$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$68717c6dc3e7acb0$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($68717c6dc3e7acb0$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$68717c6dc3e7acb0$var$stringifySymbol(v))
    };
    else if ($68717c6dc3e7acb0$export$a244864fd9645c7f(val)) return $68717c6dc3e7acb0$var$stringifySymbol(val);
    else if ($68717c6dc3e7acb0$export$a6cdc56e425d0d0a(val) && !$68717c6dc3e7acb0$export$43bee75e5e14138e(val) && !$68717c6dc3e7acb0$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $68717c6dc3e7acb0$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $68717c6dc3e7acb0$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});


parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8XWQX")).camelize);
$parcel$export(module.exports, "Comment", () => (parcelRequire("TusQn")).Comment);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createSlots", () => (parcelRequire("TusQn")).createSlots);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8XWQX")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8XWQX")).normalizeStyle);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("TusQn")).watchPostEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8XWQX")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelRadio", () => $a5d55dc64ccb07cf$export$b4356c59b38b7aa9);
$parcel$export(module.exports, "vModelDynamic", () => $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
/**
* @vue/runtime-dom v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
var $01W3b = parcelRequire("01W3b");parcelRequire("01W3b");parcelRequire("8XWQX");

var $4YcVI = parcelRequire("4YcVI");
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : $a5d55dc64ccb07cf$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$export$be58926105124dd4 = (props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots);
$a5d55dc64ccb07cf$export$be58926105124dd4.displayName = "Transition";
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = $a5d55dc64ccb07cf$export$be58926105124dd4.props = /* @__PURE__ */ (0, $4YcVI.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $4YcVI.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $4YcVI.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $4YcVI.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            $a5d55dc64ccb07cf$var$forceReflow();
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $4YcVI.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $4YcVI.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watchPostEffect)(setVars);
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $4YcVI.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $4YcVI.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $4YcVI.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $4YcVI.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8XWQX.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $4YcVI.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $4YcVI.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $4YcVI.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $4YcVI.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $4YcVI.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $4YcVI.isFunction)(value) || (0, $4YcVI.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $4YcVI.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $4YcVI.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $4YcVI.isOn)(key)) {
        if (!(0, $4YcVI.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $4YcVI.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $4YcVI.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $TusQn.defineComponent)(options);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $4YcVI.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $4YcVI.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $4YcVI.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $4YcVI.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $4YcVI.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        const camelKey = (0, $4YcVI.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $4YcVI.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $4YcVI.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $4YcVI.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $4YcVI.hyphenate)(key));
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $4YcVI.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $4YcVI.hyphenate)(event) !== event) dispatch((0, $4YcVI.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $4YcVI.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $4YcVI.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $4YcVI.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $4YcVI.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
};
const $a5d55dc64ccb07cf$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $a5d55dc64ccb07cf$var$removeMode($a5d55dc64ccb07cf$var$TransitionGroupImpl.props);
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $4YcVI.isArray)(fn) ? (value)=>(0, $4YcVI.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $4YcVI.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $4YcVI.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $4YcVI.isArray)(modelValue)) {
                const index = (0, $4YcVI.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $4YcVI.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $4YcVI.isArray)(value)) el.checked = (0, $4YcVI.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $4YcVI.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $4YcVI.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $4YcVI.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $4YcVI.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $4YcVI.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $4YcVI.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value, modifiers: { number: number } }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value, modifiers: { number: number } }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $4YcVI.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $4YcVI.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $4YcVI.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $4YcVI.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $4YcVI.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $4YcVI.isArray)(value)) {
            if (vnode.props && (0, $4YcVI.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $4YcVI.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $4YcVI.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $4YcVI.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $4YcVI.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $4YcVI.isHTMLTag)(tag) || (0, $4YcVI.isSVGTag)(tag) || (0, $4YcVI.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $4YcVI.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});
parcelRegister("4YcVI", function(module, exports) {

$parcel$export(module.exports, "EMPTY_OBJ", () => $39e6cba439e3586f$export$cf583d23ab39677c);
$parcel$export(module.exports, "NOOP", () => $39e6cba439e3586f$export$5702a91a6f42969f);
$parcel$export(module.exports, "isOn", () => $39e6cba439e3586f$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $39e6cba439e3586f$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $39e6cba439e3586f$export$8b58be045bf06082);
$parcel$export(module.exports, "isArray", () => $39e6cba439e3586f$export$43bee75e5e14138e);
$parcel$export(module.exports, "isSet", () => $39e6cba439e3586f$export$6750766a7c7ec627);
$parcel$export(module.exports, "isFunction", () => $39e6cba439e3586f$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $39e6cba439e3586f$export$844ec244b1367d54);
$parcel$export(module.exports, "isObject", () => $39e6cba439e3586f$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "camelize", () => $39e6cba439e3586f$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $39e6cba439e3586f$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $39e6cba439e3586f$export$9a00dee1beb8f576);
$parcel$export(module.exports, "invokeArrayFns", () => $39e6cba439e3586f$export$39951422d618a9d3);
$parcel$export(module.exports, "looseToNumber", () => $39e6cba439e3586f$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $39e6cba439e3586f$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "isHTMLTag", () => $39e6cba439e3586f$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $39e6cba439e3586f$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $39e6cba439e3586f$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $39e6cba439e3586f$export$d186f5eb2e810715);
$parcel$export(module.exports, "includeBooleanAttr", () => $39e6cba439e3586f$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "looseEqual", () => $39e6cba439e3586f$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $39e6cba439e3586f$export$42912a80cedb8bd4);
/**
* @vue/shared v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $39e6cba439e3586f$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $39e6cba439e3586f$export$cf583d23ab39677c = {};
const $39e6cba439e3586f$export$6bd8558f433f1cc1 = [];
const $39e6cba439e3586f$export$5702a91a6f42969f = ()=>{};
const $39e6cba439e3586f$export$c01351c0af048e39 = ()=>false;
const $39e6cba439e3586f$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $39e6cba439e3586f$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $39e6cba439e3586f$export$8b58be045bf06082 = Object.assign;
const $39e6cba439e3586f$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $39e6cba439e3586f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $39e6cba439e3586f$export$b5a638e9b3fff9f3 = (val, key)=>$39e6cba439e3586f$var$hasOwnProperty.call(val, key);
const $39e6cba439e3586f$export$43bee75e5e14138e = Array.isArray;
const $39e6cba439e3586f$export$5c90113a285f2241 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Map]";
const $39e6cba439e3586f$export$6750766a7c7ec627 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Set]";
const $39e6cba439e3586f$export$871608497c498473 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Date]";
const $39e6cba439e3586f$export$49841c62b9eff15 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object RegExp]";
const $39e6cba439e3586f$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $39e6cba439e3586f$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $39e6cba439e3586f$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $39e6cba439e3586f$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $39e6cba439e3586f$export$4369c812aac99591 = (val)=>{
    return ($39e6cba439e3586f$export$a6cdc56e425d0d0a(val) || $39e6cba439e3586f$export$f6e2535fb5126e54(val)) && $39e6cba439e3586f$export$f6e2535fb5126e54(val.then) && $39e6cba439e3586f$export$f6e2535fb5126e54(val.catch);
};
const $39e6cba439e3586f$export$830c053460e5ddf6 = Object.prototype.toString;
const $39e6cba439e3586f$export$1dccc787cc36538b = (value)=>$39e6cba439e3586f$export$830c053460e5ddf6.call(value);
const $39e6cba439e3586f$export$5ad0a3c360b8fbb5 = (value)=>{
    return $39e6cba439e3586f$export$1dccc787cc36538b(value).slice(8, -1);
};
const $39e6cba439e3586f$export$53b83ca8eaab0383 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Object]";
const $39e6cba439e3586f$export$e2a2b93446ec9fe = (key)=>$39e6cba439e3586f$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $39e6cba439e3586f$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $39e6cba439e3586f$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $39e6cba439e3586f$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $39e6cba439e3586f$var$camelizeRE = /-(\w)/g;
const $39e6cba439e3586f$export$161d051f5dd25de7 = $39e6cba439e3586f$var$cacheStringFunction((str)=>{
    return str.replace($39e6cba439e3586f$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $39e6cba439e3586f$var$hyphenateRE = /\B([A-Z])/g;
const $39e6cba439e3586f$export$6e6a0a3676c4b8bb = $39e6cba439e3586f$var$cacheStringFunction((str)=>str.replace($39e6cba439e3586f$var$hyphenateRE, "-$1").toLowerCase());
const $39e6cba439e3586f$export$9a00dee1beb8f576 = $39e6cba439e3586f$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $39e6cba439e3586f$export$8c022799eeaaefcd = $39e6cba439e3586f$var$cacheStringFunction((str)=>{
    const s = str ? `on${$39e6cba439e3586f$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $39e6cba439e3586f$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $39e6cba439e3586f$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $39e6cba439e3586f$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $39e6cba439e3586f$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $39e6cba439e3586f$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $39e6cba439e3586f$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $39e6cba439e3586f$var$_globalThis;
const $39e6cba439e3586f$export$ff5f2eeb11fc7e14 = ()=>{
    return $39e6cba439e3586f$var$_globalThis || ($39e6cba439e3586f$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $39e6cba439e3586f$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $39e6cba439e3586f$export$53d5e12f9a1d3cde(name) {
    return $39e6cba439e3586f$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $39e6cba439e3586f$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $39e6cba439e3586f$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $39e6cba439e3586f$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $39e6cba439e3586f$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $39e6cba439e3586f$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $39e6cba439e3586f$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $39e6cba439e3586f$export$f73b8c13b7f97ebf = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$GLOBALS_ALLOWED);
const $39e6cba439e3586f$export$d6571a1911e4f27e = $39e6cba439e3586f$export$f73b8c13b7f97ebf;
const $39e6cba439e3586f$var$range = 2;
function $39e6cba439e3586f$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $39e6cba439e3586f$var$range; j <= i + $39e6cba439e3586f$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $39e6cba439e3586f$export$8756898546458274(value) {
    if ($39e6cba439e3586f$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $39e6cba439e3586f$export$844ec244b1367d54(item) ? $39e6cba439e3586f$export$76a205ce979d066a(item) : $39e6cba439e3586f$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($39e6cba439e3586f$export$844ec244b1367d54(value) || $39e6cba439e3586f$export$a6cdc56e425d0d0a(value)) return value;
}
const $39e6cba439e3586f$var$listDelimiterRE = /;(?![^(]*\))/g;
const $39e6cba439e3586f$var$propertyDelimiterRE = /:([^]+)/;
const $39e6cba439e3586f$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $39e6cba439e3586f$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($39e6cba439e3586f$var$styleCommentRE, "").split($39e6cba439e3586f$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($39e6cba439e3586f$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $39e6cba439e3586f$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $39e6cba439e3586f$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if ($39e6cba439e3586f$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $39e6cba439e3586f$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $39e6cba439e3586f$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($39e6cba439e3586f$export$844ec244b1367d54(value)) res = value;
    else if ($39e6cba439e3586f$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $39e6cba439e3586f$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($39e6cba439e3586f$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $39e6cba439e3586f$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$39e6cba439e3586f$export$844ec244b1367d54(klass)) props.class = $39e6cba439e3586f$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $39e6cba439e3586f$export$8756898546458274(style);
    return props;
}
const $39e6cba439e3586f$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $39e6cba439e3586f$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $39e6cba439e3586f$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $39e6cba439e3586f$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $39e6cba439e3586f$export$1ccf854a0984f890 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$HTML_TAGS);
const $39e6cba439e3586f$export$6328ce7565ea1049 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$SVG_TAGS);
const $39e6cba439e3586f$export$4a46ca4c5be17b20 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$MATH_TAGS);
const $39e6cba439e3586f$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$VOID_TAGS);
const $39e6cba439e3586f$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $39e6cba439e3586f$export$d186f5eb2e810715 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$specialBooleanAttrs);
const $39e6cba439e3586f$export$f763ba3b84e9cd8c = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $39e6cba439e3586f$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $39e6cba439e3586f$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $39e6cba439e3586f$var$attrValidationCache = {};
function $39e6cba439e3586f$export$d55ef77660f30d12(name) {
    if ($39e6cba439e3586f$var$attrValidationCache.hasOwnProperty(name)) return $39e6cba439e3586f$var$attrValidationCache[name];
    const isUnsafe = $39e6cba439e3586f$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $39e6cba439e3586f$var$attrValidationCache[name] = !isUnsafe;
}
const $39e6cba439e3586f$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $39e6cba439e3586f$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $39e6cba439e3586f$export$80da416f43933831 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $39e6cba439e3586f$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $39e6cba439e3586f$var$escapeRE = /["'&<>]/;
function $39e6cba439e3586f$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $39e6cba439e3586f$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $39e6cba439e3586f$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $39e6cba439e3586f$export$7b105034a53bde5f(src) {
    return src.replace($39e6cba439e3586f$var$commentStripRE, "");
}
function $39e6cba439e3586f$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $39e6cba439e3586f$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $39e6cba439e3586f$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $39e6cba439e3586f$export$871608497c498473(a);
    let bValidType = $39e6cba439e3586f$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $39e6cba439e3586f$export$a244864fd9645c7f(a);
    bValidType = $39e6cba439e3586f$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $39e6cba439e3586f$export$43bee75e5e14138e(a);
    bValidType = $39e6cba439e3586f$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $39e6cba439e3586f$var$looseCompareArrays(a, b) : false;
    aValidType = $39e6cba439e3586f$export$a6cdc56e425d0d0a(a);
    bValidType = $39e6cba439e3586f$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$39e6cba439e3586f$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $39e6cba439e3586f$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$39e6cba439e3586f$export$ae8015769846262c(item, val));
}
const $39e6cba439e3586f$export$b5b1545233b45293 = (val)=>{
    return $39e6cba439e3586f$export$844ec244b1367d54(val) ? val : val == null ? "" : $39e6cba439e3586f$export$43bee75e5e14138e(val) || $39e6cba439e3586f$export$a6cdc56e425d0d0a(val) && (val.toString === $39e6cba439e3586f$export$830c053460e5ddf6 || !$39e6cba439e3586f$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $39e6cba439e3586f$var$replacer, 2) : String(val);
};
const $39e6cba439e3586f$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $39e6cba439e3586f$var$replacer(_key, val.value);
    else if ($39e6cba439e3586f$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$39e6cba439e3586f$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($39e6cba439e3586f$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$39e6cba439e3586f$var$stringifySymbol(v))
    };
    else if ($39e6cba439e3586f$export$a244864fd9645c7f(val)) return $39e6cba439e3586f$var$stringifySymbol(val);
    else if ($39e6cba439e3586f$export$a6cdc56e425d0d0a(val) && !$39e6cba439e3586f$export$43bee75e5e14138e(val) && !$39e6cba439e3586f$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $39e6cba439e3586f$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $39e6cba439e3586f$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});




parcelRegister("j7uiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $deb62d7979e5522f$export$2e2bcd8739ae039);
let $deb62d7979e5522f$var$NOOP = ()=>{};
var $deb62d7979e5522f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iPUx5", function(module, exports) {

$parcel$export(module.exports, "CdxIcon", () => $db68d79c4ce005fe$export$675126b72043484a);
$parcel$export(module.exports, "CdxButton", () => $db68d79c4ce005fe$export$3318068e43c65fe8);
$parcel$export(module.exports, "CdxTextInput", () => $db68d79c4ce005fe$export$edf7ede3ce8aed68);
$parcel$export(module.exports, "CdxMessage", () => $db68d79c4ce005fe$export$cebd7a56cc7f747);
$parcel$export(module.exports, "CdxInfoChip", () => $db68d79c4ce005fe$export$488fdba6da31f9c3);
$parcel$export(module.exports, "CdxSelect", () => $db68d79c4ce005fe$export$fd5153ff27ffff7b);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
var $8XWQX = parcelRequire("8XWQX");
var $eeJ70 = parcelRequire("eeJ70");
var $db68d79c4ce005fe$var$__defProp = Object.defineProperty;
var $db68d79c4ce005fe$var$__defProps = Object.defineProperties;
var $db68d79c4ce005fe$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $db68d79c4ce005fe$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $db68d79c4ce005fe$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $db68d79c4ce005fe$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $db68d79c4ce005fe$var$__defNormalProp = (obj, key, value)=>key in obj ? $db68d79c4ce005fe$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $db68d79c4ce005fe$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($db68d79c4ce005fe$var$__hasOwnProp.call(b, prop)) $db68d79c4ce005fe$var$__defNormalProp(a, prop, b[prop]);
    if ($db68d79c4ce005fe$var$__getOwnPropSymbols) {
        for (var prop of $db68d79c4ce005fe$var$__getOwnPropSymbols(b))if ($db68d79c4ce005fe$var$__propIsEnum.call(b, prop)) $db68d79c4ce005fe$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $db68d79c4ce005fe$var$__spreadProps = (a, b)=>$db68d79c4ce005fe$var$__defProps(a, $db68d79c4ce005fe$var$__getOwnPropDescs(b));
var $db68d79c4ce005fe$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($db68d79c4ce005fe$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $db68d79c4ce005fe$var$__getOwnPropSymbols) {
        for (var prop of $db68d79c4ce005fe$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $db68d79c4ce005fe$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $db68d79c4ce005fe$var$__publicField = (obj, key, value)=>{
    $db68d79c4ce005fe$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $db68d79c4ce005fe$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
const $db68d79c4ce005fe$var$g = '<path d="M11.53 2.3A1.85 1.85 0 0010 1.21 1.85 1.85 0 008.48 2.3L.36 16.36C-.48 17.81.21 19 1.88 19h16.24c1.67 0 2.36-1.19 1.52-2.64zM11 16H9v-2h2zm0-4H9V6h2z"/>', $db68d79c4ce005fe$var$q = '<path d="M12.43 14.34A5 5 0 0110 15a5 5 0 113.95-2L17 16.09V3a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 001.45-.63z"/><circle cx="10" cy="10" r="3"/>', $db68d79c4ce005fe$var$s1 = '<path d="M7 14.17 2.83 10l-1.41 1.41L7 17 19 5l-1.41-1.42z"/>', $db68d79c4ce005fe$var$n1 = '<path d="M10 0a10 10 0 1010 10A10 10 0 0010 0m5.66 14.24-1.41 1.41L10 11.41l-4.24 4.25-1.42-1.42L8.59 10 4.34 5.76l1.42-1.42L10 8.59l4.24-4.24 1.41 1.41L11.41 10z"/>', $db68d79c4ce005fe$var$d1 = '<path d="m4.34 2.93 12.73 12.73-1.41 1.41L2.93 4.35z"/><path d="M17.07 4.34 4.34 17.07l-1.41-1.41L15.66 2.93z"/>', $db68d79c4ce005fe$var$g1 = '<path d="M10 15 2 5h16z"/>', $db68d79c4ce005fe$var$k1 = '<path d="M13.728 1H6.272L1 6.272v7.456L6.272 19h7.456L19 13.728V6.272zM11 15H9v-2h2zm0-4H9V5h2z"/>', $db68d79c4ce005fe$var$F1 = '<path d="m17.5 4.75-7.5 7.5-7.5-7.5L1 6.25l9 9 9-9z"/>', $db68d79c4ce005fe$var$t0 = '<path d="M19 3H1v14h18zM3 14l3.5-4.5 2.5 3L12.5 8l4.5 6z"/><path d="M19 5H1V3h18zm0 12H1v-2h18z"/>', $db68d79c4ce005fe$var$p = '<path d="M8 19a1 1 0 001 1h2a1 1 0 001-1v-1H8zm9-12a7 7 0 10-12 4.9S7 14 7 15v1a1 1 0 001 1h4a1 1 0 001-1v-1c0-1 2-3.1 2-3.1A7 7 0 0017 7"/>', $db68d79c4ce005fe$var$e0 = '<path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0M9 5h2v2H9zm0 4h2v6H9z"/>', $db68d79c4ce005fe$var$z2 = '<path d="M3 1h2v18H3zm13.5 1.5L15 1l-9 9 9 9 1.5-1.5L9 10z"/>', $db68d79c4ce005fe$var$i2 = '<path d="M15 1h2v18h-2zM3.5 2.5 11 10l-7.5 7.5L5 19l9-9-9-9z"/>', $db68d79c4ce005fe$var$V2 = '<path d="M7 1 5.6 2.5 13 10l-7.4 7.5L7 19l9-9z"/>', $db68d79c4ce005fe$var$b2 = '<path d="m4 10 9 9 1.4-1.5L7 10l7.4-7.5L13 1z"/>', $db68d79c4ce005fe$var$J2 = '<path d="M12.2 13.6a7 7 0 111.4-1.4l5.4 5.4-1.4 1.4zM3 8a5 5 0 1010 0A5 5 0 003 8"/>', $db68d79c4ce005fe$var$h5 = '<path d="M10 0 3 8h14zm0 18-7-8h14z"/>', $db68d79c4ce005fe$var$M5 = '<path d="M10 20a10 10 0 010-20 10 10 0 110 20m-2-5 9-8.5L15.5 5 8 12 4.5 8.5 3 10z"/>', $db68d79c4ce005fe$var$G5 = '<path d="m10 5 8 10H2z"/>', $db68d79c4ce005fe$var$M3 = $db68d79c4ce005fe$var$g, $db68d79c4ce005fe$var$S3 = $db68d79c4ce005fe$var$q, $db68d79c4ce005fe$var$K3 = $db68d79c4ce005fe$var$s1, $db68d79c4ce005fe$var$Y3 = $db68d79c4ce005fe$var$n1, $db68d79c4ce005fe$var$X3 = $db68d79c4ce005fe$var$d1, $db68d79c4ce005fe$var$l4 = $db68d79c4ce005fe$var$g1, $db68d79c4ce005fe$var$i4 = $db68d79c4ce005fe$var$k1, $db68d79c4ce005fe$var$m4 = $db68d79c4ce005fe$var$F1, $db68d79c4ce005fe$var$P4 = $db68d79c4ce005fe$var$t0, $db68d79c4ce005fe$var$Y4 = {
    langCodeMap: {
        ar: $db68d79c4ce005fe$var$p
    },
    default: $db68d79c4ce005fe$var$e0
}, $db68d79c4ce005fe$var$P6 = {
    ltr: $db68d79c4ce005fe$var$z2,
    shouldFlip: true
}, $db68d79c4ce005fe$var$N6 = {
    ltr: $db68d79c4ce005fe$var$i2,
    shouldFlip: true
}, $db68d79c4ce005fe$var$j6 = {
    ltr: $db68d79c4ce005fe$var$V2,
    shouldFlip: true
}, $db68d79c4ce005fe$var$d7 = {
    ltr: $db68d79c4ce005fe$var$b2,
    shouldFlip: true
}, $db68d79c4ce005fe$var$A7 = $db68d79c4ce005fe$var$J2, $db68d79c4ce005fe$var$T7 = $db68d79c4ce005fe$var$h5, $db68d79c4ce005fe$var$O7 = $db68d79c4ce005fe$var$M5, $db68d79c4ce005fe$var$x8 = $db68d79c4ce005fe$var$G5;
function $db68d79c4ce005fe$var$N8(c, s, h) {
    if (typeof c == "string" || "path" in c) return c;
    if ("shouldFlip" in c) return c.ltr;
    if ("rtl" in c) return h === "rtl" ? c.rtl : c.ltr;
    const n = s in c.langCodeMap ? c.langCodeMap[s] : c.default;
    return typeof n == "string" || "path" in n ? n : n.ltr;
}
function $db68d79c4ce005fe$var$O8(c, s) {
    if (typeof c == "string") return false;
    if ("langCodeMap" in c) {
        const h = s in c.langCodeMap ? c.langCodeMap[s] : c.default;
        if (typeof h == "string") return false;
        c = h;
    }
    if ("shouldFlipExceptions" in c && Array.isArray(c.shouldFlipExceptions)) {
        const h = c.shouldFlipExceptions.indexOf(s);
        return h === void 0 || h === -1;
    }
    return "shouldFlip" in c ? c.shouldFlip : false;
}
function $db68d79c4ce005fe$export$b64edd098c9cdbaf(root) {
    const computedDir = (0, $01W3b.ref)(null);
    (0, $TusQn.onMounted)(()=>{
        const dir = window.getComputedStyle(root.value).direction;
        computedDir.value = dir === "ltr" || dir === "rtl" ? dir : null;
    });
    return computedDir;
}
function $db68d79c4ce005fe$export$fafaa3135f296aba(root) {
    const computedLang = (0, $01W3b.ref)("");
    (0, $TusQn.onMounted)(()=>{
        let ancestor = root.value;
        while(ancestor && ancestor.lang === "")ancestor = ancestor.parentElement;
        computedLang.value = ancestor ? ancestor.lang : null;
    });
    return computedLang;
}
function $db68d79c4ce005fe$var$makeStringTypeValidator(allowedValues) {
    return (s)=>typeof s === "string" && allowedValues.indexOf(s) !== -1;
}
const $db68d79c4ce005fe$var$LibraryPrefix = "cdx";
const $db68d79c4ce005fe$var$ButtonActions = [
    "default",
    "progressive",
    "destructive"
];
const $db68d79c4ce005fe$var$ButtonWeights = [
    "normal",
    "primary",
    "quiet"
];
const $db68d79c4ce005fe$var$ButtonSizes = [
    "medium",
    "large"
];
const $db68d79c4ce005fe$var$IconSizes = [
    "x-small",
    "small",
    "medium"
];
const $db68d79c4ce005fe$var$StatusTypes = [
    "notice",
    "warning",
    "error",
    "success"
];
const $db68d79c4ce005fe$var$statusTypeValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$StatusTypes);
const $db68d79c4ce005fe$var$TextInputTypes = [
    "text",
    "search",
    "number",
    "email",
    "month",
    "password",
    "tel",
    "url",
    "week",
    "date",
    "datetime-local",
    "time"
];
const $db68d79c4ce005fe$var$ValidationStatusTypes = [
    "default",
    "warning",
    "error",
    "success"
];
const $db68d79c4ce005fe$var$TableTextAlignments = [
    "start",
    "center",
    "end",
    // Numbers should be aligned to the right in all reading directionalities.
    "number"
];
const $db68d79c4ce005fe$var$DebounceInterval = 120;
const $db68d79c4ce005fe$var$PendingDelay = 500;
const $db68d79c4ce005fe$var$MenuFooterValue = "cdx-menu-footer-item";
const $db68d79c4ce005fe$var$TabsKey = Symbol("CdxTabs");
const $db68d79c4ce005fe$var$ActiveTabKey = Symbol("CdxActiveTab");
const $db68d79c4ce005fe$var$AllowArbitraryKey = Symbol("CdxAllowArbitrary");
const $db68d79c4ce005fe$var$FieldInputIdKey = Symbol("CdxFieldInputId");
const $db68d79c4ce005fe$var$FieldDescriptionIdKey = Symbol("CdxFieldDescriptionId");
const $db68d79c4ce005fe$var$FieldStatusKey = Symbol("CdxFieldStatus");
const $db68d79c4ce005fe$var$DisabledKey = Symbol("CdxDisabled");
const $db68d79c4ce005fe$var$NoInvertClass = "".concat($db68d79c4ce005fe$var$LibraryPrefix, "-no-invert");
const $db68d79c4ce005fe$export$6bc4af29e8294dab = Symbol("CdxTableRowIdentifier");
const $db68d79c4ce005fe$var$TablePaginationPositions = [
    "top",
    "bottom",
    "both"
];
const $db68d79c4ce005fe$var$iconSizeValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$IconSizes);
const $db68d79c4ce005fe$var$_sfc_main$y = (0, $TusQn.defineComponent)({
    name: "CdxIcon",
    props: {
        /** The SVG path or an object containing that path plus other data. */ icon: {
            type: [
                String,
                Object
            ],
            required: true
        },
        /**
     * Accessible label for the icon. If not included, the icon will be hidden from screen
     * readers via `aria-hidden="true"`. Browsers also display this label as a tooltip when the
     * user hovers over the icon. Note that this label is not rendered as visible text next
     * to the icon.
     */ iconLabel: {
            type: String,
            default: ""
        },
        /**
     * Explicitly set the language code to use for the icon. See
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/lang.
     * Defaults to the lang attribute of the nearest ancestor at mount time.
     */ lang: {
            type: String,
            default: null
        },
        /**
     * Explicitly set the direction to use for the icon. See
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dir.
     * Defaults to the computed direction at mount time.
     */ dir: {
            type: String,
            default: null
        },
        /**
     * Specify icon size by choosing one of several pre-defined size
     * options. See the type documentation for supported size options.
     * The `medium` size is used by default if no size prop is provided.
     */ size: {
            type: String,
            default: "medium",
            validator: $db68d79c4ce005fe$var$iconSizeValidator
        }
    },
    setup (props) {
        const rootElement = (0, $01W3b.ref)();
        const computedDir = $db68d79c4ce005fe$export$b64edd098c9cdbaf(rootElement);
        const computedLang = $db68d79c4ce005fe$export$fafaa3135f296aba(rootElement);
        const overriddenDir = (0, $01W3b.computed)(()=>{
            var _a;
            return (_a = props.dir) != null ? _a : computedDir.value;
        });
        const overriddenLang = (0, $01W3b.computed)(()=>{
            var _a;
            return (_a = props.lang) != null ? _a : computedLang.value;
        });
        const rootClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-icon--flipped": overriddenDir.value === "rtl" && overriddenLang.value !== null && $db68d79c4ce005fe$var$O8(props.icon, overriddenLang.value),
                ["cdx-icon--".concat(props.size)]: true
            };
        });
        const resolvedIcon = (0, $01W3b.computed)(()=>{
            var _a, _b;
            return $db68d79c4ce005fe$var$N8(props.icon, (_a = overriddenLang.value) != null ? _a : "", (_b = overriddenDir.value) != null ? _b : "ltr");
        });
        const iconSvg = (0, $01W3b.computed)(()=>typeof resolvedIcon.value === "string" ? resolvedIcon.value : "");
        const iconPath = (0, $01W3b.computed)(()=>typeof resolvedIcon.value !== "string" ? resolvedIcon.value.path : "");
        return {
            rootElement: rootElement,
            rootClasses: rootClasses,
            iconSvg: iconSvg,
            iconPath: iconPath
        };
    }
});
const $db68d79c4ce005fe$var$_export_sfc = (sfc, props)=>{
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props)target[key] = val;
    return target;
};
const $db68d79c4ce005fe$var$_hoisted_1$v = [
    "aria-hidden"
];
const $db68d79c4ce005fe$var$_hoisted_2$m = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_3$e = [
    "innerHTML"
];
const $db68d79c4ce005fe$var$_hoisted_4$9 = [
    "d"
];
function $db68d79c4ce005fe$var$_sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-icon",
            _ctx.rootClasses
        ])
    }, [
        ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            "aria-hidden": _ctx.iconLabel ? void 0 : true
        }, [
            _ctx.iconLabel ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("title", $db68d79c4ce005fe$var$_hoisted_2$m, (0, $8XWQX.toDisplayString)(_ctx.iconLabel), 1)) : (0, $TusQn.createCommentVNode)("v-if", true),
            _ctx.iconSvg ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("g", {
                key: 1,
                innerHTML: _ctx.iconSvg
            }, null, 8, $db68d79c4ce005fe$var$_hoisted_3$e)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("path", {
                key: 2,
                d: _ctx.iconPath
            }, null, 8, $db68d79c4ce005fe$var$_hoisted_4$9))
        ], 8, $db68d79c4ce005fe$var$_hoisted_1$v))
    ], 2);
}
const $db68d79c4ce005fe$export$675126b72043484a = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$y, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$y
    ]
]);
function $db68d79c4ce005fe$var$flattenSlotContents(slotContents) {
    const flattened = [];
    for (const node of slotContents){
        if (// HTML tag
        typeof node.type === "string" || // Component
        typeof node.type === "object") flattened.push(node);
        else if (node.type !== (0, $TusQn.Comment)) {
            if (typeof node.children === "string" && node.children.trim() !== "") flattened.push(node.children);
            else if (Array.isArray(node.children)) flattened.push(...$db68d79c4ce005fe$var$flattenSlotContents(node.children));
        }
    }
    return flattened;
}
function $db68d79c4ce005fe$var$isComponentVNode(node, componentName) {
    if (typeof node.type === "object" && "name" in node.type) {
        if (componentName !== void 0) return node.type.name === componentName;
        return true;
    }
    return false;
}
function $db68d79c4ce005fe$var$isTagVNode(node, tagName) {
    if (typeof node.type === "string") return node.type === tagName.toLowerCase();
    return false;
}
function $db68d79c4ce005fe$export$57535e89d59a174(slot) {
    const slotContents = typeof slot === "function" ? slot() : slot;
    return slotContents ? $db68d79c4ce005fe$var$flattenSlotContents(slotContents) : [];
}
function $db68d79c4ce005fe$export$3f97d07ad730ccf0(shouldWarn, message) {
    if (shouldWarn()) {
        (0, $TusQn.warn)(message);
        return;
    }
    const stop = (0, $TusQn.watch)(shouldWarn, (newValue)=>{
        if (newValue) {
            (0, $TusQn.warn)(message);
            stop();
        }
    });
}
function $db68d79c4ce005fe$var$useIconOnlyButton(slot, attrs, componentName) {
    const isIconOnly = (0, $01W3b.computed)(()=>{
        const slotContents = $db68d79c4ce005fe$export$57535e89d59a174(slot);
        if (slotContents.length !== 1) return false;
        const soleNode = slotContents[0];
        if (typeof soleNode === "object" && ($db68d79c4ce005fe$var$isComponentVNode(soleNode, "CdxIcon") || $db68d79c4ce005fe$var$isTagVNode(soleNode, "svg"))) return true;
        return false;
    });
    $db68d79c4ce005fe$export$3f97d07ad730ccf0(()=>isIconOnly.value && !attrs["aria-label"] && !attrs["aria-hidden"], "".concat(componentName, ": Icon-only buttons require one of the following attributes: aria-label or aria-hidden. See documentation at https://doc.wikimedia.org/codex/latest/components/demos/button.html#icon-only-button"));
    return isIconOnly;
}
const $db68d79c4ce005fe$var$buttonActionValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ButtonActions);
const $db68d79c4ce005fe$var$buttonWeightValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ButtonWeights);
const $db68d79c4ce005fe$var$buttonSizeValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ButtonSizes);
const $db68d79c4ce005fe$var$_sfc_main$x = (0, $TusQn.defineComponent)({
    name: "CdxButton",
    props: {
        /**
     * The kind of action that will be taken on click.
     *
     * @values 'default', 'progressive', 'destructive'
     */ action: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$buttonActionValidator
        },
        /**
     * Visual prominence of the button.
     *
     * @values 'normal', 'primary', 'quiet'
     */ weight: {
            type: String,
            default: "normal",
            validator: $db68d79c4ce005fe$var$buttonWeightValidator
        },
        /**
     * Button size.
     *
     * Most buttons should use the default medium size. In rare cases the large size should
     * be used, for example to make icon-only buttons larger on touchscreens.
     *
     * @values 'medium', 'large'
     */ size: {
            type: String,
            default: "medium",
            validator: $db68d79c4ce005fe$var$buttonSizeValidator
        }
    },
    emits: [
        "click"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        const button = (0, $01W3b.ref)();
        const isIconOnly = $db68d79c4ce005fe$var$useIconOnlyButton(slots.default, attrs, "CdxButton");
        const isActive = (0, $01W3b.ref)(false);
        const rootClasses = (0, $01W3b.computed)(()=>({
                ["cdx-button--action-".concat(props.action)]: true,
                ["cdx-button--weight-".concat(props.weight)]: true,
                ["cdx-button--size-".concat(props.size)]: true,
                "cdx-button--framed": props.weight !== "quiet",
                "cdx-button--icon-only": isIconOnly.value,
                "cdx-button--is-active": isActive.value
            }));
        const onClick = (event)=>{
            emit("click", event);
        };
        const setActive = (active)=>{
            isActive.value = active;
        };
        function onKeyDown() {
            setActive(true);
        }
        function onKeyUp() {
            var _a;
            setActive(false);
            (_a = button.value) == null || _a.click();
        }
        return {
            button: button,
            rootClasses: rootClasses,
            onClick: onClick,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        };
    }
});
function $db68d79c4ce005fe$var$_sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        ref: "button",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-button",
            _ctx.rootClasses
        ]),
        onKeydown: _cache[0] || (_cache[0] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onKeyDown && _ctx.onKeyDown(...args), [
            "prevent"
        ]), [
            "space",
            "enter"
        ])),
        onKeyup: _cache[1] || (_cache[1] = (0, $eeJ70.withKeys)((...args)=>_ctx.onKeyUp && _ctx.onKeyUp(...args), [
            "space",
            "enter"
        ])),
        onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.onClick && _ctx.onClick(...args))
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ], 34);
}
const $db68d79c4ce005fe$export$3318068e43c65fe8 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$x, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$x
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$w = (0, $TusQn.defineComponent)({
    name: "CdxAccordion",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Forces the accordion to show the action icon.
     *
     * @values 'true', 'false'
     */ actionAlwaysVisible: {
            type: Boolean,
            default: false
        },
        /**
     * The icon that will be displayed on the right side of the accordion header when expanded.
     *
     */ actionIcon: {
            type: [
                String,
                Object
            ],
            default: null
        },
        /**
     * Label for the action button. If an action icon is being used, then a label for that icon
     * should be provided for ARIA support.
     */ actionButtonLabel: {
            type: String,
            default: ""
        },
        /**
     * The heading level of the accordion title.
     *
     * @values 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
     */ headingLevel: {
            type: String,
            default: "h3"
        }
    },
    emits: [
        /**
     * When the action button is clicked.
     *
     */ "action-button-click"
    ],
    setup (props, { attrs: attrs, emit: emit }) {
        const isExpanded = (0, $01W3b.ref)("open" in attrs);
        const emitActionButtonClick = ()=>{
            emit("action-button-click");
        };
        const onToggle = (e)=>{
            isExpanded.value = e.newState === "open";
        };
        const shouldShowActionButton = (0, $01W3b.computed)(()=>{
            return props.actionIcon && (isExpanded.value || props.actionAlwaysVisible);
        });
        const rootClasses = (0, $01W3b.computed)(()=>({
                "cdx-accordion--has-icon": shouldShowActionButton.value
            }));
        return {
            emitActionButtonClick: emitActionButtonClick,
            rootClasses: rootClasses,
            shouldShowActionButton: shouldShowActionButton,
            onToggle: onToggle
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$u = {
    class: "cdx-accordion__header__title"
};
const $db68d79c4ce005fe$var$_hoisted_2$l = {
    class: "cdx-accordion__header__description"
};
function $db68d79c4ce005fe$var$_sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("details", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-accordion",
            _ctx.rootClasses
        ]),
        onToggle: _cache[1] || (_cache[1] = (...args)=>_ctx.onToggle && _ctx.onToggle(...args))
    }, [
        (0, $TusQn.createElementVNode)("summary", null, [
            ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.headingLevel), {
                class: "cdx-accordion__header"
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_1$u, [
                            (0, $TusQn.renderSlot)(_ctx.$slots, "title")
                        ]),
                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$l, [
                            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                        ])
                    ]),
                _: 3
            })),
            _ctx.shouldShowActionButton ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                key: 0,
                class: "cdx-accordion__action",
                "aria-label": _ctx.actionButtonLabel,
                type: "button",
                weight: "quiet",
                onClick: (0, $eeJ70.withModifiers)(_ctx.emitActionButtonClick, [
                    "stop"
                ])
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.actionIcon,
                            "icon-label": _ctx.actionButtonLabel,
                            size: "medium"
                        }, null, 8, [
                            "icon",
                            "icon-label"
                        ])
                    ]),
                _: 1
            }, 8, [
                "aria-label",
                "onClick"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
        ]),
        (0, $TusQn.createElementVNode)("div", {
            class: "cdx-accordion__content",
            onClick: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(()=>{}, [
                "stop"
            ]))
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ])
    ], 34);
}
const $db68d79c4ce005fe$export$62c6a40b05a2ad3 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$w, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$w
    ]
]);
function $db68d79c4ce005fe$var$getButtonLabel(button) {
    if (button.label === void 0) return button.value;
    if (button.label === null) return "";
    return button.label;
}
function $db68d79c4ce005fe$var$useButtonGroupKeyboardNav(buttonsProp) {
    const rootElement = (0, $01W3b.ref)();
    const focusedButtonIndex = (0, $01W3b.ref)();
    const buttonRefs = (0, $01W3b.ref)(/* @__PURE__ */ new Map());
    const currentDirection = $db68d79c4ce005fe$export$b64edd098c9cdbaf(rootElement);
    function assignTemplateRef(templateRef, index) {
        const button = templateRef;
        if (button) buttonRefs.value.set(index, button);
    }
    function onFocus(index) {
        focusedButtonIndex.value = index;
    }
    function onBlur() {
        focusedButtonIndex.value = void 0;
    }
    function focusNonDisabled(index, increment) {
        var _a;
        const newIndex = index + increment;
        const targetButton = buttonsProp.value[newIndex];
        if (targetButton) {
            if (targetButton.disabled) focusNonDisabled(newIndex, increment);
            else {
                const buttonElement = (_a = buttonRefs.value.get(newIndex)) == null ? void 0 : _a.$el;
                buttonElement == null || buttonElement.focus();
            }
        }
    }
    function next() {
        var _a;
        focusNonDisabled((_a = focusedButtonIndex.value) != null ? _a : -1, 1);
    }
    function prev() {
        var _a;
        focusNonDisabled((_a = focusedButtonIndex.value) != null ? _a : buttonsProp.value.length, -1);
    }
    function moveRight() {
        if (currentDirection.value === "rtl") prev();
        else next();
    }
    function moveLeft() {
        if (currentDirection.value === "rtl") next();
        else prev();
    }
    function onKeydown(e) {
        switch(e.key){
            case "ArrowRight":
                e.preventDefault();
                moveRight();
                break;
            case "ArrowLeft":
                e.preventDefault();
                moveLeft();
                break;
            case "ArrowDown":
                e.preventDefault();
                next();
                break;
            case "ArrowUp":
                e.preventDefault();
                prev();
                break;
        }
    }
    return {
        rootElement: rootElement,
        assignTemplateRef: assignTemplateRef,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeydown: onKeydown
    };
}
const $db68d79c4ce005fe$var$_sfc_main$v = (0, $TusQn.defineComponent)({
    name: "CdxButtonGroup",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Objects describing the buttons in the group. See the ButtonGroupItem type.
     */ buttons: {
            type: Array,
            required: true,
            validator: (value)=>Array.isArray(value) && value.length >= 1
        },
        /**
     * Whether the entire group is disabled.
     *
     * If this is set to true, all buttons in the group are disabled. Buttons can also be
     * disabled individually by setting their `disabled` property to true.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when a button is clicked
     *
     * @property {string | number} value The `value` property of the button that was clicked
     */ "click"
    ],
    setup (props) {
        const { rootElement: rootElement, assignTemplateRef: assignTemplateRef, onFocus: onFocus, onBlur: onBlur, onKeydown: onKeydown } = $db68d79c4ce005fe$var$useButtonGroupKeyboardNav((0, $01W3b.toRef)(props, "buttons"));
        return {
            rootElement: rootElement,
            assignTemplateRef: assignTemplateRef,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeydown: onKeydown,
            getButtonLabel: $db68d79c4ce005fe$var$getButtonLabel
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$t = {
    ref: "rootElement",
    class: "cdx-button-group"
};
function $db68d79c4ce005fe$var$_sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$t, [
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.buttons, (button, index)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                key: button.value,
                ref_for: true,
                ref: (ref2)=>_ctx.assignTemplateRef(ref2, index),
                disabled: button.disabled || _ctx.disabled,
                "aria-label": button.ariaLabel,
                onClick: ($event)=>_ctx.$emit("click", button.value),
                onFocus: ($event)=>_ctx.onFocus(index),
                onBlur: _ctx.onBlur,
                onKeydown: _ctx.onKeydown
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default", {
                            button: button
                        }, ()=>[
                                button.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                                    key: 0,
                                    icon: button.icon
                                }, null, 8, [
                                    "icon"
                                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                (0, $TusQn.createTextVNode)(" " + (0, $8XWQX.toDisplayString)(_ctx.getButtonLabel(button)), 1)
                            ])
                    ]),
                _: 2
            }, 1032, [
                "disabled",
                "aria-label",
                "onClick",
                "onFocus",
                "onBlur",
                "onKeydown"
            ]);
        }), 128))
    ], 512);
}
const $db68d79c4ce005fe$export$745f4a73ccbccffb = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$v, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$v
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$u = (0, $TusQn.defineComponent)({
    name: "CdxThumbnail",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Thumbnail data.
     */ thumbnail: {
            type: [
                Object,
                null
            ],
            default: null
        },
        /**
     * Thumbnail placeholder icon.
     */ placeholderIcon: {
            type: [
                String,
                Object
            ],
            default: $db68d79c4ce005fe$var$P4
        }
    },
    setup: (props)=>{
        const thumbnailLoaded = (0, $01W3b.ref)(false);
        const thumbnailStyle = (0, $01W3b.ref)({});
        const preloadThumbnail = (url)=>{
            const escapedUrl = url.replace(/([\\"\n])/g, "\\$1");
            const image = new Image();
            image.onload = ()=>{
                thumbnailStyle.value = {
                    backgroundImage: 'url("'.concat(escapedUrl, '")')
                };
                thumbnailLoaded.value = true;
            };
            image.onerror = ()=>{
                thumbnailLoaded.value = false;
            };
            image.src = escapedUrl;
        };
        (0, $TusQn.onMounted)(()=>{
            var _a;
            if ((_a = props.thumbnail) == null ? void 0 : _a.url) preloadThumbnail(props.thumbnail.url);
        });
        return {
            thumbnailStyle: thumbnailStyle,
            thumbnailLoaded: thumbnailLoaded,
            NoInvertClass: $db68d79c4ce005fe$var$NoInvertClass
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$s = {
    class: "cdx-thumbnail"
};
const $db68d79c4ce005fe$var$_hoisted_2$k = {
    key: 0,
    class: "cdx-thumbnail__placeholder"
};
function $db68d79c4ce005fe$var$_sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_1$s, [
        !_ctx.thumbnailLoaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_2$k, [
            (0, $TusQn.createVNode)(_component_cdx_icon, {
                icon: _ctx.placeholderIcon,
                class: "cdx-thumbnail__placeholder__icon--vue"
            }, null, 8, [
                "icon"
            ])
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
            name: "cdx-thumbnail__image"
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    _ctx.thumbnailLoaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                        key: 0,
                        style: (0, $8XWQX.normalizeStyle)(_ctx.thumbnailStyle),
                        class: (0, $8XWQX.normalizeClass)([
                            _ctx.NoInvertClass,
                            "cdx-thumbnail__image"
                        ])
                    }, null, 6)) : (0, $TusQn.createCommentVNode)("v-if", true)
                ]),
            _: 1
        })
    ]);
}
const $db68d79c4ce005fe$export$9fe12e22779707e = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$u, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$u
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$t = (0, $TusQn.defineComponent)({
    name: "CdxCard",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxThumbnail: $db68d79c4ce005fe$export$9fe12e22779707e
    },
    props: {
        /**
     * If provided, the Card will be a link to this URL.
     */ url: {
            type: String,
            default: ""
        },
        /**
     * Icon displayed at the start of the Card.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: ""
        },
        /**
     * Thumbnail image data for the Card.
     */ thumbnail: {
            type: [
                Object,
                null
            ],
            default: null
        },
        /**
     * Option to force a thumbnail layout.
     *
     * When set to `true`, the Card will display a Thumbnail. If a `thumbnail` prop was also
     * provided, the thumbnail image will display. Otherwise, a placeholder icon will display.
     *
     * This is useful when displaying groups of Cards when some of the cards have thumbnail
     * images but some do not. `forceThumbnail` will provide a consistent layout for that group.
     *
     * Note that this prop is not needed to display a thumbnail image: if the `thumbnail` prop
     * is provided, it will display. This prop is only needed to enable the display of the
     * thumbnail placeholder icon when the `thumbnail` prop is not provided.
     */ forceThumbnail: {
            type: Boolean,
            default: false
        },
        /**
     * Optional custom icon for the placeholder shown when `forceThumbnail` is true but no
     * thumbnail is provided.
     *
     * Defaults to the default placeholder icon set in the Thumbnail component.
     */ customPlaceholderIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        }
    },
    setup (props) {
        const isLink = (0, $01W3b.computed)(()=>!!props.url);
        const contentTag = (0, $01W3b.computed)(()=>isLink.value ? "a" : "span");
        const cardLink = (0, $01W3b.computed)(()=>isLink.value ? props.url : void 0);
        return {
            isLink: isLink,
            contentTag: contentTag,
            cardLink: cardLink
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$r = {
    class: "cdx-card__text"
};
const $db68d79c4ce005fe$var$_hoisted_2$j = {
    class: "cdx-card__text__title"
};
const $db68d79c4ce005fe$var$_hoisted_3$d = {
    key: 0,
    class: "cdx-card__text__description"
};
const $db68d79c4ce005fe$var$_hoisted_4$8 = {
    key: 1,
    class: "cdx-card__text__supporting-text"
};
function $db68d79c4ce005fe$var$_sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_thumbnail = (0, $TusQn.resolveComponent)("cdx-thumbnail");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.contentTag), {
        href: _ctx.cardLink,
        class: (0, $8XWQX.normalizeClass)([
            "cdx-card",
            {
                "cdx-card--is-link": _ctx.isLink,
                // Include dynamic classes in the template so that $slots is reactive.
                "cdx-card--title-only": !_ctx.$slots.description && !_ctx.$slots["supporting-text"]
            }
        ])
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                _ctx.thumbnail || _ctx.forceThumbnail ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_thumbnail, {
                    key: 0,
                    thumbnail: _ctx.thumbnail,
                    "placeholder-icon": _ctx.customPlaceholderIcon,
                    class: "cdx-card__thumbnail"
                }, null, 8, [
                    "thumbnail",
                    "placeholder-icon"
                ])) : _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                    key: 1,
                    icon: _ctx.icon,
                    class: "cdx-card__icon"
                }, null, 8, [
                    "icon"
                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_1$r, [
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$j, [
                        (0, $TusQn.renderSlot)(_ctx.$slots, "title")
                    ]),
                    _ctx.$slots.description ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_3$d, [
                        (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                    ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                    _ctx.$slots["supporting-text"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_4$8, [
                        (0, $TusQn.renderSlot)(_ctx.$slots, "supporting-text")
                    ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                ])
            ]),
        _: 3
    }, 8, [
        "href",
        "class"
    ]);
}
const $db68d79c4ce005fe$export$41b8f1d4b20997da = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$t, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$t
    ]
]);
function $db68d79c4ce005fe$export$231a0ffa6150ca75(disabledProp) {
    const providedDisabled = (0, $TusQn.inject)($db68d79c4ce005fe$var$DisabledKey, (0, $01W3b.ref)(false));
    return (0, $01W3b.computed)(()=>providedDisabled.value || disabledProp.value);
}
function $db68d79c4ce005fe$export$2a5cf560aeeed52d(disabledProp, statusProp, idAttr) {
    const computedDisabled = $db68d79c4ce005fe$export$231a0ffa6150ca75(disabledProp);
    const providedStatus = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldStatusKey, (0, $01W3b.ref)("default"));
    const computedStatus = (0, $01W3b.computed)(()=>{
        if ((statusProp == null ? void 0 : statusProp.value) && statusProp.value !== "default") return statusProp.value;
        return providedStatus.value;
    });
    const providedId = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldInputIdKey, void 0);
    const computedInputId = (0, $01W3b.computed)(()=>{
        var _a;
        return (_a = providedId == null ? void 0 : providedId.value) != null ? _a : idAttr;
    });
    return {
        computedDisabled: computedDisabled,
        computedStatus: computedStatus,
        computedInputId: computedInputId
    };
}
function $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses = (0, $01W3b.computed)(()=>({}))) {
    const rootClasses = (0, $01W3b.computed)(()=>{
        const classRecord = $db68d79c4ce005fe$var$__objRest(internalClasses.value, []);
        if (attrs.class) {
            const providedClasses = attrs.class.split(" ");
            providedClasses.forEach((className)=>{
                classRecord[className] = true;
            });
        }
        return classRecord;
    });
    const rootStyle = (0, $01W3b.computed)(()=>{
        if ("style" in attrs) return attrs.style;
        return void 0;
    });
    const otherAttrs = (0, $01W3b.computed)(()=>{
        const _a = attrs, { class: _ignoredClass, style: _ignoredStyle } = _a, attrsCopy = $db68d79c4ce005fe$var$__objRest(_a, [
            "class",
            "style"
        ]);
        return attrsCopy;
    });
    return {
        rootClasses: rootClasses,
        rootStyle: rootStyle,
        otherAttrs: otherAttrs
    };
}
function $db68d79c4ce005fe$export$3f3caade1c12f8c9(messageKey, defaultValue, params = []) {
    const providedI18nFunc = (0, $TusQn.inject)("CdxI18nFunction", void 0);
    return (0, $01W3b.computed)(()=>{
        const unwrappedParams = params.map((p2)=>typeof p2 === "function" ? p2() : p2.value);
        const fromProvidedFunc = providedI18nFunc == null ? void 0 : providedI18nFunc(messageKey, ...unwrappedParams);
        if (fromProvidedFunc !== void 0 && fromProvidedFunc !== null) return fromProvidedFunc;
        return typeof defaultValue === "function" ? defaultValue(...unwrappedParams) : defaultValue;
    });
}
function $db68d79c4ce005fe$var$useI18nWithOverride(override, messageKey, defaultValue, params = []) {
    const translatedMessage = $db68d79c4ce005fe$export$3f3caade1c12f8c9(messageKey, defaultValue, params);
    return (0, $01W3b.computed)(()=>override.value || translatedMessage.value);
}
const $db68d79c4ce005fe$var$_sfc_main$s = (0, $TusQn.defineComponent)({
    name: "CdxLabel",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    /**
   * We want the label or legend to inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Icon before the label text.
     *
     * Do not use this if including a start icon within the input component.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: null
        },
        /**
     * Whether the field is optional.
     *
     * This will add a flag next to the label indicating that the field is optional.
     */ optional: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to '(optional)' (T368444).
        /**
     * Text to indicate that the field is optional.
     *
     * Omit this prop to use the default value, "(optional)".
     */ optionalFlag: {
            type: String,
            default: ""
        },
        /**
     * Whether the label should be visually hidden.
     */ visuallyHidden: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this component should output a `<legend>` element.
     *
     * Always set this to true when this component is used inside a `<fieldset>` element. Do not
     * set it to true otherwise.
     */ isLegend: {
            type: Boolean,
            default: false
        },
        /**
     * The ID of the input/control this label is for.
     *
     * Will be added as the `for` attribute of the `<label>`. Not needed for `<legend>`.
     */ inputId: {
            type: String,
            default: ""
        },
        /**
     * The ID of the description element.
     *
     * This ID can be used for the `aria-describedby` attribute of the input.
     */ descriptionId: {
            type: String,
            default: ""
        },
        /**
     * Whether this label is for a disabled field or input.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    setup (props, { attrs: attrs }) {
        const { computedDisabled: computedDisabled } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"));
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-label--visually-hidden": props.visuallyHidden,
                "cdx-label--disabled": computedDisabled.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const translatedOptionalFlag = $db68d79c4ce005fe$var$useI18nWithOverride((0, $01W3b.toRef)(props, "optionalFlag"), "cdx-label-optional-flag", "(optional)");
        return {
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            translatedOptionalFlag: translatedOptionalFlag
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$q = [
    "for"
];
const $db68d79c4ce005fe$var$_hoisted_2$i = {
    class: "cdx-label__label__text"
};
const $db68d79c4ce005fe$var$_hoisted_3$c = {
    key: 1,
    class: "cdx-label__label__optional-flag"
};
const $db68d79c4ce005fe$var$_hoisted_4$7 = [
    "id"
];
const $db68d79c4ce005fe$var$_hoisted_5$7 = {
    class: "cdx-label__label"
};
const $db68d79c4ce005fe$var$_hoisted_6$6 = {
    class: "cdx-label__label__text"
};
const $db68d79c4ce005fe$var$_hoisted_7$2 = {
    key: 1,
    class: "cdx-label__label__optional-flag"
};
const $db68d79c4ce005fe$var$_hoisted_8$1 = {
    key: 0,
    class: "cdx-label__description"
};
function $db68d79c4ce005fe$var$_sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return !_ctx.isLegend ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        key: 0,
        class: (0, $8XWQX.normalizeClass)([
            "cdx-label",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("label", (0, $TusQn.mergeProps)({
            class: "cdx-label__label",
            for: _ctx.inputId ? _ctx.inputId : void 0
        }, _ctx.otherAttrs), [
            _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                key: 0,
                icon: _ctx.icon,
                class: "cdx-label__label__icon"
            }, null, 8, [
                "icon"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$i, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "default")
            ]),
            _ctx.optionalFlag || _ctx.optional ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_3$c, (0, $8XWQX.toDisplayString)(" ") + " " + (0, $8XWQX.toDisplayString)(_ctx.translatedOptionalFlag), 1)) : (0, $TusQn.createCommentVNode)("v-if", true)
        ], 16, $db68d79c4ce005fe$var$_hoisted_1$q),
        _ctx.$slots.description && _ctx.$slots.description().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
            key: 0,
            id: _ctx.descriptionId || void 0,
            class: "cdx-label__description"
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
        ], 8, $db68d79c4ce005fe$var$_hoisted_4$7)) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("legend", (0, $TusQn.mergeProps)({
        key: 1,
        class: [
            "cdx-label",
            _ctx.rootClasses
        ],
        style: _ctx.rootStyle
    }, _ctx.otherAttrs), [
        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_5$7, [
            _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                key: 0,
                icon: _ctx.icon,
                class: "cdx-label__label__icon"
            }, null, 8, [
                "icon"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_6$6, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "default")
            ]),
            _ctx.optionalFlag || _ctx.optional ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_7$2, (0, $8XWQX.toDisplayString)(" ") + " " + (0, $8XWQX.toDisplayString)(_ctx.translatedOptionalFlag), 1)) : (0, $TusQn.createCommentVNode)("v-if", true)
        ]),
        _ctx.$slots.description && _ctx.$slots.description().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_8$1, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 16));
}
const $db68d79c4ce005fe$export$fd351ab562a06a13 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$s, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$s
    ]
]);
function $db68d79c4ce005fe$var$useLabelChecker(slot, attrs, componentName) {
    $db68d79c4ce005fe$export$3f97d07ad730ccf0(()=>$db68d79c4ce005fe$export$57535e89d59a174(slot).length === 0 && !(attrs == null ? void 0 : attrs["aria-label"]) && !(attrs == null ? void 0 : attrs["aria-labelledby"]), "".concat(componentName, ": Inputs must have an associated label. Provide one of the following:\n - A label via the appropriate slot\n - An `aria-label` attribute set to the label text\n - An `aria-labelledby` attribute set to the ID of the label element"));
}
function $db68d79c4ce005fe$export$c9be858be225e6de(modelValueRef, emit, eventName) {
    return (0, $01W3b.computed)({
        get: ()=>modelValueRef.value,
        set: (value)=>// If eventName is undefined, then 'update:modelValue' must be a valid EventName,
            // but TypeScript's type analysis isn't clever enough to realize that
            emit(eventName || "update:modelValue", value)
    });
}
let $db68d79c4ce005fe$var$counter = 0;
function $db68d79c4ce005fe$export$6217842283d27b52(identifier) {
    var _a;
    const vm = (0, $TusQn.getCurrentInstance)();
    const externalId = (_a = vm == null ? void 0 : vm.props.id) != null ? _a : vm == null ? void 0 : vm.attrs.id;
    if (identifier) return "".concat($db68d79c4ce005fe$var$LibraryPrefix, "-").concat(identifier, "-").concat($db68d79c4ce005fe$var$counter++);
    else if (externalId) return "".concat($db68d79c4ce005fe$var$LibraryPrefix, "-").concat(externalId, "-").concat($db68d79c4ce005fe$var$counter++);
    else return "".concat($db68d79c4ce005fe$var$LibraryPrefix, "-").concat($db68d79c4ce005fe$var$counter++);
}
const $db68d79c4ce005fe$var$statusValidator$a = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$r = (0, $TusQn.defineComponent)({
    name: "CdxCheckbox",
    components: {
        CdxLabel: $db68d79c4ce005fe$export$fd351ab562a06a13
    },
    props: {
        /**
     * Value of the checkbox or checkbox group.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                Boolean,
                Array
            ],
            default: false
        },
        /**
     * HTML "value" attribute to assign to the input.
     *
     * Required for input groups.
     */ inputValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: false
        },
        /**
     * HTML "name" attribute to assign to the input.
     */ name: {
            type: String,
            default: null
        },
        /**
     * Whether the disabled attribute should be added to the input.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the indeterminate visual state should be displayed.
     *
     * This is unrelated to the value provided by `v-model`, and the indeterminate visual state
     * will override the checked or unchecked visual state.
     */ indeterminate: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the component should display inline.
     *
     * By default, `display: block` is set and a margin exists between
     * sibling components, for a stacked layout.
     */ inline: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the label should be visually hidden.
     *
     * When true, the label will remain accessible to assistive technology.
     */ hideLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Validation status of the Checkbox.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$a
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes.
     *
     * @property {boolean | string[] | number[]} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        var _a;
        $db68d79c4ce005fe$var$useLabelChecker((_a = slots.default) == null ? void 0 : _a.call(slots), attrs, "CdxCheckbox");
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const rootClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-checkbox--inline": props.inline,
                ["cdx-checkbox--status-".concat(computedStatus.value)]: true
            };
        });
        const customInputClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-checkbox__custom-input--inline": props.inline
            };
        });
        const input = (0, $01W3b.ref)();
        const checkboxId = $db68d79c4ce005fe$export$6217842283d27b52("checkbox");
        const descriptionId = $db68d79c4ce005fe$export$6217842283d27b52("description");
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        return {
            rootClasses: rootClasses,
            computedDisabled: computedDisabled,
            input: input,
            checkboxId: checkboxId,
            descriptionId: descriptionId,
            wrappedModel: wrappedModel,
            customInputClasses: customInputClasses
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$p = {
    class: "cdx-checkbox__wrapper"
};
const $db68d79c4ce005fe$var$_hoisted_2$h = [
    "id",
    "aria-describedby",
    "value",
    "name",
    "disabled",
    ".indeterminate"
];
const $db68d79c4ce005fe$var$_hoisted_3$b = /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
    class: "cdx-checkbox__icon"
}, null, -1);
function $db68d79c4ce005fe$var$_sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_label = (0, $TusQn.resolveComponent)("cdx-label");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-checkbox",
            _ctx.rootClasses
        ])
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$p, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                id: _ctx.checkboxId,
                ref: "input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
                class: "cdx-checkbox__input",
                type: "checkbox",
                "aria-describedby": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
                value: _ctx.inputValue,
                name: _ctx.name,
                disabled: _ctx.computedDisabled,
                ".indeterminate": _ctx.indeterminate
            }, null, 40, $db68d79c4ce005fe$var$_hoisted_2$h), [
                [
                    (0, $eeJ70.vModelCheckbox),
                    _ctx.wrappedModel
                ]
            ]),
            $db68d79c4ce005fe$var$_hoisted_3$b,
            _ctx.$slots.default && _ctx.$slots.default().length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_label, {
                key: 0,
                class: "cdx-checkbox__label",
                "input-id": _ctx.checkboxId,
                "description-id": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
                disabled: _ctx.computedDisabled,
                "visually-hidden": _ctx.hideLabel
            }, (0, $TusQn.createSlots)({
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                    ]),
                _: 2
            }, [
                _ctx.$slots.description && _ctx.$slots.description().length > 0 ? {
                    name: "description",
                    fn: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                        ]),
                    key: "0"
                } : void 0
            ]), 1032, [
                "input-id",
                "description-id",
                "disabled",
                "visually-hidden"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
        ]),
        _ctx.$slots["custom-input"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            class: (0, $8XWQX.normalizeClass)([
                "cdx-checkbox__custom-input",
                _ctx.customInputClasses
            ])
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "custom-input")
        ], 2)) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 2);
}
const $db68d79c4ce005fe$export$10933eadb08a15a2 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$r, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$r
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$q = (0, $TusQn.defineComponent)({
    name: "CdxInputChip",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Custom icon.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: null
        },
        /**
     * Whether the input chip can be removed.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    expose: [
        "focus"
    ],
    emits: [
        /**
     * Emitted when a chip is removed by the user.
     *
     * @property {'button'|'Backspace'|'Delete'} method How the chip was removed
     */ "remove-chip",
        /**
     * Emitted when a chip is clicked by the user.
     */ "click-chip",
        /**
     * Emitted when the user presses the left arrow key.
     */ "arrow-left",
        /**
     * Emitted when the user presses the right arrow key.
     */ "arrow-right"
    ],
    setup (props, { emit: emit }) {
        const rootElement = (0, $01W3b.ref)();
        const rootClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-input-chip--disabled": props.disabled
            };
        });
        const ariaDescription = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-input-chip-aria-description", "Press Enter to edit or Delete to remove");
        function onKeydown(e) {
            var _a;
            switch(e.key){
                case "Enter":
                    emit("click-chip");
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case "Escape":
                    (_a = rootElement.value) == null || _a.blur();
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case "Backspace":
                case "Delete":
                    emit("remove-chip", e.key);
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case "ArrowLeft":
                    emit("arrow-left");
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case "ArrowRight":
                    emit("arrow-right");
                    e.preventDefault();
                    e.stopPropagation();
                    break;
            }
        }
        return {
            rootElement: rootElement,
            rootClasses: rootClasses,
            ariaDescription: ariaDescription,
            onKeydown: onKeydown,
            cdxIconClose: $db68d79c4ce005fe$var$X3
        };
    },
    methods: {
        /**
     * Focus the chip.
     *
     * @public
     */ focus () {
            this.$refs.rootElement.focus();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$o = [
    "aria-description"
];
const $db68d79c4ce005fe$var$_hoisted_2$g = {
    class: "cdx-input-chip__text"
};
function $db68d79c4ce005fe$var$_sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-input-chip",
            _ctx.rootClasses
        ]),
        tabindex: "0",
        role: "option",
        "aria-description": _ctx.ariaDescription,
        onKeydown: _cache[1] || (_cache[1] = (...args)=>_ctx.onKeydown && _ctx.onKeydown(...args)),
        onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("click-chip"))
    }, [
        _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 0,
            icon: _ctx.icon,
            size: "small"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$g, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, $TusQn.createVNode)(_component_cdx_button, {
            class: "cdx-input-chip__button",
            weight: "quiet",
            tabindex: "-1",
            "aria-hidden": "true",
            disabled: _ctx.disabled,
            onClick: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit("remove-chip", "button"), [
                "stop"
            ]))
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)(_component_cdx_icon, {
                        icon: _ctx.cdxIconClose,
                        size: "x-small"
                    }, null, 8, [
                        "icon"
                    ])
                ]),
            _: 1
        }, 8, [
            "disabled"
        ])
    ], 42, $db68d79c4ce005fe$var$_hoisted_1$o);
}
const $db68d79c4ce005fe$var$CdxInputChip = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$q, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$q
    ]
]);
function $db68d79c4ce005fe$var$useOptionalModelWrapper(internalValueRef, modelValueRef, emit, eventName) {
    return (0, $01W3b.computed)({
        get: ()=>{
            var _a;
            return (_a = modelValueRef.value) != null ? _a : internalValueRef.value;
        },
        set: (value)=>{
            if (modelValueRef.value !== null) emit(eventName || "update:modelValue", value);
            else internalValueRef.value = value;
        }
    });
}
const $db68d79c4ce005fe$var$statusValidator$9 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$p = (0, $TusQn.defineComponent)({
    name: "CdxChipInput",
    components: {
        CdxInputChip: $db68d79c4ce005fe$var$CdxInputChip
    },
    /**
   * We want the input to inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Current chips present in the input.
     *
     * Provided by `v-model` binding in the parent component.
     */ inputChips: {
            type: Array,
            required: true
        },
        /**
     * Current value of the text input. This prop is optional and should only be used if you
     * need to keep track of the text input value for some reason (e.g. for validation).
     *
     * Optionally provided by `v-model:input-value` binding in the parent component.
     */ inputValue: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /**
     * Whether the text input should appear below the set of input chips.
     *
     * By default, the input chips are inline with the input.
     */ separateInput: {
            type: Boolean,
            default: false
        },
        /**
     * `status` attribute of the input.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$9
        },
        /**
     * Validation function for chip text. If it returns false, the chip will not be added and
     * the error status will be set.
     */ chipValidator: {
            type: Function,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            default: (value)=>true
        },
        /**
     * Whether the input is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the input chips change.
     *
     * @property {ChipInputItem[]} inputChips The new set of inputChips
     */ "update:input-chips",
        /**
     * When the input value changes. Only emitted if the inputValue prop is provided.
     *
     * @property {string | number} inputValue The new input value
     */ "update:input-value"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const rootElement = (0, $01W3b.ref)();
        const chipsContainer = (0, $01W3b.ref)();
        const separateInputWrapper = (0, $01W3b.ref)();
        const statusMessageContent = (0, $01W3b.ref)("");
        const computedDirection = $db68d79c4ce005fe$export$b64edd098c9cdbaf(rootElement);
        const input = (0, $01W3b.ref)();
        const allowArbitrary = (0, $TusQn.inject)($db68d79c4ce005fe$var$AllowArbitraryKey, (0, $01W3b.ref)(true));
        const internalInputValue = (0, $01W3b.ref)("");
        const computedInputValue = $db68d79c4ce005fe$var$useOptionalModelWrapper(internalInputValue, (0, $01W3b.toRef)(props, "inputValue"), emit, "update:input-value");
        const validatedStatus = (0, $01W3b.ref)("default");
        const internalStatus = (0, $01W3b.computed)(()=>{
            if (validatedStatus.value === "error" || props.status === "error") return "error";
            return "default";
        });
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), internalStatus);
        const isFocused = (0, $01W3b.ref)(false);
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-chip-input--has-separate-input": props.separateInput,
                ["cdx-chip-input--status-".concat(computedStatus.value)]: true,
                // We need focused and disabled classes on the root element, which contains the
                // chips and the input, since it is styled to look like the input.
                "cdx-chip-input--focused": isFocused.value,
                "cdx-chip-input--disabled": computedDisabled.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const chipRefs = [];
        const currentChipToRemove = (0, $01W3b.ref)(null);
        const computedChipToRemove = (0, $01W3b.computed)(()=>currentChipToRemove.value ? currentChipToRemove.value.value : "");
        const chipAddedMessage = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-chip-input-chip-added", (x)=>"Chip ".concat(x, " was added."), [
            computedInputValue
        ]);
        const chipRemovedMessage = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-chip-input-chip-removed", (x)=>"Chip ".concat(x, " was removed."), [
            computedChipToRemove
        ]);
        function assignChipTemplateRef(chip, index) {
            if (chip !== null) chipRefs[index] = chip;
        }
        const focusInput = ()=>{
            input.value.focus();
        };
        function addChip() {
            if (// If the input value is the same as a chip's value, or...
            !!props.inputChips.find((chip)=>chip.value === computedInputValue.value) || // ...validation fails, set status to error.
            !props.chipValidator(computedInputValue.value)) validatedStatus.value = "error";
            else if (computedInputValue.value.toString().length > 0) {
                statusMessageContent.value = chipAddedMessage.value;
                emit("update:input-chips", props.inputChips.concat({
                    value: computedInputValue.value
                }));
                computedInputValue.value = "";
            }
        }
        function removeChip(chipToRemove) {
            emit("update:input-chips", props.inputChips.filter((chip)=>chip.value !== chipToRemove.value));
        }
        function moveChipFocus(direction, startIndex) {
            const resolvedDirection = // -1 for prev (left in LTR, right in RTL), +1 for next (right in LTR, left in RTL)
            computedDirection.value === "ltr" && direction === "left" || computedDirection.value === "rtl" && direction === "right" ? -1 : 1;
            const newIndex = startIndex + resolvedDirection;
            if (newIndex < 0) return;
            if (newIndex >= props.inputChips.length) {
                focusInput();
                return;
            }
            chipRefs[newIndex].focus();
        }
        function handleChipClick(clickedChip) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                var _a;
                addChip();
                yield (0, $TusQn.nextTick)();
                removeChip(clickedChip);
                computedInputValue.value = (_a = clickedChip.label) != null ? _a : clickedChip.value;
                focusInput();
            });
        }
        function handleChipRemove(chipToRemove, index, method) {
            currentChipToRemove.value = chipToRemove;
            statusMessageContent.value = chipRemovedMessage.value;
            if (method === "button") focusInput();
            else if (method === "Backspace") {
                const newIndex = index === 0 ? 1 : index - 1;
                if (newIndex < props.inputChips.length) chipRefs[newIndex].focus();
                else focusInput();
            } else if (method === "Delete") {
                const newIndex = index + 1;
                if (newIndex < props.inputChips.length) chipRefs[newIndex].focus();
                else focusInput();
            }
            removeChip(chipToRemove);
        }
        function onInputKeydown(e) {
            var _a, _b;
            const prevArrow = computedDirection.value === "rtl" ? "ArrowRight" : "ArrowLeft";
            switch(e.key){
                case "Enter":
                    if (computedInputValue.value.toString().length > 0 && allowArbitrary.value) {
                        addChip();
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                    }
                    break;
                case "Escape":
                    (_a = input.value) == null || _a.blur();
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                case "Backspace":
                case prevArrow:
                    if (((_b = input.value) == null ? void 0 : _b.selectionStart) === 0 && input.value.selectionEnd === 0 && props.inputChips.length > 0) {
                        chipRefs[props.inputChips.length - 1].focus();
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                    }
                    break;
            }
        }
        function onInputFocus() {
            isFocused.value = true;
        }
        function onInputBlur() {
            isFocused.value = false;
        }
        function onFocusOut(e) {
            var _a;
            if (!((_a = rootElement.value) == null ? void 0 : _a.contains(e.relatedTarget)) && allowArbitrary.value) addChip();
        }
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "inputChips"), (newVal)=>{
            const matchingChip = newVal.find((chip)=>chip.value === computedInputValue.value);
            validatedStatus.value = matchingChip ? "error" : "default";
        });
        (0, $TusQn.watch)(computedInputValue, ()=>{
            if (validatedStatus.value === "error") validatedStatus.value = "default";
        });
        return {
            rootElement: rootElement,
            chipsContainer: chipsContainer,
            separateInputWrapper: separateInputWrapper,
            input: input,
            computedInputValue: computedInputValue,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            assignChipTemplateRef: assignChipTemplateRef,
            handleChipClick: handleChipClick,
            handleChipRemove: handleChipRemove,
            moveChipFocus: moveChipFocus,
            onInputKeydown: onInputKeydown,
            focusInput: focusInput,
            onInputFocus: onInputFocus,
            onInputBlur: onInputBlur,
            onFocusOut: onFocusOut,
            computedDisabled: computedDisabled,
            statusMessageContent: statusMessageContent
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$n = {
    ref: "chipsContainer",
    class: "cdx-chip-input__chips",
    role: "listbox",
    "aria-orientation": "horizontal"
};
const $db68d79c4ce005fe$var$_hoisted_2$f = [
    "disabled"
];
const $db68d79c4ce005fe$var$_hoisted_3$a = {
    key: 0,
    ref: "separateInputWrapper",
    class: "cdx-chip-input__separate-input"
};
const $db68d79c4ce005fe$var$_hoisted_4$6 = [
    "disabled"
];
const $db68d79c4ce005fe$var$_hoisted_5$6 = {
    class: "cdx-chip-input__aria-status",
    role: "status",
    "aria-live": "polite"
};
function $db68d79c4ce005fe$var$_sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_input_chip = (0, $TusQn.resolveComponent)("cdx-input-chip");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-chip-input",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle),
        onClick: _cache[8] || (_cache[8] = (...args)=>_ctx.focusInput && _ctx.focusInput(...args)),
        onFocusout: _cache[9] || (_cache[9] = (...args)=>_ctx.onFocusOut && _ctx.onFocusOut(...args))
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$n, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.inputChips, (chip, index)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_input_chip, {
                    key: chip.value,
                    ref_for: true,
                    ref: (ref2)=>_ctx.assignChipTemplateRef(ref2, index),
                    class: "cdx-chip-input__item",
                    icon: chip.icon,
                    disabled: _ctx.computedDisabled,
                    onClickChip: ($event)=>_ctx.handleChipClick(chip),
                    onRemoveChip: (method)=>_ctx.handleChipRemove(chip, index, method),
                    onArrowLeft: ($event)=>_ctx.moveChipFocus("left", index),
                    onArrowRight: ($event)=>_ctx.moveChipFocus("right", index)
                }, {
                    default: (0, $TusQn.withCtx)(()=>{
                        var _a;
                        return [
                            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)((_a = chip.label) != null ? _a : chip.value), 1)
                        ];
                    }),
                    _: 2
                }, 1032, [
                    "icon",
                    "disabled",
                    "onClickChip",
                    "onRemoveChip",
                    "onArrowLeft",
                    "onArrowRight"
                ]);
            }), 128)),
            !_ctx.separateInput ? (0, $TusQn.withDirectives)(((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("input", (0, $TusQn.mergeProps)({
                key: 0,
                ref: "input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedInputValue = $event),
                class: "cdx-chip-input__input",
                disabled: _ctx.computedDisabled
            }, _ctx.otherAttrs, {
                onBlur: _cache[1] || (_cache[1] = (...args)=>_ctx.onInputBlur && _ctx.onInputBlur(...args)),
                onFocus: _cache[2] || (_cache[2] = (...args)=>_ctx.onInputFocus && _ctx.onInputFocus(...args)),
                onKeydown: _cache[3] || (_cache[3] = (...args)=>_ctx.onInputKeydown && _ctx.onInputKeydown(...args))
            }), null, 16, $db68d79c4ce005fe$var$_hoisted_2$f)), [
                [
                    (0, $eeJ70.vModelDynamic),
                    _ctx.computedInputValue
                ]
            ]) : (0, $TusQn.createCommentVNode)("v-if", true)
        ], 512),
        _ctx.separateInput ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_3$a, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                ref: "input",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>_ctx.computedInputValue = $event),
                class: "cdx-chip-input__input",
                disabled: _ctx.computedDisabled
            }, _ctx.otherAttrs, {
                onBlur: _cache[5] || (_cache[5] = (...args)=>_ctx.onInputBlur && _ctx.onInputBlur(...args)),
                onFocus: _cache[6] || (_cache[6] = (...args)=>_ctx.onInputFocus && _ctx.onInputFocus(...args)),
                onKeydown: _cache[7] || (_cache[7] = (...args)=>_ctx.onInputKeydown && _ctx.onInputKeydown(...args))
            }), null, 16, $db68d79c4ce005fe$var$_hoisted_4$6), [
                [
                    (0, $eeJ70.vModelDynamic),
                    _ctx.computedInputValue
                ]
            ])
        ], 512)) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_5$6, (0, $8XWQX.toDisplayString)(_ctx.statusMessageContent), 1)
    ], 38);
}
const $db68d79c4ce005fe$export$942cd80f467f680f = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$p, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$p
    ]
]);
function $db68d79c4ce005fe$var$regExpEscape(value) {
    return value.replace(/([\\{}()|.?*+\-^$[\]])/g, "\\$1");
}
const $db68d79c4ce005fe$var$COMBINING_MARK = "[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]";
function $db68d79c4ce005fe$var$splitStringAtMatch(query, title) {
    if (!query) return [
        title,
        "",
        ""
    ];
    const sanitizedQuery = $db68d79c4ce005fe$var$regExpEscape(query);
    const match = new RegExp(// Per https://www.regular-expressions.info/unicode.html, "any code point that is not a
    // combining mark can be followed by any number of combining marks." See also the
    // discussion in https://phabricator.wikimedia.org/T35242.
    sanitizedQuery + $db68d79c4ce005fe$var$COMBINING_MARK + "*", "i").exec(title);
    if (!match || match.index === void 0) return [
        title,
        "",
        ""
    ];
    const matchStartIndex = match.index;
    const matchEndIndex = matchStartIndex + match[0].length;
    const highlightedTitle = title.slice(matchStartIndex, matchEndIndex);
    const beforeHighlight = title.slice(0, matchStartIndex);
    const afterHighlight = title.slice(matchEndIndex, title.length);
    return [
        beforeHighlight,
        highlightedTitle,
        afterHighlight
    ];
}
const $db68d79c4ce005fe$export$8b1d1907b037443c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    regExpEscape: $db68d79c4ce005fe$var$regExpEscape,
    splitStringAtMatch: $db68d79c4ce005fe$var$splitStringAtMatch
}, Symbol.toStringTag, {
    value: "Module"
}));
const $db68d79c4ce005fe$var$_sfc_main$o = (0, $TusQn.defineComponent)({
    name: "CdxSearchResultTitle",
    props: {
        /**
     * Title text.
     */ title: {
            type: String,
            required: true
        },
        /**
     * The current search query.
     */ searchQuery: {
            type: String,
            default: ""
        }
    },
    setup: (props)=>{
        const titleChunks = (0, $01W3b.computed)(()=>$db68d79c4ce005fe$var$splitStringAtMatch(props.searchQuery, String(props.title)));
        return {
            titleChunks: titleChunks
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$m = {
    class: "cdx-search-result-title"
};
const $db68d79c4ce005fe$var$_hoisted_2$e = {
    class: "cdx-search-result-title__match"
};
function $db68d79c4ce005fe$var$_sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_1$m, [
        (0, $TusQn.createElementVNode)("bdi", null, [
            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.titleChunks[0]), 1),
            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$e, (0, $8XWQX.toDisplayString)(_ctx.titleChunks[1]), 1),
            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.titleChunks[2]), 1)
        ])
    ]);
}
const $db68d79c4ce005fe$export$87f2877f2a5e5480 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$o, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$o
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$n = (0, $TusQn.defineComponent)({
    name: "CdxMenuItem",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxThumbnail: $db68d79c4ce005fe$export$9fe12e22779707e,
        CdxSearchResultTitle: $db68d79c4ce005fe$export$87f2877f2a5e5480
    },
    props: {
        /**
     * ID for HTML `id` attribute.
     */ id: {
            type: String,
            required: true
        },
        /**
     * The value provided to the parent menu component when this menu item is selected.
     */ value: {
            type: [
                String,
                Number
            ],
            required: true
        },
        /**
     * Whether the menu item is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this menu item is selected.
     */ selected: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this menu item is being pressed.
     */ active: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this menu item is visually highlighted due to hover or keyboard navigation.
     */ highlighted: {
            type: Boolean,
            default: false
        },
        /**
     * Label for the menu item. If this isn't provided, the value will be displayed instead.
     */ label: {
            type: String,
            default: ""
        },
        /**
     * Text that matches current search query. Only used for search results and will be
     * displayed after the label.
     */ match: {
            type: String,
            default: ""
        },
        /**
     * Text that supports the label. Supporting text will appear next to the label in a more
     * subtle color.
     */ supportingText: {
            type: String,
            default: ""
        },
        /**
     * URL for the menu item. If provided, the content of the menu item will be wrapped in an
     * anchor tag.
     */ url: {
            type: String,
            default: ""
        },
        /**
     * Icon for the menu item.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: ""
        },
        /**
     * Whether a thumbnail (or a placeholder icon) should be displayed.
     */ showThumbnail: {
            type: Boolean,
            default: false
        },
        /**
     * Thumbnail for the menu item.
     */ thumbnail: {
            type: [
                Object,
                null
            ],
            default: null
        },
        /**
     * Description of the menu item.
     */ description: {
            type: [
                String,
                null
            ],
            default: ""
        },
        /**
     * The search query to be highlighted within the menu item's title.
     */ searchQuery: {
            type: String,
            default: ""
        },
        /**
     * Whether to bold menu item labels.
     */ boldLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to hide description text overflow via an ellipsis.
     */ hideDescriptionOverflow: {
            type: Boolean,
            default: false
        },
        /**
     * Optional language codes for label, match, supporting text, and description.
     *
     * If included, that language code will be added as a `lang` attribute to the element
     * wrapping that text node.
     * @default {}
     */ language: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * MenuItems inside a MenuButton can also support an "action" prop
     */ action: {
            type: String,
            default: "default"
        },
        /**
     * Whether this menu is in multiselect mode.
     */ multiselect: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when the menu item becomes selected, active or highlighted in response to
     * user interaction. Handled in the Menu component.
     *
     * @property {MenuState} menuState State to change
     * @property {boolean} setState Whether to set that state to this menu item
     */ "change"
    ],
    setup: (props, { emit: emit })=>{
        const onMouseMove = ()=>{
            if (!props.highlighted) emit("change", "highlighted", true);
        };
        const onMouseLeave = ()=>{
            emit("change", "highlighted", false);
        };
        const onMouseDown = (e)=>{
            if (e.button === 0) emit("change", "active", true);
        };
        const onClick = ()=>{
            emit("change", "selected", true);
        };
        const highlightQuery = (0, $01W3b.computed)(()=>props.searchQuery.length > 0);
        const rootClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-menu-item--selected": props.selected,
                // Only show the active visual state when the menu item is both active and
                // highlighted. This means, on mousedown -> mouseleave, the menu item is still
                // technically tracked by the menu as active, but will not appear active to the
                // user. This also means in the case of mousedown -> mouseleave -> mouseenter, the
                // menu item will appear active again, and on click (releasing the mouse button),
                // the item will be selected.
                "cdx-menu-item--active": props.active && props.highlighted,
                "cdx-menu-item--highlighted": props.highlighted,
                "cdx-menu-item--destructive": props.action && props.action === "destructive",
                "cdx-menu-item--enabled": !props.disabled,
                "cdx-menu-item--disabled": props.disabled,
                "cdx-menu-item--highlight-query": highlightQuery.value,
                "cdx-menu-item--bold-label": props.boldLabel,
                "cdx-menu-item--has-description": !!props.description,
                "cdx-menu-item--hide-description-overflow": props.hideDescriptionOverflow
            };
        });
        const contentTag = (0, $01W3b.computed)(()=>props.url ? "a" : "span");
        const title = (0, $01W3b.computed)(()=>props.label || String(props.value));
        return {
            onMouseMove: onMouseMove,
            onMouseLeave: onMouseLeave,
            onMouseDown: onMouseDown,
            onClick: onClick,
            highlightQuery: highlightQuery,
            rootClasses: rootClasses,
            contentTag: contentTag,
            title: title,
            cdxIconCheck: $db68d79c4ce005fe$var$K3
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$l = [
    "id",
    "aria-disabled",
    "aria-selected",
    "aria-checked"
];
const $db68d79c4ce005fe$var$_hoisted_2$d = {
    class: "cdx-menu-item__text"
};
const $db68d79c4ce005fe$var$_hoisted_3$9 = [
    "lang"
];
const $db68d79c4ce005fe$var$_hoisted_4$5 = [
    "lang"
];
const $db68d79c4ce005fe$var$_hoisted_5$5 = [
    "lang"
];
const $db68d79c4ce005fe$var$_hoisted_6$5 = [
    "lang"
];
function $db68d79c4ce005fe$var$_sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_thumbnail = (0, $TusQn.resolveComponent)("cdx-thumbnail");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_search_result_title = (0, $TusQn.resolveComponent)("cdx-search-result-title");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
        id: _ctx.id,
        role: "option",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-menu-item",
            _ctx.rootClasses
        ]),
        "aria-disabled": _ctx.disabled,
        "aria-selected": _ctx.selected && !_ctx.multiselect ? true : void 0,
        "aria-checked": _ctx.selected && _ctx.multiselect ? true : void 0,
        onMousemove: _cache[0] || (_cache[0] = (...args)=>_ctx.onMouseMove && _ctx.onMouseMove(...args)),
        onMouseleave: _cache[1] || (_cache[1] = (...args)=>_ctx.onMouseLeave && _ctx.onMouseLeave(...args)),
        onMousedown: _cache[2] || (_cache[2] = (0, $eeJ70.withModifiers)((...args)=>_ctx.onMouseDown && _ctx.onMouseDown(...args), [
            "prevent"
        ])),
        onClick: _cache[3] || (_cache[3] = (...args)=>_ctx.onClick && _ctx.onClick(...args))
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.contentTag), {
                    href: _ctx.url ? _ctx.url : void 0,
                    class: "cdx-menu-item__content"
                }, {
                    default: (0, $TusQn.withCtx)(()=>{
                        var _a, _b, _c, _d, _e, _f;
                        return [
                            _ctx.showThumbnail ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_thumbnail, {
                                key: 0,
                                thumbnail: _ctx.thumbnail,
                                class: "cdx-menu-item__thumbnail"
                            }, null, 8, [
                                "thumbnail"
                            ])) : _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                                key: 1,
                                icon: _ctx.icon,
                                class: "cdx-menu-item__icon"
                            }, null, 8, [
                                "icon"
                            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$d, [
                                _ctx.highlightQuery ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_search_result_title, {
                                    key: 0,
                                    title: _ctx.title,
                                    "search-query": _ctx.searchQuery,
                                    lang: (_a = _ctx.language) == null ? void 0 : _a.label
                                }, null, 8, [
                                    "title",
                                    "search-query",
                                    "lang"
                                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: 1,
                                    class: "cdx-menu-item__text__label",
                                    lang: (_b = _ctx.language) == null ? void 0 : _b.label
                                }, [
                                    (0, $TusQn.createElementVNode)("bdi", null, (0, $8XWQX.toDisplayString)(_ctx.title), 1)
                                ], 8, $db68d79c4ce005fe$var$_hoisted_3$9)),
                                _ctx.match ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 2
                                }, [
                                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(" ") + " "),
                                    _ctx.highlightQuery ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_search_result_title, {
                                        key: 0,
                                        title: _ctx.match,
                                        "search-query": _ctx.searchQuery,
                                        lang: (_c = _ctx.language) == null ? void 0 : _c.match
                                    }, null, 8, [
                                        "title",
                                        "search-query",
                                        "lang"
                                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                        key: 1,
                                        class: "cdx-menu-item__text__match",
                                        lang: (_d = _ctx.language) == null ? void 0 : _d.match
                                    }, [
                                        (0, $TusQn.createElementVNode)("bdi", null, (0, $8XWQX.toDisplayString)(_ctx.match), 1)
                                    ], 8, $db68d79c4ce005fe$var$_hoisted_4$5))
                                ], 64)) : (0, $TusQn.createCommentVNode)("v-if", true),
                                _ctx.supportingText ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 3
                                }, [
                                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(" ") + " "),
                                    (0, $TusQn.createElementVNode)("span", {
                                        class: "cdx-menu-item__text__supporting-text",
                                        lang: (_e = _ctx.language) == null ? void 0 : _e.supportingText
                                    }, [
                                        (0, $TusQn.createElementVNode)("bdi", null, (0, $8XWQX.toDisplayString)(_ctx.supportingText), 1)
                                    ], 8, $db68d79c4ce005fe$var$_hoisted_5$5)
                                ], 64)) : (0, $TusQn.createCommentVNode)("v-if", true),
                                _ctx.description ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: 4,
                                    class: "cdx-menu-item__text__description",
                                    lang: (_f = _ctx.language) == null ? void 0 : _f.description
                                }, [
                                    (0, $TusQn.createElementVNode)("bdi", null, (0, $8XWQX.toDisplayString)(_ctx.description), 1)
                                ], 8, $db68d79c4ce005fe$var$_hoisted_6$5)) : (0, $TusQn.createCommentVNode)("v-if", true)
                            ]),
                            _ctx.multiselect && _ctx.selected ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                                key: 2,
                                icon: _ctx.cdxIconCheck,
                                size: "small",
                                class: "cdx-menu-item__selected-icon"
                            }, null, 8, [
                                "icon"
                            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                        ];
                    }),
                    _: 1
                }, 8, [
                    "href"
                ]))
            ])
    ], 42, $db68d79c4ce005fe$var$_hoisted_1$l);
}
const $db68d79c4ce005fe$export$546b4271d17a9cd5 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$n, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$n
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$m = (0, $TusQn.defineComponent)({
    name: "CdxProgressBar",
    props: {
        /**
     * Whether this is the smaller, inline variant.
     */ inline: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the progress bar is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    setup (props, { attrs: attrs }) {
        $db68d79c4ce005fe$export$3f97d07ad730ccf0(()=>!props.inline && !attrs["aria-label"] && !attrs["aria-hidden"], "CdxProgressBar: Progress bars require one of the following attribute, aria-label or aria-hidden. See documentation on https://doc.wikimedia.org/codex/latest/components/demos/progressbar.html");
        const rootClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-progress-bar--block": !props.inline,
                "cdx-progress-bar--inline": props.inline,
                "cdx-progress-bar--enabled": !props.disabled,
                "cdx-progress-bar--disabled": props.disabled
            };
        });
        const computedAriaHidden = (0, $01W3b.computed)(()=>{
            return props.inline ? "true" : void 0;
        });
        return {
            rootClasses: rootClasses,
            computedAriaHidden: computedAriaHidden
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$k = [
    "aria-hidden",
    "aria-disabled"
];
const $db68d79c4ce005fe$var$_hoisted_2$c = /* @__PURE__ */ (0, $TusQn.createElementVNode)("div", {
    class: "cdx-progress-bar__bar"
}, null, -1);
const $db68d79c4ce005fe$var$_hoisted_3$8 = [
    $db68d79c4ce005fe$var$_hoisted_2$c
];
function $db68d79c4ce005fe$var$_sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-progress-bar",
            _ctx.rootClasses
        ]),
        role: "progressbar",
        "aria-hidden": _ctx.computedAriaHidden,
        "aria-disabled": _ctx.disabled
    }, $db68d79c4ce005fe$var$_hoisted_3$8, 10, $db68d79c4ce005fe$var$_hoisted_1$k);
}
const $db68d79c4ce005fe$export$f9f679f84bac7c0c = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$m, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$m
    ]
]);
function $db68d79c4ce005fe$export$a7395f9832c00176(templateRef, observerOptions) {
    const intersectionRef = (0, $01W3b.ref)(false);
    let mounted = false;
    if (typeof window !== "object") return intersectionRef;
    if (!("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype)) return intersectionRef;
    const observer = new window.IntersectionObserver((entries)=>{
        const entry = entries[0];
        if (entry) intersectionRef.value = entry.isIntersecting;
    }, observerOptions);
    (0, $TusQn.onMounted)(()=>{
        mounted = true;
        if (templateRef.value) observer.observe(templateRef.value);
    });
    (0, $TusQn.onUnmounted)(()=>{
        mounted = false;
        observer.disconnect();
    });
    (0, $TusQn.watch)(templateRef, (newElement)=>{
        if (!mounted) return;
        observer.disconnect();
        intersectionRef.value = false;
        if (newElement) observer.observe(newElement);
    });
    return intersectionRef;
}
function $db68d79c4ce005fe$var$selectedIsArray(selected) {
    return selected !== null && Array.isArray(selected);
}
const $db68d79c4ce005fe$var$_sfc_main$l = (0, $TusQn.defineComponent)({
    name: "CdxMenu",
    components: {
        CdxMenuItem: $db68d79c4ce005fe$export$546b4271d17a9cd5,
        CdxProgressBar: $db68d79c4ce005fe$export$f9f679f84bac7c0c
    },
    /**
   * Attributes, besides class and style, will be passed to the <ul> element.
   */ inheritAttrs: false,
    props: {
        /** Menu items. See the MenuItemData type. */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Interactive footer item.
     *
     * This is a special menu item which is pinned to the bottom of the menu. When scrolling is
     * enabled within the menu, the footer item will always be visible at the bottom of the
     * menu. When scrolling is not enabled, the footer item will simply appear as the last menu
     * item.
     *
     * The footer item is selectable, like other menu items.
     */ footer: {
            type: Object,
            default: null
        },
        /**
     * Value(s) of the selected menu item(s). A single value for single-select, or an array of
     * values for multi-select.
     *
     * Must be bound with `v-model:selected`.
     *
     * The property should be initialized to `null` (for single-select) or an empty array (for
     * multi-select) rather than using a falsy value.
     */ selected: {
            // eslint-disable-next-line max-len
            type: [
                String,
                Number,
                Array,
                null
            ],
            required: true
        },
        /**
     * Whether the menu is expanded. Must be bound with `v-model:expanded`.
     */ expanded: {
            type: Boolean,
            required: true
        },
        /**
     * Whether to display pending state indicators. Meant to indicate that new menu items are
     * being fetched or computed.
     *
     * When true, the menu will expand if not already expanded, and an inline progress bar will
     * display. If there are no menu items yet, a message can be displayed in the `pending`
     * slot, e.g. "Loading results".
     */ showPending: {
            type: Boolean,
            default: false
        },
        /**
     * Limit the number of menu items to display before scrolling.
     *
     * Setting this prop to anything falsy will show all menu items.
     *
     * By default, all menu items are shown.
     */ visibleItemLimit: {
            type: Number,
            default: null
        },
        /**
     * Whether menu item thumbnails (or a placeholder icon) should be displayed.
     */ showThumbnail: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to bold menu item labels.
     */ boldLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to hide description text overflow via an ellipsis.
     */ hideDescriptionOverflow: {
            type: Boolean,
            default: false
        },
        /**
     * The search query to be highlighted within the menu items' titles.
     */ searchQuery: {
            type: String,
            default: ""
        },
        /**
     * Whether to show the `no-results` slot content.
     *
     * The Menu component automatically shows this slot when there is content in the
     * `no-results` slot and there are zero menu items. However, some components may need to
     * customize this behavior, e.g. to show the slot even when there is at least one menu item.
     * This prop can be used to override the default Menu behavior.
     *
     * Possible values:
     * `null` (default): the `no-results` slot will display only if there are zero menu items.
     * `true`: the `no-results` slot will display, regardless of number of menu items.
     * `false`: the `no-results` slot will not display, regardless of number of menu items.
     */ showNoResultsSlot: {
            type: Boolean,
            default: null
        }
    },
    emits: [
        // Don't remove the spaces in the "string | number | null" type below; removing these
        // spaces causes the documentation to render the type as "union" instead.
        // Keep property descriptions on a single line or they will get cut off.
        /**
     * When the selected menu item changes.
     *
     * Property will be a single value or `null` in single-select mode, or an array of values or
     * an empty array in multiselect mode.
     *
     * @property {MenuItemValue | MenuItemValue[] | null} selectedValue selected value or values
     */ "update:selected",
        /**
     * When the menu opens or closes.
     *
     * @property {boolean} newValue The new expanded state (true for open, false for closed)
     */ "update:expanded",
        /**
     * When a menu item is clicked.
     *
     * Typically, components with menus will respond to the selected value change, but
     * occasionally, a component might want to react specifically when a menu item is clicked.
     *
     * @property {MenuItemDataWithId} menuItem The menu item that was clicked
     */ "menu-item-click",
        /**
     * When a menu item is highlighted via keyboard navigation.
     *
     * @property {MenuItemDataWithId} highlightedMenuItem The menu item
     * was highlighted
     */ "menu-item-keyboard-navigation",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more"
    ],
    expose: [
        "isExpanded",
        "clearActive",
        "getHighlightedMenuItem",
        "getHighlightedViaKeyboard",
        "delegateKeyNavigation"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        const computedMenuItems = (0, $01W3b.computed)(()=>{
            const menuItemsWithFooter = props.footer && props.menuItems ? [
                ...props.menuItems,
                props.footer
            ] : props.menuItems;
            return menuItemsWithFooter.map((menuItem)=>$db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, menuItem), {
                    id: $db68d79c4ce005fe$export$6217842283d27b52("menu-item")
                }));
        });
        const computedShowNoResultsSlot = (0, $01W3b.computed)(()=>{
            if (!slots["no-results"]) return false;
            if (props.showNoResultsSlot !== null) return props.showNoResultsSlot;
            return computedMenuItems.value.length === 0;
        });
        const highlightedMenuItem = (0, $01W3b.ref)(null);
        const highlightedViaKeyboard = (0, $01W3b.ref)(false);
        const activeMenuItem = (0, $01W3b.ref)(null);
        const ariaRelevant = "additions removals";
        let keyBuffer = "";
        let keyBufferTimeout = null;
        function clearKeyBuffer() {
            keyBuffer = "";
            if (keyBufferTimeout !== null) {
                clearTimeout(keyBufferTimeout);
                keyBufferTimeout = null;
            }
        }
        function resetKeyBufferTimeout() {
            if (keyBufferTimeout !== null) clearTimeout(keyBufferTimeout);
            keyBufferTimeout = setTimeout(clearKeyBuffer, 1500);
        }
        function findFirstSelectedMenuItem() {
            var _a;
            return (_a = computedMenuItems.value.find((menuItem)=>$db68d79c4ce005fe$var$selectedIsArray(props.selected) ? props.selected.indexOf(menuItem.value) !== -1 : menuItem.value === props.selected)) != null ? _a : null;
        }
        const isMultiselect = (0, $01W3b.computed)(()=>$db68d79c4ce005fe$var$selectedIsArray(props.selected));
        function isItemSelected(value) {
            return $db68d79c4ce005fe$var$selectedIsArray(props.selected) ? props.selected.indexOf(value) !== -1 : value === props.selected;
        }
        function updateSelected(value) {
            if ($db68d79c4ce005fe$var$selectedIsArray(props.selected)) {
                const newSelected = props.selected.indexOf(value) === -1 ? props.selected.concat(value) : props.selected.filter((item)=>item !== value);
                emit("update:selected", newSelected);
            } else emit("update:selected", value);
        }
        function handleMenuItemChange(menuState, menuItem) {
            if (menuItem && menuItem.disabled) return;
            switch(menuState){
                case "selected":
                    if (menuItem) updateSelected(menuItem.value);
                    if (!isMultiselect.value) emit("update:expanded", false);
                    activeMenuItem.value = null;
                    break;
                case "highlighted":
                    highlightedMenuItem.value = menuItem != null ? menuItem : null;
                    highlightedViaKeyboard.value = false;
                    break;
                case "highlightedViaKeyboard":
                    highlightedMenuItem.value = menuItem != null ? menuItem : null;
                    highlightedViaKeyboard.value = true;
                    break;
                case "active":
                    activeMenuItem.value = menuItem != null ? menuItem : null;
                    break;
            }
        }
        const highlightedMenuItemIndex = (0, $01W3b.computed)(()=>{
            if (highlightedMenuItem.value === null) return;
            return computedMenuItems.value.findIndex((menuItem)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                menuItem.value === highlightedMenuItem.value.value);
        });
        function handleHighlightViaKeyboard(newHighlightedMenuItem) {
            if (!newHighlightedMenuItem) return;
            handleMenuItemChange("highlightedViaKeyboard", newHighlightedMenuItem);
            emit("menu-item-keyboard-navigation", newHighlightedMenuItem);
        }
        function highlightPrev(highlightedIndex) {
            var _a;
            const findPrevEnabled = (startIndex)=>{
                for(let index = startIndex - 1; index >= 0; index--){
                    if (!computedMenuItems.value[index].disabled) return computedMenuItems.value[index];
                }
            };
            highlightedIndex = highlightedIndex != null ? highlightedIndex : computedMenuItems.value.length;
            const prev = (_a = findPrevEnabled(highlightedIndex)) != null ? _a : findPrevEnabled(computedMenuItems.value.length);
            handleHighlightViaKeyboard(prev);
        }
        function highlightNext(highlightedIndex) {
            var _a;
            const findNextEnabled = (startIndex)=>computedMenuItems.value.find((item, index)=>!item.disabled && index > startIndex);
            highlightedIndex = highlightedIndex != null ? highlightedIndex : -1;
            const next = (_a = findNextEnabled(highlightedIndex)) != null ? _a : findNextEnabled(-1);
            handleHighlightViaKeyboard(next);
        }
        function handleCharacterNavigation(e) {
            if (e.key === "Clear") {
                clearKeyBuffer();
                return true;
            }
            if (e.key === "Backspace") {
                keyBuffer = keyBuffer.slice(0, -1);
                resetKeyBufferTimeout();
                return true;
            }
            if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
                if (!props.expanded) emit("update:expanded", true);
                if (e.key === " " && keyBuffer.length < 1) return false;
                keyBuffer += e.key.toLowerCase();
                const isRepeatedCharacter = keyBuffer.length > 1 && keyBuffer.split("").every((char)=>char === keyBuffer[0]);
                let itemsToMatch = computedMenuItems.value;
                let stringToMatch = keyBuffer;
                if (isRepeatedCharacter && highlightedMenuItemIndex.value !== void 0) {
                    itemsToMatch = itemsToMatch.slice(highlightedMenuItemIndex.value + 1).concat(itemsToMatch.slice(0, highlightedMenuItemIndex.value));
                    stringToMatch = keyBuffer[0];
                }
                const matchingItem = itemsToMatch.find((item)=>{
                    var _a;
                    return !item.disabled && String((_a = item.label) != null ? _a : item.value).toLowerCase().startsWith(stringToMatch);
                });
                if (matchingItem) {
                    handleMenuItemChange("highlightedViaKeyboard", matchingItem);
                    maybeScrollIntoView();
                }
                resetKeyBufferTimeout();
                return true;
            }
            return false;
        }
        function handleKeyNavigation(e, { prevent: prevent = true, characterNavigation: characterNavigation = false } = {}) {
            if (characterNavigation) {
                if (handleCharacterNavigation(e)) {
                    e.preventDefault();
                    return true;
                }
                clearKeyBuffer();
            }
            function maybePrevent() {
                if (prevent) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            switch(e.key){
                case "Enter":
                case " ":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value && highlightedViaKeyboard.value) updateSelected(highlightedMenuItem.value.value);
                        if (!isMultiselect.value) emit("update:expanded", false);
                    } else emit("update:expanded", true);
                    return true;
                case "Tab":
                    if (props.expanded) {
                        if (highlightedMenuItem.value && highlightedViaKeyboard.value && !isMultiselect.value) {
                            updateSelected(highlightedMenuItem.value.value);
                            emit("update:expanded", false);
                        }
                    }
                    return true;
                case "ArrowUp":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value === null) handleMenuItemChange("highlightedViaKeyboard", findFirstSelectedMenuItem());
                        highlightPrev(highlightedMenuItemIndex.value);
                    } else emit("update:expanded", true);
                    maybeScrollIntoView();
                    return true;
                case "ArrowDown":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value === null) handleMenuItemChange("highlightedViaKeyboard", findFirstSelectedMenuItem());
                        highlightNext(highlightedMenuItemIndex.value);
                    } else emit("update:expanded", true);
                    maybeScrollIntoView();
                    return true;
                case "Home":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value === null) handleMenuItemChange("highlightedViaKeyboard", findFirstSelectedMenuItem());
                        highlightNext();
                    } else emit("update:expanded", true);
                    maybeScrollIntoView();
                    return true;
                case "End":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value === null) handleMenuItemChange("highlightedViaKeyboard", findFirstSelectedMenuItem());
                        highlightPrev();
                    } else emit("update:expanded", true);
                    maybeScrollIntoView();
                    return true;
                case "Escape":
                    maybePrevent();
                    emit("update:expanded", false);
                    return true;
                default:
                    return false;
            }
        }
        function onMouseUp() {
            handleMenuItemChange("active", null);
        }
        const menuItemElements = [];
        const loadMoreTriggerElement = (0, $01W3b.ref)(void 0);
        const isTriggerVisible = $db68d79c4ce005fe$export$a7395f9832c00176(loadMoreTriggerElement, {
            threshold: 0.8
        });
        (0, $TusQn.watch)(isTriggerVisible, (value)=>{
            if (value) emit("load-more");
        });
        function assignTemplateRef(templateRef, index) {
            if (templateRef) {
                menuItemElements[index] = templateRef.$el;
                const visibleItemLimit = props.visibleItemLimit;
                if (!visibleItemLimit || props.menuItems.length < visibleItemLimit) return;
                const loadMoreThreshold = Math.min(visibleItemLimit, Math.max(2, Math.floor(0.2 * props.menuItems.length)));
                if (index === props.menuItems.length - loadMoreThreshold) loadMoreTriggerElement.value = templateRef.$el;
            }
        }
        const menuListbox = (0, $01W3b.ref)();
        function maybeScrollIntoView() {
            const isListboxScrollable = menuListbox.value && menuListbox.value.scrollHeight > menuListbox.value.clientHeight;
            if (highlightedMenuItemIndex.value === void 0 || !isListboxScrollable) return;
            const scrollIndex = highlightedMenuItemIndex.value >= 0 ? highlightedMenuItemIndex.value : 0;
            menuItemElements[scrollIndex].scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
        const maxMenuHeight = (0, $01W3b.ref)(null);
        const footerHeight = (0, $01W3b.ref)(null);
        function resizeMenu() {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                yield (0, $TusQn.nextTick)();
                updateFooterHeight();
                updateMaxMenuHeight();
                yield (0, $TusQn.nextTick)();
                maybeScrollIntoView();
            });
        }
        function updateFooterHeight() {
            if (props.footer) {
                const footerElement = menuItemElements[menuItemElements.length - 1];
                footerHeight.value = footerElement.scrollHeight;
            } else footerHeight.value = null;
        }
        function updateMaxMenuHeight() {
            if (!props.visibleItemLimit || menuItemElements.length <= props.visibleItemLimit) {
                maxMenuHeight.value = null;
                return;
            }
            const firstMenuItemTop = menuItemElements[0].getBoundingClientRect().top;
            const firstHiddenMenuItemTop = menuItemElements[props.visibleItemLimit].getBoundingClientRect().top;
            maxMenuHeight.value = firstHiddenMenuItemTop - firstMenuItemTop + 2;
        }
        (0, $TusQn.onMounted)(()=>{
            document.addEventListener("mouseup", onMouseUp);
        });
        (0, $TusQn.onUnmounted)(()=>{
            document.removeEventListener("mouseup", onMouseUp);
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "expanded"), (newVal)=>$db68d79c4ce005fe$var$__async(this, null, function*() {
                if (newVal) {
                    const selectedMenuItem = findFirstSelectedMenuItem();
                    if (selectedMenuItem && !highlightedMenuItem.value) handleMenuItemChange("highlighted", selectedMenuItem);
                    yield resizeMenu();
                } else handleMenuItemChange("highlighted", null);
            }));
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "menuItems"), (newPropMenuItems)=>$db68d79c4ce005fe$var$__async(this, null, function*() {
                if (newPropMenuItems.length < menuItemElements.length) menuItemElements.length = newPropMenuItems.length;
                if (props.expanded) yield resizeMenu();
            }), {
            deep: true
        });
        const listBoxStyle = (0, $01W3b.computed)(()=>{
            return {
                "max-height": maxMenuHeight.value ? "".concat(maxMenuHeight.value, "px") : void 0,
                "margin-bottom": footerHeight.value ? "".concat(footerHeight.value, "px") : void 0
            };
        });
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-menu--has-footer": !!props.footer
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        return {
            listBoxStyle: listBoxStyle,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            assignTemplateRef: assignTemplateRef,
            computedMenuItems: computedMenuItems,
            computedShowNoResultsSlot: computedShowNoResultsSlot,
            highlightedMenuItem: highlightedMenuItem,
            highlightedViaKeyboard: highlightedViaKeyboard,
            activeMenuItem: activeMenuItem,
            handleMenuItemChange: handleMenuItemChange,
            handleKeyNavigation: handleKeyNavigation,
            ariaRelevant: ariaRelevant,
            isMultiselect: isMultiselect,
            isItemSelected: isItemSelected,
            menuListbox: menuListbox
        };
    },
    // Public methods
    // These must be in the methods block, not in the setup function, otherwise their documentation
    // won't be picked up by vue-docgen
    methods: {
        /**
     * Returns whether the menu is expanded.
     *
     * @return {boolean}
     */ isExpanded () {
            return this.expanded;
        },
        /**
     * Get the highlighted menu item, if any.
     *
     * The parent component should set `aria-activedescendant` to the `.id` property of the
     * object returned by this method. If this method returns null, `aria-activedescendant`
     * should not be set.
     *
     * @public
     * @return {MenuItemDataWithId|null} The highlighted menu item,
     *   or null if no item is highlighted or if the menu is closed.
     */ getHighlightedMenuItem () {
            return this.expanded ? this.highlightedMenuItem : null;
        },
        /**
     * Get whether the last highlighted item was highlighted via the keyboard.
     *
     * @public
     * @return {boolean} Whether the last highlighted menu item was highlighted via keyboard.
     */ getHighlightedViaKeyboard () {
            return this.highlightedViaKeyboard;
        },
        /**
     * Ensure no menu item is active. This unsets the active item if there is one.
     *
     * @public
     */ clearActive () {
            this.handleMenuItemChange("active", null);
        },
        /**
     * Handles all necessary keyboard navigation.
     *
     * The parent component should listen for keydown events on its focusable element,
     * and pass those events to this method. Events for arrow keys, tab and enter are handled
     * by this method. If a different key was pressed, this method will return false to indicate
     * that it didn't handle the event.
     *
     * @public
     * @param event {KeyboardEvent} Keydown event object
     * @param options
     * @param options.prevent {boolean} If false, do not call e.preventDefault() or
     *   e.stopPropagation()
     * @param options.characterNavigation {boolean}
     * @return Whether the event was handled
     */ delegateKeyNavigation (event, { prevent: prevent = true, characterNavigation: characterNavigation = false } = {}) {
            return this.handleKeyNavigation(event, {
                prevent: prevent,
                characterNavigation: characterNavigation
            });
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$j = [
    "aria-live",
    "aria-relevant",
    "aria-multiselectable"
];
const $db68d79c4ce005fe$var$_hoisted_2$b = {
    key: 0,
    class: "cdx-menu__pending cdx-menu-item"
};
const $db68d79c4ce005fe$var$_hoisted_3$7 = {
    key: 1,
    class: "cdx-menu__no-results cdx-menu-item",
    role: "option"
};
function $db68d79c4ce005fe$var$_sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_menu_item = (0, $TusQn.resolveComponent)("cdx-menu-item");
    const _component_cdx_progress_bar = (0, $TusQn.resolveComponent)("cdx-progress-bar");
    return (0, $TusQn.withDirectives)(((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-menu",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("ul", (0, $TusQn.mergeProps)({
            ref: "menuListbox",
            class: "cdx-menu__listbox",
            role: "listbox",
            style: _ctx.listBoxStyle,
            "aria-live": _ctx.showPending ? "polite" : void 0,
            "aria-relevant": _ctx.showPending ? _ctx.ariaRelevant : void 0,
            "aria-multiselectable": _ctx.isMultiselect ? true : void 0
        }, _ctx.otherAttrs), [
            _ctx.showPending && _ctx.computedMenuItems.length === 0 && _ctx.$slots.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $db68d79c4ce005fe$var$_hoisted_2$b, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "pending")
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            _ctx.computedShowNoResultsSlot ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $db68d79c4ce005fe$var$_hoisted_3$7, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "no-results")
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.computedMenuItems, (menuItem, index)=>{
                var _a, _b;
                return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_menu_item, (0, $TusQn.mergeProps)({
                    key: menuItem.value,
                    ref_for: true,
                    ref: (ref2)=>_ctx.assignTemplateRef(ref2, index)
                }, menuItem, {
                    selected: _ctx.isItemSelected(menuItem.value),
                    active: menuItem.value === ((_a = _ctx.activeMenuItem) == null ? void 0 : _a.value),
                    highlighted: menuItem.value === ((_b = _ctx.highlightedMenuItem) == null ? void 0 : _b.value),
                    "show-thumbnail": _ctx.showThumbnail,
                    "bold-label": _ctx.boldLabel,
                    "hide-description-overflow": _ctx.hideDescriptionOverflow,
                    "search-query": _ctx.searchQuery,
                    multiselect: _ctx.isMultiselect,
                    onChange: (menuState, setState)=>_ctx.handleMenuItemChange(menuState, setState ? menuItem : null),
                    onClick: ($event)=>_ctx.$emit("menu-item-click", menuItem)
                }), {
                    default: (0, $TusQn.withCtx)(()=>{
                        var _a2, _b2;
                        return [
                            (0, $TusQn.renderSlot)(_ctx.$slots, "default", {
                                menuItem: menuItem,
                                active: menuItem.value === ((_a2 = _ctx.activeMenuItem) == null ? void 0 : _a2.value) && menuItem.value === ((_b2 = _ctx.highlightedMenuItem) == null ? void 0 : _b2.value)
                            })
                        ];
                    }),
                    _: 2
                }, 1040, [
                    "selected",
                    "active",
                    "highlighted",
                    "show-thumbnail",
                    "bold-label",
                    "hide-description-overflow",
                    "search-query",
                    "multiselect",
                    "onChange",
                    "onClick"
                ]);
            }), 128)),
            _ctx.showPending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_progress_bar, {
                key: 2,
                class: "cdx-menu__progress-bar",
                inline: true
            })) : (0, $TusQn.createCommentVNode)("v-if", true)
        ], 16, $db68d79c4ce005fe$var$_hoisted_1$j)
    ], 6)), [
        [
            (0, $eeJ70.vShow),
            _ctx.expanded
        ]
    ]);
}
const $db68d79c4ce005fe$export$a33433a93a74f3ad = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$l, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$l
    ]
]);
const $db68d79c4ce005fe$var$textInputTypeValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$TextInputTypes);
const $db68d79c4ce005fe$var$statusValidator$8 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$k = (0, $TusQn.defineComponent)({
    name: "CdxTextInput",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    /**
   * We want the input to inherit attributes, not the root element.
   */ inheritAttrs: false,
    expose: [
        "focus",
        "blur"
    ],
    props: {
        /**
     * Current value of the input.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                String,
                Number
            ],
            default: ""
        },
        /**
     * `type` attribute of the input.
     *
     * @values 'text', 'search', 'number', 'email', 'password', 'tel', 'url',
     * 'week', 'month', 'date', 'datetime-local', 'time'
     */ inputType: {
            type: String,
            default: "text",
            validator: $db68d79c4ce005fe$var$textInputTypeValidator
        },
        /**
     * `status` attribute of the input.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$8
        },
        /**
     * Whether the input is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * An icon at the start of the input element. Similar to a `::before` pseudo-element.
     */ startIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        },
        /**
     * An icon at the end of the input element. Similar to an `::after` pseudo-element.
     */ endIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        },
        /**
     * Add a clear button at the end of the input element.
     *
     * When the clear button is pressed, the input's value is set to an empty string.
     * The clear button is displayed when input text is present.
     */ clearable: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the input value changes
     *
     * @property {string | number} modelValue The new model value
     */ "update:modelValue",
        /**
     * When the user presses a key.
     *
     * This event is not emitted when the user presses the Home or End key (T314728),
     * but is emitted for Ctrl/Cmd+Home and Ctrl/Cmd+End.
     *
     * @property {KeyboardEvent}
     */ "keydown",
        /**
     * When the input value changes via direct use of the input
     *
     * @property {InputEvent} event
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur",
        /**
     * When the input value is cleared through the use of the clear button
     *
     * @property {MouseEvent} event
     */ "clear"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const idAttribute = attrs.id;
        const { computedDisabled: computedDisabled, computedStatus: computedStatus, computedInputId: computedInputId } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"), idAttribute);
        const descriptionId = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldDescriptionIdKey, void 0);
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        const isClearable = (0, $01W3b.computed)(()=>{
            return props.clearable && !!wrappedModel.value && !computedDisabled.value;
        });
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-text-input--has-start-icon": !!props.startIcon,
                "cdx-text-input--has-end-icon": !!props.endIcon,
                "cdx-text-input--clearable": isClearable.value,
                ["cdx-text-input--status-".concat(computedStatus.value)]: true
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const otherAttrsMinusId = (0, $01W3b.computed)(()=>{
            const _a = otherAttrs.value, { id: id } = _a, everythingElse = $db68d79c4ce005fe$var$__objRest(_a, [
                "id"
            ]);
            return everythingElse;
        });
        const inputClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-text-input__input--has-value": !!wrappedModel.value
            };
        });
        const onClear = (event)=>{
            wrappedModel.value = "";
            emit("clear", event);
        };
        const onKeydown = (event)=>{
            if ((event.key === "Home" || event.key === "End") && !event.ctrlKey && !event.metaKey) return;
            emit("keydown", event);
        };
        const onInput = (event)=>{
            emit("input", event);
        };
        const onChange = (event)=>{
            emit("change", event);
        };
        const onFocus = (event)=>{
            emit("focus", event);
        };
        const onBlur = (event)=>{
            emit("blur", event);
        };
        return {
            computedInputId: computedInputId,
            descriptionId: descriptionId,
            wrappedModel: wrappedModel,
            isClearable: isClearable,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrsMinusId: otherAttrsMinusId,
            inputClasses: inputClasses,
            computedDisabled: computedDisabled,
            onClear: onClear,
            onInput: onInput,
            onChange: onChange,
            onKeydown: onKeydown,
            onFocus: onFocus,
            onBlur: onBlur,
            cdxIconClear: $db68d79c4ce005fe$var$Y3
        };
    },
    // Public methods
    // These must be in the methods block, not in the setup function, otherwise their documentation
    // won't be picked up by vue-docgen
    methods: {
        /**
     * Focus the component's input element.
     *
     * @public
     */ focus () {
            const input = this.$refs.input;
            input.focus();
        },
        /**
     * Blur the component's input element.
     *
     * @public
     */ blur () {
            const input = this.$refs.input;
            input.blur();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$i = [
    "id",
    "type",
    "aria-describedby",
    "disabled"
];
function $db68d79c4ce005fe$var$_sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-text-input",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
            id: _ctx.computedInputId,
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
            class: [
                "cdx-text-input__input",
                _ctx.inputClasses
            ]
        }, _ctx.otherAttrsMinusId, {
            type: _ctx.inputType,
            "aria-describedby": _ctx.descriptionId,
            disabled: _ctx.computedDisabled,
            size: "1",
            onInput: _cache[1] || (_cache[1] = (...args)=>_ctx.onInput && _ctx.onInput(...args)),
            onChange: _cache[2] || (_cache[2] = (...args)=>_ctx.onChange && _ctx.onChange(...args)),
            onFocus: _cache[3] || (_cache[3] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args)),
            onBlur: _cache[4] || (_cache[4] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
            onKeydown: _cache[5] || (_cache[5] = (...args)=>_ctx.onKeydown && _ctx.onKeydown(...args))
        }), null, 16, $db68d79c4ce005fe$var$_hoisted_1$i), [
            [
                (0, $eeJ70.vModelDynamic),
                _ctx.wrappedModel
            ]
        ]),
        _ctx.startIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 0,
            icon: _ctx.startIcon,
            class: "cdx-text-input__icon-vue cdx-text-input__start-icon"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.endIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 1,
            icon: _ctx.endIcon,
            class: "cdx-text-input__icon-vue cdx-text-input__end-icon"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.isClearable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 2,
            icon: _ctx.cdxIconClear,
            class: "cdx-text-input__icon-vue cdx-text-input__clear-icon",
            onMousedown: _cache[6] || (_cache[6] = (0, $eeJ70.withModifiers)(()=>{}, [
                "prevent"
            ])),
            onClick: _ctx.onClear
        }, null, 8, [
            "icon",
            "onClick"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6);
}
const $db68d79c4ce005fe$export$edf7ede3ce8aed68 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$k, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$k
    ]
]);
const $db68d79c4ce005fe$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const $db68d79c4ce005fe$var$min = Math.min;
const $db68d79c4ce005fe$var$max = Math.max;
const $db68d79c4ce005fe$var$round = Math.round;
const $db68d79c4ce005fe$var$floor = Math.floor;
const $db68d79c4ce005fe$var$createCoords = (v)=>({
        x: v,
        y: v
    });
const $db68d79c4ce005fe$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $db68d79c4ce005fe$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $db68d79c4ce005fe$var$clamp(start, value, end) {
    return $db68d79c4ce005fe$var$max(start, $db68d79c4ce005fe$var$min(value, end));
}
function $db68d79c4ce005fe$var$evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $db68d79c4ce005fe$var$getSide(placement) {
    return placement.split("-")[0];
}
function $db68d79c4ce005fe$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $db68d79c4ce005fe$var$getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function $db68d79c4ce005fe$var$getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function $db68d79c4ce005fe$var$getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes($db68d79c4ce005fe$var$getSide(placement)) ? "y" : "x";
}
function $db68d79c4ce005fe$var$getAlignmentAxis(placement) {
    return $db68d79c4ce005fe$var$getOppositeAxis($db68d79c4ce005fe$var$getSideAxis(placement));
}
function $db68d79c4ce005fe$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $db68d79c4ce005fe$var$getAlignment(placement);
    const alignmentAxis = $db68d79c4ce005fe$var$getAlignmentAxis(placement);
    const length = $db68d79c4ce005fe$var$getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $db68d79c4ce005fe$var$getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $db68d79c4ce005fe$var$getOppositePlacement(mainAlignmentSide)
    ];
}
function $db68d79c4ce005fe$var$getExpandedPlacements(placement) {
    const oppositePlacement = $db68d79c4ce005fe$var$getOppositePlacement(placement);
    return [
        $db68d79c4ce005fe$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $db68d79c4ce005fe$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $db68d79c4ce005fe$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$db68d79c4ce005fe$var$oppositeAlignmentMap[alignment]);
}
function $db68d79c4ce005fe$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $db68d79c4ce005fe$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $db68d79c4ce005fe$var$getAlignment(placement);
    let list = $db68d79c4ce005fe$var$getSideList($db68d79c4ce005fe$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($db68d79c4ce005fe$var$getOppositeAlignmentPlacement));
    }
    return list;
}
function $db68d79c4ce005fe$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$db68d79c4ce005fe$var$oppositeSideMap[side]);
}
function $db68d79c4ce005fe$var$expandPaddingObject(padding) {
    return $db68d79c4ce005fe$var$__spreadValues({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $db68d79c4ce005fe$var$getPaddingObject(padding) {
    return typeof padding !== "number" ? $db68d79c4ce005fe$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $db68d79c4ce005fe$var$rectToClientRect(rect) {
    return $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, rect), {
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}
function $db68d79c4ce005fe$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = $db68d79c4ce005fe$var$getSideAxis(placement);
    const alignmentAxis = $db68d79c4ce005fe$var$getAlignmentAxis(placement);
    const alignLength = $db68d79c4ce005fe$var$getAxisLength(alignmentAxis);
    const side = $db68d79c4ce005fe$var$getSide(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($db68d79c4ce005fe$var$getAlignment(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
const $db68d79c4ce005fe$var$computePosition$1 = (reference, floating, config)=>$db68d79c4ce005fe$var$__async(void 0, null, function*() {
        const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform2 } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(floating);
        let rects = yield platform2.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $db68d79c4ce005fe$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = yield fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform2,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, middlewareData), {
                [name]: $db68d79c4ce005fe$var$__spreadValues($db68d79c4ce005fe$var$__spreadValues({}, middlewareData[name]), data)
            });
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === "object") {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? yield platform2.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $db68d79c4ce005fe$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    });
function $db68d79c4ce005fe$var$detectOverflow(state, options) {
    return $db68d79c4ce005fe$var$__async(this, null, function*() {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform2, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = $db68d79c4ce005fe$var$evaluate(options, state);
        const paddingObject = $db68d79c4ce005fe$var$getPaddingObject(padding);
        const altContext = elementContext === "floating" ? "reference" : "floating";
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = $db68d79c4ce005fe$var$rectToClientRect((yield platform2.getClippingRect({
            element: ((_await$platform$isEle = yield platform2.isElement == null ? void 0 : platform2.isElement(element)) != null ? _await$platform$isEle : true) ? element : element.contextElement || (yield platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        })));
        const rect = elementContext === "floating" ? $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, rects.floating), {
            x: x,
            y: y
        }) : rects.reference;
        const offsetParent = yield platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating);
        const offsetScale = (yield platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? (yield platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = $db68d79c4ce005fe$var$rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? yield platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    });
}
const $db68d79c4ce005fe$var$flip$1 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform2, elements: elements } = state;
                const _a2 = $db68d79c4ce005fe$var$evaluate(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true } = _a2, detectOverflowOptions = $db68d79c4ce005fe$var$__objRest(_a2, [
                    "mainAxis",
                    "crossAxis",
                    "fallbackPlacements",
                    "fallbackStrategy",
                    "fallbackAxisSideDirection",
                    "flipAlignment"
                ]);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = $db68d79c4ce005fe$var$getSide(placement);
                const isBasePlacement = $db68d79c4ce005fe$var$getSide(initialPlacement) === initialPlacement;
                const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    $db68d79c4ce005fe$var$getOppositePlacement(initialPlacement)
                ] : $db68d79c4ce005fe$var$getExpandedPlacements(initialPlacement));
                if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...$db68d79c4ce005fe$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides2 = $db68d79c4ce005fe$var$getAlignmentSides(placement, rects, rtl);
                    overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side2)=>side2 <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case "bestFit":
                            {
                                var _overflowsData$map$so;
                                const placement2 = (_overflowsData$map$so = overflowsData.map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow2)=>overflow2 > 0).reduce((acc, overflow2)=>acc + overflow2, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                                if (placement2) resetPlacement = placement2;
                                break;
                            }
                        case "initialPlacement":
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            });
        }
    };
};
function $db68d79c4ce005fe$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $db68d79c4ce005fe$var$isAnySideFullyClipped(overflow) {
    return $db68d79c4ce005fe$var$sides.some((side)=>overflow[side] >= 0);
}
const $db68d79c4ce005fe$var$hide$1 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                const { rects: rects } = state;
                const _a2 = $db68d79c4ce005fe$var$evaluate(options, state), { strategy: strategy = "referenceHidden" } = _a2, detectOverflowOptions = $db68d79c4ce005fe$var$__objRest(_a2, [
                    "strategy"
                ]);
                switch(strategy){
                    case "referenceHidden":
                        {
                            const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, detectOverflowOptions), {
                                elementContext: "reference"
                            }));
                            const offsets = $db68d79c4ce005fe$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $db68d79c4ce005fe$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case "escaped":
                        {
                            const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, detectOverflowOptions), {
                                altBoundary: true
                            }));
                            const offsets = $db68d79c4ce005fe$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $db68d79c4ce005fe$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            });
        }
    };
};
function $db68d79c4ce005fe$var$convertValueToCoords(state, options) {
    return $db68d79c4ce005fe$var$__async(this, null, function*() {
        const { placement: placement, platform: platform2, elements: elements } = state;
        const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
        const side = $db68d79c4ce005fe$var$getSide(placement);
        const alignment = $db68d79c4ce005fe$var$getAlignment(placement);
        const isVertical = $db68d79c4ce005fe$var$getSideAxis(placement) === "y";
        const mainAxisMulti = [
            "left",
            "top"
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = $db68d79c4ce005fe$var$evaluate(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : $db68d79c4ce005fe$var$__spreadValues({
            mainAxis: 0,
            crossAxis: 0,
            alignmentAxis: null
        }, rawValue);
        if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    });
}
const $db68d79c4ce005fe$var$offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = yield $db68d79c4ce005fe$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, diffCoords), {
                        placement: placement
                    })
                };
            });
        }
    };
};
const $db68d79c4ce005fe$var$shift$1 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                const { x: x, y: y, placement: placement } = state;
                const _a2 = $db68d79c4ce005fe$var$evaluate(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x2, y: y2 } = _ref;
                        return {
                            x: x2,
                            y: y2
                        };
                    }
                } } = _a2, detectOverflowOptions = $db68d79c4ce005fe$var$__objRest(_a2, [
                    "mainAxis",
                    "crossAxis",
                    "limiter"
                ]);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, detectOverflowOptions);
                const crossAxis = $db68d79c4ce005fe$var$getSideAxis($db68d79c4ce005fe$var$getSide(placement));
                const mainAxis = $db68d79c4ce005fe$var$getOppositeAxis(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === "y" ? "top" : "left";
                    const maxSide = mainAxis === "y" ? "bottom" : "right";
                    const min2 = mainAxisCoord + overflow[minSide];
                    const max2 = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = $db68d79c4ce005fe$var$clamp(min2, mainAxisCoord, max2);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === "y" ? "top" : "left";
                    const maxSide = crossAxis === "y" ? "bottom" : "right";
                    const min2 = crossAxisCoord + overflow[minSide];
                    const max2 = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = $db68d79c4ce005fe$var$clamp(min2, crossAxisCoord, max2);
                }
                const limitedCoords = limiter.fn($db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, state), {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                }));
                return $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, limitedCoords), {
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y
                    }
                });
            });
        }
    };
};
const $db68d79c4ce005fe$var$size$1 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                const { placement: placement, rects: rects, platform: platform2, elements: elements } = state;
                const _a2 = $db68d79c4ce005fe$var$evaluate(options, state), { apply: apply = ()=>{} } = _a2, detectOverflowOptions = $db68d79c4ce005fe$var$__objRest(_a2, [
                    "apply"
                ]);
                const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, detectOverflowOptions);
                const side = $db68d79c4ce005fe$var$getSide(placement);
                const alignment = $db68d79c4ce005fe$var$getAlignment(placement);
                const isYAxis = $db68d79c4ce005fe$var$getSideAxis(placement) === "y";
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === "top" || side === "bottom") {
                    heightSide = side;
                    widthSide = alignment === ((yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
                } else {
                    widthSide = side;
                    heightSide = alignment === "end" ? "top" : "bottom";
                }
                const overflowAvailableHeight = height - overflow[heightSide];
                const overflowAvailableWidth = width - overflow[widthSide];
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if (isYAxis) {
                    const maximumClippingWidth = width - overflow.left - overflow.right;
                    availableWidth = alignment || noShift ? $db68d79c4ce005fe$var$min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
                } else {
                    const maximumClippingHeight = height - overflow.top - overflow.bottom;
                    availableHeight = alignment || noShift ? $db68d79c4ce005fe$var$min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
                }
                if (noShift && !alignment) {
                    const xMin = $db68d79c4ce005fe$var$max(overflow.left, 0);
                    const xMax = $db68d79c4ce005fe$var$max(overflow.right, 0);
                    const yMin = $db68d79c4ce005fe$var$max(overflow.top, 0);
                    const yMax = $db68d79c4ce005fe$var$max(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $db68d79c4ce005fe$var$max(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $db68d79c4ce005fe$var$max(overflow.top, overflow.bottom));
                }
                yield apply($db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, state), {
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                }));
                const nextDimensions = yield platform2.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            });
        }
    };
};
function $db68d79c4ce005fe$var$getNodeName(node) {
    if ($db68d79c4ce005fe$var$isNode(node)) return (node.nodeName || "").toLowerCase();
    return "#document";
}
function $db68d79c4ce005fe$var$getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $db68d79c4ce005fe$var$getDocumentElement(node) {
    var _ref;
    return (_ref = ($db68d79c4ce005fe$var$isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $db68d79c4ce005fe$var$isNode(value) {
    return value instanceof Node || value instanceof $db68d79c4ce005fe$var$getWindow(value).Node;
}
function $db68d79c4ce005fe$var$isElement(value) {
    return value instanceof Element || value instanceof $db68d79c4ce005fe$var$getWindow(value).Element;
}
function $db68d79c4ce005fe$var$isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof $db68d79c4ce005fe$var$getWindow(value).HTMLElement;
}
function $db68d79c4ce005fe$var$isShadowRoot(value) {
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $db68d79c4ce005fe$var$getWindow(value).ShadowRoot;
}
function $db68d79c4ce005fe$var$isOverflowElement(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $db68d79c4ce005fe$var$getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $db68d79c4ce005fe$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($db68d79c4ce005fe$var$getNodeName(element));
}
function $db68d79c4ce005fe$var$isContainingBlock(element) {
    const webkit = $db68d79c4ce005fe$var$isWebKit();
    const css = $db68d79c4ce005fe$var$getComputedStyle(element);
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $db68d79c4ce005fe$var$getContainingBlock(element) {
    let currentNode = $db68d79c4ce005fe$var$getParentNode(element);
    while($db68d79c4ce005fe$var$isHTMLElement(currentNode) && !$db68d79c4ce005fe$var$isLastTraversableNode(currentNode)){
        if ($db68d79c4ce005fe$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $db68d79c4ce005fe$var$getParentNode(currentNode);
    }
    return null;
}
function $db68d79c4ce005fe$var$isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $db68d79c4ce005fe$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($db68d79c4ce005fe$var$getNodeName(node));
}
function $db68d79c4ce005fe$var$getComputedStyle(element) {
    return $db68d79c4ce005fe$var$getWindow(element).getComputedStyle(element);
}
function $db68d79c4ce005fe$var$getNodeScroll(element) {
    if ($db68d79c4ce005fe$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $db68d79c4ce005fe$var$getParentNode(node) {
    if ($db68d79c4ce005fe$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $db68d79c4ce005fe$var$isShadowRoot(node) && node.host || // Fallback.
    $db68d79c4ce005fe$var$getDocumentElement(node);
    return $db68d79c4ce005fe$var$isShadowRoot(result) ? result.host : result;
}
function $db68d79c4ce005fe$var$getNearestOverflowAncestor(node) {
    const parentNode = $db68d79c4ce005fe$var$getParentNode(node);
    if ($db68d79c4ce005fe$var$isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($db68d79c4ce005fe$var$isHTMLElement(parentNode) && $db68d79c4ce005fe$var$isOverflowElement(parentNode)) return parentNode;
    return $db68d79c4ce005fe$var$getNearestOverflowAncestor(parentNode);
}
function $db68d79c4ce005fe$var$getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $db68d79c4ce005fe$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $db68d79c4ce005fe$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $db68d79c4ce005fe$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $db68d79c4ce005fe$var$getOverflowAncestors(win.frameElement) : []);
    return list.concat(scrollableAncestor, $db68d79c4ce005fe$var$getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function $db68d79c4ce005fe$var$getCssDimensions(element) {
    const css = $db68d79c4ce005fe$var$getComputedStyle(element);
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = $db68d79c4ce005fe$var$isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = $db68d79c4ce005fe$var$round(width) !== offsetWidth || $db68d79c4ce005fe$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $db68d79c4ce005fe$var$unwrapElement$2(element) {
    return !$db68d79c4ce005fe$var$isElement(element) ? element.contextElement : element;
}
function $db68d79c4ce005fe$var$getScale(element) {
    const domElement = $db68d79c4ce005fe$var$unwrapElement$2(element);
    if (!$db68d79c4ce005fe$var$isHTMLElement(domElement)) return $db68d79c4ce005fe$var$createCoords(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $db68d79c4ce005fe$var$getCssDimensions(domElement);
    let x = ($ ? $db68d79c4ce005fe$var$round(rect.width) : rect.width) / width;
    let y = ($ ? $db68d79c4ce005fe$var$round(rect.height) : rect.height) / height;
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $db68d79c4ce005fe$var$noOffsets = /* @__PURE__ */ $db68d79c4ce005fe$var$createCoords(0);
function $db68d79c4ce005fe$var$getVisualOffsets(element) {
    const win = $db68d79c4ce005fe$var$getWindow(element);
    if (!$db68d79c4ce005fe$var$isWebKit() || !win.visualViewport) return $db68d79c4ce005fe$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $db68d79c4ce005fe$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== $db68d79c4ce005fe$var$getWindow(element)) return false;
    return isFixed;
}
function $db68d79c4ce005fe$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $db68d79c4ce005fe$var$unwrapElement$2(element);
    let scale = $db68d79c4ce005fe$var$createCoords(1);
    if (includeScale) {
        if (offsetParent) {
            if ($db68d79c4ce005fe$var$isElement(offsetParent)) scale = $db68d79c4ce005fe$var$getScale(offsetParent);
        } else scale = $db68d79c4ce005fe$var$getScale(element);
    }
    const visualOffsets = $db68d79c4ce005fe$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $db68d79c4ce005fe$var$getVisualOffsets(domElement) : $db68d79c4ce005fe$var$createCoords(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $db68d79c4ce005fe$var$getWindow(domElement);
        const offsetWin = offsetParent && $db68d79c4ce005fe$var$isElement(offsetParent) ? $db68d79c4ce005fe$var$getWindow(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $db68d79c4ce005fe$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = $db68d79c4ce005fe$var$getComputedStyle(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = $db68d79c4ce005fe$var$getWindow(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return $db68d79c4ce005fe$var$rectToClientRect({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $db68d79c4ce005fe$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $db68d79c4ce005fe$var$isTopLayer(floating) {
    return $db68d79c4ce005fe$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $db68d79c4ce005fe$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = $db68d79c4ce005fe$var$getDocumentElement(offsetParent);
    const topLayer = elements ? $db68d79c4ce005fe$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = $db68d79c4ce005fe$var$createCoords(1);
    const offsets = $db68d79c4ce005fe$var$createCoords(0);
    const isOffsetParentAnElement = $db68d79c4ce005fe$var$isHTMLElement(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($db68d79c4ce005fe$var$getNodeName(offsetParent) !== "body" || $db68d79c4ce005fe$var$isOverflowElement(documentElement)) scroll = $db68d79c4ce005fe$var$getNodeScroll(offsetParent);
        if ($db68d79c4ce005fe$var$isHTMLElement(offsetParent)) {
            const offsetRect = $db68d79c4ce005fe$var$getBoundingClientRect(offsetParent);
            scale = $db68d79c4ce005fe$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $db68d79c4ce005fe$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $db68d79c4ce005fe$var$getWindowScrollBarX(element) {
    return $db68d79c4ce005fe$var$getBoundingClientRect($db68d79c4ce005fe$var$getDocumentElement(element)).left + $db68d79c4ce005fe$var$getNodeScroll(element).scrollLeft;
}
function $db68d79c4ce005fe$var$getDocumentRect(element) {
    const html = $db68d79c4ce005fe$var$getDocumentElement(element);
    const scroll = $db68d79c4ce005fe$var$getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = $db68d79c4ce005fe$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = $db68d79c4ce005fe$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $db68d79c4ce005fe$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($db68d79c4ce005fe$var$getComputedStyle(body).direction === "rtl") x += $db68d79c4ce005fe$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $db68d79c4ce005fe$var$getViewportRect(element, strategy) {
    const win = $db68d79c4ce005fe$var$getWindow(element);
    const html = $db68d79c4ce005fe$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = $db68d79c4ce005fe$var$isWebKit();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $db68d79c4ce005fe$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $db68d79c4ce005fe$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $db68d79c4ce005fe$var$isHTMLElement(element) ? $db68d79c4ce005fe$var$getScale(element) : $db68d79c4ce005fe$var$createCoords(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $db68d79c4ce005fe$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $db68d79c4ce005fe$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $db68d79c4ce005fe$var$getDocumentRect($db68d79c4ce005fe$var$getDocumentElement(element));
    else if ($db68d79c4ce005fe$var$isElement(clippingAncestor)) rect = $db68d79c4ce005fe$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $db68d79c4ce005fe$var$getVisualOffsets(element);
        rect = $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return $db68d79c4ce005fe$var$rectToClientRect(rect);
}
function $db68d79c4ce005fe$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = $db68d79c4ce005fe$var$getParentNode(element);
    if (parentNode === stopNode || !$db68d79c4ce005fe$var$isElement(parentNode) || $db68d79c4ce005fe$var$isLastTraversableNode(parentNode)) return false;
    return $db68d79c4ce005fe$var$getComputedStyle(parentNode).position === "fixed" || $db68d79c4ce005fe$var$hasFixedPositionAncestor(parentNode, stopNode);
}
function $db68d79c4ce005fe$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $db68d79c4ce005fe$var$getOverflowAncestors(element, [], false).filter((el)=>$db68d79c4ce005fe$var$isElement(el) && $db68d79c4ce005fe$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $db68d79c4ce005fe$var$getComputedStyle(element).position === "fixed";
    let currentNode = elementIsFixed ? $db68d79c4ce005fe$var$getParentNode(element) : element;
    while($db68d79c4ce005fe$var$isElement(currentNode) && !$db68d79c4ce005fe$var$isLastTraversableNode(currentNode)){
        const computedStyle = $db68d79c4ce005fe$var$getComputedStyle(currentNode);
        const currentNodeIsContaining = $db68d79c4ce005fe$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $db68d79c4ce005fe$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $db68d79c4ce005fe$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
        else currentContainingBlockComputedStyle = computedStyle;
        currentNode = $db68d79c4ce005fe$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
function $db68d79c4ce005fe$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $db68d79c4ce005fe$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $db68d79c4ce005fe$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $db68d79c4ce005fe$var$max(rect.top, accRect.top);
        accRect.right = $db68d79c4ce005fe$var$min(rect.right, accRect.right);
        accRect.bottom = $db68d79c4ce005fe$var$min(rect.bottom, accRect.bottom);
        accRect.left = $db68d79c4ce005fe$var$max(rect.left, accRect.left);
        return accRect;
    }, $db68d79c4ce005fe$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $db68d79c4ce005fe$var$getDimensions(element) {
    const { width: width, height: height } = $db68d79c4ce005fe$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $db68d79c4ce005fe$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $db68d79c4ce005fe$var$isHTMLElement(offsetParent);
    const documentElement = $db68d79c4ce005fe$var$getDocumentElement(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $db68d79c4ce005fe$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = $db68d79c4ce005fe$var$createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($db68d79c4ce005fe$var$getNodeName(offsetParent) !== "body" || $db68d79c4ce005fe$var$isOverflowElement(documentElement)) scroll = $db68d79c4ce005fe$var$getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $db68d79c4ce005fe$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $db68d79c4ce005fe$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $db68d79c4ce005fe$var$getTrueOffsetParent(element, polyfill) {
    if (!$db68d79c4ce005fe$var$isHTMLElement(element) || $db68d79c4ce005fe$var$getComputedStyle(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
function $db68d79c4ce005fe$var$getOffsetParent(element, polyfill) {
    const window2 = $db68d79c4ce005fe$var$getWindow(element);
    if (!$db68d79c4ce005fe$var$isHTMLElement(element) || $db68d79c4ce005fe$var$isTopLayer(element)) return window2;
    let offsetParent = $db68d79c4ce005fe$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $db68d79c4ce005fe$var$isTableElement(offsetParent) && $db68d79c4ce005fe$var$getComputedStyle(offsetParent).position === "static")offsetParent = $db68d79c4ce005fe$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ($db68d79c4ce005fe$var$getNodeName(offsetParent) === "html" || $db68d79c4ce005fe$var$getNodeName(offsetParent) === "body" && $db68d79c4ce005fe$var$getComputedStyle(offsetParent).position === "static" && !$db68d79c4ce005fe$var$isContainingBlock(offsetParent))) return window2;
    return offsetParent || $db68d79c4ce005fe$var$getContainingBlock(element) || window2;
}
const $db68d79c4ce005fe$var$getElementRects = function(data) {
    return $db68d79c4ce005fe$var$__async(this, null, function*() {
        const getOffsetParentFn = this.getOffsetParent || $db68d79c4ce005fe$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        return {
            reference: $db68d79c4ce005fe$var$getRectRelativeToOffsetParent(data.reference, (yield getOffsetParentFn(data.floating)), data.strategy),
            floating: $db68d79c4ce005fe$var$__spreadValues({
                x: 0,
                y: 0
            }, (yield getDimensionsFn(data.floating)))
        };
    });
};
function $db68d79c4ce005fe$var$isRTL(element) {
    return $db68d79c4ce005fe$var$getComputedStyle(element).direction === "rtl";
}
const $db68d79c4ce005fe$var$platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $db68d79c4ce005fe$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $db68d79c4ce005fe$var$getDocumentElement,
    getClippingRect: $db68d79c4ce005fe$var$getClippingRect,
    getOffsetParent: $db68d79c4ce005fe$var$getOffsetParent,
    getElementRects: $db68d79c4ce005fe$var$getElementRects,
    getClientRects: $db68d79c4ce005fe$var$getClientRects,
    getDimensions: $db68d79c4ce005fe$var$getDimensions,
    getScale: $db68d79c4ce005fe$var$getScale,
    isElement: $db68d79c4ce005fe$var$isElement,
    isRTL: $db68d79c4ce005fe$var$isRTL
};
function $db68d79c4ce005fe$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = $db68d79c4ce005fe$var$getDocumentElement(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = $db68d79c4ce005fe$var$floor(top);
        const insetRight = $db68d79c4ce005fe$var$floor(root.clientWidth - (left + width));
        const insetBottom = $db68d79c4ce005fe$var$floor(root.clientHeight - (top + height));
        const insetLeft = $db68d79c4ce005fe$var$floor(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: $db68d79c4ce005fe$var$max(0, $db68d79c4ce005fe$var$min(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        try {
            io = new IntersectionObserver(handleObserve, $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
function $db68d79c4ce005fe$var$autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $db68d79c4ce005fe$var$unwrapElement$2(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? $db68d79c4ce005fe$var$getOverflowAncestors(referenceEl) : [],
        ...$db68d79c4ce005fe$var$getOverflowAncestors(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $db68d79c4ce005fe$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $db68d79c4ce005fe$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $db68d79c4ce005fe$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
const $db68d79c4ce005fe$var$shift = $db68d79c4ce005fe$var$shift$1;
const $db68d79c4ce005fe$var$flip = $db68d79c4ce005fe$var$flip$1;
const $db68d79c4ce005fe$var$size = $db68d79c4ce005fe$var$size$1;
const $db68d79c4ce005fe$var$hide = $db68d79c4ce005fe$var$hide$1;
const $db68d79c4ce005fe$var$computePosition = (reference, floating, options)=>{
    const cache = /* @__PURE__ */ new Map();
    const mergedOptions = $db68d79c4ce005fe$var$__spreadValues({
        platform: $db68d79c4ce005fe$var$platform
    }, options);
    const platformWithCache = $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, mergedOptions.platform), {
        _c: cache
    });
    return $db68d79c4ce005fe$var$computePosition$1(reference, floating, $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, mergedOptions), {
        platform: platformWithCache
    }));
};
function $db68d79c4ce005fe$var$isComponentPublicInstance(target) {
    return target != null && typeof target === "object" && "$el" in target;
}
function $db68d79c4ce005fe$var$unwrapElement$1(target) {
    if ($db68d79c4ce005fe$var$isComponentPublicInstance(target)) {
        const element = target.$el;
        return $db68d79c4ce005fe$var$isNode(element) && $db68d79c4ce005fe$var$getNodeName(element) === "#comment" ? null : element;
    }
    return target;
}
function $db68d79c4ce005fe$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $db68d79c4ce005fe$var$roundByDPR(element, value) {
    const dpr = $db68d79c4ce005fe$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $db68d79c4ce005fe$var$useFloating(reference, floating, options) {
    if (options === void 0) options = {};
    const whileElementsMountedOption = options.whileElementsMounted;
    const openOption = (0, $01W3b.computed)(()=>{
        var _unref;
        return (_unref = (0, $01W3b.unref)(options.open)) != null ? _unref : true;
    });
    const middlewareOption = (0, $01W3b.computed)(()=>(0, $01W3b.unref)(options.middleware));
    const placementOption = (0, $01W3b.computed)(()=>{
        var _unref2;
        return (_unref2 = (0, $01W3b.unref)(options.placement)) != null ? _unref2 : "bottom";
    });
    const strategyOption = (0, $01W3b.computed)(()=>{
        var _unref3;
        return (_unref3 = (0, $01W3b.unref)(options.strategy)) != null ? _unref3 : "absolute";
    });
    const transformOption = (0, $01W3b.computed)(()=>{
        var _unref4;
        return (_unref4 = (0, $01W3b.unref)(options.transform)) != null ? _unref4 : true;
    });
    const referenceElement = (0, $01W3b.computed)(()=>$db68d79c4ce005fe$var$unwrapElement$1(reference.value));
    const floatingElement = (0, $01W3b.computed)(()=>$db68d79c4ce005fe$var$unwrapElement$1(floating.value));
    const x = (0, $01W3b.ref)(0);
    const y = (0, $01W3b.ref)(0);
    const strategy = (0, $01W3b.ref)(strategyOption.value);
    const placement = (0, $01W3b.ref)(placementOption.value);
    const middlewareData = (0, $01W3b.shallowRef)({});
    const isPositioned = (0, $01W3b.ref)(false);
    const floatingStyles = (0, $01W3b.computed)(()=>{
        const initialStyles = {
            position: strategy.value,
            left: "0",
            top: "0"
        };
        if (!floatingElement.value) return initialStyles;
        const xVal = $db68d79c4ce005fe$var$roundByDPR(floatingElement.value, x.value);
        const yVal = $db68d79c4ce005fe$var$roundByDPR(floatingElement.value, y.value);
        if (transformOption.value) return $db68d79c4ce005fe$var$__spreadValues($db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, initialStyles), {
            transform: "translate(" + xVal + "px, " + yVal + "px)"
        }), $db68d79c4ce005fe$var$getDPR(floatingElement.value) >= 1.5 && {
            willChange: "transform"
        });
        return {
            position: strategy.value,
            left: xVal + "px",
            top: yVal + "px"
        };
    });
    let whileElementsMountedCleanup;
    function update() {
        if (referenceElement.value == null || floatingElement.value == null) return;
        $db68d79c4ce005fe$var$computePosition(referenceElement.value, floatingElement.value, {
            middleware: middlewareOption.value,
            placement: placementOption.value,
            strategy: strategyOption.value
        }).then((position)=>{
            x.value = position.x;
            y.value = position.y;
            strategy.value = position.strategy;
            placement.value = position.placement;
            middlewareData.value = position.middlewareData;
            isPositioned.value = true;
        });
    }
    function cleanup() {
        if (typeof whileElementsMountedCleanup === "function") {
            whileElementsMountedCleanup();
            whileElementsMountedCleanup = void 0;
        }
    }
    function attach() {
        cleanup();
        if (whileElementsMountedOption === void 0) {
            update();
            return;
        }
        if (referenceElement.value != null && floatingElement.value != null) {
            whileElementsMountedCleanup = whileElementsMountedOption(referenceElement.value, floatingElement.value, update);
            return;
        }
    }
    function reset() {
        if (!openOption.value) isPositioned.value = false;
    }
    (0, $TusQn.watch)([
        middlewareOption,
        placementOption,
        strategyOption
    ], update, {
        flush: "sync"
    });
    (0, $TusQn.watch)([
        referenceElement,
        floatingElement
    ], attach, {
        flush: "sync"
    });
    (0, $TusQn.watch)(openOption, reset, {
        flush: "sync"
    });
    if ((0, $01W3b.getCurrentScope)()) (0, $01W3b.onScopeDispose)(cleanup);
    return {
        x: (0, $01W3b.shallowReadonly)(x),
        y: (0, $01W3b.shallowReadonly)(y),
        strategy: (0, $01W3b.shallowReadonly)(strategy),
        placement: (0, $01W3b.shallowReadonly)(placement),
        middlewareData: (0, $01W3b.shallowReadonly)(middlewareData),
        isPositioned: (0, $01W3b.shallowReadonly)(isPositioned),
        floatingStyles: floatingStyles,
        update: update
    };
}
function $db68d79c4ce005fe$var$unwrapElement(element) {
    return element && "$el" in element ? element.$el : element;
}
const $db68d79c4ce005fe$var$clipPadding = 16;
const $db68d79c4ce005fe$var$minClipHeight = 128;
function $db68d79c4ce005fe$export$ebb1680baab55ef5(referenceElement, menu, opt) {
    var _a;
    const menuIsExpanded = ()=>{
        var _a2;
        return (_a2 = menu.value) == null ? void 0 : _a2.isExpanded();
    };
    const middleware = [
        $db68d79c4ce005fe$var$offset(opt == null ? void 0 : opt.offset),
        $db68d79c4ce005fe$var$size({
            // Don't size the menu to take up exactly all of the available height, because that
            // makes it look like it's cut off. Instead, leave 16px of free space between the bottom
            // of the menu and the bottom edge of the viewport / scrollable container.
            padding: $db68d79c4ce005fe$var$clipPadding,
            apply ({ rects: rects, elements: elements, availableHeight: availableHeight, availableWidth: availableWidth }) {
                Object.assign(elements.floating.style, {
                    // Optionally use all available width
                    // Else, set the width of the menu to match the width of the triggering element.
                    // This is needed in Dialogs, when the menu's position is set relative to
                    // the dialog, not the triggering element.
                    width: "".concat((opt == null ? void 0 : opt.useAvailableWidth) ? availableWidth : rects.reference.width, "px"),
                    // Set the max-height to the available height, to prevent the menu from
                    // extending past the edge of the viewport or scrollable container. But don't
                    // allow the menu to be shrunk to less than 128px; this is necessary to make
                    // the flip() call below work.
                    maxHeight: "".concat(Math.max($db68d79c4ce005fe$var$minClipHeight, availableHeight), "px")
                });
            }
        }),
        // If there is not enough space to put the menu below the triggering element, put it above
        // it instead. Because of the maxHeight logic above, this happens when there is less than
        // 128px available below the triggering element.
        $db68d79c4ce005fe$var$flip({
            // Apply the same padding here as in size(), otherwise the gap between the bottom of
            // the menu and the bottom edge of the viewport is allowed to shrink to zero before the
            // menu flips.
            padding: $db68d79c4ce005fe$var$clipPadding
        }),
        // Hide the menu when it has escaped the reference element's clipping context (e.g. the menu
        // is opened down and you scroll up until the reference element just starts to leave the
        // container).
        $db68d79c4ce005fe$var$hide({
            strategy: "escaped"
        }),
        // Hide the menu when the reference element is fully hidden (e.g. the menu is opened down
        // and you scroll down until the whole reference element is gone).
        $db68d79c4ce005fe$var$hide()
    ];
    const { floatingStyles: floatingStyles, placement: placement, middlewareData: middlewareData, update: update } = $db68d79c4ce005fe$var$useFloating(referenceElement, menu, {
        middleware: middleware,
        placement: (_a = opt == null ? void 0 : opt.placement) != null ? _a : "bottom"
    });
    const menuVisibility = (0, $01W3b.computed)(()=>{
        var _a2, _b;
        const isHidden = !menuIsExpanded() || !!((_a2 = middlewareData.value.hide) == null ? void 0 : _a2.escaped) || ((_b = middlewareData.value.hide) == null ? void 0 : _b.referenceHidden);
        return isHidden ? "hidden" : "visible";
    });
    (0, $TusQn.watch)([
        floatingStyles,
        menuVisibility,
        placement
    ], ([newStyles, newVisibility, newPlacement])=>{
        var _a2, _b, _c, _d, _e;
        Object.assign((_b = (_a2 = menu.value) == null ? void 0 : _a2.$el.style) != null ? _b : {}, {
            visibility: newVisibility,
            position: newStyles.position,
            top: "".concat(newStyles.top, "px"),
            // `left: 0` is set in the Menu component, which gets transformed to `right: 0` for
            // RTL. For this component, we must unset `right: 0`, because the transform value
            // is relative to the left side of the screen regardless of reading direction.
            right: "unset",
            // Set `left` value to ensure the menu is translated relative to the left side of
            // the screen, which is what FloatingUI expects when it calculates the translate-x
            // value for both LTR and RTL.
            left: "".concat(newStyles.left, "px"),
            // If menuWidth is specified, transform shifts negative, for now ignore that
            transform: (_c = newStyles.transform) != null ? _c : "none",
            // Zero out border-radius on the corners of the menu where it touches the reference
            // element. Which corners these are depends on whether the menu is flipped
            borderTopLeftRadius: newPlacement === "bottom" && newVisibility === "visible" ? "0" : "",
            borderTopRightRadius: newPlacement === "bottom" && newVisibility === "visible" ? "0" : "",
            borderBottomLeftRadius: newPlacement === "top" && newVisibility === "visible" ? "0" : "",
            borderBottomRightRadius: newPlacement === "top" && newVisibility === "visible" ? "0" : ""
        });
        Object.assign((_e = (_d = $db68d79c4ce005fe$var$unwrapElement(referenceElement.value)) == null ? void 0 : _d.style) != null ? _e : {}, {
            // Zero out border-radius on the corners of the reference element where it touches
            // the menu. Which corners these are depends on whether the menu is flipped
            borderTopLeftRadius: newPlacement === "top" && newVisibility === "visible" ? "0" : "",
            borderTopRightRadius: newPlacement === "top" && newVisibility === "visible" ? "0" : "",
            borderBottomLeftRadius: newPlacement === "bottom" && newVisibility === "visible" ? "0" : "",
            borderBottomRightRadius: newPlacement === "bottom" && newVisibility === "visible" ? "0" : ""
        });
    });
    let cleanupAutoUpdate = null;
    (0, $TusQn.watch)(menuIsExpanded, (newExpanded)=>{
        var _a2;
        if (newExpanded) cleanupAutoUpdate = $db68d79c4ce005fe$var$autoUpdate(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        referenceElement.value && "$el" in referenceElement.value ? referenceElement.value.$el : referenceElement, // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        (_a2 = menu.value) == null ? void 0 : _a2.$el, update);
        else if (cleanupAutoUpdate) {
            cleanupAutoUpdate();
            cleanupAutoUpdate = null;
        }
    });
}
const $db68d79c4ce005fe$var$statusValidator$7 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$j = (0, $TusQn.defineComponent)({
    name: "CdxCombobox",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad,
        CdxTextInput: $db68d79c4ce005fe$export$edf7ede3ce8aed68
    },
    /**
   * Attributes applied to this component by a parent will be applied
   * to the TextInput child component rather than the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Menu items. See the MenuItemData type.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Value of the current selection.
     *
     * Must be bound with `v-model:selected`.
     */ selected: {
            type: [
                String,
                Number
            ],
            required: true
        },
        /**
     * Whether the dropdown is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * `status` property of the TextInput component
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$7
        }
    },
    emits: [
        /**
     * When the selected value changes.
     *
     * @property {string | number} selected The new selected value
     */ "update:selected",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more",
        /**
     * When the input value changes via direct use of the input
     *
     * @property {InputEvent} event
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur"
    ],
    setup (props, { emit: emit, attrs: attrs, slots: slots }) {
        const input = (0, $01W3b.ref)();
        const inputWrapper = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("combobox");
        const selectedProp = (0, $01W3b.toRef)(props, "selected");
        const modelWrapper = $db68d79c4ce005fe$export$c9be858be225e6de(selectedProp, emit, "update:selected");
        const expanded = (0, $01W3b.ref)(false);
        const expanderClicked = (0, $01W3b.ref)(false);
        const highlightedId = (0, $01W3b.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-combobox--expanded": expanded.value,
                "cdx-combobox--disabled": computedDisabled.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        function onInputFocus(event) {
            if (expanderClicked.value && expanded.value) expanded.value = false;
            else if (props.menuItems.length > 0 || slots["no-results"]) expanded.value = true;
            emit("focus", event);
        }
        function onInputBlur(event) {
            expanded.value = expanderClicked.value && expanded.value;
            emit("blur", event);
        }
        function onButtonMousedown() {
            if (computedDisabled.value) return;
            expanderClicked.value = true;
        }
        function onButtonClick() {
            var _a;
            if (computedDisabled.value) return;
            (_a = input.value) == null || _a.focus();
        }
        function onKeydown(e) {
            if (!menu.value || computedDisabled.value || props.menuItems.length === 0 || e.key === " ") return;
            menu.value.delegateKeyNavigation(e);
        }
        $db68d79c4ce005fe$export$ebb1680baab55ef5(input, menu);
        (0, $TusQn.watch)(expanded, ()=>{
            expanderClicked.value = false;
        });
        return {
            input: input,
            inputWrapper: inputWrapper,
            menu: menu,
            menuId: menuId,
            modelWrapper: modelWrapper,
            expanded: expanded,
            highlightedId: highlightedId,
            computedDisabled: computedDisabled,
            computedStatus: computedStatus,
            onInputFocus: onInputFocus,
            onInputBlur: onInputBlur,
            onKeydown: onKeydown,
            onButtonClick: onButtonClick,
            onButtonMousedown: onButtonMousedown,
            cdxIconExpand: $db68d79c4ce005fe$var$m4,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$h = {
    ref: "inputWrapper",
    class: "cdx-combobox__input-wrapper"
};
function $db68d79c4ce005fe$var$_sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_text_input = (0, $TusQn.resolveComponent)("cdx-text-input");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-combobox",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$h, [
            (0, $TusQn.createVNode)(_component_cdx_text_input, (0, $TusQn.mergeProps)({
                ref: "input",
                modelValue: _ctx.modelWrapper,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.modelWrapper = $event)
            }, _ctx.otherAttrs, {
                class: "cdx-combobox__input",
                "aria-activedescendant": _ctx.highlightedId,
                "aria-expanded": _ctx.expanded,
                "aria-controls": _ctx.menuId,
                disabled: _ctx.computedDisabled,
                status: _ctx.computedStatus,
                autocomplete: "off",
                role: "combobox",
                onKeydown: _ctx.onKeydown,
                onInput: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("input", $event)),
                onChange: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("change", $event)),
                onFocus: _ctx.onInputFocus,
                onBlur: _ctx.onInputBlur
            }), null, 16, [
                "modelValue",
                "aria-activedescendant",
                "aria-expanded",
                "aria-controls",
                "disabled",
                "status",
                "onKeydown",
                "onFocus",
                "onBlur"
            ]),
            (0, $TusQn.createVNode)(_component_cdx_button, {
                class: "cdx-combobox__expand-button",
                "aria-hidden": "true",
                disabled: _ctx.computedDisabled,
                tabindex: "-1",
                type: "button",
                onMousedown: _ctx.onButtonMousedown,
                onClick: _ctx.onButtonClick
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            class: "cdx-combobox__expand-icon",
                            icon: _ctx.cdxIconExpand
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "onMousedown",
                "onClick"
            ])
        ], 512),
        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
            id: _ctx.menuId,
            ref: "menu",
            selected: _ctx.modelWrapper,
            "onUpdate:selected": _cache[3] || (_cache[3] = ($event)=>_ctx.modelWrapper = $event),
            expanded: _ctx.expanded,
            "onUpdate:expanded": _cache[4] || (_cache[4] = ($event)=>_ctx.expanded = $event),
            "menu-items": _ctx.menuItems
        }, _ctx.menuConfig, {
            onLoadMore: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit("load-more"))
        }), {
            default: (0, $TusQn.withCtx)(({ menuItem: menuItem })=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "menu-item", {
                        menuItem: menuItem
                    })
                ]),
            "no-results": (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "no-results")
                ]),
            _: 3
        }, 16, [
            "id",
            "selected",
            "expanded",
            "menu-items"
        ])
    ], 6);
}
const $db68d79c4ce005fe$export$583459ee9b921b7f = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$j, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$j
    ]
]);
function $db68d79c4ce005fe$export$683480f191c0e3ea(templateRef) {
    const currentDimensions = (0, $01W3b.ref)({
        width: void 0,
        height: void 0
    });
    if (typeof window !== "object" || !("ResizeObserver" in window) || !("ResizeObserverEntry" in window)) return currentDimensions;
    const observer = new window.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry) currentDimensions.value = {
            width: entry.borderBoxSize[0].inlineSize,
            height: entry.borderBoxSize[0].blockSize
        };
    });
    let mounted = false;
    (0, $TusQn.onMounted)(()=>{
        mounted = true;
        if (templateRef.value) observer.observe(templateRef.value);
    });
    (0, $TusQn.onUnmounted)(()=>{
        mounted = false;
        observer.disconnect();
    });
    (0, $TusQn.watch)(templateRef, (newElement)=>{
        if (!mounted) return;
        observer.disconnect();
        currentDimensions.value = {
            width: void 0,
            height: void 0
        };
        if (newElement) observer.observe(newElement);
    });
    return currentDimensions;
}
const $db68d79c4ce005fe$var$_sfc_main$i = (0, $TusQn.defineComponent)({
    name: "CdxDialog",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    inheritAttrs: false,
    props: {
        /**
     * Whether the dialog is visible. Should be provided via a v-model:open
     * binding in the parent scope.
     */ open: {
            type: Boolean,
            default: false
        },
        /**
     * Title for the dialog header. Used for ARIA purposes even if no
     * visible header element is displayed.
     */ title: {
            type: String,
            required: true
        },
        /**
     * Optional subtitle for the dialog.
     */ subtitle: {
            type: String,
            required: false,
            default: null
        },
        /**
     * Whether the dialog header should hide the title & subtitle
     */ hideTitle: {
            type: Boolean,
            default: false
        },
        /**
     * Add an icon-only close button to the dialog header.
     */ useCloseButton: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: Set default to 'Close' (T368444)
        /**
     * Visually-hidden label text for the icon-only close button in the header.
     *
     * Omit this prop to use the default value, "Close".
     */ closeButtonLabel: {
            type: String,
            default: ""
        },
        /**
     * Primary user action. This will display a primary button with the specified action
     * (progressive or destructive).
     */ primaryAction: {
            type: Object,
            default: null
        },
        /**
     * Default user action. This will display a normal button.
     */ defaultAction: {
            type: Object,
            default: null
        },
        /**
     * Whether action buttons should be vertically stacked and 100% width.
     */ stackedActions: {
            type: Boolean,
            default: false
        },
        /**
     * Selector or DOM element identifying the container the dialog should
     * be rendered in. The dialog will be `<teleport>`ed to this element.
     * An ID selector is recommended, e.g. `#foo-bar`, but providing an
     * actual element is also supported.
     *
     * If this prop is not set, and the parent or one of its ancestors
     * provides a teleport target using `provide( 'CdxTeleportTarget',
     * '#foo-bar' )`, the provided target will be used. If there is no
     * provided target, the dialog will be teleported to the end of the
     * `<body>` element.
     */ target: {
            type: String,
            default: null
        },
        /**
     * Whether to disable the use of teleport and render the Dialog in its
     * original location in the document. If this is true, the `target` prop
     * is ignored.
     */ renderInPlace: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the open/close state changes, e.g. when the close button is clicked.
     *
     * @property {boolean} newValue The new open/close state (true for open, false for closed)
     */ "update:open",
        /**
     * When the primary action button is clicked.
     */ "primary",
        /**
     * When the default action button is clicked.
     */ "default"
    ],
    setup (props, { emit: emit }) {
        const labelId = $db68d79c4ce005fe$export$6217842283d27b52("dialog-label");
        const backdrop = (0, $01W3b.ref)();
        const dialogElement = (0, $01W3b.ref)();
        const dialogBody = (0, $01W3b.ref)();
        const focusHolder = (0, $01W3b.ref)();
        const focusTrapStart = (0, $01W3b.ref)();
        const focusTrapEnd = (0, $01W3b.ref)();
        let previouslyFocused = null;
        const useCloseButtonOrLabel = (0, $01W3b.computed)(()=>props.useCloseButton || props.closeButtonLabel.length > 0);
        const translatedCloseButtonLabel = $db68d79c4ce005fe$var$useI18nWithOverride((0, $01W3b.toRef)(props, "closeButtonLabel"), "cdx-dialog-close-button-label", "Close");
        const showHeader = (0, $01W3b.computed)(()=>!props.hideTitle || useCloseButtonOrLabel.value);
        const showFooterActions = (0, $01W3b.computed)(()=>!!props.primaryAction || !!props.defaultAction);
        const bodyDimensions = $db68d79c4ce005fe$export$683480f191c0e3ea(dialogBody);
        const currentBodyHeight = (0, $01W3b.computed)(()=>{
            var _a;
            return (_a = bodyDimensions.value.height) != null ? _a : 0;
        });
        const showDividers = (0, $01W3b.ref)(false);
        const rootClasses = (0, $01W3b.computed)(()=>({
                "cdx-dialog--vertical-actions": props.stackedActions,
                "cdx-dialog--horizontal-actions": !props.stackedActions,
                "cdx-dialog--dividers": showDividers.value
            }));
        const providedTarget = (0, $TusQn.inject)("CdxTeleportTarget", void 0);
        const computedTarget = (0, $01W3b.computed)(()=>{
            var _a, _b;
            return (_b = (_a = props.target) != null ? _a : providedTarget) != null ? _b : "body";
        });
        const scrollWidth = (0, $01W3b.ref)(0);
        function close() {
            emit("update:open", false);
        }
        function focusFirst() {
            focusFirstFocusableElement(dialogElement.value);
        }
        function focusLast() {
            focusFirstFocusableElement(dialogElement.value, true);
        }
        function focusFirstFocusableElement(container, backwards = false) {
            let candidates = Array.from(container.querySelectorAll('\n					input, select, textarea, button, object, a, area,\n					[contenteditable], [tabindex]:not([tabindex^="-"])\n				'));
            if (backwards) candidates = candidates.reverse();
            for (const candidate of candidates){
                candidate.focus();
                if (document.activeElement === candidate) return true;
            }
            return false;
        }
        let ariaHiddenElements = [];
        let inertElements = [];
        function setAriaHiddenAndInert() {
            let element = backdrop.value;
            while(element.parentElement && element.nodeName !== "BODY"){
                for (const sibling of Array.from(element.parentElement.children)){
                    if (sibling === element || sibling.nodeName === "SCRIPT") continue;
                    if (!sibling.hasAttribute("aria-hidden")) {
                        sibling.setAttribute("aria-hidden", "true");
                        ariaHiddenElements.push(sibling);
                    }
                    if (!sibling.hasAttribute("inert")) {
                        sibling.setAttribute("inert", "");
                        inertElements.push(sibling);
                    }
                }
                element = element.parentElement;
            }
        }
        function unsetAriaHiddenAndInert() {
            for (const element of ariaHiddenElements)element.removeAttribute("aria-hidden");
            for (const element of inertElements)element.removeAttribute("inert");
            ariaHiddenElements = [];
            inertElements = [];
        }
        function onDialogOpen() {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                var _a;
                yield (0, $TusQn.nextTick)();
                scrollWidth.value = window.innerWidth - document.documentElement.clientWidth;
                document.documentElement.style.setProperty("margin-right", "".concat(scrollWidth.value, "px"));
                document.body.classList.add("cdx-dialog-open");
                setAriaHiddenAndInert();
                previouslyFocused = document.activeElement;
                if (!focusFirstFocusableElement(dialogBody.value)) (_a = focusHolder.value) == null || _a.focus();
            });
        }
        function onDialogClose() {
            document.body.classList.remove("cdx-dialog-open");
            document.documentElement.style.removeProperty("margin-right");
            unsetAriaHiddenAndInert();
            if (previouslyFocused instanceof HTMLElement && document.contains(previouslyFocused)) {
                previouslyFocused.focus();
                previouslyFocused = null;
            }
        }
        (0, $TusQn.onMounted)(()=>{
            if (props.open) onDialogOpen();
        });
        (0, $TusQn.onUnmounted)(()=>{
            if (props.open) onDialogClose();
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "open"), (opened)=>{
            if (opened) onDialogOpen();
            else onDialogClose();
        });
        (0, $TusQn.watch)(currentBodyHeight, ()=>{
            if (dialogBody.value) showDividers.value = dialogBody.value.clientHeight < dialogBody.value.scrollHeight;
        });
        return {
            close: close,
            cdxIconClose: $db68d79c4ce005fe$var$X3,
            labelId: labelId,
            rootClasses: rootClasses,
            backdrop: backdrop,
            dialogElement: dialogElement,
            focusTrapStart: focusTrapStart,
            focusTrapEnd: focusTrapEnd,
            focusFirst: focusFirst,
            focusLast: focusLast,
            dialogBody: dialogBody,
            focusHolder: focusHolder,
            showHeader: showHeader,
            showFooterActions: showFooterActions,
            useCloseButtonOrLabel: useCloseButtonOrLabel,
            translatedCloseButtonLabel: translatedCloseButtonLabel,
            computedTarget: computedTarget
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$g = [
    "aria-label",
    "aria-labelledby"
];
const $db68d79c4ce005fe$var$_hoisted_2$a = {
    key: 0,
    class: "cdx-dialog__header__title-group"
};
const $db68d79c4ce005fe$var$_hoisted_3$6 = [
    "id"
];
const $db68d79c4ce005fe$var$_hoisted_4$4 = {
    key: 0,
    class: "cdx-dialog__header__subtitle"
};
const $db68d79c4ce005fe$var$_hoisted_5$4 = {
    ref: "focusHolder",
    class: "cdx-dialog-focus-trap",
    tabindex: "-1"
};
const $db68d79c4ce005fe$var$_hoisted_6$4 = {
    key: 0,
    class: "cdx-dialog__footer__text"
};
const $db68d79c4ce005fe$var$_hoisted_7$1 = {
    key: 1,
    class: "cdx-dialog__footer__actions"
};
function $db68d79c4ce005fe$var$_sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.Teleport), {
        to: _ctx.computedTarget,
        disabled: _ctx.renderInPlace
    }, [
        (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
            name: "cdx-dialog-fade",
            appear: ""
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    _ctx.open ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: 0,
                        ref: "backdrop",
                        class: "cdx-dialog-backdrop",
                        onClick: _cache[5] || (_cache[5] = (...args)=>_ctx.close && _ctx.close(...args)),
                        onKeyup: _cache[6] || (_cache[6] = (0, $eeJ70.withKeys)((...args)=>_ctx.close && _ctx.close(...args), [
                            "escape"
                        ]))
                    }, [
                        (0, $TusQn.createElementVNode)("div", {
                            ref: "focusTrapStart",
                            tabindex: "0",
                            onFocus: _cache[0] || (_cache[0] = (...args)=>_ctx.focusLast && _ctx.focusLast(...args))
                        }, null, 544),
                        (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                            ref: "dialogElement",
                            class: [
                                "cdx-dialog",
                                _ctx.rootClasses
                            ],
                            role: "dialog"
                        }, _ctx.$attrs, {
                            "aria-label": _ctx.$slots.header || _ctx.hideTitle ? _ctx.title : void 0,
                            "aria-labelledby": !_ctx.$slots.header && !_ctx.hideTitle ? _ctx.labelId : void 0,
                            "aria-modal": "true",
                            onClick: _cache[3] || (_cache[3] = (0, $eeJ70.withModifiers)(()=>{}, [
                                "stop"
                            ]))
                        }), [
                            _ctx.showHeader || _ctx.$slots.header ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("header", {
                                key: 0,
                                class: (0, $8XWQX.normalizeClass)([
                                    "cdx-dialog__header",
                                    {
                                        "cdx-dialog__header--default": !_ctx.$slots.header
                                    }
                                ])
                            }, [
                                (0, $TusQn.renderSlot)(_ctx.$slots, "header", {}, ()=>[
                                        !_ctx.hideTitle ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_2$a, [
                                            (0, $TusQn.createElementVNode)("h2", {
                                                id: _ctx.labelId,
                                                class: "cdx-dialog__header__title"
                                            }, (0, $8XWQX.toDisplayString)(_ctx.title), 9, $db68d79c4ce005fe$var$_hoisted_3$6),
                                            _ctx.subtitle ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $db68d79c4ce005fe$var$_hoisted_4$4, (0, $8XWQX.toDisplayString)(_ctx.subtitle), 1)) : (0, $TusQn.createCommentVNode)("v-if", true)
                                        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                        _ctx.useCloseButtonOrLabel ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                                            key: 1,
                                            class: "cdx-dialog__header__close-button",
                                            weight: "quiet",
                                            type: "button",
                                            "aria-label": _ctx.translatedCloseButtonLabel,
                                            onClick: _ctx.close
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_cdx_icon, {
                                                        icon: _ctx.cdxIconClose
                                                    }, null, 8, [
                                                        "icon"
                                                    ])
                                                ]),
                                            _: 1
                                        }, 8, [
                                            "aria-label",
                                            "onClick"
                                        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                                    ])
                            ], 2)) : (0, $TusQn.createCommentVNode)("v-if", true),
                            (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_5$4, null, 512),
                            (0, $TusQn.createElementVNode)("div", {
                                ref: "dialogBody",
                                class: (0, $8XWQX.normalizeClass)([
                                    "cdx-dialog__body",
                                    {
                                        "cdx-dialog__body--no-header": !(_ctx.showHeader || _ctx.$slots.header),
                                        "cdx-dialog__body--no-footer": !(_ctx.showFooterActions || _ctx.$slots.footer || _ctx.$slots["footer-text"])
                                    }
                                ])
                            }, [
                                (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                            ], 2),
                            _ctx.showFooterActions || _ctx.$slots.footer || _ctx.$slots["footer-text"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("footer", {
                                key: 1,
                                class: (0, $8XWQX.normalizeClass)([
                                    "cdx-dialog__footer",
                                    {
                                        "cdx-dialog__footer--default": !_ctx.$slots.footer
                                    }
                                ])
                            }, [
                                (0, $TusQn.renderSlot)(_ctx.$slots, "footer", {}, ()=>[
                                        _ctx.$slots["footer-text"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $db68d79c4ce005fe$var$_hoisted_6$4, [
                                            (0, $TusQn.renderSlot)(_ctx.$slots, "footer-text")
                                        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                        _ctx.showFooterActions ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_7$1, [
                                            _ctx.primaryAction ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                                                key: 0,
                                                class: "cdx-dialog__footer__primary-action",
                                                weight: "primary",
                                                action: _ctx.primaryAction.actionType,
                                                disabled: _ctx.primaryAction.disabled,
                                                onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("primary"))
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.primaryAction.label), 1)
                                                    ]),
                                                _: 1
                                            }, 8, [
                                                "action",
                                                "disabled"
                                            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                            _ctx.defaultAction ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                                                key: 1,
                                                class: "cdx-dialog__footer__default-action",
                                                disabled: _ctx.defaultAction.disabled,
                                                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("default"))
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.defaultAction.label), 1)
                                                    ]),
                                                _: 1
                                            }, 8, [
                                                "disabled"
                                            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                                        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                                    ])
                            ], 2)) : (0, $TusQn.createCommentVNode)("v-if", true)
                        ], 16, $db68d79c4ce005fe$var$_hoisted_1$g),
                        (0, $TusQn.createElementVNode)("div", {
                            ref: "focusTrapEnd",
                            tabindex: "0",
                            onFocus: _cache[4] || (_cache[4] = (...args)=>_ctx.focusFirst && _ctx.focusFirst(...args))
                        }, null, 544)
                    ], 544)) : (0, $TusQn.createCommentVNode)("v-if", true)
                ]),
            _: 3
        })
    ], 8, [
        "to",
        "disabled"
    ]);
}
const $db68d79c4ce005fe$export$47ed18c984f34b4c = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$i, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$i
    ]
]);
const $db68d79c4ce005fe$var$iconMap$2 = {
    notice: $db68d79c4ce005fe$var$Y4,
    error: $db68d79c4ce005fe$var$i4,
    warning: $db68d79c4ce005fe$var$M3,
    success: $db68d79c4ce005fe$var$O7
};
const $db68d79c4ce005fe$var$_sfc_main$h = (0, $TusQn.defineComponent)({
    name: "CdxMessage",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Status type of Message.
     *
     * @values 'notice', 'warning', 'error', 'success'
     */ type: {
            type: String,
            default: "notice",
            validator: $db68d79c4ce005fe$var$statusTypeValidator
        },
        /**
     * Whether this message follows the inline design (no padding, background color, or border).
     */ inline: {
            type: Boolean,
            default: false
        },
        /**
     * Custom message icon. Only allowed for notice messages.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: null
        },
        /**
     * Whether the message should fade in. Should be used for messages that are dynamically
     * displayed, not present on page load.
     */ fadeIn: {
            type: Boolean,
            default: false
        },
        /**
     * Allow the message to be dismissed by the user. Adds an icon-only dismiss button.
     */ allowUserDismiss: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to 'Close' (T368444).
        /**
     * Visually-hidden label text for the dismiss button for user-dismissable messages.
     *
     * Omit this prop to use the default value, "Close".
     */ dismissButtonLabel: {
            type: String,
            default: ""
        },
        /**
     * Enable automatic dismissal of message after a period of time.
     *
     * This prop can be set to `true` to use the default display time of 4000 milliseconds. To
     * customize the display time, set this prop to a number of milliseconds.
     *
     * Error messages cannot be automatically dismissed. If the `type` prop is set to `error`,
     * this prop will be ignored.
     *
     * TODO: consider adding a stricter validator to set limits on this. If the time is too
     * short, the message may not be readable. If the time is too long, the message probably
     * shouldn't be auto-dismissed.
     */ autoDismiss: {
            type: [
                Boolean,
                Number
            ],
            default: false,
            validator: (value)=>typeof value === "boolean" || typeof value === "number" && value > 0
        }
    },
    emits: [
        /**
     * Emitted when the message is dismissed by the user via the dismiss button.
     */ "user-dismissed",
        /**
     * Emitted when the message is automatically dismissed after the display time.
     */ "auto-dismissed"
    ],
    setup (props, { emit: emit }) {
        const dismissed = (0, $01W3b.ref)(false);
        const userDismissable = (0, $01W3b.computed)(()=>props.inline === false && // DEPRECATED: require use of new prop allowUserDismiss (T368444).
            (props.dismissButtonLabel.length > 0 || props.allowUserDismiss));
        const translatedDismissButtonLabel = $db68d79c4ce005fe$var$useI18nWithOverride((0, $01W3b.toRef)(props, "dismissButtonLabel"), "cdx-message-dismiss-button-label", "Close");
        const displayTime = (0, $01W3b.computed)(()=>{
            if (props.autoDismiss === false || props.type === "error") return false;
            else if (props.autoDismiss === true) return 4e3;
            return props.autoDismiss;
        });
        const rootClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-message--inline": props.inline,
                "cdx-message--block": !props.inline,
                "cdx-message--user-dismissable": userDismissable.value,
                ["cdx-message--".concat(props.type)]: true
            };
        });
        const computedIcon = (0, $01W3b.computed)(()=>props.icon && props.type === "notice" ? props.icon : $db68d79c4ce005fe$var$iconMap$2[props.type]);
        const leaveActiveClass = (0, $01W3b.ref)("");
        function onDismiss(eventName) {
            if (dismissed.value) return;
            leaveActiveClass.value = eventName === "user-dismissed" ? "cdx-message-leave-active-user" : "cdx-message-leave-active-system";
            dismissed.value = true;
            emit(eventName);
        }
        (0, $TusQn.onMounted)(()=>{
            if (props.type === "error" && props.autoDismiss !== false) (0, $TusQn.warn)('CdxMessage: Message with type="error" cannot use auto-dismiss');
            else if (displayTime.value) setTimeout(()=>onDismiss("auto-dismissed"), displayTime.value);
        });
        return {
            dismissed: dismissed,
            userDismissable: userDismissable,
            translatedDismissButtonLabel: translatedDismissButtonLabel,
            rootClasses: rootClasses,
            leaveActiveClass: leaveActiveClass,
            computedIcon: computedIcon,
            onDismiss: onDismiss,
            cdxIconClose: $db68d79c4ce005fe$var$X3
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$f = [
    "aria-live",
    "role"
];
const $db68d79c4ce005fe$var$_hoisted_2$9 = {
    class: "cdx-message__content"
};
function $db68d79c4ce005fe$var$_sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "cdx-message",
        appear: _ctx.fadeIn,
        "leave-active-class": _ctx.leaveActiveClass
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                !_ctx.dismissed ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: 0,
                    class: (0, $8XWQX.normalizeClass)([
                        "cdx-message",
                        _ctx.rootClasses
                    ]),
                    "aria-live": _ctx.type !== "error" ? "polite" : void 0,
                    role: _ctx.type === "error" ? "alert" : void 0
                }, [
                    (0, $TusQn.createVNode)(_component_cdx_icon, {
                        class: "cdx-message__icon--vue",
                        icon: _ctx.computedIcon
                    }, null, 8, [
                        "icon"
                    ]),
                    (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_2$9, [
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                    ]),
                    _ctx.userDismissable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                        key: 0,
                        class: "cdx-message__dismiss-button",
                        weight: "quiet",
                        type: "button",
                        "aria-label": _ctx.translatedDismissButtonLabel,
                        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.onDismiss("user-dismissed"))
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_cdx_icon, {
                                    icon: _ctx.cdxIconClose
                                }, null, 8, [
                                    "icon"
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "aria-label"
                    ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                ], 10, $db68d79c4ce005fe$var$_hoisted_1$f)) : (0, $TusQn.createCommentVNode)("v-if", true)
            ]),
        _: 3
    }, 8, [
        "appear",
        "leave-active-class"
    ]);
}
const $db68d79c4ce005fe$export$cebd7a56cc7f747 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$h, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$h
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$6 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$g = (0, $TusQn.defineComponent)({
    name: "CdxField",
    components: {
        CdxLabel: $db68d79c4ce005fe$export$fd351ab562a06a13,
        CdxMessage: $db68d79c4ce005fe$export$cebd7a56cc7f747
    },
    props: {
        /**
     * Icon before the label text.
     *
     * Do not use this if including a start icon within the input component.
     */ labelIcon: {
            type: [
                String,
                Object
            ],
            default: ""
        },
        /**
     * Whether the field is optional.
     *
     * This will add a flag next to the label indicating that the field is optional.
     */ optional: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to '(optional)' (T368444).
        /**
     * Text to indicate that the field is optional.
     *
     * Omit this prop to use the default value, "(optional)".
     */ optionalFlag: {
            type: String,
            default: ""
        },
        /**
     * Whether the label should be visually hidden.
     *
     * Note that this will also hide the description.
     */ hideLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this field contains a group of inputs.
     *
     * When true, this outputs a `<fieldset>` element with a semantic `<legend>`. When false,
     * it outputs a `<div>` with a semantic `<label>`.
     */ isFieldset: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the entire field is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * `status` attribute of the input. This also determines which validation message is shown.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$6
        },
        /**
     * Message text keyed on validation status type.
     * @default {}
     */ messages: {
            type: Object,
            default: ()=>{
                return {};
            }
        }
    },
    setup (props, { slots: slots }) {
        const { disabled: disabled, status: status, isFieldset: isFieldset } = (0, $01W3b.toRefs)(props);
        const computedDisabled = $db68d79c4ce005fe$export$231a0ffa6150ca75(disabled);
        const rootClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-field--disabled": computedDisabled.value,
                "cdx-field--is-fieldset": isFieldset.value
            };
        });
        const labelId = $db68d79c4ce005fe$export$6217842283d27b52("label");
        const descriptionId = $db68d79c4ce005fe$export$6217842283d27b52("description");
        const inputId = $db68d79c4ce005fe$export$6217842283d27b52("input");
        const computedInputId = (0, $01W3b.computed)(()=>!isFieldset.value ? inputId : void 0);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$FieldInputIdKey, computedInputId);
        const computedDescriptionId = (0, $01W3b.computed)(()=>!isFieldset.value && slots.description ? descriptionId : void 0);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$FieldDescriptionIdKey, computedDescriptionId);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$DisabledKey, computedDisabled);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$FieldStatusKey, status);
        const validationMessage = (0, $01W3b.computed)(()=>props.status !== "default" && props.status in props.messages ? props.messages[props.status] : "");
        const validationMessageType = (0, $01W3b.computed)(()=>props.status === "default" ? "notice" : props.status);
        return {
            rootClasses: rootClasses,
            computedDisabled: computedDisabled,
            labelId: labelId,
            descriptionId: descriptionId,
            inputId: inputId,
            validationMessage: validationMessage,
            validationMessageType: validationMessageType
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$e = {
    class: "cdx-field__control"
};
const $db68d79c4ce005fe$var$_hoisted_2$8 = {
    class: "cdx-field__help-text"
};
const $db68d79c4ce005fe$var$_hoisted_3$5 = {
    key: 0,
    class: "cdx-field__validation-message"
};
function $db68d79c4ce005fe$var$_sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_label = (0, $TusQn.resolveComponent)("cdx-label");
    const _component_cdx_message = (0, $TusQn.resolveComponent)("cdx-message");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.isFieldset ? "fieldset" : "div"), {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-field",
            _ctx.rootClasses
        ]),
        "aria-disabled": !_ctx.isFieldset && _ctx.computedDisabled ? true : void 0,
        disabled: _ctx.isFieldset && _ctx.computedDisabled ? true : void 0
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)(_component_cdx_label, {
                    id: _ctx.labelId,
                    icon: _ctx.labelIcon,
                    "visually-hidden": _ctx.hideLabel,
                    optional: _ctx.optional,
                    "optional-flag": _ctx.optionalFlag,
                    "input-id": _ctx.inputId,
                    "description-id": _ctx.descriptionId,
                    disabled: _ctx.computedDisabled,
                    "is-legend": _ctx.isFieldset
                }, (0, $TusQn.createSlots)({
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.renderSlot)(_ctx.$slots, "label")
                        ]),
                    _: 2
                }, [
                    _ctx.$slots.description && _ctx.$slots.description().length > 0 ? {
                        name: "description",
                        fn: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                            ]),
                        key: "0"
                    } : void 0
                ]), 1032, [
                    "id",
                    "icon",
                    "visually-hidden",
                    "optional",
                    "optional-flag",
                    "input-id",
                    "description-id",
                    "disabled",
                    "is-legend"
                ]),
                (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$e, [
                    (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                ]),
                (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_2$8, [
                    (0, $TusQn.renderSlot)(_ctx.$slots, "help-text")
                ]),
                !_ctx.computedDisabled && _ctx.validationMessage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_3$5, [
                    (0, $TusQn.createVNode)(_component_cdx_message, {
                        type: _ctx.validationMessageType,
                        inline: true
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.validationMessage), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "type"
                    ])
                ])) : (0, $TusQn.createCommentVNode)("v-if", true)
            ]),
        _: 3
    }, 8, [
        "class",
        "aria-disabled",
        "disabled"
    ]);
}
const $db68d79c4ce005fe$export$efade408a7e046bf = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$g, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$g
    ]
]);
const $db68d79c4ce005fe$var$iconMap$1 = {
    error: $db68d79c4ce005fe$var$i4,
    warning: $db68d79c4ce005fe$var$M3,
    success: $db68d79c4ce005fe$var$O7
};
const $db68d79c4ce005fe$var$_sfc_main$f = (0, $TusQn.defineComponent)({
    name: "CdxInfoChip",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Status type.
     *
     * @values 'notice', 'warning', 'error', 'success'
     */ status: {
            type: String,
            default: "notice",
            validator: $db68d79c4ce005fe$var$statusTypeValidator
        },
        /**
     * Custom icon to use for "notice" chips. Chips with other status types
     * (warning, etc) do not allow custom icons and will ignore this option.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: null
        }
    },
    setup (props) {
        const iconClass = (0, $01W3b.computed)(()=>{
            return {
                ["cdx-info-chip__icon--".concat(props.status)]: true
            };
        });
        const computedIcon = (0, $01W3b.computed)(()=>props.status === "notice" ? props.icon : $db68d79c4ce005fe$var$iconMap$1[props.status]);
        return {
            iconClass: iconClass,
            computedIcon: computedIcon
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$d = {
    class: "cdx-info-chip"
};
const $db68d79c4ce005fe$var$_hoisted_2$7 = {
    class: "cdx-info-chip--text"
};
function $db68d79c4ce005fe$var$_sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$d, [
        _ctx.computedIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 0,
            class: (0, $8XWQX.normalizeClass)([
                "cdx-info-chip__icon",
                _ctx.iconClass
            ]),
            icon: _ctx.computedIcon
        }, null, 8, [
            "class",
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$7, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ])
    ]);
}
const $db68d79c4ce005fe$export$488fdba6da31f9c3 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$f, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$f
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$5 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$e = (0, $TusQn.defineComponent)({
    name: "CdxLookup",
    components: {
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad,
        CdxTextInput: $db68d79c4ce005fe$export$edf7ede3ce8aed68
    },
    /**
   * We want the input to inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Value of the current selection.
     *
     * Must be bound with `v-model:selected`.
     *
     * The property should be initialized to `null` rather than using a falsy value.
     */ selected: {
            type: [
                String,
                Number,
                null
            ],
            required: true
        },
        /**
     * Menu items.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Current value of the input. This prop is optional and should only be used if you need to
     * keep track of the input value for some reason (e.g. to set an initial value).
     *
     * Optionally provided by `v-model:input-value` binding in the parent component.
     */ inputValue: {
            type: [
                String,
                Number
            ],
            default: null
        },
        // DEPRECATED: Remove (T373532).
        /**
     * Initial value of the text input. Non-reactive.
     *
     * @deprecated Use `inputValue` instead.
     */ initialInputValue: {
            type: [
                String,
                Number
            ],
            default: "",
            validator: (value)=>{
                if (value) console.warn("CdxLookup: prop initialInputValue is deprecated. Use inputValue instead.");
                return true;
            }
        },
        /**
     * Whether the entire component is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * `status` property of the TextInput component
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$5
        }
    },
    emits: [
        /**
     * When the selected value changes.
     *
     * @property {string | number | null} selected The new selected value
     */ "update:selected",
        /**
     * When the input value changes. Only emitted if the inputValue prop is provided.
     *
     * @property {string | number} inputValue The new input value
     */ "update:input-value",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more",
        /**
     * When the text input value changes.
     *
     * @property {string | number} value The new value
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur"
    ],
    setup: (props, { emit: emit, attrs: attrs, slots: slots })=>{
        const rootElement = (0, $01W3b.ref)();
        const textInput = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("lookup-menu");
        const pending = (0, $01W3b.ref)(false);
        const expanded = (0, $01W3b.ref)(false);
        const isActive = (0, $01W3b.ref)(false);
        const initialMenuItems = (0, $01W3b.ref)(props.menuItems);
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const selectedProp = (0, $01W3b.toRef)(props, "selected");
        const modelWrapper = $db68d79c4ce005fe$export$c9be858be225e6de(selectedProp, emit, "update:selected");
        const selectedMenuItem = (0, $01W3b.computed)(()=>props.menuItems.find((item)=>item.value === props.selected));
        const highlightedId = (0, $01W3b.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        const internalInputValue = (0, $01W3b.ref)(props.initialInputValue);
        const computedInputValue = $db68d79c4ce005fe$var$useOptionalModelWrapper(internalInputValue, (0, $01W3b.toRef)(props, "inputValue"), emit, "update:input-value");
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-lookup--disabled": computedDisabled.value,
                "cdx-lookup--pending": pending.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        function onUpdateInput(newVal) {
            if (selectedMenuItem.value) {
                if (selectedMenuItem.value.label !== newVal && selectedMenuItem.value.value !== newVal) modelWrapper.value = null;
            } else if (props.selected !== null && props.selected !== newVal) modelWrapper.value = null;
            if (newVal === "" && initialMenuItems.value.length === 0) {
                expanded.value = false;
                pending.value = false;
            } else pending.value = true;
            emit("input", newVal);
        }
        function onInputFocus(event) {
            isActive.value = true;
            const hasInput = computedInputValue.value !== null && computedInputValue.value !== "";
            const hasMenuItems = !!(props.menuItems.length > 0 || slots["no-results"]);
            if (hasMenuItems && (hasInput || initialMenuItems.value.length > 0)) expanded.value = true;
            emit("focus", event);
        }
        function onInputBlur(event) {
            isActive.value = false;
            expanded.value = false;
            emit("blur", event);
        }
        function onKeydown(e) {
            if (!menu.value || computedDisabled.value || props.menuItems.length === 0 && !slots["no-results"] || e.key === " ") return;
            menu.value.delegateKeyNavigation(e);
        }
        $db68d79c4ce005fe$export$ebb1680baab55ef5(textInput, menu);
        (0, $TusQn.watch)(selectedProp, (newVal)=>{
            var _a;
            if (newVal !== null) {
                const selectedValue = selectedMenuItem.value ? (_a = selectedMenuItem.value.label) != null ? _a : selectedMenuItem.value.value : "";
                if (computedInputValue.value !== selectedValue) {
                    computedInputValue.value = selectedValue;
                    emit("input", computedInputValue.value);
                }
            }
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "menuItems"), (newVal)=>{
            if (// Only show the menu if we were in the pending state (meaning this menuItems change
            // was in response to user input) and the menu is still focused
            isActive.value && pending.value && // Show the menu if there are either menu items or no-results content to show
            (newVal.length > 0 || slots["no-results"])) expanded.value = true;
            if (newVal.length === 0 && !slots["no-results"]) expanded.value = false;
            pending.value = false;
        });
        return {
            rootElement: rootElement,
            textInput: textInput,
            menu: menu,
            menuId: menuId,
            highlightedId: highlightedId,
            computedInputValue: computedInputValue,
            modelWrapper: modelWrapper,
            expanded: expanded,
            computedDisabled: computedDisabled,
            computedStatus: computedStatus,
            onInputBlur: onInputBlur,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            onUpdateInput: onUpdateInput,
            onInputFocus: onInputFocus,
            onKeydown: onKeydown
        };
    }
});
function $db68d79c4ce005fe$var$_sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_text_input = (0, $TusQn.resolveComponent)("cdx-text-input");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-lookup",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createVNode)(_component_cdx_text_input, (0, $TusQn.mergeProps)({
            ref: "textInput",
            modelValue: _ctx.computedInputValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedInputValue = $event)
        }, _ctx.otherAttrs, {
            class: "cdx-lookup__input",
            role: "combobox",
            autocomplete: "off",
            "aria-autocomplete": "list",
            "aria-controls": _ctx.menuId,
            "aria-expanded": _ctx.expanded,
            "aria-activedescendant": _ctx.highlightedId,
            disabled: _ctx.computedDisabled,
            status: _ctx.computedStatus,
            "onUpdate:modelValue": _ctx.onUpdateInput,
            onChange: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("change", $event)),
            onFocus: _ctx.onInputFocus,
            onBlur: _ctx.onInputBlur,
            onKeydown: _ctx.onKeydown
        }), null, 16, [
            "modelValue",
            "aria-controls",
            "aria-expanded",
            "aria-activedescendant",
            "disabled",
            "status",
            "onUpdate:modelValue",
            "onFocus",
            "onBlur",
            "onKeydown"
        ]),
        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
            id: _ctx.menuId,
            ref: "menu",
            selected: _ctx.modelWrapper,
            "onUpdate:selected": _cache[2] || (_cache[2] = ($event)=>_ctx.modelWrapper = $event),
            expanded: _ctx.expanded,
            "onUpdate:expanded": _cache[3] || (_cache[3] = ($event)=>_ctx.expanded = $event),
            "menu-items": _ctx.menuItems
        }, _ctx.menuConfig, {
            onLoadMore: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("load-more"))
        }), {
            default: (0, $TusQn.withCtx)(({ menuItem: menuItem })=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "menu-item", {
                        menuItem: menuItem
                    })
                ]),
            "no-results": (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "no-results")
                ]),
            _: 3
        }, 16, [
            "id",
            "selected",
            "expanded",
            "menu-items"
        ])
    ], 6);
}
const $db68d79c4ce005fe$export$7e170b6706eda8a5 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$e, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$e
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$d = (0, $TusQn.defineComponent)({
    name: "CdxToggleButton",
    props: {
        /**
     * Whether the button should be set to "on" (true) or "off" (false).
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the disabled attribute should be added to the button, which prevents
     * it from being clicked.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the toggle button should be "quiet", which renders more minimally.
     */ quiet: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes (i.e. when the state is toggled)
     *
     * @property {boolean} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        const isIconOnly = $db68d79c4ce005fe$var$useIconOnlyButton(slots.default, attrs, "CdxToggleButton");
        const isActive = (0, $01W3b.ref)(false);
        const rootClasses = (0, $01W3b.computed)(()=>({
                // Quiet means frameless among other things
                "cdx-toggle-button--quiet": props.quiet,
                "cdx-toggle-button--framed": !props.quiet,
                // Provide --toggled-off too so that we can simplify selectors
                "cdx-toggle-button--toggled-on": props.modelValue,
                "cdx-toggle-button--toggled-off": !props.modelValue,
                "cdx-toggle-button--icon-only": isIconOnly.value,
                "cdx-toggle-button--is-active": isActive.value
            }));
        const onClick = ()=>{
            emit("update:modelValue", !props.modelValue);
        };
        const setActive = (active)=>{
            isActive.value = active;
        };
        function onKeyDown() {
            setActive(true);
        }
        function onKeyUp() {
            setActive(false);
            onClick();
        }
        return {
            rootClasses: rootClasses,
            onClick: onClick,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$c = [
    "aria-pressed",
    "disabled"
];
function $db68d79c4ce005fe$var$_sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-toggle-button",
            _ctx.rootClasses
        ]),
        "aria-pressed": _ctx.modelValue,
        disabled: _ctx.disabled,
        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.onClick && _ctx.onClick(...args)),
        onKeydown: _cache[1] || (_cache[1] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onKeyDown && _ctx.onKeyDown(...args), [
            "prevent"
        ]), [
            "space",
            "enter"
        ])),
        onKeyup: _cache[2] || (_cache[2] = (0, $eeJ70.withKeys)((...args)=>_ctx.onKeyUp && _ctx.onKeyUp(...args), [
            "space",
            "enter"
        ]))
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ], 42, $db68d79c4ce005fe$var$_hoisted_1$c);
}
const $db68d79c4ce005fe$export$e302ca96e16828af = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$d, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$d
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$c = (0, $TusQn.defineComponent)({
    name: "CdxMenuButton",
    components: {
        CdxToggleButton: $db68d79c4ce005fe$export$e302ca96e16828af,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad
    },
    inheritAttrs: false,
    props: {
        /**
     * Value of the current selection.
     *
     * Must be bound with `v-model:selected`.
     */ selected: {
            type: [
                String,
                Number,
                null
            ],
            required: true
        },
        /**
     * Menu items. See the MenuItemData type.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * Whether the dropdown is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the selected value changes.
     *
     * @property {string | number} selected The new selected value
     */ "update:selected"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const menu = (0, $01W3b.ref)();
        const toggle = (0, $01W3b.ref)();
        const selectedProp = (0, $01W3b.toRef)(props, "selected");
        const modelWrapper = $db68d79c4ce005fe$export$c9be858be225e6de(selectedProp, emit, "update:selected");
        const expanded = (0, $01W3b.ref)(false);
        const toggleId = $db68d79c4ce005fe$export$6217842283d27b52("menuToggle");
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("menu");
        const { computedDisabled: computedDisabled } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"));
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs);
        function onKeydown(e) {
            if (!menu.value || computedDisabled.value || props.menuItems.length === 0 || e.key === " ") return;
            menu.value.delegateKeyNavigation(e);
        }
        $db68d79c4ce005fe$export$ebb1680baab55ef5(toggle, menu, {
            useAvailableWidth: true,
            placement: "bottom-start",
            offset: 4
        });
        return {
            computedDisabled: computedDisabled,
            expanded: expanded,
            menu: menu,
            menuId: menuId,
            modelWrapper: modelWrapper,
            onKeydown: onKeydown,
            toggle: toggle,
            toggleId: toggleId,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$b = {
    class: "cdx-menu-button__menu-wrapper"
};
function $db68d79c4ce005fe$var$_sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_toggle_button = (0, $TusQn.resolveComponent)("cdx-toggle-button");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-menu-button",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createVNode)(_component_cdx_toggle_button, (0, $TusQn.mergeProps)({
            id: _ctx.toggleId,
            ref: "toggle"
        }, _ctx.otherAttrs, {
            modelValue: _ctx.expanded,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.expanded = $event),
            disabled: _ctx.computedDisabled,
            quiet: "",
            "aria-haspopup": "menu",
            "aria-controls": _ctx.menuId,
            "aria-expanded": _ctx.expanded,
            onBlur: _cache[1] || (_cache[1] = ($event)=>_ctx.expanded = false),
            onKeydown: _ctx.onKeydown
        }), {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                ]),
            _: 3
        }, 16, [
            "id",
            "modelValue",
            "disabled",
            "aria-controls",
            "aria-expanded",
            "onKeydown"
        ]),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$b, [
            (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
                id: _ctx.menuId,
                ref: "menu",
                selected: _ctx.modelWrapper,
                "onUpdate:selected": _cache[2] || (_cache[2] = ($event)=>_ctx.modelWrapper = $event),
                expanded: _ctx.expanded,
                "onUpdate:expanded": _cache[3] || (_cache[3] = ($event)=>_ctx.expanded = $event),
                "menu-items": _ctx.menuItems
            }, _ctx.menuConfig, {
                role: "menu",
                "aria-labelledby": _ctx.toggleId
            }), null, 16, [
                "id",
                "selected",
                "expanded",
                "menu-items",
                "aria-labelledby"
            ])
        ])
    ], 6);
}
const $db68d79c4ce005fe$export$89add103f07d42fd = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$c, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$c
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$4 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$b = (0, $TusQn.defineComponent)({
    name: "CdxMultiselectLookup",
    components: {
        CdxChipInput: $db68d79c4ce005fe$export$942cd80f467f680f,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad
    },
    props: {
        /**
     * Current chips present in the input.
     *
     * Must be bound with `v-model:input-chips`. Initialize to an empty array if there are no
     * initial selections. If there are, initialize to an array of input chips matching those
     * selections.
     */ inputChips: {
            type: Array,
            required: true
        },
        /**
     * Value(s) of the current selection(s).
     *
     * Must be bound with `v-model:selected`. Initialize to an empty array if there are no
     * initial selections.
     */ selected: {
            type: [
                Array
            ],
            required: true
        },
        /**
     * Menu items.
     *
     * Initialize to an empty array if there are no initial menu items.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Current value of the text input. This prop is optional and should only be used if you
     * need to keep track of the text input value for some reason (e.g. for validation).
     *
     * Optionally provided by `v-model:input-value` binding in the parent component.
     */ inputValue: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /**
     * Whether the text input should appear below the set of input chips.
     *
     * By default, the input chips are inline with the input.
     */ separateInput: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the entire component is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * `status` attribute of the input.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$4
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        }
    },
    emits: [
        /**
     * When the input chips change.
     *
     * @property {ChipInputItem[]} inputChips The new set of inputChips
     */ "update:input-chips",
        /**
     * When the selected value changes.
     *
     * @property {MenuItemValue[]} selected The new set of selected values
     */ "update:selected",
        /**
     * When the input value changes. Only emitted if the inputValue prop is provided.
     *
     * This event is emitted both when the user changes the input and when the input is changed
     * or cleared automatically (e.g. on selection).
     *
     * @property {string | number} inputValue The new input value
     */ "update:input-value",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more",
        /**
     * When the user changes the value of the input. Not emitted when the input is changed
     * automatically (e.g. on selection).
     *
     * @property {string | number} value The new value
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur"
    ],
    setup: (props, { emit: emit, attrs: attrs, slots: slots })=>{
        const chipInput = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("multiselect-lookup-menu");
        const highlightedId = (0, $01W3b.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        const pending = (0, $01W3b.ref)(false);
        const expanded = (0, $01W3b.ref)(false);
        const isActive = (0, $01W3b.ref)(false);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$AllowArbitraryKey, (0, $01W3b.ref)(false));
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-multiselect-lookup--disabled": computedDisabled.value,
                "cdx-multiselect-lookup--pending": pending.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        $db68d79c4ce005fe$export$ebb1680baab55ef5(chipInput, menu);
        const selectedWrapper = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "selected"), emit, "update:selected");
        const inputChipsWrapper = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "inputChips"), emit, "update:input-chips");
        const internalInputValue = (0, $01W3b.ref)("");
        const computedInputValue = $db68d79c4ce005fe$var$useOptionalModelWrapper(internalInputValue, (0, $01W3b.toRef)(props, "inputValue"), emit, "update:input-value");
        const showNoResults = (0, $01W3b.computed)(()=>computedInputValue.value.toString().length > 0 && slots["no-results"]);
        function onUpdateInputValue(newVal) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                yield (0, $TusQn.nextTick)();
                pending.value = newVal !== null && newVal !== "";
                emit("input", newVal);
            });
        }
        function onInputFocus(event) {
            isActive.value = true;
            if (props.menuItems.length > 0 || showNoResults.value) expanded.value = true;
            emit("focus", event);
        }
        function onInputBlur(event) {
            isActive.value = false;
            expanded.value = false;
            emit("blur", event);
        }
        function onKeydown(e) {
            if (!menu.value || computedDisabled.value || props.menuItems.length === 0 && !showNoResults.value || e.key === " ") return;
            menu.value.delegateKeyNavigation(e);
        }
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "selected"), (newVal)=>{
            const newSelections = newVal.filter((selection)=>inputChipsWrapper.value.find((chip)=>selection === chip.value) === void 0);
            if (newSelections.length > 0) {
                newSelections.forEach((newSelection)=>{
                    const newMenuItem = props.menuItems.find((menuItem)=>menuItem.value === newSelection);
                    if (newMenuItem) inputChipsWrapper.value.push(newMenuItem);
                });
                computedInputValue.value = "";
                emit("input", "");
            }
            inputChipsWrapper.value = inputChipsWrapper.value.filter((chip)=>{
                return newVal.find((selection)=>chip.value === selection) !== void 0;
            });
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "inputChips"), (newVal)=>{
            if (newVal.length < selectedWrapper.value.length) selectedWrapper.value = newVal.map((chip)=>chip.value);
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "menuItems"), (newVal)=>{
            if (newVal.length === 0 && !showNoResults.value) expanded.value = false;
            else if (isActive.value && pending.value) expanded.value = true;
            pending.value = false;
        });
        return {
            chipInput: chipInput,
            menu: menu,
            menuId: menuId,
            highlightedId: highlightedId,
            expanded: expanded,
            computedDisabled: computedDisabled,
            computedStatus: computedStatus,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            selectedWrapper: selectedWrapper,
            inputChipsWrapper: inputChipsWrapper,
            computedInputValue: computedInputValue,
            onUpdateInputValue: onUpdateInputValue,
            onInputBlur: onInputBlur,
            onInputFocus: onInputFocus,
            onKeydown: onKeydown
        };
    }
});
function $db68d79c4ce005fe$var$_sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_chip_input = (0, $TusQn.resolveComponent)("cdx-chip-input");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-multiselect-lookup",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createVNode)(_component_cdx_chip_input, (0, $TusQn.mergeProps)({
            ref: "chipInput",
            "input-chips": _ctx.inputChipsWrapper,
            "onUpdate:inputChips": _cache[0] || (_cache[0] = ($event)=>_ctx.inputChipsWrapper = $event),
            "input-value": _ctx.computedInputValue,
            "onUpdate:inputValue": _cache[1] || (_cache[1] = ($event)=>_ctx.computedInputValue = $event)
        }, _ctx.otherAttrs, {
            class: "cdx-multiselect-lookup__chip-input",
            role: "combobox",
            autocomplete: "off",
            "aria-autocomplete": "list",
            "aria-controls": _ctx.menuId,
            "aria-expanded": _ctx.expanded,
            "aria-activedescendant": _ctx.highlightedId,
            "separate-input": _ctx.separateInput,
            disabled: _ctx.computedDisabled,
            status: _ctx.computedStatus,
            "disallow-arbitrary": true,
            "onUpdate:inputValue": _ctx.onUpdateInputValue,
            onFocus: _ctx.onInputFocus,
            onBlur: _ctx.onInputBlur,
            onKeydown: _ctx.onKeydown
        }), null, 16, [
            "input-chips",
            "input-value",
            "aria-controls",
            "aria-expanded",
            "aria-activedescendant",
            "separate-input",
            "disabled",
            "status",
            "onUpdate:inputValue",
            "onFocus",
            "onBlur",
            "onKeydown"
        ]),
        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
            id: _ctx.menuId,
            ref: "menu",
            selected: _ctx.selectedWrapper,
            "onUpdate:selected": _cache[2] || (_cache[2] = ($event)=>_ctx.selectedWrapper = $event),
            expanded: _ctx.expanded,
            "onUpdate:expanded": _cache[3] || (_cache[3] = ($event)=>_ctx.expanded = $event),
            "menu-items": _ctx.menuItems
        }, _ctx.menuConfig, {
            onLoadMore: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("load-more"))
        }), {
            default: (0, $TusQn.withCtx)(({ menuItem: menuItem })=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "menu-item", {
                        menuItem: menuItem
                    })
                ]),
            "no-results": (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "no-results")
                ]),
            _: 3
        }, 16, [
            "id",
            "selected",
            "expanded",
            "menu-items"
        ])
    ], 6);
}
const $db68d79c4ce005fe$export$c989905f222b55d0 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$b, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$b
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$3 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$a = (0, $TusQn.defineComponent)({
    name: "CdxRadio",
    components: {
        CdxLabel: $db68d79c4ce005fe$export$fd351ab562a06a13
    },
    props: {
        /**
     * Value of the currently selected radio.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: ""
        },
        /**
     * HTML "value" attribute to assign to the input.
     *
     * Required for input groups.
     */ inputValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: false
        },
        /**
     * HTML "name" attribute to assign to the input.
     */ name: {
            type: String,
            required: true
        },
        /**
     * Whether the disabled attribute should be added to the input.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the component should display inline.
     *
     * By default, `display: block` is set and a margin exists between
     * sibling components, for a stacked layout.
     */ inline: {
            type: Boolean,
            default: false
        },
        /**
     * Validation status of the Radio.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$3
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes.
     *
     * @property {string | number | boolean} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        var _a;
        $db68d79c4ce005fe$var$useLabelChecker((_a = slots.default) == null ? void 0 : _a.call(slots), attrs, "CdxRadio");
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const rootClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-radio--inline": props.inline,
                ["cdx-radio--status-".concat(computedStatus.value)]: true
            };
        });
        const customInputClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-radio__custom-input--inline": props.inline
            };
        });
        const input = (0, $01W3b.ref)();
        const radioId = $db68d79c4ce005fe$export$6217842283d27b52("radio");
        const descriptionId = $db68d79c4ce005fe$export$6217842283d27b52("description");
        const focusInput = ()=>{
            input.value.focus();
        };
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        return {
            rootClasses: rootClasses,
            computedDisabled: computedDisabled,
            input: input,
            radioId: radioId,
            descriptionId: descriptionId,
            focusInput: focusInput,
            wrappedModel: wrappedModel,
            customInputClasses: customInputClasses
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$a = {
    class: "cdx-radio__wrapper"
};
const $db68d79c4ce005fe$var$_hoisted_2$6 = [
    "id",
    "aria-describedby",
    "name",
    "value",
    "disabled"
];
const $db68d79c4ce005fe$var$_hoisted_3$4 = /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
    class: "cdx-radio__icon"
}, null, -1);
function $db68d79c4ce005fe$var$_sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_label = (0, $TusQn.resolveComponent)("cdx-label");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-radio",
            _ctx.rootClasses
        ])
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$a, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                id: _ctx.radioId,
                ref: "input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
                class: "cdx-radio__input",
                type: "radio",
                "aria-describedby": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
                name: _ctx.name,
                value: _ctx.inputValue,
                disabled: _ctx.computedDisabled
            }, null, 8, $db68d79c4ce005fe$var$_hoisted_2$6), [
                [
                    (0, $eeJ70.vModelRadio),
                    _ctx.wrappedModel
                ]
            ]),
            $db68d79c4ce005fe$var$_hoisted_3$4,
            _ctx.$slots.default && _ctx.$slots.default().length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_label, {
                key: 0,
                class: "cdx-radio__label",
                "input-id": _ctx.radioId,
                "description-id": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
                disabled: _ctx.computedDisabled,
                onClick: _ctx.focusInput
            }, (0, $TusQn.createSlots)({
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                    ]),
                _: 2
            }, [
                _ctx.$slots.description && _ctx.$slots.description().length > 0 ? {
                    name: "description",
                    fn: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                        ]),
                    key: "0"
                } : void 0
            ]), 1032, [
                "input-id",
                "description-id",
                "disabled",
                "onClick"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
        ]),
        _ctx.$slots["custom-input"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            class: (0, $8XWQX.normalizeClass)([
                "cdx-radio__custom-input",
                _ctx.customInputClasses
            ])
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "custom-input")
        ], 2)) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 2);
}
const $db68d79c4ce005fe$export$27f3c4ce4bd91ba9 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$a, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$a
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$2 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$9 = (0, $TusQn.defineComponent)({
    name: "CdxSearchInput",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxTextInput: $db68d79c4ce005fe$export$edf7ede3ce8aed68
    },
    /**
   * Attributes, besides class, will be passed to the TextInput's input element.
   */ inheritAttrs: false,
    props: {
        /**
     * Value of the search input, provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                String,
                Number
            ],
            default: ""
        },
        /**
     *
     * Whether to display the search button.
     */ useButton: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to 'Search' (T368444).
        /**
     * Search button text.
     *
     * Omit this prop to use the default value, "Search".
     */ buttonLabel: {
            type: String,
            default: ""
        },
        /**
     * Whether the search input is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * `status` property of the TextInput component
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$2
        }
    },
    emits: [
        /**
     * When the input value changes
     *
     * @property {string | number} value The new value
     */ "update:modelValue",
        /**
     * When the submit button is clicked.
     *
     * @property {string | number} value The current input
     */ "submit-click",
        /**
     * When the input value changes via direct use of the input
     *
     * @property {InputEvent} event
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        const { computedDisabled: computedDisabled } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"));
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-search-input--has-end-button": !!props.buttonLabel || props.useButton
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const translatedSearchButtonLabel = $db68d79c4ce005fe$var$useI18nWithOverride((0, $01W3b.toRef)(props, "buttonLabel"), "cdx-search-input-search-button-label", // Allow custom button label via props or fallback to a default English string.
        "Search");
        const useButtonOrLabel = (0, $01W3b.computed)(()=>props.useButton || props.buttonLabel.length > 0);
        const handleSubmit = ()=>{
            emit("submit-click", wrappedModel.value);
        };
        return {
            wrappedModel: wrappedModel,
            computedDisabled: computedDisabled,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            handleSubmit: handleSubmit,
            searchIcon: $db68d79c4ce005fe$var$A7,
            translatedSearchButtonLabel: translatedSearchButtonLabel,
            useButtonOrLabel: useButtonOrLabel
        };
    },
    methods: {
        /**
     * Focus the component's input element.
     *
     * @public
     */ focus () {
            const textInput = this.$refs.textInput;
            textInput.focus();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$9 = {
    class: "cdx-search-input__input-wrapper"
};
function $db68d79c4ce005fe$var$_sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_text_input = (0, $TusQn.resolveComponent)("cdx-text-input");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-search-input",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$9, [
            (0, $TusQn.createVNode)(_component_cdx_text_input, (0, $TusQn.mergeProps)({
                ref: "textInput",
                modelValue: _ctx.wrappedModel,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
                class: "cdx-search-input__text-input",
                "input-type": "search",
                "start-icon": _ctx.searchIcon,
                disabled: _ctx.computedDisabled,
                status: _ctx.status
            }, _ctx.otherAttrs, {
                onKeydown: (0, $eeJ70.withKeys)(_ctx.handleSubmit, [
                    "enter"
                ]),
                onInput: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("input", $event)),
                onChange: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("change", $event)),
                onFocus: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit("focus", $event)),
                onBlur: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("blur", $event))
            }), null, 16, [
                "modelValue",
                "start-icon",
                "disabled",
                "status",
                "onKeydown"
            ]),
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ]),
        _ctx.useButtonOrLabel ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
            key: 0,
            class: "cdx-search-input__end-button",
            disabled: _ctx.computedDisabled,
            onClick: _ctx.handleSubmit
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.translatedSearchButtonLabel), 1)
                ]),
            _: 1
        }, 8, [
            "disabled",
            "onClick"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6);
}
const $db68d79c4ce005fe$export$4d07ca0116afbc71 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$9, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$9
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$1 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$8 = (0, $TusQn.defineComponent)({
    name: "CdxSelect",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad
    },
    /**
   * We want the select handle to inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Menu items. See the MenuItemData type.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Value of the current selection.
     *
     * Must be bound with `v-model:selected`.
     *
     * The property should be initialized to `null` rather than using a falsy value.
     */ selected: {
            type: [
                String,
                Number,
                null
            ],
            required: true
        },
        /**
     * Label to display when no selection has been made.
     */ defaultLabel: {
            type: String,
            default: ""
        },
        /**
     * Whether the dropdown is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * An icon at the start of the select element
     * displayed when no selection has been made.
     */ defaultIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        },
        /**
     * `status` attribute of the input.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$1
        }
    },
    emits: [
        /**
     * When the selection value changes.
     *
     * @property {string | number | null} modelValue The new model value
     */ "update:selected",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const handle = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const descriptionId = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldDescriptionIdKey, void 0);
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("select-menu");
        const expanded = (0, $01W3b.ref)(false);
        const handleId = attrs.id || $db68d79c4ce005fe$export$6217842283d27b52("select-handle");
        const { computedDisabled: computedDisabled, computedStatus: computedStatus, computedInputId: computedHandleId } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"), handleId);
        const modelWrapper = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "selected"), emit, "update:selected");
        const selectedMenuItem = (0, $01W3b.computed)(()=>props.menuItems.find((menuItem)=>menuItem.value === props.selected));
        const currentLabel = (0, $01W3b.computed)(()=>{
            var _a;
            return selectedMenuItem.value ? (_a = selectedMenuItem.value.label) != null ? _a : selectedMenuItem.value.value : props.defaultLabel;
        });
        const startIcon = (0, $01W3b.computed)(()=>{
            var _a;
            if (props.defaultIcon && !selectedMenuItem.value) return props.defaultIcon;
            else if ((_a = selectedMenuItem.value) == null ? void 0 : _a.icon) return selectedMenuItem.value.icon;
            return void 0;
        });
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-select-vue--enabled": !computedDisabled.value,
                "cdx-select-vue--disabled": computedDisabled.value,
                "cdx-select-vue--expanded": expanded.value,
                "cdx-select-vue--value-selected": !!selectedMenuItem.value,
                "cdx-select-vue--no-selections": !selectedMenuItem.value,
                "cdx-select-vue--has-start-icon": !!startIcon.value,
                ["cdx-select-vue--status-".concat(computedStatus.value)]: true
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const otherAttrsMinusId = (0, $01W3b.computed)(()=>{
            const _a = otherAttrs.value, { id: id } = _a, everythingElse = $db68d79c4ce005fe$var$__objRest(_a, [
                "id"
            ]);
            return everythingElse;
        });
        const highlightedId = (0, $01W3b.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        function onBlur() {
            expanded.value = false;
        }
        function onClick() {
            var _a;
            if (computedDisabled.value) return;
            expanded.value = !expanded.value;
            (_a = handle.value) == null || _a.focus();
        }
        function onKeydown(e) {
            var _a;
            if (computedDisabled.value) return;
            (_a = menu.value) == null || _a.delegateKeyNavigation(e, {
                characterNavigation: true
            });
        }
        $db68d79c4ce005fe$export$ebb1680baab55ef5(handle, menu);
        return {
            handle: handle,
            menu: menu,
            computedHandleId: computedHandleId,
            descriptionId: descriptionId,
            menuId: menuId,
            modelWrapper: modelWrapper,
            selectedMenuItem: selectedMenuItem,
            highlightedId: highlightedId,
            expanded: expanded,
            computedDisabled: computedDisabled,
            onBlur: onBlur,
            currentLabel: currentLabel,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrsMinusId: otherAttrsMinusId,
            onClick: onClick,
            onKeydown: onKeydown,
            startIcon: startIcon,
            cdxIconExpand: $db68d79c4ce005fe$var$m4
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$8 = [
    "aria-disabled"
];
const $db68d79c4ce005fe$var$_hoisted_2$5 = [
    "id",
    "aria-controls",
    "aria-activedescendant",
    "aria-expanded",
    "aria-describedby"
];
function $db68d79c4ce005fe$var$_sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-select-vue",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle),
        "aria-disabled": _ctx.computedDisabled
    }, [
        (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
            id: _ctx.computedHandleId,
            ref: "handle",
            class: "cdx-select-vue__handle"
        }, _ctx.otherAttrsMinusId, {
            tabindex: "0",
            role: "combobox",
            "aria-controls": _ctx.menuId,
            "aria-activedescendant": _ctx.highlightedId,
            "aria-expanded": _ctx.expanded,
            "aria-describedby": _ctx.descriptionId,
            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.onClick && _ctx.onClick(...args)),
            onBlur: _cache[1] || (_cache[1] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
            onKeydown: _cache[2] || (_cache[2] = (...args)=>_ctx.onKeydown && _ctx.onKeydown(...args))
        }), [
            (0, $TusQn.renderSlot)(_ctx.$slots, "label", {
                selectedMenuItem: _ctx.selectedMenuItem,
                defaultLabel: _ctx.defaultLabel
            }, ()=>[
                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.currentLabel), 1)
                ]),
            _ctx.startIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                key: 0,
                icon: _ctx.startIcon,
                class: "cdx-select-vue__start-icon"
            }, null, 8, [
                "icon"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            (0, $TusQn.createVNode)(_component_cdx_icon, {
                icon: _ctx.cdxIconExpand,
                class: "cdx-select-vue__indicator"
            }, null, 8, [
                "icon"
            ])
        ], 16, $db68d79c4ce005fe$var$_hoisted_2$5),
        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
            id: _ctx.menuId,
            ref: "menu",
            selected: _ctx.modelWrapper,
            "onUpdate:selected": _cache[3] || (_cache[3] = ($event)=>_ctx.modelWrapper = $event),
            expanded: _ctx.expanded,
            "onUpdate:expanded": _cache[4] || (_cache[4] = ($event)=>_ctx.expanded = $event),
            "menu-items": _ctx.menuItems
        }, _ctx.menuConfig, {
            onLoadMore: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit("load-more"))
        }), {
            default: (0, $TusQn.withCtx)(({ menuItem: menuItem })=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "menu-item", {
                        menuItem: menuItem
                    })
                ]),
            _: 3
        }, 16, [
            "id",
            "selected",
            "expanded",
            "menu-items"
        ])
    ], 14, $db68d79c4ce005fe$var$_hoisted_1$8);
}
const $db68d79c4ce005fe$export$fd5153ff27ffff7b = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$8, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$8
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$7 = (0, $TusQn.defineComponent)({
    name: "CdxTablePager",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxSelect: $db68d79c4ce005fe$export$fd5153ff27ffff7b
    },
    props: {
        paginationSizeOptions: {
            type: Array,
            required: true
        },
        itemsPerPage: {
            type: Number,
            required: true
        },
        nextDisabled: {
            type: Boolean,
            default: false
        },
        prevDisabled: {
            type: Boolean,
            default: false
        },
        lastDisabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the items per page option changes
     *
     * @property {number} itemsPerPage the number of items to display
     */ "update:itemsPerPage",
        /**
     * Emitted when the user requests the first page of data
     */ "first",
        /**
     * Emitted when the user requests the last page of data
     */ "last",
        /**
     * Emitted when the user requests the next page of data
     */ "next",
        /**
     * Emitted when the user requests the previous page of data
     */ "prev"
    ],
    setup (props, { emit: emit }) {
        const wrappedItemsPerPage = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "itemsPerPage"), emit, "update:itemsPerPage");
        const defaultItemsPerPageLabel = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-items-per-page-default", "Results per page");
        const currentItemsPerPageLabel = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-items-per-page-current", (current)=>"".concat(current, " rows"), [
            wrappedItemsPerPage
        ]);
        const btnLabelFirst = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-button-first-page", "First page");
        const btnLabelNext = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-button-next-page", "Next page");
        const btnLabelPrev = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-button-prev-page", "Previous page");
        const btnLabelLast = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-button-last-page", "Last page");
        return {
            defaultItemsPerPageLabel: defaultItemsPerPageLabel,
            currentItemsPerPageLabel: currentItemsPerPageLabel,
            btnLabelFirst: btnLabelFirst,
            btnLabelNext: btnLabelNext,
            btnLabelPrev: btnLabelPrev,
            btnLabelLast: btnLabelLast,
            wrappedItemsPerPage: wrappedItemsPerPage,
            cdxIconPrevious: $db68d79c4ce005fe$var$d7,
            cdxIconNext: $db68d79c4ce005fe$var$j6,
            cdxIconMoveFirst: $db68d79c4ce005fe$var$P6,
            cdxIconMoveLast: $db68d79c4ce005fe$var$N6
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$7 = {
    class: "cdx-table-pager"
};
const $db68d79c4ce005fe$var$_hoisted_2$4 = {
    class: "cdx-table-pager__start"
};
const $db68d79c4ce005fe$var$_hoisted_3$3 = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_4$3 = {
    key: 1
};
const $db68d79c4ce005fe$var$_hoisted_5$3 = {
    class: "cdx-table-pager__center"
};
const $db68d79c4ce005fe$var$_hoisted_6$3 = {
    class: "cdx-table-pager__end"
};
function $db68d79c4ce005fe$var$_sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_select = (0, $TusQn.resolveComponent)("cdx-select");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$7, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_2$4, [
            (0, $TusQn.createVNode)(_component_cdx_select, {
                selected: _ctx.wrappedItemsPerPage,
                "onUpdate:selected": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedItemsPerPage = $event),
                "default-label": _ctx.defaultItemsPerPageLabel,
                "menu-items": _ctx.paginationSizeOptions
            }, {
                label: (0, $TusQn.withCtx)(({ selectedMenuItem: selectedMenuItem, defaultLabel: defaultLabel })=>[
                        selectedMenuItem ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_3$3, [
                            (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)(_ctx.currentItemsPerPageLabel), 1)
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_4$3, (0, $8XWQX.toDisplayString)(defaultLabel), 1))
                    ]),
                _: 1
            }, 8, [
                "selected",
                "default-label",
                "menu-items"
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_5$3, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_6$3, [
            (0, $TusQn.createVNode)(_component_cdx_button, {
                disabled: _ctx.prevDisabled,
                class: "cdx-table-pager__button-first",
                weight: "quiet",
                "aria-label": _ctx.btnLabelFirst,
                onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("first"))
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.cdxIconMoveFirst
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "aria-label"
            ]),
            (0, $TusQn.createVNode)(_component_cdx_button, {
                disabled: _ctx.prevDisabled,
                class: "cdx-table-pager__button-prev",
                weight: "quiet",
                "aria-label": _ctx.btnLabelPrev,
                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("prev"))
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.cdxIconPrevious
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "aria-label"
            ]),
            (0, $TusQn.createVNode)(_component_cdx_button, {
                disabled: _ctx.nextDisabled,
                class: "cdx-table-pager__button-next",
                weight: "quiet",
                "aria-label": _ctx.btnLabelNext,
                onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit("next"))
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.cdxIconNext
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "aria-label"
            ]),
            (0, $TusQn.createVNode)(_component_cdx_button, {
                disabled: _ctx.nextDisabled || _ctx.lastDisabled,
                class: "cdx-table-pager__button-last",
                weight: "quiet",
                "aria-label": _ctx.btnLabelLast,
                onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("last"))
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.cdxIconMoveLast
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "aria-label"
            ])
        ])
    ]);
}
const $db68d79c4ce005fe$var$CdxTablePager = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$7, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$7
    ]
]);
const $db68d79c4ce005fe$var$tableTextAlignmentsValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$TableTextAlignments);
const $db68d79c4ce005fe$var$paginationPositionValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$TablePaginationPositions);
const $db68d79c4ce005fe$var$iconMap = {
    none: $db68d79c4ce005fe$var$T7,
    asc: $db68d79c4ce005fe$var$x8,
    desc: $db68d79c4ce005fe$var$l4
};
const $db68d79c4ce005fe$var$sortDirectionMap = {
    none: "none",
    asc: "ascending",
    desc: "descending"
};
const $db68d79c4ce005fe$var$_sfc_main$6 = (0, $TusQn.defineComponent)({
    name: "CdxTable",
    components: {
        CdxCheckbox: $db68d79c4ce005fe$export$10933eadb08a15a2,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxTablePager: $db68d79c4ce005fe$var$CdxTablePager,
        CdxProgressBar: $db68d79c4ce005fe$export$f9f679f84bac7c0c
    },
    props: {
        /**
     * Table caption.
     *
     * Required to support users of assistive technology, but can be visually hidden.
     */ caption: {
            type: String,
            required: true
        },
        /**
     * Whether to visually hide the caption.
     */ hideCaption: {
            type: Boolean,
            default: false
        },
        /**
     * Column definitions.
     *
     * @default []
     */ columns: {
            type: Array,
            default: ()=>[],
            validator: (value)=>{
                const ids = value.map((column)=>column.id);
                const hasUniqueIds = new Set(ids).size === ids.length;
                if (!hasUniqueIds) {
                    console.warn('Each column in the "columns" prop of CdxTable must have a unique "id".');
                    return false;
                }
                return true;
            }
        },
        /**
     * Table data.
     *
     * An array of objects, with each object representing the data for a table row. Item keys
     * should align with column IDs, as defined in the `columns` prop.
     *
     * @default []
     */ data: {
            type: Array,
            default: ()=>[],
            validator: (value, props)=>{
                if (!Array.isArray(props.columns) || props.columns.length === 0 || value.length === 0) return true;
                const hasSort = props.columns.some((column)=>"allowSort" in column);
                const rowsHaveIds = value.every((row)=>$db68d79c4ce005fe$export$6bc4af29e8294dab in row);
                if (hasSort && props.useRowSelection && !rowsHaveIds) {
                    console.warn('For CdxTables with sorting and row selection, each row in the "data" prop must have a "TableRowIdentifier".');
                    return false;
                }
                return true;
            }
        },
        /**
     * Whether to use `<th>` for the first cell in each row.
     */ useRowHeaders: {
            type: Boolean,
            default: false
        },
        /**
     * Whether vertical borders separating columns should be rendered.
     */ showVerticalBorders: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to enable row selection.
     */ useRowSelection: {
            type: Boolean,
            default: false
        },
        /**
     * An array of selected row indices. Must be bound with `v-model:selected-rows`.
     *
     * If sorting is also enabled, this will be an array of TableRowIdentifiers.
     *
     * @default []
     */ selectedRows: {
            type: Array,
            default: ()=>[]
        },
        /**
     * Definition of sort order. Column(s) can be sorted ascending, descending, or not sorted.
     * To display data unsorted initially, set to an empty object initially.
     * Must be bound with v-model:sort
     *
     * @default {}
     */ sort: {
            type: Object,
            default: ()=>({})
        },
        /**
     * Whether the table is waiting for data to be fetched.
     */ pending: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to enable pagination.
     */ paginate: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the table is paginating through remote data. Setting this to
     * "true" will cause the table to emit events indicating that more data
     * should be loaded when the user navigates between pages.
     */ serverPagination: {
            type: Boolean,
            default: false
        },
        /**
     * The total number of rows/results available on the server that the
     * user can access via pagination. Providing this value will make for
     * a better user experience when navigating through pages of remote
     * data, but it is not required.
     */ totalRows: {
            type: Number,
            default: NaN
        },
        /**
     * Where the pagination controls should appear relative to the table body.
     */ paginationPosition: {
            type: String,
            default: "bottom",
            validator: $db68d79c4ce005fe$var$paginationPositionValidator
        },
        /**
     * Pre-defined options for how may rows should be displayed per page.
     * The value of these menu items must be a number.
     *
     * @default [ { value: 10 }, { value: 20 }, { value: 50 } ]
     */ paginationSizeOptions: {
            type: Array,
            default: ()=>[
                    {
                        value: 10
                    },
                    {
                        value: 20
                    },
                    {
                        value: 50
                    }
                ],
            validator: (value)=>{
                const hasNumberValue = (item)=>typeof item.value === "number";
                if (value.every(hasNumberValue)) return true;
                else {
                    console.warn('"value" property of all menu items in PaginationOptions must be a number.');
                    return false;
                }
            }
        },
        /**
     * The default number of rows to show per page. For basic pagination,
     * this will default to the value of the first of the pagination options
     * if not provided. For server-side pagination, this will default to
     * the initial number of rows if no default is provided.
     *
     * @default paginationSizeOptions[ 0 ].value
     */ paginationSizeDefault: {
            type: Number,
            default: (rawProps)=>{
                if (rawProps.paginate && rawProps.serverPagination) return rawProps.data.length;
                else return rawProps.paginationSizeOptions[0].value;
            }
        }
    },
    emits: [
        /**
     * When the selected row(s) changes.
     *
     * @property {string[]} selectedRows The new selected rows.
     */ "update:selectedRows",
        /**
     * When the sort order changes emit an event to update the sort order.
     *
     * @property {Object} sort The new sort order.
     */ "update:sort",
        /**
     * When the user requests another page of data from the server.
     *
     * @property {number} offset Index of the first visible row on the new page.
     * @property {number} rows Number of rows to display.
     *
     */ "load-more",
        /**
     * When the user requests the last page of data from the server.
     *
     * @property {number} rows Number of rows to display.
     */ "last"
    ],
    setup (props, { emit: emit }) {
        const offset2 = (0, $01W3b.ref)(0);
        const pageSize = (0, $01W3b.ref)(props.paginationSizeDefault);
        const dataForDisplay = (0, $01W3b.computed)(()=>{
            if (props.serverPagination && props.paginate) return props.data;
            else if (props.paginate) return props.data.slice(offset2.value, pageSize.value + offset2.value);
            else return props.data;
        });
        const totalCount = (0, $01W3b.computed)(()=>{
            var _a;
            if (props.serverPagination) return (_a = props.totalRows) != null ? _a : NaN;
            else return props.data.length;
        });
        const indeterminate = (0, $01W3b.computed)(()=>isNaN(totalCount.value));
        const currentCount = (0, $01W3b.computed)(()=>dataForDisplay.value.length);
        const firstOrdinal = (0, $01W3b.computed)(()=>offset2.value + 1);
        const lastOrdinal = (0, $01W3b.computed)(()=>offset2.value + currentCount.value);
        const lastDisabled = (0, $01W3b.computed)(()=>indeterminate.value);
        const prevDisabled = (0, $01W3b.computed)(()=>offset2.value <= 0);
        const nextDisabled = (0, $01W3b.computed)(()=>{
            if (indeterminate.value) return currentCount.value < pageSize.value;
            else return offset2.value + pageSize.value >= totalCount.value;
        });
        const paginationStatusMessageDeterminateShort = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-determinate-short", (x, y, z)=>"".concat(x, "\u2013").concat(y, " of ").concat(z), [
            firstOrdinal,
            lastOrdinal,
            totalCount
        ]);
        const paginationStatusMessageDeterminateLong = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-determinate-long", (x, y, z)=>"Showing results ".concat(x, "\u2013").concat(y, " of ").concat(z), [
            firstOrdinal,
            lastOrdinal,
            totalCount
        ]);
        const paginationStatusMessageIndeterminateShort = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-indeterminate-short", (x, y)=>"".concat(x, "\u2013").concat(y, " of many"), [
            firstOrdinal,
            lastOrdinal
        ]);
        const paginationStatusMessageIndeterminateLong = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-indeterminate-long", (x, y)=>"Showing results ".concat(x, "\u2013").concat(y, " of many"), [
            firstOrdinal,
            lastOrdinal
        ]);
        const paginationStatusMessageIndeterminateFinal = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-indeterminate-final", (x)=>"Showing the last ".concat(x, " results"), [
            currentCount
        ]);
        const paginationStatusMessagePending = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-pending", "Loading results...");
        const paginationStatusMessageShort = (0, $01W3b.computed)(()=>{
            if (props.pending) return paginationStatusMessagePending.value;
            else if (indeterminate.value && nextDisabled.value) return paginationStatusMessageIndeterminateFinal.value;
            else if (indeterminate.value) return paginationStatusMessageIndeterminateShort.value;
            else return paginationStatusMessageDeterminateShort.value;
        });
        const paginationStatusMessageLong = (0, $01W3b.computed)(()=>{
            if (props.pending) return paginationStatusMessagePending.value;
            else if (indeterminate.value && nextDisabled.value) return paginationStatusMessageIndeterminateFinal.value;
            else if (indeterminate.value) return paginationStatusMessageIndeterminateLong.value;
            else return paginationStatusMessageDeterminateLong.value;
        });
        function onNext() {
            offset2.value += pageSize.value;
            if (props.serverPagination) emit("load-more", offset2.value, pageSize.value);
        }
        function onPrev() {
            if (offset2.value - pageSize.value < 1) onFirst();
            else {
                offset2.value -= pageSize.value;
                if (props.serverPagination) emit("load-more", offset2.value, pageSize.value);
            }
        }
        function onFirst() {
            offset2.value = 0;
            if (props.serverPagination) emit("load-more", offset2.value, pageSize.value);
        }
        function onLast() {
            if (totalCount.value % pageSize.value === 0) {
                offset2.value = totalCount.value - pageSize.value;
                emit("load-more", offset2.value, pageSize.value);
            } else {
                offset2.value = Math.floor(totalCount.value / pageSize.value) * pageSize.value;
                emit("load-more", offset2.value, pageSize.value);
            }
        }
        (0, $TusQn.watch)(pageSize, (newPageSize)=>{
            if (props.serverPagination) emit("load-more", offset2.value, newPageSize);
        });
        const wrappedSelectedRows = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "selectedRows"), emit, "update:selectedRows");
        const selectAll = (0, $01W3b.ref)(totalCount.value === wrappedSelectedRows.value.length);
        const selectAllIndeterminate = (0, $01W3b.ref)(false);
        const activeSortColumn = (0, $01W3b.computed)(()=>{
            return Object.keys(props.sort)[0];
        });
        const hasSortableColumns = (0, $01W3b.computed)(()=>{
            return props.columns.some((column)=>column.allowSort);
        });
        const tableClasses = (0, $01W3b.computed)(()=>{
            var _a;
            const useFixedLayout = (_a = props.columns) == null ? void 0 : _a.some((column)=>"width" in column || "minWidth" in column);
            return {
                "cdx-table__table--layout-fixed": useFixedLayout,
                "cdx-table__table--borders-vertical": props.showVerticalBorders
            };
        });
        const translatedSortCaption = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-sort-caption", (caption)=>"".concat(caption, ", column headers with buttons are sortable."), [
            (0, $01W3b.toRef)(props, "caption")
        ]);
        const translatedSelectRowLabel = (rowIndex, totalRows)=>$db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-select-row-label", (row, total)=>"Select row ".concat(row, " of ").concat(total), [
                ()=>rowIndex,
                ()=>totalRows
            ]).value;
        const translatedSelectAllLabel = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-select-all-label", "Select all rows");
        function getRowKey(row, index) {
            return $db68d79c4ce005fe$export$6bc4af29e8294dab in row ? row[$db68d79c4ce005fe$export$6bc4af29e8294dab] : index;
        }
        function getRowClass(row, rowIndex) {
            const rowKey = getRowKey(row, rowIndex);
            return {
                "cdx-table__row--selected": wrappedSelectedRows.value.indexOf(rowKey) !== -1
            };
        }
        function getRowHeaderScope(columnId) {
            const firstColumn = props.columns[0].id;
            if (props.useRowHeaders === true && columnId === firstColumn) return "row";
        }
        function getCellElement(columnId) {
            const firstColumn = props.columns[0].id;
            if (props.useRowHeaders && columnId === firstColumn) return "th";
            return "td";
        }
        function getCellClass(column, hasSort = false) {
            if ("textAlign" in column && !$db68d79c4ce005fe$var$tableTextAlignmentsValidator(column.textAlign)) {
                console.warn("Invalid value for TableColumn textAlign property.");
                return void 0;
            }
            return {
                // Don't assign a class for the default value 'start'. Instead, we'll set
                // text-align: left on the td and th elements.
                ["cdx-table__table__cell--align-".concat(column.textAlign)]: "textAlign" in column && column.textAlign !== "start",
                "cdx-table__table__cell--has-sort": hasSort
            };
        }
        function getCellStyle(column) {
            const styles = {};
            if ("width" in column) styles.width = column.width;
            if ("minWidth" in column) styles.minWidth = column.minWidth;
            return styles;
        }
        function handleRowSelection(newSelectedRows) {
            if (totalCount.value === newSelectedRows.length) {
                selectAll.value = true;
                selectAllIndeterminate.value = false;
                return;
            }
            selectAll.value = false;
            if (totalCount.value > newSelectedRows.length) selectAllIndeterminate.value = true;
            if (newSelectedRows.length === 0) selectAllIndeterminate.value = false;
        }
        function handleSelectAll(newValue) {
            selectAllIndeterminate.value = false;
            if (newValue) wrappedSelectedRows.value = props.data.map((row, rowIndex)=>getRowKey(row, rowIndex));
            else wrappedSelectedRows.value = [];
        }
        function handleSort(columnId) {
            var _a;
            const currentSortOrder = (_a = props.sort[columnId]) != null ? _a : "none";
            let newSortOrder = "asc";
            if (currentSortOrder === "asc") newSortOrder = "desc";
            if (currentSortOrder === "desc") newSortOrder = "none";
            emit("update:sort", {
                [columnId]: newSortOrder
            });
        }
        function getSortIcon(columnId) {
            var _a;
            const currentSortOrder = (_a = props.sort[columnId]) != null ? _a : "none";
            return $db68d79c4ce005fe$var$iconMap[currentSortOrder];
        }
        function getSortOrder(columnId, hasSort = false) {
            var _a;
            if (hasSort) {
                const currentSortOrder = (_a = props.sort[columnId]) != null ? _a : "none";
                return currentSortOrder === "none" ? void 0 : $db68d79c4ce005fe$var$sortDirectionMap[currentSortOrder];
            }
        }
        return {
            dataForDisplay: // pagination
            dataForDisplay,
            pageSize: pageSize,
            onNext: onNext,
            onPrev: onPrev,
            onFirst: onFirst,
            onLast: onLast,
            nextDisabled: nextDisabled,
            prevDisabled: prevDisabled,
            lastDisabled: lastDisabled,
            paginationStatusMessageShort: paginationStatusMessageShort,
            paginationStatusMessageLong: paginationStatusMessageLong,
            wrappedSelectedRows: // Row selection constants.
            wrappedSelectedRows,
            selectAll: selectAll,
            selectAllIndeterminate: selectAllIndeterminate,
            activeSortColumn: // Sorting constants.
            activeSortColumn,
            hasSortableColumns: hasSortableColumns,
            tableClasses: // Template helpers.
            tableClasses,
            getRowKey: getRowKey,
            getRowClass: getRowClass,
            getRowHeaderScope: getRowHeaderScope,
            getCellElement: getCellElement,
            getCellClass: getCellClass,
            getCellStyle: getCellStyle,
            handleRowSelection: // Row selection methods.
            handleRowSelection,
            handleSelectAll: handleSelectAll,
            handleSort: // Sorting methods.
            handleSort,
            getSortIcon: getSortIcon,
            getSortOrder: getSortOrder,
            translatedSortCaption: // i18n
            translatedSortCaption,
            translatedSelectRowLabel: translatedSelectRowLabel,
            translatedSelectAllLabel: translatedSelectAllLabel
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$6 = {
    class: "cdx-table",
    tabindex: "0"
};
const $db68d79c4ce005fe$var$_hoisted_2$3 = {
    key: 0,
    class: "cdx-table__header"
};
const $db68d79c4ce005fe$var$_hoisted_3$2 = [
    "aria-hidden"
];
const $db68d79c4ce005fe$var$_hoisted_4$2 = {
    class: "cdx-table__header__content"
};
const $db68d79c4ce005fe$var$_hoisted_5$2 = {
    class: "cdx-table__pagination-status--long"
};
const $db68d79c4ce005fe$var$_hoisted_6$2 = {
    class: "cdx-table__pagination-status--short"
};
const $db68d79c4ce005fe$var$_hoisted_7 = {
    class: "cdx-table__table-wrapper"
};
const $db68d79c4ce005fe$var$_hoisted_8 = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_9 = {
    key: 0,
    class: "cdx-table__table__select-rows"
};
const $db68d79c4ce005fe$var$_hoisted_10 = [
    "aria-sort"
];
const $db68d79c4ce005fe$var$_hoisted_11 = [
    "aria-selected",
    "onClick"
];
const $db68d79c4ce005fe$var$_hoisted_12 = {
    class: "cdx-table__table__sort-label"
};
const $db68d79c4ce005fe$var$_hoisted_13 = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_14 = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_15 = {
    key: 1
};
const $db68d79c4ce005fe$var$_hoisted_16 = {
    class: "cdx-table__table__empty-state"
};
const $db68d79c4ce005fe$var$_hoisted_17 = {
    class: "cdx-table__table__empty-state-content"
};
const $db68d79c4ce005fe$var$_hoisted_18 = {
    class: "cdx-table__pagination-status--long"
};
const $db68d79c4ce005fe$var$_hoisted_19 = {
    class: "cdx-table__pagination-status--short"
};
const $db68d79c4ce005fe$var$_hoisted_20 = {
    key: 3,
    class: "cdx-table__footer"
};
function $db68d79c4ce005fe$var$_sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_table_pager = (0, $TusQn.resolveComponent)("cdx-table-pager");
    const _component_cdx_checkbox = (0, $TusQn.resolveComponent)("cdx-checkbox");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_progress_bar = (0, $TusQn.resolveComponent)("cdx-progress-bar");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$6, [
        !_ctx.hideCaption || _ctx.$slots.header && _ctx.$slots.header().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_2$3, [
            (0, $TusQn.createElementVNode)("div", {
                class: "cdx-table__header__caption",
                "aria-hidden": _ctx.$slots.header && _ctx.$slots.header().length > 0 ? void 0 : true
            }, [
                !_ctx.hideCaption ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 0
                }, [
                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.caption), 1)
                ], 64)) : (0, $TusQn.createCommentVNode)("v-if", true)
            ], 8, $db68d79c4ce005fe$var$_hoisted_3$2),
            (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_4$2, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "header")
            ])
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.paginate && (_ctx.paginationPosition === "top" || _ctx.paginationPosition === "both") ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_table_pager, {
            key: 1,
            "items-per-page": _ctx.pageSize,
            "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event)=>_ctx.pageSize = $event),
            class: "cdx-table__pagination--top",
            "pagination-size-options": _ctx.paginationSizeOptions,
            "prev-disabled": _ctx.prevDisabled,
            "next-disabled": _ctx.nextDisabled,
            "last-disabled": _ctx.lastDisabled,
            onNext: _ctx.onNext,
            onPrev: _ctx.onPrev,
            onFirst: _ctx.onFirst,
            onLast: _ctx.onLast
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_5$2, (0, $8XWQX.toDisplayString)(_ctx.paginationStatusMessageLong), 1),
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_6$2, (0, $8XWQX.toDisplayString)(_ctx.paginationStatusMessageShort), 1)
                ]),
            _: 1
        }, 8, [
            "items-per-page",
            "pagination-size-options",
            "prev-disabled",
            "next-disabled",
            "last-disabled",
            "onNext",
            "onPrev",
            "onFirst",
            "onLast"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("table", {
                class: (0, $8XWQX.normalizeClass)([
                    "cdx-table__table",
                    _ctx.tableClasses
                ])
            }, [
                (0, $TusQn.createElementVNode)("caption", null, [
                    !_ctx.hasSortableColumns ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, [
                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.caption), 1)
                    ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, [
                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.translatedSortCaption), 1)
                    ], 64))
                ]),
                (0, $TusQn.renderSlot)(_ctx.$slots, "thead", {}, ()=>[
                        _ctx.columns.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("thead", $db68d79c4ce005fe$var$_hoisted_8, [
                            (0, $TusQn.createElementVNode)("tr", null, [
                                _ctx.useRowSelection ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("th", $db68d79c4ce005fe$var$_hoisted_9, [
                                    (0, $TusQn.createVNode)(_component_cdx_checkbox, {
                                        modelValue: _ctx.selectAll,
                                        "onUpdate:modelValue": [
                                            _cache[1] || (_cache[1] = ($event)=>_ctx.selectAll = $event),
                                            _ctx.handleSelectAll
                                        ],
                                        "hide-label": true,
                                        indeterminate: _ctx.selectAllIndeterminate
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.translatedSelectAllLabel), 1)
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "modelValue",
                                        "indeterminate",
                                        "onUpdate:modelValue"
                                    ])
                                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.columns, (column)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("th", {
                                        key: column.id,
                                        scope: "col",
                                        class: (0, $8XWQX.normalizeClass)(_ctx.getCellClass(column, column.allowSort)),
                                        "aria-sort": _ctx.getSortOrder(column.id, column.allowSort),
                                        style: (0, $8XWQX.normalizeStyle)(_ctx.getCellStyle(column))
                                    }, [
                                        column.allowSort ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                            key: 0,
                                            "aria-selected": column.id === _ctx.activeSortColumn,
                                            class: "cdx-table__table__sort-button",
                                            onClick: ($event)=>_ctx.handleSort(column.id)
                                        }, [
                                            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_12, (0, $8XWQX.toDisplayString)(column.label), 1),
                                            (0, $TusQn.createVNode)(_component_cdx_icon, {
                                                icon: _ctx.getSortIcon(column.id),
                                                size: "small",
                                                class: "cdx-table__table__sort-icon",
                                                "aria-hidden": "true"
                                            }, null, 8, [
                                                "icon"
                                            ])
                                        ], 8, $db68d79c4ce005fe$var$_hoisted_11)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                            key: 1
                                        }, [
                                            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(column.label), 1)
                                        ], 64))
                                    ], 14, $db68d79c4ce005fe$var$_hoisted_10);
                                }), 128))
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                    ]),
                _ctx.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_progress_bar, {
                    key: 0,
                    inline: true,
                    class: "cdx-table__pending-indicator"
                })) : (0, $TusQn.createCommentVNode)("v-if", true),
                (0, $TusQn.renderSlot)(_ctx.$slots, "tbody", {}, ()=>[
                        _ctx.dataForDisplay.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $db68d79c4ce005fe$var$_hoisted_13, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.dataForDisplay, (row, rowIndex)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                    key: _ctx.getRowKey(row, rowIndex),
                                    class: (0, $8XWQX.normalizeClass)(_ctx.getRowClass(row, rowIndex))
                                }, [
                                    _ctx.useRowSelection ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("td", $db68d79c4ce005fe$var$_hoisted_14, [
                                        (0, $TusQn.createVNode)(_component_cdx_checkbox, {
                                            modelValue: _ctx.wrappedSelectedRows,
                                            "onUpdate:modelValue": [
                                                _cache[2] || (_cache[2] = ($event)=>_ctx.wrappedSelectedRows = $event),
                                                _ctx.handleRowSelection
                                            ],
                                            "input-value": _ctx.getRowKey(row, rowIndex),
                                            "hide-label": true
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.translatedSelectRowLabel(rowIndex + 1, _ctx.dataForDisplay.length)), 1)
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "modelValue",
                                            "input-value",
                                            "onUpdate:modelValue"
                                        ])
                                    ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.columns, (column)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.getCellElement(column.id)), {
                                            key: column.id,
                                            scope: _ctx.getRowHeaderScope(column.id),
                                            class: (0, $8XWQX.normalizeClass)(_ctx.getCellClass(column))
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.renderSlot)(_ctx.$slots, "item-" + column.id, {
                                                        item: row[column.id],
                                                        row: row
                                                    }, ()=>[
                                                            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(row[column.id]), 1)
                                                        ])
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "scope",
                                            "class"
                                        ]);
                                    }), 128))
                                ], 2);
                            }), 128))
                        ])) : _ctx.$slots["empty-state"] && _ctx.$slots["empty-state"]().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $db68d79c4ce005fe$var$_hoisted_15, [
                            (0, $TusQn.createElementVNode)("tr", $db68d79c4ce005fe$var$_hoisted_16, [
                                (0, $TusQn.createElementVNode)("td", $db68d79c4ce005fe$var$_hoisted_17, [
                                    (0, $TusQn.renderSlot)(_ctx.$slots, "empty-state")
                                ])
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                    ]),
                (0, $TusQn.renderSlot)(_ctx.$slots, "tfoot")
            ], 2)
        ]),
        _ctx.paginate && (_ctx.paginationPosition === "bottom" || _ctx.paginationPosition === "both") ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_table_pager, {
            key: 2,
            "items-per-page": _ctx.pageSize,
            "onUpdate:itemsPerPage": _cache[3] || (_cache[3] = ($event)=>_ctx.pageSize = $event),
            class: "cdx-table__pagination--bottom",
            "pagination-size-options": _ctx.paginationSizeOptions,
            "prev-disabled": _ctx.prevDisabled,
            "next-disabled": _ctx.nextDisabled,
            "last-disabled": _ctx.lastDisabled,
            onNext: _ctx.onNext,
            onPrev: _ctx.onPrev,
            onFirst: _ctx.onFirst,
            onLast: _ctx.onLast
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_18, (0, $8XWQX.toDisplayString)(_ctx.paginationStatusMessageLong), 1),
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_19, (0, $8XWQX.toDisplayString)(_ctx.paginationStatusMessageShort), 1)
                ]),
            _: 1
        }, 8, [
            "items-per-page",
            "pagination-size-options",
            "prev-disabled",
            "next-disabled",
            "last-disabled",
            "onNext",
            "onPrev",
            "onFirst",
            "onLast"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.$slots.footer && _ctx.$slots.footer().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_20, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "footer")
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ]);
}
const $db68d79c4ce005fe$export$fa4e6546674df247 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$6, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$6
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$5 = (0, $TusQn.defineComponent)({
    name: "CdxTab",
    /**
   * The "label" and "disabled" props are referenced by the parent Tabs
   * component during the generation of a list of labels.
   */ props: {
        /**
     * String name of the tab, used for programmatic selection. Each Tab
     * inside a layout must have a unique name. This prop will also be
     * used as the tab label if no "label" prop is provided.
     */ name: {
            type: String,
            required: true
        },
        /**
     * Label that corresponds to this Tab in the Tabs component's header.
     * Lengthy labels will be truncated.
     */ // eslint-disable-next-line vue/no-unused-properties
        label: {
            type: String,
            default: ""
        },
        /**
     * Whether or not the tab is disabled. Disabled tabs cannot be accessed
     * via label clicks or keyboard navigation.
     */ // eslint-disable-next-line vue/no-unused-properties
        disabled: {
            type: Boolean,
            default: false
        }
    },
    setup (props) {
        var _a;
        const tabsData = (0, $TusQn.inject)($db68d79c4ce005fe$var$TabsKey);
        const activeTab = (0, $TusQn.inject)($db68d79c4ce005fe$var$ActiveTabKey);
        if (!tabsData || !activeTab) throw new Error("Tab component must be used inside a Tabs component");
        const tab = (_a = tabsData.value.get(props.name)) != null ? _a : {};
        const isActive = (0, $01W3b.computed)(()=>props.name === activeTab.value);
        return {
            tab: tab,
            isActive: isActive
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$5 = [
    "id",
    "aria-hidden",
    "aria-labelledby"
];
function $db68d79c4ce005fe$var$_sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.withDirectives)(((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("section", {
        id: _ctx.tab.id,
        "aria-hidden": !_ctx.isActive ? true : void 0,
        "aria-labelledby": "".concat(_ctx.tab.id, "-label"),
        class: "cdx-tab",
        role: "tabpanel",
        tabindex: "-1"
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ], 8, $db68d79c4ce005fe$var$_hoisted_1$5)), [
        [
            (0, $eeJ70.vShow),
            _ctx.isActive
        ]
    ]);
}
const $db68d79c4ce005fe$export$b9548060c0a710bb = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$5, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$5
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$4 = (0, $TusQn.defineComponent)({
    name: "CdxTabs",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * The `name` of the currently active Tab in the layout.
     *
     * This prop is optional; if it is provided, it should be bound
     * using a `v-model:active` directive in the parent component.
     * Two-way binding the active tab is only necessary if some tab
     * other than the first should be active as soon as the component
     * renders (such as in cases where the active tab is bound to URL
     * params). If this prop is not provided, then the first tab will
     * be active by default. Regardless, the active tab can be changed
     * normally by user interaction (clicking on tab headings) or by
     * using the exposed methods "select", "next", and "prev".
     */ active: {
            type: String,
            default: null
        },
        /**
     * Whether or not the component should be displayed in a framed
     * visual style.
     */ framed: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted whenever the active tab changes, assuming that an `active`
     * prop has been provided in the parent.
     *
     * @property {string} active The `name` of the current active tab
     */ "update:active"
    ],
    /**
   * Some methods are exposed to allow for programmatic selection of
   * the active tab from outside of the component.
   */ expose: [
        "select",
        "next",
        "prev"
    ],
    setup (props, { slots: slots, emit: emit }) {
        const rootElement = (0, $01W3b.ref)();
        const tabListElement = (0, $01W3b.ref)();
        const prevScroller = (0, $01W3b.ref)();
        const nextScroller = (0, $01W3b.ref)();
        const currentDirection = $db68d79c4ce005fe$export$b64edd098c9cdbaf(rootElement);
        const childTabNodes = (0, $01W3b.computed)(()=>{
            const slotContents = $db68d79c4ce005fe$export$57535e89d59a174(slots.default);
            if (!slotContents.every((node)=>typeof node === "object" && $db68d79c4ce005fe$var$isComponentVNode(node, $db68d79c4ce005fe$export$b9548060c0a710bb.name))) throw new Error("Slot content may only contain CdxTab components");
            if (slotContents.length === 0) throw new Error("Slot content cannot be empty");
            return slotContents;
        });
        const tabsData = (0, $01W3b.computed)(()=>{
            return childTabNodes.value.reduce((map, item)=>{
                var _a;
                if (((_a = item.props) == null ? void 0 : _a.name) && typeof item.props.name === "string") {
                    if (map.get(item.props.name)) throw new Error("Tab names must be unique");
                    map.set(item.props.name, {
                        name: item.props.name,
                        id: $db68d79c4ce005fe$export$6217842283d27b52(item.props.name),
                        label: item.props.label || item.props.name,
                        disabled: item.props.disabled
                    });
                }
                return map;
            }, /* @__PURE__ */ new Map());
        });
        const internalRefForActiveTab = (0, $01W3b.ref)(Array.from(tabsData.value.keys())[0]);
        const activeTab = $db68d79c4ce005fe$var$useOptionalModelWrapper(internalRefForActiveTab, (0, $01W3b.toRef)(props, "active"), emit, "update:active");
        const tabNames = (0, $01W3b.computed)(()=>Array.from(tabsData.value.keys()));
        const activeTabIndex = (0, $01W3b.computed)(()=>tabNames.value.indexOf(activeTab.value));
        const activeTabId = (0, $01W3b.computed)(()=>{
            var _a;
            return (_a = tabsData.value.get(activeTab.value)) == null ? void 0 : _a.id;
        });
        (0, $TusQn.provide)($db68d79c4ce005fe$var$ActiveTabKey, activeTab);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$TabsKey, tabsData);
        const tabButtonRefs = (0, $01W3b.ref)(/* @__PURE__ */ new Map());
        const firstTabLabel = (0, $01W3b.ref)();
        const lastTabLabel = (0, $01W3b.ref)();
        const firstLabelVisible = $db68d79c4ce005fe$export$a7395f9832c00176(firstTabLabel, {
            threshold: 0.95
        });
        const lastLabelVisible = $db68d79c4ce005fe$export$a7395f9832c00176(lastTabLabel, {
            threshold: 0.95
        });
        function assignTemplateRefForTabButton(templateRef, index) {
            const el = templateRef;
            if (el) {
                tabButtonRefs.value.set(index, el);
                if (index === 0) firstTabLabel.value = el;
                else if (index === tabNames.value.length - 1) lastTabLabel.value = el;
            }
        }
        const rootClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-tabs--framed": props.framed,
                "cdx-tabs--quiet": !props.framed
            };
        });
        function focusActiveTab() {
            var _a;
            (_a = tabButtonRefs.value.get(activeTabIndex.value)) == null || _a.focus();
        }
        function getScrollDistance(tabLabel) {
            if (!tabListElement.value || !prevScroller.value || !nextScroller.value) return 0;
            const leftScroller = currentDirection.value === "rtl" ? nextScroller.value : prevScroller.value;
            const rightScroller = currentDirection.value === "rtl" ? prevScroller.value : nextScroller.value;
            const labelLeft = tabLabel.offsetLeft;
            const labelRight = labelLeft + tabLabel.clientWidth;
            const visibleLeft = tabListElement.value.scrollLeft + leftScroller.clientWidth;
            const visibleRight = tabListElement.value.scrollLeft + tabListElement.value.clientWidth - rightScroller.clientWidth;
            if (labelLeft < visibleLeft) return labelLeft - visibleLeft;
            if (labelRight > visibleRight) return labelRight - visibleRight;
            return 0;
        }
        function scrollTabs(logicalDirection) {
            if (!tabListElement.value || !prevScroller.value || !nextScroller.value) return;
            const scrollDirection = logicalDirection === "next" && currentDirection.value === "ltr" || logicalDirection === "prev" && currentDirection.value === "rtl" ? 1 : -1;
            let scrollDistance = 0;
            let tabLabel = logicalDirection === "next" ? tabListElement.value.firstElementChild : tabListElement.value.lastElementChild;
            while(tabLabel){
                const nextTabLabel = logicalDirection === "next" ? tabLabel.nextElementSibling : tabLabel.previousElementSibling;
                scrollDistance = getScrollDistance(tabLabel);
                if (Math.sign(scrollDistance) === scrollDirection) {
                    if (nextTabLabel && Math.abs(scrollDistance) < 0.25 * tabListElement.value.clientWidth) scrollDistance = getScrollDistance(nextTabLabel);
                    break;
                }
                tabLabel = nextTabLabel;
            }
            tabListElement.value.scrollBy({
                left: scrollDistance,
                behavior: "smooth"
            });
            focusActiveTab();
        }
        (0, $TusQn.watch)(activeTab, ()=>{
            if (activeTabId.value === void 0 || !tabListElement.value || !prevScroller.value || !nextScroller.value) return;
            const activeTabLabel = document.getElementById("".concat(activeTabId.value, "-label"));
            if (!activeTabLabel) return;
            tabListElement.value.scrollBy({
                left: getScrollDistance(activeTabLabel),
                behavior: "smooth"
            });
        });
        return {
            activeTab: activeTab,
            activeTabIndex: activeTabIndex,
            activeTabId: activeTabId,
            currentDirection: currentDirection,
            rootElement: rootElement,
            tabListElement: tabListElement,
            prevScroller: prevScroller,
            nextScroller: nextScroller,
            rootClasses: rootClasses,
            tabNames: tabNames,
            tabsData: tabsData,
            firstLabelVisible: firstLabelVisible,
            lastLabelVisible: lastLabelVisible,
            assignTemplateRefForTabButton: assignTemplateRefForTabButton,
            scrollTabs: scrollTabs,
            focusActiveTab: focusActiveTab,
            cdxIconPrevious: $db68d79c4ce005fe$var$d7,
            cdxIconNext: $db68d79c4ce005fe$var$j6
        };
    },
    /**
   * Some non-public methods are defined here rather than in setup because
   * they support public methods (which *must* be defined using the Options
   * API in order to show up in documentation), or are thematically related
   * (such as key handlers).
   */ methods: {
        /**
     * Programmatically select a tab based on its "name" prop
     *
     * @param {string} tabName The name of the tab to select
     * @param {boolean} setFocus Whether or not to also set focus to the new tab
     * @public
     */ select (tabName, setFocus) {
            const target = this.tabsData.get(tabName);
            if (target && !(target == null ? void 0 : target.disabled)) {
                this.activeTab = tabName;
                if (setFocus) (0, $TusQn.nextTick)(()=>{
                    this.focusActiveTab();
                });
            }
        },
        /**
     * Used to select next or previous tab in the sequence, skipping
     * over any tabs that are disabled. The provided increment should
     * be either 1 (to move forward) or -1 (to move backwards)
     *
     * @param index
     * @param increment
     * @param setFocus
     */ selectNonDisabled (index, increment, setFocus) {
            const target = this.tabsData.get(this.tabNames[index + increment]);
            if (target) {
                if (target.disabled) this.selectNonDisabled(index + increment, increment, setFocus);
                else this.select(target.name, setFocus);
            }
        },
        /**
     * Set the next tab to active, if one exists
     *
     * @param {boolean} setFocus
     * @public
     */ next (setFocus) {
            this.selectNonDisabled(this.activeTabIndex, 1, setFocus);
        },
        /**
     * Set the previous tab to active, if one exists
     *
     * @param {boolean} setFocus
     * @public
     */ prev (setFocus) {
            this.selectNonDisabled(this.activeTabIndex, -1, setFocus);
        },
        /**
     * Handle left arrow key navigation (based on LTR/RTL direction)
     */ onLeftArrowKeypress () {
            if (this.currentDirection === "rtl") this.next(true);
            else this.prev(true);
        },
        /**
     * Handle right arrow key navigation (based on LTR/RTL direction)
     */ onRightArrowKeypress () {
            if (this.currentDirection === "rtl") this.prev(true);
            else this.next(true);
        },
        /**
     * Handle down arrow key navigation by moving focus to the contents
     * of the currently active tab
     */ onDownArrowKeypress () {
            var _a;
            if (this.activeTabId) (_a = document.getElementById(this.activeTabId)) == null || _a.focus();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$4 = {
    class: "cdx-tabs__header"
};
const $db68d79c4ce005fe$var$_hoisted_2$2 = {
    ref: "prevScroller",
    class: "cdx-tabs__prev-scroller"
};
const $db68d79c4ce005fe$var$_hoisted_3$1 = {
    ref: "tabListElement",
    class: "cdx-tabs__list",
    role: "tablist"
};
const $db68d79c4ce005fe$var$_hoisted_4$1 = [
    "id",
    "disabled",
    "aria-controls",
    "aria-selected",
    "tabindex",
    "onClick",
    "onKeyup"
];
const $db68d79c4ce005fe$var$_hoisted_5$1 = {
    ref: "nextScroller",
    class: "cdx-tabs__next-scroller"
};
const $db68d79c4ce005fe$var$_hoisted_6$1 = {
    class: "cdx-tabs__content"
};
function $db68d79c4ce005fe$var$_sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-tabs",
            _ctx.rootClasses
        ])
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$4, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_2$2, [
                (0, $TusQn.createVNode)(_component_cdx_button, {
                    class: "cdx-tabs__scroll-button",
                    weight: "quiet",
                    type: "button",
                    tabindex: "-1",
                    "aria-hidden": true,
                    onMousedown: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(()=>{}, [
                        "prevent"
                    ])),
                    onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.scrollTabs("prev"))
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_cdx_icon, {
                                icon: _ctx.cdxIconPrevious
                            }, null, 8, [
                                "icon"
                            ])
                        ]),
                    _: 1
                })
            ], 512), [
                [
                    (0, $eeJ70.vShow),
                    !_ctx.firstLabelVisible
                ]
            ]),
            (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_3$1, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.tabsData.values(), (tab, index)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        id: "".concat(tab.id, "-label"),
                        key: index,
                        ref_for: true,
                        ref: (ref2)=>_ctx.assignTemplateRefForTabButton(ref2, index),
                        disabled: tab.disabled ? true : void 0,
                        "aria-controls": tab.id,
                        "aria-selected": tab.name === _ctx.activeTab,
                        tabindex: tab.name === _ctx.activeTab ? void 0 : -1,
                        class: "cdx-tabs__list__item",
                        role: "tab",
                        onClick: (0, $eeJ70.withModifiers)(($event)=>_ctx.select(tab.name), [
                            "prevent"
                        ]),
                        onKeyup: (0, $eeJ70.withKeys)(($event)=>_ctx.select(tab.name), [
                            "enter"
                        ]),
                        onKeydown: [
                            _cache[2] || (_cache[2] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onRightArrowKeypress && _ctx.onRightArrowKeypress(...args), [
                                "prevent"
                            ]), [
                                "right"
                            ])),
                            _cache[3] || (_cache[3] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onDownArrowKeypress && _ctx.onDownArrowKeypress(...args), [
                                "prevent"
                            ]), [
                                "down"
                            ])),
                            _cache[4] || (_cache[4] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onLeftArrowKeypress && _ctx.onLeftArrowKeypress(...args), [
                                "prevent"
                            ]), [
                                "left"
                            ]))
                        ]
                    }, [
                        (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)(tab.label), 1)
                    ], 40, $db68d79c4ce005fe$var$_hoisted_4$1);
                }), 128))
            ], 512),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_5$1, [
                (0, $TusQn.createVNode)(_component_cdx_button, {
                    class: "cdx-tabs__scroll-button",
                    weight: "quiet",
                    type: "button",
                    tabindex: "-1",
                    "aria-hidden": true,
                    onMousedown: _cache[5] || (_cache[5] = (0, $eeJ70.withModifiers)(()=>{}, [
                        "prevent"
                    ])),
                    onClick: _cache[6] || (_cache[6] = ($event)=>_ctx.scrollTabs("next"))
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_cdx_icon, {
                                icon: _ctx.cdxIconNext
                            }, null, 8, [
                                "icon"
                            ])
                        ]),
                    _: 1
                })
            ], 512), [
                [
                    (0, $eeJ70.vShow),
                    !_ctx.lastLabelVisible
                ]
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_6$1, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ])
    ], 2);
}
const $db68d79c4ce005fe$export$a83e2c3a89339f7f = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$4, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$4
    ]
]);
const $db68d79c4ce005fe$var$statusValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$3 = (0, $TusQn.defineComponent)({
    name: "CdxTextArea",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    inheritAttrs: false,
    props: {
        /**
     * Current value of the textarea.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: String,
            default: ""
        },
        /**
     * `status` attribute of the textarea.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator
        },
        /**
     * Whether the textarea is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Describes whether the textarea grows vertically to show all text.
     *
     * When autosize is true, the textarea automatically grows in height (vertically).
     * The height of the textarea expands while the user types in the textarea.
     * The content inside the textarea is visible and there's no scroll.
     *
     * @values true, false
     */ autosize: {
            type: Boolean,
            default: false
        },
        /**
     * An icon at the start of the textarea element. Similar to a `::before` pseudo-element.
     */ startIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        },
        /**
     * An icon at the end of the textarea element. Similar to an `::after` pseudo-element.
     */ endIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        }
    },
    emits: [
        /**
     * When the textarea value changes.
     *
     * @property {string} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { attrs: attrs, emit: emit }) {
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        const idAttribute = attrs.id;
        const { computedDisabled: computedDisabled, computedStatus: computedStatus, computedInputId: computedInputId } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"), idAttribute);
        const descriptionId = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldDescriptionIdKey, void 0);
        const textareaClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-text-area__textarea--has-value": !!wrappedModel.value,
                "cdx-text-area__textarea--is-autosize": props.autosize
            };
        });
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-text-area--status-default": computedStatus.value === "default",
                "cdx-text-area--status-error": computedStatus.value === "error",
                "cdx-text-area--has-start-icon": !!props.startIcon,
                "cdx-text-area--has-end-icon": !!props.endIcon
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const otherAttrsMinusId = (0, $01W3b.computed)(()=>{
            const _a = otherAttrs.value, { id: id } = _a, everythingElse = $db68d79c4ce005fe$var$__objRest(_a, [
                "id"
            ]);
            return everythingElse;
        });
        const textarea = (0, $01W3b.ref)();
        function onInput() {
            if (textarea.value && props.autosize) {
                textarea.value.style.height = "auto";
                textarea.value.style.height = "".concat(textarea.value.scrollHeight, "px");
            }
        }
        return {
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            wrappedModel: wrappedModel,
            computedDisabled: computedDisabled,
            computedInputId: computedInputId,
            descriptionId: descriptionId,
            textareaClasses: textareaClasses,
            otherAttrsMinusId: otherAttrsMinusId,
            textarea: textarea,
            onInput: onInput
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$3 = [
    "id",
    "aria-describedby",
    "disabled"
];
function $db68d79c4ce005fe$var$_sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-text-area",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", (0, $TusQn.mergeProps)({
            id: _ctx.computedInputId,
            ref: "textarea"
        }, _ctx.otherAttrsMinusId, {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
            class: [
                _ctx.textareaClasses,
                "cdx-text-area__textarea"
            ],
            "aria-describedby": _ctx.descriptionId,
            disabled: _ctx.computedDisabled,
            onInput: _cache[1] || (_cache[1] = (...args)=>_ctx.onInput && _ctx.onInput(...args))
        }), null, 16, $db68d79c4ce005fe$var$_hoisted_1$3), [
            [
                (0, $eeJ70.vModelText),
                _ctx.wrappedModel
            ]
        ]),
        _ctx.startIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 0,
            icon: _ctx.startIcon,
            class: "cdx-text-area__icon-vue cdx-text-area__start-icon"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.endIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 1,
            icon: _ctx.endIcon,
            class: "cdx-text-area__icon-vue cdx-text-area__end-icon"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6);
}
const $db68d79c4ce005fe$export$7d16ed33844943b8 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$3, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$3
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$2 = (0, $TusQn.defineComponent)({
    name: "CdxToggleButtonGroup",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxToggleButton: $db68d79c4ce005fe$export$e302ca96e16828af
    },
    props: {
        /**
     * Buttons to display. See the ButtonGroupItem type.
     */ buttons: {
            type: Array,
            required: true,
            validator: (value)=>Array.isArray(value) && value.length >= 1
        },
        /**
     * Selected value, or array of selected values.
     *
     * If this is a string or number, the button whose value equals that string or number is
     * selected, and only a single selection is allowed. If this is an array, the buttons whose
     * values equal any of the values in the array are selected, and multiple selections are
     * allowed. To select none of the buttons initially, set this to `null`
     * (for single-selection groups) or to `[]` (for multi-selection groups).
     *
     * Must be bound with `v-model`.
     */ modelValue: {
            type: [
                String,
                Number,
                null,
                Array
            ],
            required: true
        },
        /**
     * Whether the entire group is disabled.
     *
     * If this is set to true, all buttons in the group are disabled. Buttons can also be
     * disabled individually by setting their `disabled` property to true.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes.
     *
     * @property {string | number | ( string | number )[]} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit }) {
        const { rootElement: rootElement, assignTemplateRef: assignTemplateRef, onFocus: onFocus, onBlur: onBlur, onKeydown: onKeydown } = $db68d79c4ce005fe$var$useButtonGroupKeyboardNav((0, $01W3b.toRef)(props, "buttons"));
        function isSelected(button) {
            if (Array.isArray(props.modelValue)) return props.modelValue.indexOf(button.value) !== -1;
            else if (props.modelValue !== null) return props.modelValue === button.value;
            return false;
        }
        function onUpdate(button, nowSelected) {
            if (Array.isArray(props.modelValue)) {
                const wasSelected = props.modelValue.indexOf(button.value) !== -1;
                if (nowSelected && !wasSelected) emit("update:modelValue", props.modelValue.concat(button.value));
                else if (!nowSelected && wasSelected) emit("update:modelValue", props.modelValue.filter((v)=>v !== button.value));
            } else if (nowSelected && props.modelValue !== button.value) emit("update:modelValue", button.value);
        }
        return {
            rootElement: rootElement,
            assignTemplateRef: assignTemplateRef,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeydown: onKeydown,
            getButtonLabel: $db68d79c4ce005fe$var$getButtonLabel,
            isSelected: isSelected,
            onUpdate: onUpdate
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$2 = {
    ref: "rootElement",
    class: "cdx-toggle-button-group"
};
function $db68d79c4ce005fe$var$_sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_toggle_button = (0, $TusQn.resolveComponent)("cdx-toggle-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$2, [
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.buttons, (button, index)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_toggle_button, {
                key: button.value,
                ref_for: true,
                ref: (ref2)=>_ctx.assignTemplateRef(ref2, index),
                "model-value": _ctx.isSelected(button),
                disabled: button.disabled || _ctx.disabled,
                "aria-label": button.ariaLabel,
                "onUpdate:modelValue": ($event)=>_ctx.onUpdate(button, $event),
                onFocus: ($event)=>_ctx.onFocus(index),
                onBlur: _ctx.onBlur,
                onKeydown: _ctx.onKeydown
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default", {
                            button: button,
                            selected: _ctx.isSelected(button)
                        }, ()=>[
                                button.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                                    key: 0,
                                    icon: button.icon
                                }, null, 8, [
                                    "icon"
                                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                (0, $TusQn.createTextVNode)(" " + (0, $8XWQX.toDisplayString)(_ctx.getButtonLabel(button)), 1)
                            ])
                    ]),
                _: 2
            }, 1032, [
                "model-value",
                "disabled",
                "aria-label",
                "onUpdate:modelValue",
                "onFocus",
                "onBlur",
                "onKeydown"
            ]);
        }), 128))
    ], 512);
}
const $db68d79c4ce005fe$export$97d7169b3dc35473 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$2, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$2
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$1 = (0, $TusQn.defineComponent)({
    name: "CdxToggleSwitch",
    components: {
        CdxLabel: $db68d79c4ce005fe$export$fd351ab562a06a13
    },
    /**
   * The input element will inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Current value of the toggle switch or toggle switch group.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                Boolean,
                Array
            ],
            default: false
        },
        /**
     * HTML "value" attribute to assign to the input element.
     *
     * Required for groups of ToggleSwitches. Can be omitted for single true/false switches.
     */ inputValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: false
        },
        /**
     * Whether to align the switch to the end of the container.
     *
     * Useful for ToggleSwitch groups, where each switch should be aligned regardless of
     * label length.
     */ alignSwitch: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the label should be visually hidden.
     *
     * Note that this will also hide the description.
     */ hideLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the disabled attribute should be added to the input.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes.
     *
     * @property {boolean} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        var _a;
        $db68d79c4ce005fe$var$useLabelChecker((_a = slots.default) == null ? void 0 : _a.call(slots), attrs, "CdxToggleSwitch");
        const input = (0, $01W3b.ref)();
        const inputId = $db68d79c4ce005fe$export$6217842283d27b52("toggle-switch");
        const descriptionId = $db68d79c4ce005fe$export$6217842283d27b52("description");
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-toggle-switch--align-switch": props.alignSwitch
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const { computedDisabled: computedDisabled } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"));
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        const clickInput = ()=>{
            input.value.click();
        };
        return {
            input: input,
            inputId: inputId,
            descriptionId: descriptionId,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            computedDisabled: computedDisabled,
            wrappedModel: wrappedModel,
            clickInput: clickInput
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$1 = [
    "id",
    "aria-describedby",
    "value",
    "disabled"
];
const $db68d79c4ce005fe$var$_hoisted_2$1 = /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
    class: "cdx-toggle-switch__switch"
}, [
    /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
        class: "cdx-toggle-switch__switch__grip"
    })
], -1);
function $db68d79c4ce005fe$var$_sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_label = (0, $TusQn.resolveComponent)("cdx-label");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-toggle-switch",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
            id: _ctx.inputId,
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
            class: "cdx-toggle-switch__input",
            type: "checkbox",
            role: "switch",
            "aria-describedby": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
            value: _ctx.inputValue,
            disabled: _ctx.computedDisabled
        }, _ctx.otherAttrs, {
            onKeydown: _cache[1] || (_cache[1] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.clickInput && _ctx.clickInput(...args), [
                "prevent"
            ]), [
                "enter"
            ]))
        }), null, 16, $db68d79c4ce005fe$var$_hoisted_1$1), [
            [
                (0, $eeJ70.vModelCheckbox),
                _ctx.wrappedModel
            ]
        ]),
        $db68d79c4ce005fe$var$_hoisted_2$1,
        _ctx.$slots.default && _ctx.$slots.default().length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_label, {
            key: 0,
            class: "cdx-toggle-switch__label",
            "input-id": _ctx.inputId,
            "description-id": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
            "visually-hidden": _ctx.hideLabel,
            disabled: _ctx.computedDisabled
        }, (0, $TusQn.createSlots)({
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                ]),
            _: 2
        }, [
            _ctx.$slots.description && _ctx.$slots.description().length > 0 ? {
                name: "description",
                fn: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                    ]),
                key: "0"
            } : void 0
        ]), 1032, [
            "input-id",
            "description-id",
            "visually-hidden",
            "disabled"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6);
}
const $db68d79c4ce005fe$export$47bd8c36709c3277 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$1, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$1
    ]
]);
class $db68d79c4ce005fe$var$Tooltip {
    constructor(referenceElement, options){
        $db68d79c4ce005fe$var$__publicField(this, "referenceElement");
        $db68d79c4ce005fe$var$__publicField(this, "tooltipElement");
        $db68d79c4ce005fe$var$__publicField(this, "textContent");
        $db68d79c4ce005fe$var$__publicField(this, "placement");
        $db68d79c4ce005fe$var$__publicField(this, "autoUpdateCleanup");
        $db68d79c4ce005fe$var$__publicField(this, "referenceElementHandlers");
        $db68d79c4ce005fe$var$__publicField(this, "tooltipElementHandlers");
        $db68d79c4ce005fe$var$__publicField(this, "escapeHandler");
        $db68d79c4ce005fe$var$__publicField(this, "timeoutId");
        var _a, _b;
        const doc = referenceElement.ownerDocument;
        const tooltipId = $db68d79c4ce005fe$export$6217842283d27b52("tooltip");
        this.referenceElement = referenceElement;
        this.textContent = options.textContent;
        this.placement = (_a = options.placement) != null ? _a : "bottom";
        this.timeoutId = null;
        this.tooltipElement = doc.createElement("div");
        this.tooltipElement.classList.add("cdx-tooltip");
        this.tooltipElement.role = "tooltip";
        this.tooltipElement.id = tooltipId;
        this.referenceElement.setAttribute("aria-describedby", tooltipId);
        this.tooltipElement.textContent = this.textContent;
        (_b = this.referenceElement.parentElement) == null || _b.appendChild(this.tooltipElement);
        this.referenceElementHandlers = {};
        this.referenceElementHandlers.mouseenter = this.show.bind(this);
        this.referenceElementHandlers.mouseleave = this.hideAfterDelay.bind(this);
        this.referenceElementHandlers.focus = this.show.bind(this);
        this.referenceElementHandlers.blur = this.hide.bind(this);
        this.tooltipElementHandlers = {};
        this.tooltipElementHandlers.mouseenter = this.show.bind(this);
        this.tooltipElementHandlers.mouseleave = this.hideAfterDelay.bind(this);
        this.escapeHandler = this.onKeyup.bind(this);
        this.addEventListeners();
        this.autoUpdateCleanup = $db68d79c4ce005fe$var$autoUpdate(this.referenceElement, this.tooltipElement, ()=>this.update());
    }
    isVisible() {
        return this.tooltipElement.style.display === "block";
    }
    show() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
        this.tooltipElement.style.display = "block";
        this.tooltipElement.ownerDocument.addEventListener("keyup", this.escapeHandler);
    }
    hide() {
        this.tooltipElement.style.display = "none";
        this.tooltipElement.ownerDocument.removeEventListener("keyup", this.escapeHandler);
    }
    hideAfterDelay() {
        this.timeoutId = setTimeout(this.hide.bind(this), 250);
    }
    onKeyup(event) {
        if (event.key === "Escape" && this.isVisible()) this.hide();
    }
    addEventListeners() {
        Object.keys(this.referenceElementHandlers).forEach((k)=>{
            this.referenceElement.addEventListener(k, this.referenceElementHandlers[k]);
        });
        Object.keys(this.tooltipElementHandlers).forEach((k)=>{
            this.tooltipElement.addEventListener(k, this.tooltipElementHandlers[k]);
        });
    }
    removeEventListeners() {
        Object.keys(this.referenceElementHandlers).forEach((k)=>{
            this.referenceElement.removeEventListener(k, this.referenceElementHandlers[k]);
        });
        Object.keys(this.tooltipElementHandlers).forEach((k)=>{
            this.tooltipElement.removeEventListener(k, this.tooltipElementHandlers[k]);
        });
    }
    update() {
        $db68d79c4ce005fe$var$computePosition(this.referenceElement, this.tooltipElement, {
            placement: this.placement,
            middleware: [
                $db68d79c4ce005fe$var$offset(4),
                $db68d79c4ce005fe$var$flip(),
                $db68d79c4ce005fe$var$shift(),
                $db68d79c4ce005fe$var$hide()
            ]
        }).then(({ x: x, y: y, middlewareData: middlewareData })=>{
            var _a, _b, _c;
            const finalPlacement = (_b = (_a = middlewareData.offset) == null ? void 0 : _a.placement) != null ? _b : this.placement;
            const opposites = {
                left: "right",
                "left-start": "right",
                "left-end": "right",
                top: "bottom",
                "top-start": "bottom",
                "top-end": "bottom",
                bottom: "top",
                "bottom-start": "top",
                "bottom-end": "top",
                right: "left",
                "right-start": "left",
                "right-end": "left"
            };
            Object.assign(this.tooltipElement.style, {
                left: "".concat(x, "px"),
                top: "".concat(y, "px"),
                visibility: ((_c = middlewareData.hide) == null ? void 0 : _c.referenceHidden) ? "hidden" : "visible",
                transformOrigin: opposites[finalPlacement]
            });
        });
    }
    remove() {
        this.tooltipElement.remove();
        this.autoUpdateCleanup();
        this.removeEventListeners();
    }
}
const $db68d79c4ce005fe$export$e00d4f6eba63ec7d = {
    mounted (el, { value: value, arg: arg }) {
        el.tooltip = new $db68d79c4ce005fe$var$Tooltip(el, {
            textContent: String(value),
            placement: arg
        });
    },
    beforeUnmount (el) {
        if (el.tooltip) el.tooltip.remove();
    }
};
const $db68d79c4ce005fe$var$_sfc_main = (0, $TusQn.defineComponent)({
    name: "CdxTypeaheadSearch",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad,
        CdxSearchInput: $db68d79c4ce005fe$export$4d07ca0116afbc71
    },
    /**
   * Attributes, besides class, will be passed to the TextInput's input element.
   */ inheritAttrs: false,
    props: {
        /**
     * ID attribute for the form.
     */ id: {
            type: String,
            required: true
        },
        /**
     * Action attribute for form.
     */ formAction: {
            type: String,
            required: true
        },
        /**
     * List of search results. See the SearchResult type.
     */ searchResults: {
            type: Array,
            required: true
        },
        /**
     *
     * Whether to display a submit button.
     */ useButton: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to 'Search' (T368444).
        /**
     * Custom label for the submit button.
     *
     * Omit this prop to use the default value, "Search".
     */ buttonLabel: {
            type: String,
            default: ""
        },
        /**
     * Initial value for the text input.
     *
     * Triggers an initial `input` event on mount.
     */ initialInputValue: {
            type: String,
            default: ""
        },
        /**
     * Link for the final menu item.
     *
     * This will typically be a link to the search page for the current search query.
     */ searchFooterUrl: {
            type: String,
            default: ""
        },
        /**
     * Time interval for debouncing input events, in ms.
     */ debounceInterval: {
            type: Number,
            default: $db68d79c4ce005fe$var$DebounceInterval
        },
        /**
     * Whether the search query should be highlighted within a search result's title.
     */ highlightQuery: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to show search results' thumbnails (or a placeholder icon).
     */ showThumbnail: {
            type: Boolean,
            default: false
        },
        /**
     * Contract the width of the input when unfocused and expand the width of
     * the input when focused to accommodate the extra width of the thumbnails.
     *
     * This prop is ignored if showThumbnail is false.
     */ autoExpandWidth: {
            type: Boolean,
            default: false
        },
        /**
     * Limit the number of menu items to display before scrolling.
     *
     * Setting this prop to anything falsy will show all menu items.
     *
     * By default, all menu items are shown.
     */ visibleItemLimit: {
            type: Number,
            default: null
        }
    },
    emits: [
        /**
     * When the text input value changes. Debounced by default.
     *
     * @property {string} value The new input value
     */ "input",
        /**
     * When a search result is selected.
     *
     * @property {SearchResultClickEvent} event Data for the selected result
     */ "search-result-click",
        /**
     * When the form is submitted.
     *
     * @property {SearchResultClickEvent} event Data for the selected result
     */ "submit",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more"
    ],
    setup (props, { attrs: attrs, emit: emit, slots: slots }) {
        const form = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("typeahead-search-menu");
        const translatedSearchResultsLabel = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-typeahead-search-search-results-label", "Search results");
        const expanded = (0, $01W3b.ref)(false);
        const pending = (0, $01W3b.ref)(false);
        const showPending = (0, $01W3b.ref)(false);
        const isActive = (0, $01W3b.ref)(false);
        const inputValue = (0, $01W3b.ref)(props.initialInputValue);
        const searchQuery = (0, $01W3b.ref)("");
        const highlightedId = (0, $01W3b.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        const selection = (0, $01W3b.ref)(null);
        const menuMessageClass = (0, $01W3b.computed)(()=>({
                "cdx-typeahead-search__menu-message--has-thumbnail": props.showThumbnail
            }));
        const selectedResult = (0, $01W3b.computed)(()=>props.searchResults.find((searchResult)=>searchResult.value === selection.value));
        const footer = (0, $01W3b.computed)(()=>props.searchFooterUrl ? {
                value: $db68d79c4ce005fe$var$MenuFooterValue,
                url: props.searchFooterUrl
            } : void 0);
        const internalClasses = (0, $01W3b.computed)(()=>{
            return {
                "cdx-typeahead-search--show-thumbnail": props.showThumbnail,
                "cdx-typeahead-search--expanded": expanded.value,
                "cdx-typeahead-search--auto-expand-width": props.showThumbnail && props.autoExpandWidth
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        function asSearchResult(menuItem) {
            return menuItem;
        }
        const menuConfig = (0, $01W3b.computed)(()=>{
            return {
                visibleItemLimit: props.visibleItemLimit,
                showThumbnail: props.showThumbnail,
                // In case search queries aren't highlighted, default to a bold label.
                boldLabel: true,
                hideDescriptionOverflow: true
            };
        });
        let debounceId;
        let pendingDelayId;
        function onUpdateInputValue(newVal, immediate = false) {
            if (selectedResult.value && selectedResult.value.label !== newVal && selectedResult.value.value !== newVal) selection.value = null;
            if (pendingDelayId !== void 0) {
                clearTimeout(pendingDelayId);
                pendingDelayId = void 0;
            }
            if (newVal === "") expanded.value = false;
            else {
                pending.value = true;
                if (slots["search-results-pending"]) pendingDelayId = setTimeout(()=>{
                    if (isActive.value) expanded.value = true;
                    showPending.value = true;
                }, $db68d79c4ce005fe$var$PendingDelay);
            }
            if (debounceId !== void 0) {
                clearTimeout(debounceId);
                debounceId = void 0;
            }
            const handleUpdateInputValue = ()=>{
                emit("input", newVal);
            };
            if (immediate) handleUpdateInputValue();
            else debounceId = setTimeout(()=>{
                handleUpdateInputValue();
            }, props.debounceInterval);
        }
        function onUpdateMenuSelection(newVal) {
            var _a;
            if (newVal === $db68d79c4ce005fe$var$MenuFooterValue) {
                selection.value = null;
                inputValue.value = searchQuery.value;
                return;
            }
            selection.value = newVal;
            if (newVal !== null) inputValue.value = selectedResult.value ? (_a = selectedResult.value.label) != null ? _a : String(selectedResult.value.value) : "";
        }
        function onFocus() {
            isActive.value = true;
            if (searchQuery.value || showPending.value) expanded.value = true;
        }
        function onBlur() {
            isActive.value = false;
            expanded.value = false;
        }
        function onSearchResultClick(searchResult) {
            const _a = searchResult, { id: id } = _a, resultWithoutId = $db68d79c4ce005fe$var$__objRest(_a, [
                "id"
            ]);
            if (resultWithoutId.value === $db68d79c4ce005fe$var$MenuFooterValue) {
                emit("search-result-click", {
                    searchResult: null,
                    index: props.searchResults.length,
                    numberOfResults: props.searchResults.length
                });
                return;
            }
            emitSearchResultClick(resultWithoutId);
        }
        function emitSearchResultClick(searchResult) {
            const searchResultClickEvent = {
                searchResult: searchResult,
                index: props.searchResults.findIndex((r)=>r.value === searchResult.value),
                numberOfResults: props.searchResults.length
            };
            emit("search-result-click", searchResultClickEvent);
        }
        function onSearchResultKeyboardNavigation(searchResult) {
            var _a;
            if (searchResult.value === $db68d79c4ce005fe$var$MenuFooterValue) {
                inputValue.value = searchQuery.value;
                return;
            }
            inputValue.value = searchResult.value ? (_a = searchResult.label) != null ? _a : String(searchResult.value) : "";
        }
        function onSearchFooterClick(footerMenuItem) {
            var _a;
            expanded.value = false;
            (_a = menu.value) == null || _a.clearActive();
            onSearchResultClick(footerMenuItem);
        }
        function onSubmit(e) {
            if (selectedResult.value) {
                emitSearchResultClick(selectedResult.value);
                e.stopPropagation();
                window.location.assign(selectedResult.value.url);
                e.preventDefault();
            } else {
                const submitEvent = {
                    searchResult: null,
                    index: -1,
                    numberOfResults: props.searchResults.length
                };
                emit("submit", submitEvent);
            }
        }
        function onKeydown(e) {
            if (!menu.value || !searchQuery.value || e.key === " ") return;
            const highlightedResult = menu.value.getHighlightedMenuItem();
            const resultHighlightedViaKeyboard = menu.value.getHighlightedViaKeyboard();
            switch(e.key){
                case "Enter":
                    if (highlightedResult) {
                        if (highlightedResult.value === $db68d79c4ce005fe$var$MenuFooterValue && resultHighlightedViaKeyboard) window.location.assign(props.searchFooterUrl);
                        else menu.value.delegateKeyNavigation(e, {
                            prevent: false
                        });
                    }
                    expanded.value = false;
                    break;
                case "Tab":
                    expanded.value = false;
                    break;
                default:
                    menu.value.delegateKeyNavigation(e);
                    break;
            }
        }
        (0, $TusQn.onMounted)(()=>{
            if (props.initialInputValue) onUpdateInputValue(props.initialInputValue, true);
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "searchResults"), ()=>{
            searchQuery.value = inputValue.value.trim();
            if (isActive.value && pending.value && searchQuery.value.length > 0) expanded.value = true;
            if (pendingDelayId !== void 0) {
                clearTimeout(pendingDelayId);
                pendingDelayId = void 0;
            }
            pending.value = false;
            showPending.value = false;
        });
        return {
            form: form,
            menu: menu,
            menuId: menuId,
            highlightedId: highlightedId,
            selection: selection,
            menuMessageClass: menuMessageClass,
            footer: footer,
            asSearchResult: asSearchResult,
            inputValue: inputValue,
            searchQuery: searchQuery,
            expanded: expanded,
            showPending: showPending,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            menuConfig: menuConfig,
            onUpdateInputValue: onUpdateInputValue,
            onUpdateMenuSelection: onUpdateMenuSelection,
            onFocus: onFocus,
            onBlur: onBlur,
            onSearchResultClick: onSearchResultClick,
            onSearchResultKeyboardNavigation: onSearchResultKeyboardNavigation,
            onSearchFooterClick: onSearchFooterClick,
            onSubmit: onSubmit,
            onKeydown: onKeydown,
            MenuFooterValue: $db68d79c4ce005fe$var$MenuFooterValue,
            articleIcon: $db68d79c4ce005fe$var$S3,
            translatedSearchResultsLabel: translatedSearchResultsLabel
        };
    },
    methods: {
        /**
     * Focus the component's input element.
     *
     * @public
     */ focus () {
            const searchInput = this.$refs.searchInput;
            searchInput.focus();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1 = [
    "id",
    "action"
];
const $db68d79c4ce005fe$var$_hoisted_2 = {
    class: "cdx-typeahead-search__menu-message__text"
};
const $db68d79c4ce005fe$var$_hoisted_3 = {
    class: "cdx-typeahead-search__menu-message__text"
};
const $db68d79c4ce005fe$var$_hoisted_4 = [
    "href",
    "onClickCapture"
];
const $db68d79c4ce005fe$var$_hoisted_5 = {
    class: "cdx-menu-item__text cdx-typeahead-search__search-footer__text"
};
const $db68d79c4ce005fe$var$_hoisted_6 = {
    class: "cdx-typeahead-search__search-footer__query"
};
function $db68d79c4ce005fe$var$_sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    const _component_cdx_search_input = (0, $TusQn.resolveComponent)("cdx-search-input");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-typeahead-search",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("form", {
            id: _ctx.id,
            ref: "form",
            class: "cdx-typeahead-search__form",
            action: _ctx.formAction,
            onSubmit: _cache[4] || (_cache[4] = (...args)=>_ctx.onSubmit && _ctx.onSubmit(...args))
        }, [
            (0, $TusQn.createVNode)(_component_cdx_search_input, (0, $TusQn.mergeProps)({
                ref: "searchInput",
                modelValue: _ctx.inputValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>_ctx.inputValue = $event),
                "button-label": _ctx.buttonLabel,
                "use-button": _ctx.useButton
            }, _ctx.otherAttrs, {
                class: "cdx-typeahead-search__input",
                name: "search",
                role: "combobox",
                autocomplete: "off",
                "aria-autocomplete": "list",
                "aria-controls": _ctx.menuId,
                "aria-expanded": _ctx.expanded,
                "aria-activedescendant": _ctx.highlightedId,
                "onUpdate:modelValue": _ctx.onUpdateInputValue,
                onFocus: _ctx.onFocus,
                onBlur: _ctx.onBlur,
                onKeydown: _ctx.onKeydown
            }), {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
                            id: _ctx.menuId,
                            ref: "menu",
                            expanded: _ctx.expanded,
                            "onUpdate:expanded": _cache[0] || (_cache[0] = ($event)=>_ctx.expanded = $event),
                            class: "cdx-typeahead-search__menu",
                            "show-pending": _ctx.showPending,
                            selected: _ctx.selection,
                            "menu-items": _ctx.searchResults,
                            footer: _ctx.footer,
                            "search-query": _ctx.highlightQuery ? _ctx.searchQuery : "",
                            "show-no-results-slot": _ctx.searchQuery.length > 0 && _ctx.searchResults.length === 0 && _ctx.$slots["search-no-results-text"] && _ctx.$slots["search-no-results-text"]().length > 0
                        }, _ctx.menuConfig, {
                            "aria-label": _ctx.translatedSearchResultsLabel,
                            "onUpdate:selected": _ctx.onUpdateMenuSelection,
                            onMenuItemClick: _cache[1] || (_cache[1] = (menuItem)=>_ctx.onSearchResultClick(_ctx.asSearchResult(menuItem))),
                            onMenuItemKeyboardNavigation: _ctx.onSearchResultKeyboardNavigation,
                            onLoadMore: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("load-more"))
                        }), {
                            pending: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("div", {
                                        class: (0, $8XWQX.normalizeClass)([
                                            "cdx-menu-item__content cdx-typeahead-search__menu-message",
                                            _ctx.menuMessageClass
                                        ])
                                    }, [
                                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2, [
                                            (0, $TusQn.renderSlot)(_ctx.$slots, "search-results-pending")
                                        ])
                                    ], 2)
                                ]),
                            "no-results": (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("div", {
                                        class: (0, $8XWQX.normalizeClass)([
                                            "cdx-menu-item__content cdx-typeahead-search__menu-message",
                                            _ctx.menuMessageClass
                                        ])
                                    }, [
                                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_3, [
                                            (0, $TusQn.renderSlot)(_ctx.$slots, "search-no-results-text")
                                        ])
                                    ], 2)
                                ]),
                            default: (0, $TusQn.withCtx)(({ menuItem: menuItem, active: active })=>[
                                    menuItem.value === _ctx.MenuFooterValue ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                        key: 0,
                                        class: (0, $8XWQX.normalizeClass)([
                                            "cdx-menu-item__content cdx-typeahead-search__search-footer",
                                            {
                                                "cdx-typeahead-search__search-footer__active": active
                                            }
                                        ]),
                                        href: _ctx.asSearchResult(menuItem).url,
                                        onClickCapture: (0, $eeJ70.withModifiers)(($event)=>_ctx.onSearchFooterClick(_ctx.asSearchResult(menuItem)), [
                                            "stop"
                                        ])
                                    }, [
                                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                                            class: "cdx-menu-item__thumbnail cdx-typeahead-search__search-footer__icon",
                                            icon: _ctx.articleIcon
                                        }, null, 8, [
                                            "icon"
                                        ]),
                                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_5, [
                                            (0, $TusQn.renderSlot)(_ctx.$slots, "search-footer-text", {
                                                searchQuery: _ctx.searchQuery
                                            }, ()=>[
                                                    (0, $TusQn.createElementVNode)("strong", $db68d79c4ce005fe$var$_hoisted_6, (0, $8XWQX.toDisplayString)(_ctx.searchQuery), 1)
                                                ])
                                        ])
                                    ], 42, $db68d79c4ce005fe$var$_hoisted_4)) : (0, $TusQn.createCommentVNode)("v-if", true)
                                ]),
                            _: 3
                        }, 16, [
                            "id",
                            "expanded",
                            "show-pending",
                            "selected",
                            "menu-items",
                            "footer",
                            "search-query",
                            "show-no-results-slot",
                            "aria-label",
                            "onUpdate:selected",
                            "onMenuItemKeyboardNavigation"
                        ])
                    ]),
                _: 3
            }, 16, [
                "modelValue",
                "button-label",
                "use-button",
                "aria-controls",
                "aria-expanded",
                "aria-activedescendant",
                "onUpdate:modelValue",
                "onFocus",
                "onBlur",
                "onKeydown"
            ]),
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ], 40, $db68d79c4ce005fe$var$_hoisted_1)
    ], 6);
}
const $db68d79c4ce005fe$export$c806659652d42b0 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render
    ]
]);

});

parcelRegister("fhnAG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1fabe282bc2c176$export$2e2bcd8739ae039);
let $b1fabe282bc2c176$var$script;




let $b1fabe282bc2c176$var$initialize = ()=>{
    $b1fabe282bc2c176$var$script = (parcelRequire("7yzsN"));
    if ($b1fabe282bc2c176$var$script.__esModule) $b1fabe282bc2c176$var$script = $b1fabe282bc2c176$var$script.default;
    $b1fabe282bc2c176$var$script.render = (parcelRequire("7Vxyp")).render;
    $b1fabe282bc2c176$var$script.__cssModules = {};
    (parcelRequire("e1CGa")).default($b1fabe282bc2c176$var$script);
    $b1fabe282bc2c176$var$script.__scopeId = 'data-v-ffb8ad';
    $b1fabe282bc2c176$var$script.__file = "ShareBox.vue";
};
$b1fabe282bc2c176$var$initialize();
var $b1fabe282bc2c176$export$2e2bcd8739ae039 = $b1fabe282bc2c176$var$script;

});
parcelRegister("7yzsN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $580737af4b536d63$export$2e2bcd8739ae039);

var $kl0vg = parcelRequire("kl0vg");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $lYxW4 = parcelRequire("lYxW4");

var $iPUx5 = parcelRequire("iPUx5");

var $liybR = parcelRequire("liybR");

var $dwPVL = parcelRequire("dwPVL");
var // @vue/component
$580737af4b536d63$export$2e2bcd8739ae039 = (0, $TusQn.defineComponent)({
    components: {
        StatBox: $kl0vg.default,
        CdxInfoChip: $iPUx5.CdxInfoChip
    },
    name: 'ShareBox',
    computed: {
        notes () {
            const topDay = this.stats.dayofweek[0];
            const topSlot = this.stats.hourofweek[0];
            const notes = [
                {
                    label: (0, $liybR.humanDay)(topDay.day),
                    tooltip: (0, $dwPVL.default).message('badge-day-desc', topSlot.timespan)
                },
                {
                    label: (0, $liybR.getTimeslotNote)(topSlot.timespan),
                    tooltip: (0, $dwPVL.default).message('badge-timeslot-desc', topSlot.timespan)
                }
            ];
            if (this.stats.fileUploads > 364) notes.push({
                label: (0, $dwPVL.default).message('badge-archivist'),
                tooltip: (0, $dwPVL.default).message('badge-archivist-desc')
            });
            if (this.stats.pageEdits > 50) notes.push({
                label: (0, $dwPVL.default).message('badge-proofreader'),
                tooltip: (0, $dwPVL.default).message('badge-proofreader-desc')
            });
            if (this.stats.templateEdits > 50) notes.push({
                label: (0, $dwPVL.default).message('badge-template-wizard'),
                tooltip: (0, $dwPVL.default).message('badge-template-wizard-desc')
            });
            if (this.stats.interfaceEdits > 20) notes.push({
                label: (0, $dwPVL.default).message('badge-interface-hero'),
                tooltip: (0, $dwPVL.default).message('badge-interface-hero-desc')
            });
            if (this.stats.totalEdits > 1000000) notes.push({
                label: (0, $dwPVL.default).message('badge-1m'),
                tooltip: (0, $dwPVL.default).message('badge-1m-desc')
            });
            else if (this.stats.totalEdits > 100000) notes.push({
                label: (0, $dwPVL.default).message('badge-100k'),
                tooltip: (0, $dwPVL.default).message('badge-100k-desc')
            });
            else if (this.stats.totalEdits > 10000) notes.push({
                label: (0, $dwPVL.default).message('badge-10k'),
                tooltip: (0, $dwPVL.default).message('badge-10k-desc')
            });
            else if (this.stats.totalEdits > 1000) notes.push({
                label: (0, $dwPVL.default).message('badge-1k'),
                tooltip: (0, $dwPVL.default).message('badge-1k-desc')
            });
            else if (this.stats.totalEdits > 100) notes.push({
                label: (0, $dwPVL.default).message('badge-100'),
                tooltip: (0, $dwPVL.default).message('badge-100-desc')
            });
            if (this.stats.talkEdits > 1000) notes.push({
                label: (0, $dwPVL.default).message('badge-chatterbox'),
                tooltip: (0, $dwPVL.default).message('badge-chatterbox-desc')
            });
            if (this.stats.thankedCount > 100) notes.push({
                label: (0, $dwPVL.default).message('badge-appreciated'),
                tooltip: (0, $dwPVL.default).message('badge-appreciated-desc')
            });
            if (this.stats.streak.longestStreak > 30) notes.push({
                label: (0, $dwPVL.default).message('badge-streak'),
                tooltip: (0, $dwPVL.default).message('badge-streak-desc')
            });
            return notes;
        },
        imageLogo () {
            switch(this.project){
                case 'www.mediawiki.org':
                    return 'https://www.wikidata.org/static/images/icons/mediawikiwiki.svg';
                case 'www.wikidata.org':
                    return 'https://www.wikidata.org/static/images/icons/wikidatawiki.svg';
                case 'commons.wikimedia.org':
                    return 'https://commons.wikimedia.org/static/images/icons/commonswiki.svg';
                default:
                    return 'https://upload.wikimedia.org/wikipedia/commons/a/a7/Adapted_Wikipedia20symbol_puzzleglobe.svg';
            }
        }
    },
    props: {
        host: {
            type: String,
            default: window.location.host
        },
        username: {
            type: String
        },
        project: {
            type: String
        },
        streakIcon: {
            type: String,
            default: (0, $lYxW4.cdxIconPlay)
        },
        wikidataIcon: {
            type: String,
            default: (0, $lYxW4.cdxIconLogoWikidata)
        },
        templateIcon: {
            type: String,
            default: (0, $lYxW4.cdxIconTemplateAdd)
        },
        gadgetIcon: {
            type: String,
            default: (0, $lYxW4.cdxIconLabFlask)
        },
        uploadIcon: {
            type: String,
            default: (0, $lYxW4.cdxIconUpload)
        },
        editIcon: {
            type: String,
            default: (0, $lYxW4.cdxIconEdit)
        },
        talkIcon: {
            type: Object,
            default: (0, $lYxW4.cdxIconOngoingConversation)
        },
        thankIcon: {
            type: Object,
            default: (0, $lYxW4.cdxIconUserTalk)
        },
        /**
		 * @type YIRStats
		 */ stats: {
            type: Object
        }
    }
});

});
parcelRegister("kl0vg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece628bb2d9cc9ae$export$2e2bcd8739ae039);
let $ece628bb2d9cc9ae$var$script;




let $ece628bb2d9cc9ae$var$initialize = ()=>{
    $ece628bb2d9cc9ae$var$script = (parcelRequire("iO5ZB"));
    if ($ece628bb2d9cc9ae$var$script.__esModule) $ece628bb2d9cc9ae$var$script = $ece628bb2d9cc9ae$var$script.default;
    $ece628bb2d9cc9ae$var$script.render = (parcelRequire("fDijm")).render;
    $ece628bb2d9cc9ae$var$script.__cssModules = {};
    (parcelRequire("4eq2q")).default($ece628bb2d9cc9ae$var$script);
    $ece628bb2d9cc9ae$var$script.__scopeId = 'data-v-3d5c35';
    $ece628bb2d9cc9ae$var$script.__file = "StatBox.vue";
};
$ece628bb2d9cc9ae$var$initialize();
var $ece628bb2d9cc9ae$export$2e2bcd8739ae039 = $ece628bb2d9cc9ae$var$script;

});
parcelRegister("iO5ZB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $db118b83b9edba85$export$2e2bcd8739ae039);

var $iPUx5 = parcelRequire("iPUx5");

var $dwPVL = parcelRequire("dwPVL");
var $db118b83b9edba85$export$2e2bcd8739ae039 = {
    name: 'StatBox',
    components: {
        CdxIcon: $iPUx5.CdxIcon
    },
    computed: {
        valueFormatted () {
            return (0, $dwPVL.default).convertNumber(this.value);
        }
    },
    props: {
        icon: String | Object,
        value: {
            type: Number
        },
        label: {
            type: String
        }
    }
};

});

parcelRegister("fDijm", function(module, exports) {

$parcel$export(module.exports, "render", () => $b618b3c36493bbc4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $b618b3c36493bbc4$var$_hoisted_1 = {
    class: "statbox"
};
const $b618b3c36493bbc4$var$_hoisted_2 = {
    class: "statbox-label"
};
function $b618b3c36493bbc4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b618b3c36493bbc4$var$_hoisted_1, [
        (0, $TusQn.createVNode)(_component_cdx_icon, {
            icon: $props.icon
        }, null, 8, [
            "icon"
        ]),
        (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)($options.valueFormatted), 1),
        (0, $TusQn.createElementVNode)("span", $b618b3c36493bbc4$var$_hoisted_2, (0, $8XWQX.toDisplayString)($props.label), 1)
    ]);
}

});

parcelRegister("4eq2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $314caae1338abd8f$export$2e2bcd8739ae039);
let $314caae1338abd8f$var$NOOP = ()=>{};
var $314caae1338abd8f$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("7Vxyp", function(module, exports) {

$parcel$export(module.exports, "render", () => $5c57e26a311690c7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");

var $bSGnN = parcelRequire("bSGnN");

var $hlpZx = parcelRequire("hlpZx");
const $5c57e26a311690c7$var$_hoisted_1 = {
    class: "sharebox",
    id: "statBox"
};
const $5c57e26a311690c7$var$_hoisted_2 = [
    "src"
];
const $5c57e26a311690c7$var$_hoisted_3 = {
    class: "stats"
};
const $5c57e26a311690c7$var$_hoisted_4 = {
    class: "sharebox-info-chips"
};
const $5c57e26a311690c7$var$_hoisted_5 = {
    class: "year"
};
const $5c57e26a311690c7$var$_hoisted_6 = [
    "href"
];
function $5c57e26a311690c7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_stat_box = (0, $TusQn.resolveComponent)("stat-box");
    const _component_cdx_info_chip = (0, $TusQn.resolveComponent)("cdx-info-chip");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5c57e26a311690c7$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", null, [
            (0, $TusQn.createElementVNode)("h2", null, [
                (0, $TusQn.createElementVNode)("strong", null, "@" + (0, $8XWQX.toDisplayString)(_ctx.username), 1)
            ]),
            (0, $TusQn.createElementVNode)("h3", null, [
                (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)(_ctx.project), 1)
            ]),
            (0, $TusQn.createElementVNode)("img", {
                src: _ctx.imageLogo,
                width: "512",
                height: "401"
            }, null, 8, $5c57e26a311690c7$var$_hoisted_2),
            (0, $TusQn.createElementVNode)("div", $5c57e26a311690c7$var$_hoisted_3, [
                _ctx.project === 'commons.wikimedia.org' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_stat_box, {
                    key: 0,
                    value: _ctx.stats.fileUploads,
                    label: _ctx.$i18n('file-uploads'),
                    icon: _ctx.uploadIcon
                }, null, 8, [
                    "value",
                    "label",
                    "icon"
                ])) : _ctx.project === 'www.wikidata.org' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_stat_box, {
                    key: 1,
                    value: _ctx.stats.totalEdits,
                    label: _ctx.$i18n('claims'),
                    icon: _ctx.wikidataIcon
                }, null, 8, [
                    "value",
                    "label",
                    "icon"
                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_stat_box, {
                    key: 2,
                    value: _ctx.stats.totalEdits,
                    label: _ctx.$i18n('edits'),
                    icon: _ctx.editIcon
                }, null, 8, [
                    "value",
                    "label",
                    "icon"
                ])),
                (0, $TusQn.createVNode)(_component_stat_box, {
                    value: _ctx.stats.talkEdits,
                    label: _ctx.$i18n('talk-page-edits'),
                    icon: _ctx.talkIcon
                }, null, 8, [
                    "value",
                    "label",
                    "icon"
                ]),
                (0, $TusQn.createVNode)(_component_stat_box, {
                    value: _ctx.stats.thanksCount,
                    label: _ctx.$i18n('thanks'),
                    icon: _ctx.thankIcon
                }, null, 8, [
                    "value",
                    "label",
                    "icon"
                ]),
                (0, $TusQn.createVNode)(_component_stat_box, {
                    value: _ctx.stats.thankedCount,
                    label: _ctx.$i18n('thanked'),
                    icon: _ctx.thankIcon
                }, null, 8, [
                    "value",
                    "label",
                    "icon"
                ]),
                _ctx.stats.streak.longestStreak > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_stat_box, {
                    key: 3,
                    value: _ctx.stats.streak.longestStreak,
                    label: _ctx.$i18n('longest-streak'),
                    icon: _ctx.streakIcon
                }, null, 8, [
                    "value",
                    "label",
                    "icon"
                ])) : (0, $TusQn.createCommentVNode)("", true),
                _ctx.stats.templateEdits ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_stat_box, {
                    key: 4,
                    value: _ctx.stats.templateEdits,
                    label: _ctx.$i18n('template-edits'),
                    icon: _ctx.templateIcon
                }, null, 8, [
                    "value",
                    "label",
                    "icon"
                ])) : (0, $TusQn.createCommentVNode)("", true),
                _ctx.stats.interfaceEdits ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_stat_box, {
                    key: 5,
                    value: _ctx.stats.interfaceEdits,
                    label: _ctx.$i18n('interface-edits'),
                    icon: _ctx.gadgetIcon
                }, null, 8, [
                    "value",
                    "label",
                    "icon"
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.createElementVNode)("div", $5c57e26a311690c7$var$_hoisted_4, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.notes, (note)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_info_chip, {
                            title: note.tooltip
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(note.label), 1)
                                ]),
                            _: 2
                        }, 1032, [
                            "title"
                        ]);
                    }), 256))
                ])
            ]),
            (0, $TusQn.createElementVNode)("h3", $5c57e26a311690c7$var$_hoisted_5, [
                (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)(_ctx.stats.year - 1), 1)
            ]),
            (0, $TusQn.createElementVNode)("footer", null, [
                (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.$i18n('generate-your-own')) + " ", 1),
                (0, $TusQn.createElementVNode)("a", {
                    href: `https://${_ctx.host}`
                }, (0, $8XWQX.toDisplayString)(_ctx.host), 9, $5c57e26a311690c7$var$_hoisted_6),
                _cache[0] || (_cache[0] = (0, $TusQn.createElementVNode)("div", {
                    class: "license-logo"
                }, [
                    (0, $TusQn.createElementVNode)("a", {
                        href: "https://creativecommons.org/publicdomain/zero/1.0/deed.en"
                    }, [
                        (0, $TusQn.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bSGnN)))
                        }),
                        (0, $TusQn.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($hlpZx)))
                        })
                    ])
                ], -1))
            ])
        ])
    ]);
}

});
parcelRegister("bSGnN", function(module, exports) {
module.exports = new URL("Cc.logo.circle.svg.8c5edd9b.webp", import.meta.url).toString();

});

parcelRegister("hlpZx", function(module, exports) {
module.exports = new URL("Cc-zero.svg.39e831f5.png", import.meta.url).toString();

});


parcelRegister("e1CGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35f298dd89e1f82$export$2e2bcd8739ae039);
let $a35f298dd89e1f82$var$NOOP = ()=>{};
var $a35f298dd89e1f82$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("7qROO", function(module, exports) {
module.exports = JSON.parse("[\"ar\",\"az\",\"be-tarask\",\"bn\",\"br\",\"cs\",\"csb\",\"de\",\"diq\",\"en\",\"es\",\"fi\",\"fr\",\"ga\",\"gl\",\"he\",\"hi\",\"iba\",\"id\",\"isv-latn\",\"it\",\"ja\",\"kea\",\"ko\",\"krc\",\"lb\",\"mk\",\"ml\",\"mn\",\"mni\",\"ms\",\"nb\",\"nl\",\"olo\",\"pa\",\"pl\",\"ps\",\"pt-br\",\"ru\",\"sk\",\"skr-arab\",\"sr-ec\",\"sv\",\"tcy\",\"th\",\"tr\",\"uk\",\"ur\",\"vi\",\"yoda\",\"zh-hans\",\"zh-hant\"]");

});


parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
var $eeJ70 = parcelRequire("eeJ70");
const $2c4cb1eb429dee56$var$_hoisted_1 = [
    "lang",
    "dir"
];
const $2c4cb1eb429dee56$var$_hoisted_2 = {
    class: "intro"
};
const $2c4cb1eb429dee56$var$_hoisted_3 = {
    key: 0
};
const $2c4cb1eb429dee56$var$_hoisted_4 = {
    class: "progressBar"
};
const $2c4cb1eb429dee56$var$_hoisted_5 = {
    key: 0
};
const $2c4cb1eb429dee56$var$_hoisted_6 = {
    key: 1
};
const $2c4cb1eb429dee56$var$_hoisted_7 = {
    key: 2
};
const $2c4cb1eb429dee56$var$_hoisted_8 = {
    key: 3
};
const $2c4cb1eb429dee56$var$_hoisted_9 = {
    class: "yearSwitcher"
};
const $2c4cb1eb429dee56$var$_hoisted_10 = {
    class: "happy"
};
const $2c4cb1eb429dee56$var$_hoisted_11 = [
    "href"
];
const $2c4cb1eb429dee56$var$_hoisted_12 = {
    key: 0
};
const $2c4cb1eb429dee56$var$_hoisted_13 = {
    key: 1
};
const $2c4cb1eb429dee56$var$_hoisted_14 = {
    key: 3
};
const $2c4cb1eb429dee56$var$_hoisted_15 = [
    "value",
    "selected"
];
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_text_input = (0, $TusQn.resolveComponent)("cdx-text-input");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    const _component_cdx_message = (0, $TusQn.resolveComponent)("cdx-message");
    const _component_cdx_select = (0, $TusQn.resolveComponent)("cdx-select");
    const _component_page = (0, $TusQn.resolveComponent)("page");
    const _component_share_box = (0, $TusQn.resolveComponent)("share-box");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "app-wrapper",
        style: (0, $8XWQX.normalizeStyle)(_ctx.appStyle),
        lang: _ctx.language,
        dir: _ctx.languageDirection
    }, [
        _ctx.currentPage <= 0 && !_ctx.activePage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_page, {
            key: 0
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    _cache[3] || (_cache[3] = (0, $TusQn.createElementVNode)("img", {
                        class: "mainImg",
                        src: "https://upload.wikimedia.org/wikipedia/commons/e/ed/WP20Symbols_MediaWiki.svg",
                        width: "512",
                        height: "401"
                    }, null, -1)),
                    (0, $TusQn.createElementVNode)("h1", null, (0, $8XWQX.toDisplayString)(_ctx.$i18n(_ctx.titleProjectMessage, _ctx.language)), 1),
                    (0, $TusQn.createElementVNode)("h2", null, (0, $8XWQX.toDisplayString)(_ctx.$i18n('year-in-review', _ctx.language)), 1),
                    (0, $TusQn.createElementVNode)("p", $2c4cb1eb429dee56$var$_hoisted_2, (0, $8XWQX.toDisplayString)(_ctx.$i18n('intro', _ctx.language)), 1),
                    (0, $TusQn.createElementVNode)("label", null, (0, $8XWQX.toDisplayString)(_ctx.$i18n('project-label', _ctx.language)), 1),
                    (0, $TusQn.createVNode)(_component_cdx_text_input, {
                        required: "",
                        pattern: "[^\\.]*\\.(wikivoyage|wikinews|wikiversity|wikibooks|wikiquote|wiktionary|wikifunctions|wikisource|wikipedia|mediawiki|wikidata|wikimedia)\\.org",
                        type: "text",
                        modelValue: _ctx.project,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.project = $event)
                    }, null, 8, [
                        "modelValue"
                    ]),
                    (0, $TusQn.createVNode)(_component_cdx_text_input, {
                        required: "",
                        placeholder: _ctx.$i18n('username-placeholder', _ctx.language),
                        pattern: "^[^:]+$",
                        onKeyup: (0, $eeJ70.withKeys)(_ctx.start, [
                            "enter"
                        ]),
                        type: "text",
                        modelValue: _ctx.username,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.username = $event)
                    }, null, 8, [
                        "placeholder",
                        "onKeyup",
                        "modelValue"
                    ]),
                    (0, $TusQn.createVNode)(_component_cdx_button, {
                        disabled: _ctx.disableBtn,
                        onClick: _ctx.start,
                        action: "progressive",
                        weight: "primary"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_cdx_icon, {
                                    class: "nextIcon",
                                    icon: _ctx.nextIcon
                                }, null, 8, [
                                    "icon"
                                ]),
                                (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)(_ctx.$i18n('get-started', _ctx.language)), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "disabled",
                        "onClick"
                    ]),
                    _ctx.loading > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_3, [
                        (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_4, [
                            (0, $TusQn.createElementVNode)("div", {
                                style: (0, $8XWQX.normalizeStyle)(`width: ${_ctx.status * 200}px`)
                            }, null, 4)
                        ])
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    _ctx.error ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_message, {
                        key: 1,
                        type: "error"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                _ctx.errorMsg === 'share-error' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $2c4cb1eb429dee56$var$_hoisted_5, (0, $8XWQX.toDisplayString)(_ctx.$i18n('error-share', _ctx.language)), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                _ctx.errorMsg === 'clipboard-error' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $2c4cb1eb429dee56$var$_hoisted_6, (0, $8XWQX.toDisplayString)(_ctx.$i18n('error-clipboard', _ctx.language)), 1)) : _ctx.errorMsg === 'username-disabled-error' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $2c4cb1eb429dee56$var$_hoisted_7, (0, $8XWQX.toDisplayString)(_ctx.$i18n('error-toomanyedits', _ctx.language)), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $2c4cb1eb429dee56$var$_hoisted_8, (0, $8XWQX.toDisplayString)(_ctx.$i18n('error-generic', _ctx.errorMsg)), 1))
                            ]),
                        _: 1
                    })) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_9, [
                        (0, $TusQn.createVNode)(_component_cdx_select, {
                            placeholder: _ctx.$i18n('year-placeholder', _ctx.language),
                            "menu-items": _ctx.lastFiveYears,
                            selected: String(_ctx.previousYear),
                            "onUpdate:selected": _ctx.updateYear
                        }, null, 8, [
                            "placeholder",
                            "menu-items",
                            "selected",
                            "onUpdate:selected"
                        ])
                    ])
                ]),
            _: 1
        })) : (0, $TusQn.createCommentVNode)("", true),
        _ctx.activePage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_page, {
            key: 1,
            message: _ctx.activePage.message,
            image: _ctx.activePage.image,
            class: (0, $8XWQX.normalizeClass)(_ctx.activePage.class)
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    _ctx.currentPage > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                        key: 0,
                        onClick: _ctx.decrementPage,
                        weight: "primary",
                        class: "previous",
                        "aria-label": "previous"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_cdx_icon, {
                                    class: "previousIcon",
                                    icon: _ctx.nextIcon
                                }, null, 8, [
                                    "icon"
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "onClick"
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createVNode)(_component_cdx_button, {
                        onClick: _ctx.incrementPage,
                        action: "progressive",
                        weight: "primary"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_cdx_icon, {
                                    class: "nextIcon",
                                    icon: _ctx.nextIcon
                                }, null, 8, [
                                    "icon"
                                ]),
                                (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)(_ctx.currentPage + 1) + " / " + (0, $8XWQX.toDisplayString)(_ctx.pages.length + 1), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "onClick"
                    ])
                ]),
            _: 1
        }, 8, [
            "message",
            "image",
            "class"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        _ctx.pages.length && _ctx.currentPage >= _ctx.pages.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_page, {
            key: 2
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    _ctx.currentPage > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                        key: 0,
                        onClick: _ctx.decrementPage,
                        weight: "primary",
                        class: "previous",
                        "aria-label": "previous"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_cdx_icon, {
                                    class: "previousIcon",
                                    icon: _ctx.nextIcon
                                }, null, 8, [
                                    "icon"
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "onClick"
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createVNode)(_component_share_box, {
                        stats: _ctx.stats,
                        username: _ctx.username,
                        project: _ctx.project
                    }, null, 8, [
                        "stats",
                        "username",
                        "project"
                    ]),
                    (0, $TusQn.createElementVNode)("p", null, (0, $8XWQX.toDisplayString)(_ctx.$i18n('thanks-for-playing', _ctx.language)), 1),
                    (0, $TusQn.createElementVNode)("p", $2c4cb1eb429dee56$var$_hoisted_10, (0, $8XWQX.toDisplayString)(_ctx.$i18n('hny', _ctx.nextYear, _ctx.language)), 1),
                    _ctx.shareImg ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                        key: 1,
                        href: _ctx.shareImg,
                        class: "download-link",
                        download: ""
                    }, (0, $8XWQX.toDisplayString)(_ctx.$i18n('save-image', _ctx.language)), 9, $2c4cb1eb429dee56$var$_hoisted_11)) : (0, $TusQn.createCommentVNode)("", true),
                    _ctx.feedback ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_message, {
                        key: 2,
                        type: "success"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.feedback), 1)
                            ]),
                        _: 1
                    })) : (0, $TusQn.createCommentVNode)("", true),
                    _ctx.error ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_message, {
                        key: 3,
                        type: "error"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.$i18n('error-share', _ctx.language)), 1)
                            ]),
                        _: 1
                    })) : (0, $TusQn.createCommentVNode)("", true),
                    _ctx.shareable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                        key: 4,
                        onClick: _ctx.shareIt,
                        action: "progressive",
                        weight: "primary"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_cdx_icon, {
                                    icon: _ctx.shareIcon
                                }, null, 8, [
                                    "icon"
                                ]),
                                _ctx.navigatorShareable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $2c4cb1eb429dee56$var$_hoisted_12, (0, $8XWQX.toDisplayString)(_ctx.$i18n('share', _ctx.language)), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $2c4cb1eb429dee56$var$_hoisted_13, (0, $8XWQX.toDisplayString)(_ctx.$i18n('share-to-clipboard', _ctx.language)), 1))
                            ]),
                        _: 1
                    }, 8, [
                        "onClick"
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ]),
            _: 1
        })) : (0, $TusQn.createCommentVNode)("", true),
        _ctx.currentPage === -1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_14, [
            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.$i18n('language-label', _ctx.language)) + " ", 1),
            (0, $TusQn.createElementVNode)("select", {
                id: "languageSwitcher",
                name: "language",
                onChange: _cache[2] || (_cache[2] = (...args)=>_ctx.setLanguage && _ctx.setLanguage(...args))
            }, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.supportedLanguages, (lang)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                        value: lang.code,
                        selected: lang.code === _ctx.language
                    }, (0, $8XWQX.toDisplayString)(lang.label), 9, $2c4cb1eb429dee56$var$_hoisted_15);
                }), 256))
            ], 32)
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ], 12, $2c4cb1eb429dee56$var$_hoisted_1);
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

var $af62be290beaaaec$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"2BF4I\",\"index.476d9ad1.js\",\"gLchw\",\"Cc.logo.circle.svg.8c5edd9b.webp\",\"1unq9\",\"Cc-zero.svg.39e831f5.png\",\"8koGT\",\"index.c8224ff9.css\"]"));

parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");

var $dwPVL = parcelRequire("dwPVL");
var // Copy of https://gerrit.wikimedia.org/g/mediawiki/core/+/fc63ca2856d969c45329343045f0c6bb33c07983/resources/src/vue/i18n.js
/*!
 * i18n plugin for Vue that connects to MediaWiki's i18n system.
 *
 * Based on https://github.com/santhoshtr/vue-banana-i18n , but modified to connect to mw.message()
 * instead of banana-i18n.
 */ $43253b2367e4eb2b$export$2e2bcd8739ae039 = {
    install: function(app) {
        /**
		 * Adds an `$i18n()` instance method that can be used in all components. This method is a
		 * proxy to {@link mw.message}.
		 *
		 * Usage:
		 * ```
		 * <p>{{ $i18n( 'my-message-key', param1, param2 ) }}</p>
		 * ```
		 * or
		 * ```
		 * <p>{{ $i18n( 'my-message-key' ).params( [ param1, param2 ] ) }}</p>
		 * ```
		 *
		 * Note that this method only works for messages that return text. For messages that
		 * need to be parsed to HTML, use the `v-i18n-html` directive.
		 *
		 * @param {string} key Key of message to get
		 * @param {...any} parameters Values for $N replacements
		 * @return {mw.Message}
		 * @memberof module:vue.prototype
		 */ function $i18n(key, ...parameters) {
            // eslint-disable-next-line mediawiki/msg-doc
            return (0, $dwPVL.default).message(key, ...parameters);
        }
        // Make $i18n available as a global property
        app.config.globalProperties.$i18n = $i18n;
        // Also make $i18n available in setup() functions through inject()
        app.provide('i18n', $i18n);
        function renderI18nHtml(el, binding) {
            /* eslint-disable mediawiki/msg-doc */ let message;
            if (Array.isArray(binding.value)) {
                if (binding.arg === undefined) // v-i18n-html="[ ...params ]" (error)
                throw new Error('v-i18n-html used with parameter array but without message key');
                // v-i18n-html:messageKey="[ ...params ]"
                message = (0, $dwPVL.default).message(binding.arg).params(binding.value);
            } else if (binding.value instanceof (0, $dwPVL.default).Message) // v-i18n-html="mw.message( '...' ).params( [ ... ] )"
            message = binding.value;
            else // v-i18n-html:foo or v-i18n-html="'foo'"
            message = (0, $dwPVL.default).message(binding.arg || binding.value);
            /* eslint-enable mediawiki/msg-doc */ el.innerHTML = message.parse();
        }
        /*
		 * Add a custom v-i18n-html directive. This is used to inject parsed i18n message contents.
		 *
		 * <div v-i18n-html:my-message-key />
		 *     Parses the my-message-key message and injects the parsed HTML into the div.
		 *     Equivalent to v-html="mw.message( 'my-message-key' ).parse()"
		 *
		 * <div v-i18n-html="msgKey" />
		 *     Looks in the msgKey variable for the message name, and parses that message.
		 *     Equivalent to v-html="mw.message( msgKey ).parse()"
		 *
		 * <div v-i18n-html="'my-message-key'" />
		 *     Parses the message named my-message-key. Note the nested quotes!
		 *     Equivalent to v-html="mw.message( 'my-message-key' ).parse()"
		 *
		 * <div v-i18n-html:my-message-key="[ param1, param2 ]" />
		 *     Parses the my-message-key message, passing parameters param1 and param2
		 *     Equivalent to v-html="mw.message( 'my-message-key' ).params( [ param1, param2 ] ).parse()"
		 *
		 * <div v-i18n-html:my-message-key="[ param1 ]" />
		 *     Parses the my-message-key message, passing only one parameter. Note the array brackets!
		 *     Equivalent to v-html="mw.message( 'my-message-key' ).params( [ param1 ] ).parse()"
		 *
		 * <div v-i18n-html="$i18n( 'my-message-key' ).params( [ param1, param2 ] )" />
		 *     If a mw.Message object is passed in, .parse() will be called on it.
		 *     Equivalent to v-html="mw.message( 'my-message-key' ).params( [ param1, param2 ] ).parse()"
		 *     This is only recommended for when you have a Message object coming from a
		 *     computed property or a method, or for when you can't use any of the other calling
		 *     styles (e.g. because the message key is dynamic, or contains unusual characters).
		 *     Note that you can use mw.message() in computed properties, but in template attributes
		 *     you have to use $i18n() instead as demonstrated above.
		 *
		 * WARNING: Do not use dynamic argument syntax, like <div v-i18n-html:[msgKeyVariable] />
		 *          If you do this, the message will not update when msgKeyVariable changes, due to
		 *          limitations in Vue's directives API. Instead, use the $i18n style described
		 *          above if you need a dynamic message key.
		 */ app.directive('i18n-html', {
            mounted: renderI18nHtml,
            updated (el, binding) {
                // This function is invoked often, every time anything in the component changes.
                // We don't want to rerender unnecessarily, because that's wasteful and can cause
                // strange issues like T327229. For each possible type of binding.value, compare it
                // to binding.oldValue, and abort if they're equal. This does not account for
                // changes in binding.arg; we can't detect those, so there's a warning in the
                // documentation above explaining that using a dynamic argument is not supported.
                const areArraysEqual = (arr1, arr2)=>Array.isArray(arr1) && Array.isArray(arr2) && arr1.length === arr2.length && arr1.every((val, index)=>arr2[index] === val);
                const areMessagesEqual = (msg1, msg2)=>msg1 instanceof (0, $dwPVL.default).Message && msg2 instanceof (0, $dwPVL.default).Message && msg1.key === msg2.key && areArraysEqual(msg1.parameters, msg2.parameters);
                if (binding.value === binding.oldValue || areArraysEqual(binding.value, binding.oldValue) || areMessagesEqual(binding.value, binding.oldValue)) return;
                renderI18nHtml(el, binding);
            }
        });
    }
};


let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = 'data-v-a3ab84';
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;



var $dwPVL = parcelRequire("dwPVL");
const $dad545c909cfec2d$var$language = new URLSearchParams(location.search).get('uselang') || navigator.language;
new Promise((resolve)=>{
    if ($dad545c909cfec2d$var$language === 'en' || $dad545c909cfec2d$var$language === 'en-us') resolve();
    else return (0, $dwPVL.default).setLanguage($dad545c909cfec2d$var$language).then(resolve);
}).then((r)=>{
    (0, $eeJ70.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039)).use((0, $43253b2367e4eb2b$export$2e2bcd8739ae039)).mount('#app');
}, (e)=>{
    console.log(e);
});


//# sourceMappingURL=index.476d9ad1.js.map
